export interface StringsType {
  domain: string;
  lang: string;
  completeness: number;
  plural_forms: string;
  locale_data: {
    messages: Record<string, unknown>;
  };
}
export const strings: Record<string, StringsType> = {};

strings["uk"] = {
  locale_data: {
    messages: {
      "": {
        domain: "messages",
        lang: "uk",
        plural_forms:
          "nplurals=3; plural=n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2;",
      },
      "Hide password": ["Приховати пароль"],
      "Show password": ["Показати пароль"],
      "Hide": ["Приховати"],
      "Show": ["Показати"],
      "Identity verification.": ["Підтвердження особи."],
      "You do not have permission to access this account.": [
        "У вас немає дозволу на доступ до цього рахунку.",
      ],
      "This account is locked. Contact the bank administrator.": [
        "Рахунок заблоковано і не може увійти. Зверніться до адміністратора.",
      ],
      "The password is incorrect.": ["Неправильний пароль."],
      "Account not found.": ["Обліковий запис не знайдено"],
      "Could not reach the bank. Check your connection and try again.": [
        "Не вдалося зв’язатися з банком. Перевірте з’єднання та повторіть спробу.",
      ],
      "Confirm your password": ["Підтвердьте пароль"],
      "Sign in to %1$s": ["Увійти до %1$s"],
      "Enter the password for %1$s to continue.": [
        "Введіть пароль для %1$s, щоб продовжити.",
      ],
      "Use your bank account credentials to continue.": [
        "Щоб продовжити, використайте дані свого банківського рахунку.",
      ],
      "Need an account?": ["Потрібен рахунок?"],
      "Create one": ["Створити обліковий запис"],
      "Your session expired. Confirm your password to continue.": [
        "Термін дії сеансу минув. Підтвердьте пароль, щоб продовжити.",
      ],
      "Username": ["Імʼя користувача"],
      "Password": ["Пароль"],
      "Sign out": ["Вийти"],
      "Signing in…": ["Виконується вхід…"],
      "Continue": ["Продовжити"],
      "Sign in": ["Увійти"],
      "Enter your username.": ["Введіть ім’я користувача."],
      "Use letters, numbers, or any of these characters: - . _ ~": [
        "Використовуйте літери, цифри або будь-які з цих символів: - . _ ~",
      ],
      "The username must not exceed 126 characters.": [
        "Ім’я користувача не повинно перевищувати 126 символів.",
      ],
      "Enter your password.": ["Введіть пароль."],
      "The password must contain at least 8 characters.": [
        "Пароль занадто короткий. Не може містити менше ніж 8 символів.",
      ],
      "The password must not exceed %1$s characters.": [
        "Пароль не повинен перевищувати %1$s символів.",
      ],
      "IBAN country code not found": ["Код країни IBAN не знайдено"],
      "IBAN length is invalid for this country": [
        "Довжина IBAN неприпустима для цієї країни",
      ],
      "The IBAN contains invalid characters": [
        "IBAN містить неприпустимі символи",
      ],
      "IBAN number is not valid, checksum is wrong": [
        "Номер IBAN не коректний, контрольна сума не сходиться",
      ],
      "The IBAN is not valid": ["IBAN недійсний"],
      "Use letters, numbers or any of these characters: - . _ ~": [
        "Використовуйте літери, цифри або будь-які з цих символів: - . _ ~",
      ],
      "Failed to load cashouts.": ["Не вдалося завантажити виплати готівкою."],
      "Try again": ["Спробувати ще раз"],
      "Cashout is disabled": ["Виплата готівкою вимкнена"],
      "Cashout should be enabled in the configuration, the conversion rate should be initialized with fee(s), rates and a rounding mode.":
        [
          "Виплату готівкою потрібно увімкнути в конфігурації, обмінний курс має бути ініціалізований з комісією(ями), курсами та режимом округлення.",
        ],
      "Failed to load conversion rate information.": [
        "Не вдалося завантажити інформацію про обмінний курс.",
      ],
      "Some cashout details could not be loaded.": [
        "Не вдалося завантажити деякі відомості про виплати готівкою.",
      ],
      "The partial list omits cashout IDs: %1$s.": [
        "У частковому списку відсутні ідентифікатори виплат готівкою: %1$s.",
      ],
      "Debited": ["Дебетовано"],
      "Transferred": ["Переказано"],
      "Created": ["Створено"],
      "Actions": ["Дії"],
      "Cashout history": ["Історія виведення коштів"],
      "Profile": ["Профіль"],
      "Security": ["Безпека"],
      "Merchant integration": ["Інтеграція з продавцем"],
      "Back to overview": ["Повернутися до огляду"],
      "My account settings": ["Налаштування мого рахунку"],
      "Copy": ["Копіювати"],
      "Failed to load account details.": [
        "Не вдалося завантажити дані рахунку.",
      ],
      'Use this information to link your Taler Merchant Backoffice account with the current bank account. You can start by copying the values, then go to your merchant backoffice service provider, login into your account and look for the "import" button in the "bank account" section.':
        [
          'Використовуйте цю інформацію, щоб зв\'язати свій обліковий запис Taler Merchant Backoffice з поточним банківським рахунком. Почніть зі копіювання значень, потім перейдіть до вашого постачальника послуг Merchant Backoffice, увійдіть у свій обліковий запис і знайдіть кнопку "імпорт" у розділі "банківський рахунок".',
        ],
      "Not available": ["Недоступно"],
      "Merchant integration is not available for this account.": [
        "Інтеграція з продавцем недоступна для цього рахунку.",
      ],
      "Account type": ["Тип рахунку"],
      "Method to use for wire transfer.": [
        "Метод, що використовується для банківського переказу.",
      ],
      "IBAN": ["IBAN"],
      "International Bank Account Number.": [
        "Міжнародний номер банківського рахунку.",
      ],
      "Bank host": ["Сервер банку"],
      "Bank host where the service is located.": [
        "Хост банку, де розташована служба.",
      ],
      "Account name": ["Назва рахунку"],
      "Bank account identifier for wire transfers.": [
        "Ідентифікатор банківського рахунку для переказів.",
      ],
      "Address": ["Адреса"],
      "Bitcoin address for this account.": ["Bitcoin-адреса цього рахунку."],
      "Account address": ["Адреса рахунку"],
      "Owner's name": ["Ім'я власника"],
      "Legal name of the person holding the account.": [
        "Юридичне ім'я особи, яка володіє рахунком.",
      ],
      "Account info URL": ["URL інформації про рахунок"],
      "From where the merchant can download information about incoming wire transfers to this account.":
        [
          "Звідки продавець може завантажити інформацію про вхідні банківські перекази на цей рахунок.",
        ],
      "Unable to create a cashout": ["Не вдалося створити виплату готівкою"],
      "The bank configuration does not support cashout operations.": [
        "Конфігурація банку не підтримує операції з виплати готівкою.",
      ],
      "Close": ["Закрити"],
      "The bank returned incomplete conversion information.": [
        "Банк повернув неповні відомості про конвертацію.",
      ],
      "Please contact the bank administrator.": [
        "Зверніться до адміністратора банку.",
      ],
      "Authentication required": ["Потрібна автентифікація"],
      "Please sign in to create a cashout.": [
        "Увійдіть, щоб створити виплату готівкою.",
      ],
      "Failed to calculate the conversion fee.": [
        "Не вдалося розрахувати комісію за конвертацію.",
      ],
      "The amount is too small": ["Сума занадто мала"],
      "Conversion is not implemented.": ["Конвертація не реалізована."],
      "The currency is not supported": ["Валюта не підтримується"],
      "Required": ["Обов'язково"],
      "Invalid": ["Недійсно"],
      "The balance is not sufficient": ["Недостатньо коштів на балансі"],
      "It is not possible to cash out less than %1$s: %2$s": [
        "Неможливо вивести менше ніж %1$s: %2$s",
      ],
      "The total transfer to the destination will be zero": [
        "Загальна сума переказу на призначення дорівнюватиме нулю",
      ],
      "Failed to create the cashout.": [
        "Не вдалося створити виплату готівкою.",
      ],
      "Cashout": ["Виплати готівкою"],
      "Account not found": ["Обліковий запис не знайдено"],
      "Duplicate request detected, check if the operation succeeded or try again.":
        [
          "Виявлено повторний запит, перевірте, чи була операція успішною, або спробуйте ще раз.",
        ],
      "The conversion rate was applied incorrectly": [
        "Обмінний курс було застосовано неправильно",
      ],
      "The account does not have sufficient funds": [
        "На рахунку недостатньо коштів",
      ],
      "Missing cashout URI in the profile": [
        "Відсутній URI виплати готівкою в профілі",
      ],
      "The amount is below the minimum amount permitted.": [
        "Сума нижча за дозволений мінімум.",
      ],
      "Sending the confirmation message failed, retry later or contact the administrator.":
        [
          "Не вдалося надіслати повідомлення з підтвердженням, спробуйте пізніше або зверніться до адміністратора.",
        ],
      "The server doesn't support the current TAN channel.": [
        "Сервер не підтримує поточний канал TAN.",
      ],
      "Conversion rate": ["Обмінний курс"],
      "Balance": ["Баланс"],
      "Fee": ["Комісія"],
      "No fee": ["Без комісії"],
      "To account": ["На рахунок"],
      "Legal name": ["Юридичне ім'я"],
      "If this name doesn't match the account holder's name, your transaction may fail.":
        [
          "Якщо це ім'я не збігається з іменем власника рахунку, ваша транзакція може завершитися невдало.",
        ],
      "Unable to cash out": ["Неможливо вивести кошти"],
      "Before being able to cash out to a bank account, you need to complete your profile":
        [
          "Перш ніж ви зможете вивести кошти на банківський рахунок, потрібно заповнити ваш профіль",
        ],
      "Send %1$s": ["Надіслати %1$s"],
      "Receive %1$s": ["Отримати %1$s"],
      "Amount": ["Сума"],
      "Total cost": ["Загальна вартість"],
      "Balance left": ["Залишок балансу"],
      "Before fee": ["Комісія до"],
      "Total cashout transfer": ["Загальна сума виплати готівкою"],
      "Cancel": ["Скасувати"],
      "Cash out": ["Вивести кошти"],
      "Not valid": ["Недійсно"],
      "Does not follow the pattern": ["Не відповідає шаблону"],
      "The request was invalid or the payto://-URI used unacceptable features.":
        ["Запит недійсний або payto://-URI використовує неприпустимі функції."],
      "Not enough permission to complete the operation.": [
        "Недостатньо прав для виконання операції.",
      ],
      "The bank administrator cannot be the transfer creditor.": [
        "Адміністратор банку не може бути кредитором переказу.",
      ],
      'The destination account "%1$s" was not found.': [
        'Обліковий запис призначення "%1$s" не знайдено.',
      ],
      "The origin and the destination of the transfer can't be the same.": [
        "Джерело та місце призначення переказу не можуть бути однаковими.",
      ],
      "Your balance is not sufficient for the operation.": [
        "Вашого балансу недостатньо для цієї операції.",
      ],
      'The origin account "%1$s" was not found.': [
        'Обліковий запис джерела "%1$s" не знайдено.',
      ],
      "The attempt to create the transaction has failed. Please try again.": [
        "Спроба створити транзакцію не вдалася. Спробуйте ще раз.",
      ],
      "Confirm transaction.": ["Підтвердити транзакцію."],
      "Transfer details": ["Деталі переказу"],
      "Enter the recipient, a reference, and the amount to send.": [""],
      "Maximum transfer": ["Максимальна сума переказу"],
      "Debt limit": ["Ліміт заборгованості"],
      "This is not your account balance. This account cannot go into debt.": [
        "Це не баланс вашого рахунку. Для цього рахунку заборгованість не дозволена.",
      ],
      "This is not your account balance. It includes borrowing up to the debt limit shown here.":
        [
          "Це не баланс вашого рахунку. Сума включає доступний кредит у межах указаного тут ліміту заборгованості.",
        ],
      "Recipient": ["Одержувач"],
      "username": ["імʼя користувача"],
      "IBAN of the recipient's account": ["IBAN рахунку одержувача"],
      "What is this transfer for?": [""],
      "Paste a payto URI containing the recipient, amount, and transfer reference.":
        [""],
      "Uniform resource identifier of the target account": [
        "Уніфікований ідентифікатор ресурсу цільового рахунку",
      ],
      "payto://x-taler-bank/[bank-host]/[receiver-account]?message=[subject]&amount=[%1$s:X.Y]":
        [
          "payto://x-taler-bank/[oператор банку]/[pахунок одержувача]?message=[причина платежу]&amount=[%1$s:X.Y]",
        ],
      "payto://iban/[receiver-iban]?message=[subject]&amount=[%1$s:X.Y]": [
        "payto://iban/[iban одержувача]?message=[причина платежу]&amount=[%1$s:X.Y]",
      ],
      "Bank fee": ["Комісія банку"],
      "Total debited": ["Усього списано"],
      "Need to move money out of this bank?": [""],
      'Only "x-taler-bank" targets are supported': [
        'Підтримуються лише цілі "x-taler-bank"',
      ],
      'Only this host is allowed. Use "%1$s"': [
        'Дозволено лише цей хост. Використовуйте "%1$s"',
      ],
      "Account name is missing": ["Відсутня назва рахунку"],
      'Only "IBAN" targets are supported': ['Підтримуються лише цілі "IBAN"'],
      'Missing "amount" parameter to specify the amount to be transferred': [
        'Відсутній параметр "amount" для вказання суми переказу',
      ],
      'The "amount" parameter is not valid': ['Параметр "amount" недійсний'],
      '"message" parameters to specify a reference text for the transfer are missing':
        ['Відсутні параметри "message" для вказання тексту посилання переказу'],
      'The only currency allowed is "%1$s"': [
        'Єдина дозволена валюта — "%1$s"',
      ],
      "You cannot transfer an amount of zero.": [
        "Не можна переказати нульову суму.",
      ],
      "Please enter a longer subject": ["Введіть довше призначення"],
      "Email and SMS authentication were disabled because their contact details were removed.":
        [
          "Автентифікацію електронною поштою та SMS вимкнено, оскільки відповідні контактні дані було видалено.",
        ],
      "Email authentication was disabled because the email address was removed.":
        [
          "Автентифікацію електронною поштою вимкнено, оскільки адресу електронної пошти було видалено.",
        ],
      "SMS authentication was disabled because the phone number was removed.": [
        "Автентифікацію через SMS вимкнено, оскільки номер телефону було видалено.",
      ],
      "Invalid email format": ["Недійсний формат email"],
      "Should start with +": ["Має починатися з +"],
      "A phone number consists of numbers only": [
        "Номер телефону складається лише з цифр",
      ],
      "Login username": ["ім'я користувача"],
      "Account ID for authentication": ["ID рахунку для автентифікації"],
      "Full name": ["Повне ім'я"],
      "Name of the account holder": ["Ім'я власника рахунку"],
      "Internal account": ["Внутрішній рахунок"],
      "Copy and share this account address to receive transfers.": [
        "Скопіюйте та поширте цю адресу рахунку, щоб отримувати перекази.",
      ],
      "Email": ["Email"],
      "To be used when second factor authentication is enabled": [
        "Використовується, коли увімкнена двофакторна автентифікація",
      ],
      "Phone": ["Телефон"],
      "Enable second factor authentication": [
        "Увімкнути двофакторну автентифікацію",
      ],
      "Using email": ["Використовуючи email"],
      "Add an email in your profile to enable this option": [
        "Додайте email у свій профіль, щоб увімкнути цю опцію",
      ],
      "Using SMS": ["Використовуючи SMS"],
      "Add a phone number in your profile to enable this option": [
        "Додайте номер телефону у свій профіль, щоб увімкнути цю опцію",
      ],
      "Cashout account": ["Рахунок для виплати готівкою"],
      "External account to which cashout transfers are sent.": [""],
      "Max debt": ["Максимальний борг"],
      "How much the balance can go below zero.": [
        "Наскільки баланс може опускатися нижче нуля.",
      ],
      "Is this account public?": ["Цей обліковий запис є публічним?"],
      "Public accounts expose their balance and complete transaction history, including subjects and both account addresses, to anonymous visitors.":
        [
          "Публічні рахунки розкривають анонімним відвідувачам свій баланс і повну історію транзакцій, зокрема призначення платежів та адреси обох рахунків.",
        ],
      "Does this account belong to a Payment Service Provider?": [
        "Чи належить цей рахунок надавачу платіжних послуг?",
      ],
      "Account updated": ["Рахунок оновлено"],
      "Failed to update the account.": ["Не вдалося оновити рахунок."],
      "The rights to change the account are not sufficient": [
        "Недостатньо прав для зміни облікового запису",
      ],
      "The username was not found": ["Ім'я користувача не знайдено"],
      "You can't change the legal name, please contact your account administrator.":
        [
          "Ви не можете змінити юридичне ім'я, будь ласка, зверніться до адміністратора вашого облікового запису.",
        ],
      "You can't change the debt limit, please contact your account administrator.":
        [
          "Ви не можете змінити ліміт боргу, будь ласка, зверніться до адміністратора вашого облікового запису.",
        ],
      "You can't change the cashout address, please contact your account administrator.":
        [
          "Ви не можете змінити адресу виплати готівкою, будь ласка, зверніться до адміністратора вашого облікового запису.",
        ],
      "No information for the selected authentication channel.": [
        "Немає інформації про обраний канал автентифікації.",
      ],
      "Account update": ["Оновлення рахунку"],
      "Authentication channel is not supported.": [
        "Канал автентифікації не підтримується.",
      ],
      "Only the administrator can change the conversion rate.": [
        "Лише адміністратор може змінювати обмінний курс.",
      ],
      "The conversion rate class doesn't exist.": [
        "Клас обмінного курсу не існує.",
      ],
      "The password is too short. Can't have less than 8 characters.": [
        "Пароль занадто короткий. Не може містити менше ніж 8 символів.",
      ],
      "The password is too long. Can't have more than 64 characters.": [
        "Пароль занадто довгий. Не може містити більше ніж 64 символи.",
      ],
      'Account "%1$s"': ['Рахунок "%1$s"'],
      "Removed": ["Видалено"],
      "This account can't be used.": ["Цей рахунок не можна використовувати."],
      "Account details": ["Дані рахунку"],
      "Not configured": ["Не налаштовано"],
      "Change details": ["Зміна реквізитів"],
      "Update": ["Оновити"],
      "Delete account": ["Видалити рахунок"],
      "Permanently remove this bank account. The account must have a zero balance before it can be deleted.":
        [
          "Видалити цей банківський рахунок назавжди. Перед видаленням баланс рахунку має дорівнювати нулю.",
        ],
      "The passwords do not match.": ["Паролі не збігаються"],
      "Failed to update the password.": ["Не вдалося оновити пароль."],
      "Not authorized to change the password, maybe the session is invalid.": [
        "Немає прав для зміни пароля, можливо, сеанс недійсний.",
      ],
      "You need to provide the old password. If you don't have it contact your account administrator.":
        [
          "Вам потрібно надати старий пароль. Якщо у вас його немає, зверніться до адміністратора вашого облікового запису.",
        ],
      "The current password is incorrect, so the password cannot be changed.": [
        "",
      ],
      "Password update": ["Оновлення пароля"],
      "You don't have the rights to change the password.": [
        "У вас немає прав для зміни пароля.",
      ],
      "Update password": ["Оновити пароль"],
      "Current password": ["Поточний пароль"],
      "Your current password, for security": [
        "Ваш поточний пароль, для безпеки",
      ],
      "New password": ["Новий пароль"],
      "Failed to load transactions.": ["Не вдалося завантажити транзакції."],
      "Unknown account": ["Невідомий рахунок"],
      "Recent activity": ["Нещодавня активність"],
      "Transactions": ["Транзакції"],
      "Subject": ["Призначення"],
      "Today": ["Сьогодні"],
      "Yesterday": ["Учора"],
      "Invalid value": ["Недійсне значення"],
      "View all transactions": ["Показати всі транзакції"],
      "No transactions yet.": ["Ще немає транзакцій."],
      "Your account activity will appear here.": [
        "Тут з’явиться активність вашого рахунку.",
      ],
      "Date": ["Дата"],
      "Counterparty": ["Контррахунок"],
      "Pagination": ["Посторінкова навігація"],
      "Newer": ["Новіші"],
      "Older": ["Старіші"],
      "Withdraw to Taler Wallet": ["Вивести до гаманця Taler"],
      "Move digital cash to your Taler Wallet.": [
        "Переказуйте цифрові гроші до свого гаманця Taler.",
      ],
      "Send bank transfer": ["Надіслати банківський переказ"],
      "Transfer money to another bank account.": [
        "Переказуйте гроші на інший банківський рахунок.",
      ],
      "Convert regional currency and send it to your cashout account.": [
        "Конвертуйте регіональну валюту та надішліть її на рахунок виведення коштів.",
      ],
      "Copy account address": ["Копіювати адресу рахунку"],
      "Current balance": ["Поточний баланс"],
      "Go to account details": ["Перейти до даних рахунку"],
      "Failed to load the admin account.": [
        "Не вдалося завантажити рахунок адміністратора.",
      ],
      "Admin account": ["Рахунок адміністратора"],
      "Admin account activity": ["Активність рахунку адміністратора"],
      "Failed to load the monitor info.": [
        "Не вдалося завантажити інформацію монітора.",
      ],
      "Failed to load cashout info.": [
        "Не вдалося завантажити інформацію про виплату готівкою.",
      ],
      "Querying for the current stats failed": [
        "Не вдалося запитати поточну статистику",
      ],
      "The user is unauthorized": ["Користувач не авторизований"],
      "Querying for the previous stats failed": [
        "Не вдалося запитати попередню статистику",
      ],
      "Bank activity": ["Активність банку"],
      "Select a section": ["Оберіть розділ"],
      "Last hour": ["Остання година"],
      "Previous day": ["Попередній день"],
      "Last month": ["Останній місяць"],
      "Last year": ["Останній рік"],
      "Tabs": ["Вкладки"],
      "Last Year": ["Попередній рік"],
      "Trading volume from %1$s to %2$s": ["Обсяг торгів з %1$s по %2$s"],
      "Cash in": ["Внесення коштів"],
      "Transferred from an external account to an account in this bank.": [
        "Переказано із зовнішнього рахунку на рахунок у цьому банку.",
      ],
      "Transferred from an account in this bank to an external account.": [
        "Переказано з рахунку в цьому банку на зовнішній рахунок.",
      ],
      "Taler pay-in": ["Внесення в Taler"],
      "Transferred from an account to a Taler exchange.": [
        "Переказано з рахунку до Taler Exchange.",
      ],
      "Transfers": ["Перекази"],
      "Taler payout": ["Виплата Taler"],
      "Transferred from a Taler exchange to another account.": [
        "Переказано з Taler Exchange на інший рахунок.",
      ],
      "Download stats as CSV": ["Завантажити статистику як CSV"],
      "previous": ["попередній"],
      "Decreased by": ["Зменшилось на"],
      "Increased by": ["Збільшилось на"],
      'Account created with password "%1$s".': [
        'Обліковий запис створено з паролем "%1$s".',
      ],
      "Failed to create a new account.": ["Не вдалося створити новий рахунок."],
      "Server replied that phone or email is invalid": [
        "Сервер відповів, що номер телефону або електронна пошта недійсні",
      ],
      "The rights to perform the operation are not sufficient": [
        "Недостатньо прав для виконання операції",
      ],
      "Account username is already taken": [
        "Ім'я користувача облікового запису вже зайнято",
      ],
      "Account ID is already taken": ["ID рахунку вже зайнято"],
      "Bank ran out of bonus credit.": ["У банку закінчився бонусний кредит."],
      "Only an administrator is allowed to set the debt limit.": [
        "Лише адміністратор може встановлювати ліміт заборгованості.",
      ],
      "Only admin can create accounts with second factor authentication.": [
        "Лише адміністратор може створювати облікові записи з двофакторною автентифікацією.",
      ],
      "Can't create accounts": ["Не вдається створити рахунки"],
      "New bank account": ["Новий банківський рахунок"],
      "Create an account and configure its initial access and profile.": [""],
      "Create account": ["Створити обліковий запис"],
      "Failed to download statistics.": ["Не вдалося завантажити статистику."],
      "A statistics request failed. Please try again.": [
        "Не вдалося виконати запит статистики. Спробуйте ще раз.",
      ],
      "only admin can download stats": [
        "лише адміністратор може завантажувати статистику",
      ],
      "Choose which reporting periods to include in the CSV file.": [""],
      "Include hour metric": ["Включити часову метрику"],
      "Include day metric": ["Включити добову метрику"],
      "Include month metric": ["Включити місячну метрику"],
      "Include year metric": ["Включити річну метрику"],
      "Include table header": ["Включити заголовок таблиці"],
      "Add previous metric for comparison": [
        "Додати попередню метрику для порівняння",
      ],
      "Fail on first error": ["Збій на першій помилці"],
      "Download": ["Завантажити"],
      "Download completed with missing data": [
        "Завантаження завершено з неповними даними",
      ],
      "Download completed": ["Завантаження завершено"],
      "%1$s statistics requests failed. The file contains only the data that could be retrieved. Click here to save it.":
        [
          "Не вдалося виконати запити статистики в кількості %1$s. Файл містить лише ті дані, які вдалося отримати. Натисніть тут, щоб зберегти його.",
        ],
      "Click here to save the file on your computer.": [
        "Натисніть тут, щоб зберегти файл на своєму комп'ютері.",
      ],
      "Name doesn't match": ["Ім'я не збігається"],
      "Faild to delete the account.": ["Не вдалося видалити рахунок."],
      "Not enough permission to delete the account.": [
        "Недостатньо прав для видалення облікового запису.",
      ],
      "The username was not found.": ["Ім'я користувача не знайдено."],
      "Can't delete a reserved username.": [
        "Не можна видалити зарезервоване ім'я користувача.",
      ],
      "Can't delete an account with balance different than zero.": [
        "Не можна видалити обліковий запис з балансом, відмінним від нуля.",
      ],
      "Account deletion": ["Видалення рахунку"],
      "there was an error reading the balance": [
        "сталася помилка під час читання балансу",
      ],
      "Can't delete the account": ["Не вдається видалити обліковий запис"],
      "The account can't be deleted while still holding some balance. First make sure that the owner makes a complete cashout.":
        [
          "Обліковий запис не можна видалити, поки на ньому є баланс. Спочатку переконайтеся, що власник зробив повну виплату готівкою.",
        ],
      "Go back": [""],
      "All account data will be permanently removed.": [""],
      "Verification": ["Підтвердження"],
      "Enter the account name that is going to be deleted": [
        "Введіть назву рахунку, який буде видалено",
      ],
      "Withdraw without setting amount": ["Зняття без вказання суми"],
      "Show install wallet first": [
        "Спочатку показати, як встановити гаманець",
      ],
      "Introduction": ["Вступ"],
      "Bank": ["Банк"],
      "Essay Shop": ["Магазин есе"],
      "Donations": ["Пожертви"],
      "GNU Taler logo": ["Логотип GNU Taler"],
      "Withdraw toy currency into your GNU Taler wallet.": [
        "Виведіть тестову валюту у свій гаманець GNU Taler.",
      ],
      "Demo pages": ["Демонстраційні сторінки"],
      "You were signed out locally, but the bank could not confirm that the server token was revoked. Close other sessions or sign in again to review active tokens.":
        [
          "Ви вийшли із системи локально, але банк не зміг підтвердити відкликання серверного токена. Закрийте інші сеанси або ввійдіть знову, щоб перевірити активні токени.",
        ],
      "Dismiss": ["Закрити"],
      "Public accounts": ["Публічні рахунки"],
      "Open interface preferences": ["Відкрити налаштування інтерфейсу"],
      "Interface preferences": ["Налаштування інтерфейсу"],
      "Choose how this bank interface behaves on this browser.": [
        "Виберіть, як цей інтерфейс банку працюватиме в цьому браузері.",
      ],
      "Close interface preferences": ["Закрити налаштування інтерфейсу"],
      "Show debug information": ["Показати налагоджувальну інформацію"],
      "Done": ["Готово"],
      "Welcome": ["Вітаємо"],
      "Welcome, %1$s": ["Вітаємо, %1$s"],
      "Failed to load conversion rate.": [
        "Не вдалося завантажити обмінний курс.",
      ],
      "Not enough permission to access the conversion rate list.": [
        "Недостатньо прав для доступу до списку обмінних курсів.",
      ],
      "Conversion list not implemented.": [
        "Список конвертацій не реалізовано.",
      ],
      "Conversion rate classes": ["Класи обмінного курсу"],
      "Configure different cash-in and cashout terms for groups of accounts.": [
        "",
      ],
      "Default conversion rate": ["Типовий курс конвертації"],
      "Create conversion rate class": ["Створити клас обмінного курсу"],
      "Name": ["Назва"],
      "Description": ["Опис"],
      "Cashin": ["Внесення готівки"],
      "First page": ["Перша сторінка"],
      "Next": ["Далі"],
      "min:": ["мін:"],
      "fee:": ["комісія:"],
      "only admin can setup conversion": [
        "лише адміністратор може налаштовувати конвертацію",
      ],
      "Failed to calculate cashout fee.": [
        "Не вдалося розрахувати комісію за виплату готівкою.",
      ],
      "Failed to update the conversion rate.": [
        "Не вдалося оновити обмінний курс.",
      ],
      "Wrong credentials": ["Неправильні облікові дані"],
      "Conversion is disabled": ["Конвертація вимкнена"],
      "Review the default terms or choose a direction to update its settings.":
        [""],
      "Details": ["Деталі"],
      "Bad ratios": ["Неправильні співвідношення"],
      "Initial amount": ["Початкова сума"],
      "Use it to test how the conversion will affect the amount.": [
        "Використайте це, щоб перевірити, як конвертація вплине на суму.",
      ],
      "Sending to this bank": ["Надсилання до цього банку"],
      "Converted": ["Конвертовано"],
      "Cashin after fee": ["Внесення готівки після комісії"],
      "Sending from this bank": ["Надсилання з цього банку"],
      "Cashout after fee": ["Виплата готівкою після комісії"],
      "Bad configuration": ["Неправильна конфігурація"],
      "This configuration allows users to cash out more of what has been cashed in.":
        [
          "Ця конфігурація дозволяє користувачам виводити готівкою більше, ніж було внесено.",
        ],
      "Must be > 0": ["Має бути > 0"],
      "Ratio": ["Співвідношення"],
      "Zero": ["До нуля"],
      "Up": ["Вгору"],
      "Nearest": ["До найближчого"],
      "Minimum amount": ["Мінімальна сума"],
      "Only cashout operations above this threshold will be allowed.": [
        "Дозволені лише операції виплати готівкою, що перевищують цей поріг.",
      ],
      "Conversion ratio between currencies": [
        "Коефіцієнт конвертації між валютами",
      ],
      "Example conversion": ["Приклад конвертації"],
      "1 %1$s will be converted into %2$s %3$s": [
        "1 %1$s буде конвертовано в %2$s %3$s",
      ],
      "Tiny amount": ["Мінімальна одиниця"],
      "Rounding mode": ["Режим округлення"],
      "Amount will be rounded below to the largest possible value smaller than the input.":
        [
          "Сума буде округлена вниз до найбільшого можливого значення, меншого за введене.",
        ],
      "Amount will be rounded up to the smallest possible value larger than the input.":
        [
          "Сума буде округлена вгору до найменшого можливого значення, більшого за введене.",
        ],
      "Amount will be rounded to the closest possible value.": [
        "Сума буде округлена до найближчого можливого значення.",
      ],
      'If none specified the fallback value is "%1$s ".': [
        'Якщо не вказано, резервне значення — "%1$s ".',
      ],
      "Examples": ["Приклади"],
      "Rounding an amount of 1.24 with rounding value 0.1": [
        "Округлення суми 1.24 зі значенням округлення 0.1",
      ],
      "Given the rounding value of 0.1 the possible values closest to 1.24 are: 1.1, 1.2, 1.3, 1.4.":
        [
          "При значенні округлення 0.1 можливі значення, найближчі до 1.24: 1.1, 1.2, 1.3, 1.4.",
        ],
      'With the "zero" mode the value will be rounded to 1.2': [
        'У режимі "до нуля" значення буде округлено до 1.2',
      ],
      'With the "nearest" mode the value will be rounded to 1.2': [
        'У режимі "до найближчого" значення буде округлено до 1.2',
      ],
      'With the "up" mode the value will be rounded to 1.3': [
        'У режимі "вгору" значення буде округлено до 1.3',
      ],
      "Rounding an amount of 1.26 with rounding value 0.1": [
        "Округлення суми 1.26 зі значенням округлення 0.1",
      ],
      'With the "nearest" mode the value will be rounded to 1.3': [
        'У режимі "до найближчого" значення буде округлено до 1.3',
      ],
      "Rounding an amount of 1.24 with rounding value 0.3": [
        "Округлення суми 1.24 зі значенням округлення 0.3",
      ],
      "Given the rounding value of 0.3 the possible values closest to 1.24 are: 0.9, 1.2, 1.5, 1.8.":
        [
          "При значенні округлення 0.3 можливі значення, найближчі до 1.24: 0.9, 1.2, 1.5, 1.8.",
        ],
      'With the "up" mode the value will be rounded to 1.5': [
        'У режимі "вгору" значення буде округлено до 1.5',
      ],
      "Rounding an amount of 1.26 with rounding value 0.3": [
        "Округлення суми 1.26 зі значенням округлення 0.3",
      ],
      "Amount to be deducted before amount is credited.": [
        "Сума, яка вираховується перед зарахуванням.",
      ],
      "Failed to load conversion details.": [
        "Не вдалося завантажити дані конвертації.",
      ],
      "Conversion should be enabled in the configuration, the conversion rate should be initialized with fee(s), rates and a rounding mode.":
        [
          "Конвертацію потрібно увімкнути в конфігурації, обмінний курс має бути ініціалізований з комісією(ями), курсами та режимом округлення.",
        ],
      "Failed to delete conversion rate class": [
        "Не вдалося видалити клас обмінного курсу",
      ],
      "Unauthorized": ["Не авторизовано"],
      "Forbidden": ["Заборонено"],
      "Failed to update conversion rate class.": [
        "Не вдалося оновити клас обмінного курсу.",
      ],
      "Not Found": ["Не знайдено"],
      "Not implemented": ["Не реалізовано"],
      "The name of the conversion is already used.": [
        "Назва конвертації вже використовується.",
      ],
      "Accounts": ["Рахунки"],
      "identification": ["ідентифікація"],
      "Users": ["Користувачі"],
      "Delete": ["Видалити"],
      "Failed to calculate the cashout fee.": [
        "Не вдалося розрахувати комісію за виплату готівкою.",
      ],
      "Can't remove the conversion rate class": [
        "Неможливо видалити клас обмінного курсу",
      ],
      "There are some users associated with this class. You need to remove them first.":
        [
          "З цим класом пов'язані деякі користувачі. Спочатку потрібно видалити їх.",
        ],
      "You are going to remove the conversion rate class": [
        "Ви збираєтеся видалити клас обмінного курсу",
      ],
      "This step can't be undone.": ["Цей крок не можна скасувати."],
      "Class": ["Клас"],
      "Action": ["Дія"],
      "Failed to update conversion class membership.": [
        "Не вдалося оновити належність до класу конвертації.",
      ],
      "The account could not be updated. Please try again.": [
        "Не вдалося оновити рахунок. Спробуйте ще раз.",
      ],
      "Conversion rate information is unavailable for these accounts.": [
        "Для цих рахунків недоступні відомості про курс конвертації.",
      ],
      "Failed to load users in conversion class.": [
        "Не вдалося завантажити користувачів у класі конвертації.",
      ],
      "Filters": ["Фільтри"],
      "Show from other classes": ["Показати з інших класів"],
      "Account": ["Рахунок"],
      "Group ID": ["ID групи"],
      "No users in this conversion rate class": [
        "У цьому класі обмінного курсу немає користувачів",
      ],
      "Remove": ["Видалити"],
      "Add": ["Додати"],
      "Conversion rate name": ["Назва обмінного курсу"],
      "Short description of the class": ["Короткий опис класу"],
      "Failed to create conversion class.": [
        "Не вдалося створити клас конвертації.",
      ],
      "New conversion rate class": ["Новий клас обмінного курсу"],
      "Create a named set of conversion terms that can be assigned to accounts.":
        [""],
      "Failed to load public accounts.": [
        "Не вдалося завантажити публічні рахунки.",
      ],
      "Browse transaction histories shared by public bank accounts.": [
        "Переглядайте історію транзакцій, опубліковану власниками банківських рахунків.",
      ],
      "No public accounts are available.": [
        "Немає доступних публічних рахунків.",
      ],
      "View previous cashouts": ["Показати попередні виведення коштів"],
      "Failed to load cashout details.": [
        "Не вдалося завантажити дані виплати готівкою.",
      ],
      "Amounts recorded for this completed cashout transfer.": [""],
      "Enter your full name.": ["Введіть повне ім’я."],
      "Repeat your password.": ["Повторіть пароль"],
      "Create your bank account": ["Створити обліковий запис"],
      "Choose the credentials you will use to sign in.": [
        "Виберіть облікові дані, які використовуватимете для входу.",
      ],
      "Already have an account?": ["Уже маєте рахунок?"],
      "Confirm password": ["Підтвердьте пароль"],
      "Use between 8 and 64 characters. A longer, unique password is easier to keep secure.":
        [
          "Використовуйте від 8 до 64 символів. Довший унікальний пароль легше зберігати в безпеці.",
        ],
      "Creating account…": ["Створення рахунку…"],
      "Check the account details and try again.": [
        "Перевірте дані рахунку та повторіть спробу.",
      ],
      "You are not authorized to create this account.": [
        "Ви не маєте прав для створення цього рахунку.",
      ],
      "Registration is unavailable because the bank cannot grant the account credit.":
        ["Реєстрація недоступна, оскільки банк не може надати рахунку кредит."],
      "That username is reserved. Choose another username.": [
        "Це ім’я користувача зарезервовано. Виберіть інше.",
      ],
      "That username is already taken.": ["Це ім'я користувача вже зайняте."],
      "That account ID is already taken.": ["Цей ID рахунку вже зайнято."],
      "The bank is missing information for the selected authentication channel.":
        ["Немає інформації про обраний канал автентифікації."],
      "The selected authentication channel is not supported.": [
        "Канал автентифікації не підтримується.",
      ],
      "Only an administrator may set the debt limit.": [
        "Лише адміністратор може встановлювати ліміт заборгованості.",
      ],
      "Only an administrator may select a conversion rate class.": [
        "Лише адміністратор може вибрати клас обмінного курсу.",
      ],
      "The selected conversion rate class does not exist.": [
        "Клас обмінного курсу не існує.",
      ],
      "Only an administrator may enable two-factor authentication while creating an account.":
        [
          "Лише адміністратор може ввімкнути двофакторну автентифікацію під час створення рахунку.",
        ],
      "Account registration is unavailable": ["Реєстрація облікового запису"],
      "This bank is not accepting new account registrations.": [
        "Наразі банк не приймає нові реєстрації!",
      ],
      "Return to sign in": ["Повернутися до входу"],
      "Contact the bank administrator if you need an account.": [
        "Зверніться до адміністратора банку.",
      ],
      "Failed to load withdrawal details.": [
        "Не вдалося завантажити дані зняття.",
      ],
      "Abort this withdrawal?": ["Скасувати це зняття?"],
      "This stops the withdrawal. No money will be transferred, and this operation cannot be resumed.":
        [
          "Зняття буде скасовано. Гроші не буде переказано, і цю операцію не можна буде відновити.",
        ],
      "Keep withdrawal": ["Не скасовувати зняття"],
      "Abort withdrawal": ["Скасувати зняття"],
      'The payto URI returned by the server is invalid: "%1$s".': [
        'URI payto, повернений сервером, є недійсним: "%1$s".',
      ],
      'The withdrawal URI returned by the server is invalid: "%1$s".': [
        'URI виведення коштів, повернений сервером, є недійсним: "%1$s".',
      ],
      'The reserve public key returned by the server is invalid: "%1$s".': [
        'Відкритий ключ резерву, повернений сервером, є недійсним: "%1$s".',
      ],
      "Enter an amount.": ["Введіть суму."],
      "Enter a valid amount.": ["Введіть коректну суму."],
      "The amount must be greater than zero.": [
        "Сума має бути більшою за нуль.",
      ],
      "The amount is below the bank's minimum.": [
        "Сума менша за встановлений банком мінімум.",
      ],
      "The amount is above the bank's maximum.": [
        "Сума перевищує встановлений банком максимум.",
      ],
      "Failed to abort the withdrawal.": ["Не вдалося скасувати зняття."],
      "The server did not understand the request.": [
        "Сервер не зрозумів запит.",
      ],
      "The operation was not found.": ["Операцію не знайдено."],
      "The withdrawal operation has already been confirmed and cannot be aborted.":
        ["Операцію зняття вже підтверджено, і її не можна скасувати."],
      "The bank could not be reached. Please try again.": [
        "Не вдалося зв’язатися з банком. Повторіть спробу.",
      ],
      "Withdrawal confirmation": ["Підтвердження зняття"],
      "Failed to confirm the withdrawal.": ["Не вдалося підтвердити зняття."],
      "The account does not have sufficient funds or the amount is outside the limits.":
        ["На рахунку недостатньо коштів або сума виходить за межі лімітів."],
      "The withdrawal has been aborted and cannot be confirmed.": [
        "Зняття було скасовано і не може бути підтверджено.",
      ],
      "The wallet has not finished selecting an exchange account.": [
        "Гаманець ще не завершив вибір рахунку обмінника.",
      ],
      "The withdrawal amount changed. Review the current amount and try again.":
        ["Сума зняття змінилася. Перевірте поточну суму й повторіть спробу."],
      "Enter an amount before confirming the withdrawal.": [
        "Перед підтвердженням зняття введіть суму.",
      ],
      "Selected exchange": ["Вибраний обмінник"],
      "Sign in to confirm the withdrawal": ["Увійдіть, щоб підтвердити зняття"],
      "Sign in as %1$s before reviewing and confirming this withdrawal.": [
        "Увійдіть як %1$s, перш ніж перевіряти й підтверджувати це зняття.",
      ],
      "You are signed in as %1$s, but this withdrawal belongs to %2$s.": [
        "Ви ввійшли як %1$s, але це зняття належить обліковому запису %2$s.",
      ],
      "Finish later": ["Завершити пізніше"],
      "Confirm wallet withdrawal": ["Підтвердити зняття в гаманець"],
      "Review how much will leave your bank account before confirming.": [
        "Перед підтвердженням перевірте суму, яку буде списано з банківського рахунку.",
      ],
      "Unsupported exchange account": ["Непідтримуваний рахунок обмінника"],
      "The exchange account does not use the transfer type configured by this bank. This withdrawal cannot be confirmed.":
        [
          "Рахунок обмінника не використовує тип переказу, налаштований цим банком. Це зняття не можна підтвердити.",
        ],
      "Withdrawal amount missing": ["Не вказано суму зняття"],
      "The bank did not provide an amount for this withdrawal. It cannot be confirmed.":
        ["Банк не вказав суму для цього зняття. Його не можна підтвердити."],
      "Bank amount configuration invalid": [
        "Налаштування сум у банку некоректне",
      ],
      "The withdrawal amount and bank fee could not be combined safely. This withdrawal cannot be confirmed.":
        [
          "Суму зняття та комісію банку неможливо безпечно додати. Це зняття не можна підтвердити.",
        ],
      "Wallet receives": ["Гаманець отримає"],
      "Amount to your Taler Wallet": ["Сума для гаманця Taler"],
      "Allowed amount": ["Допустима сума"],
      "Maximum amount": ["Максимальна сума"],
      "Amount unavailable": ["Сума недоступна"],
      "From": ["З рахунку"],
      "To": ["Одержувач"],
      "Taler Wallet": ["Гаманець Taler"],
      "Exchange": ["Обмінник"],
      "Unavailable": ["Недоступно"],
      "Exchange details": ["Відомості про обмінник"],
      "Exchange IBAN": ["IBAN обмінника"],
      "Bank hostname": ["Ім’я сервера банку"],
      "Exchange account": ["Рахунок обмінника"],
      "No money is withdrawn until you confirm. You can finish this later from your account overview.":
        [
          "Гроші не буде знято до підтвердження. Ви можете завершити пізніше на сторінці огляду рахунку.",
        ],
      "Confirm withdrawal": ["Підтвердити зняття"],
      "Unauthorized to make the operation, maybe the session has expired or the password changed.":
        [
          "Не авторизовано для виконання операції, можливо, сесія закінчилася або пароль було змінено.",
        ],
      "The operation was rejected due to insufficient funds.": [
        "Операцію було відхилено через недостатність коштів.",
      ],
      "Withdrawal aborted": ["Виведення коштів скасовано"],
      "Withdrawal confirmed": ["Зняття коштів підтверджено"],
      "The bank transfer to the Taler exchange has been initiated. Your Taler Wallet will receive the withdrawn amount shortly.":
        [
          "Банківський переказ до обмінника Taler ініційовано. Знята сума незабаром надійде до вашого гаманця Taler.",
        ],
      "Back to account": ["Повернутися до рахунку"],
      "Complete withdrawal with your Taler Wallet": [
        "Завершіть зняття за допомогою гаманця Taler",
      ],
      "Scan this QR code with your Taler Wallet. Your wallet will select an exchange and prepare the withdrawal.":
        [
          "Відскануйте цей QR-код гаманцем Taler. Гаманець вибере обмінник і підготує зняття.",
        ],
      "Withdrawal amount": ["Сума зняття"],
      "Suggested amount": ["Запропонована сума"],
      "You can change this amount in your wallet.": [
        "Цю суму можна змінити в гаманці.",
      ],
      "QR code to continue the withdrawal in a Taler Wallet.": [
        "QR-код для продовження зняття в гаманці Taler.",
      ],
      "Open Taler Wallet manually": ["Відкрити гаманець Taler вручну"],
      "Don't have a Taler Wallet?": ["У вас немає гаманця Taler?"],
      "Get a wallet": ["Отримати гаманець"],
      "No money will be transferred until you return here to review and confirm the withdrawal.":
        [
          "Гроші не буде переказано, доки ви не повернетеся сюди, щоб перевірити й підтвердити зняття.",
        ],
      "Sign in to abort this withdrawal": ["Увійдіть, щоб скасувати це зняття"],
      "The withdrawal operation has been confirmed previously and can not be aborted.":
        [
          "Операцію зняття вже було підтверджено раніше, і її не можна скасувати.",
        ],
      "Withdrawal ready for confirmation": ["Зняття готове до підтвердження"],
      "Withdrawal waiting for your wallet": [
        "Операція зняття очікує дій у гаманці",
      ],
      "The pending withdrawal could not be checked": [
        "Не вдалося перевірити очікувану операцію зняття",
      ],
      "Checking the pending withdrawal…": [
        "Перевірка очікуваної операції зняття…",
      ],
      "Review withdrawal": ["Перевірити зняття"],
      "Retry": ["Повторити"],
      "Resume withdrawal": ["Відновити зняття"],
      "Finish or abort this withdrawal before starting another one.": [
        "Завершіть або скасуйте це зняття, перш ніж починати нове.",
      ],
      "Dashboard": ["Панель керування"],
      "Admin activity": ["Активність адміністратора"],
      "Conversion": ["Конвертація"],
      "My account": ["Мій рахунок"],
      "Bank administration": ["Керування банком"],
      "Failed to load the account list.": [
        "Не вдалося завантажити список рахунків.",
      ],
      "Search accounts": ["Пошук рахунків"],
      "Search by username or name": ["Пошук за іменем користувача або ім’ям"],
      "Search": ["Пошук"],
      "Clear": ["Очистити"],
      "Unknown": ["Невідомо"],
      "Change password": ["Змінити пароль"],
      "Previous": ["Попередня"],
      "The amount exceeds what is available to withdraw.": [""],
      "The server replied with an invalid taler://withdraw URI": [
        "Сервер повернув недійсний URI taler://withdraw",
      ],
      "Withdraw URI: %1$s": ["URI для зняття коштів: %1$s"],
      "Failed to create the withdrawal.": ["Не вдалося створити зняття."],
      "The operation was rejected due to insufficient funds": [
        "Операцію було відхилено через брак коштів",
      ],
      "Please sign in again.": ["Увійдіть знову."],
      "The bank's withdrawal limits or fee are configured incorrectly.": [""],
      "Maximum withdrawal": ["Максимальна сума зняття"],
      "There is not enough available balance to cover a withdrawal and the bank fee.":
        [""],
      "Dismiss wallet installation hint": [""],
      "Unable to start a withdrawal.": ["Не вдалося почати виведення коштів."],
      "Your account was created. Sign in to continue.": [
        "Рахунок створено. Увійдіть, щоб продовжити.",
      ],
      "Home": ["Головна"],
      "Page not found": ["Сторінку не знайдено"],
      "The requested bank page does not exist.": [
        "Запитана сторінка банку не існує.",
      ],
      "Unknown challenge.": ["Невідомий виклик."],
      "Failed to validate the verification code.": [
        "Не вдалося перевірити код підтвердження.",
      ],
      "Too many challenges are active. Wait or confirm an existing challenge.":
        [
          "Наразі активно забагато викликів, потрібно зачекати або підтвердити поточні виклики.",
        ],
      "The verification code is incorrect.": [
        "Код підтвердження неправильний.",
      ],
      "The verification code has expired.": [
        "Термін дії коду підтвердження минув.",
      ],
      "Submit the transmitted code number.": ["Надішліть переданий код."],
      "The verification code sent to the email address starting with %1$s": [
        "Код підтвердження надіслано на email-адресу, що починається з %1$s",
      ],
      "The verification code sent to the phone number ending with %1$s": [
        "Код підтвердження надіслано на номер телефону, що закінчується на %1$s",
      ],
      "Code": ["Код"],
      "Authentication code": ["Код автентифікації"],
      "It will expire at %1$s": ["Термін дії закінчиться о %1$s"],
      "This challenge is terminal and cannot be retransmitted.": [
        "Цей запит автентифікації завершено, і його неможливо надіслати повторно.",
      ],
      "Restart authentication": ["Перезапустити автентифікацію"],
      "Back": ["Назад"],
      "Verifying…": ["Перевірка…"],
      "Verify": ["Перевірити"],
      "Complete": ["Завершити"],
      "Failed to start the challenge.": ["Не вдалося розпочати виклик."],
      "Unable to send the verification code.": [
        "Не вдалося надіслати код підтвердження.",
      ],
      "The request was valid, but the server is refusing action.": [
        "Запит був дійсним, але сервер відмовляється виконувати дію.",
      ],
      "The backend is not aware of the specified MFA challenge.": [
        "Бекенд не знає про вказаний виклик MFA.",
      ],
      "It is too early to request another transmission of the challenge.": [
        "Занадто рано для повторного надсилання виклику.",
      ],
      "Code transmission failed.": ["Не вдалося надіслати код."],
      "Multi-factor authentication required": [
        "Потрібна багатофакторна автентифікація",
      ],
      "This operation is protected with second factor authentication. In order to complete it we need to verify your identity using the authentication channel you provided.":
        [
          "Ця операція захищена двофакторною автентифікацією. Щоб завершити її, нам потрібно підтвердити вашу особу за допомогою наданого вами каналу автентифікації.",
        ],
      "The next challenge needs to be completed to confirm the operation.": [
        "Щоб підтвердити операцію, потрібно виконати наступний виклик.",
      ],
      "All the next challenges need to be completed to confirm the operation.":
        ["Щоб підтвердити операцію, потрібно виконати всі наступні виклики."],
      "One of the next challenges needs to be completed to confirm the operation.":
        [
          "Щоб підтвердити операцію, потрібно виконати один із наступних викликів.",
        ],
      'To a phone ending with "%1$s"': [
        'На телефон, що закінчується на "%1$s"',
      ],
      'To an email starting with " %1$s"': [
        'На email, що починається з " %1$s"',
      ],
      "I have a code": ["У мене є код"],
      "Send me a message": ["Надіслати мені повідомлення"],
      "You have to wait until %1$s to send a new code.": [
        "Вам потрібно зачекати до %1$s, щоб надіслати новий код.",
      ],
      "Use configured value (enabled)": [
        "Використовувати налаштоване значення (увімкнено)",
      ],
      "Use configured value (disabled)": [
        "Використовувати налаштоване значення (вимкнено)",
      ],
      "Force enabled": ["Примусово увімкнути"],
      "Force disabled": ["Примусово вимкнути"],
      "Enter a valid HTTP or HTTPS URL.": [
        "Введіть дійсну HTTP- або HTTPS-адресу.",
      ],
      "Development settings": ["Налаштування для розробки"],
      "These overrides are stored only in this browser.": [
        "Ці перевизначення зберігаються лише в цьому браузері.",
      ],
      "Corebank API base URL": ["Базова URL-адреса API Corebank"],
      "Leave empty to use the configured URL: %1$s": [
        "Залиште поле порожнім, щоб використовувати налаштовану URL-адресу: %1$s",
      ],
      "Leave empty to derive the URL from this page.": [
        "Залиште поле порожнім, щоб визначити URL-адресу з цієї сторінки.",
      ],
      "Demo header": ["Заголовок демоверсії"],
      "Control whether the demo header is shown in this browser.": [
        "Визначає, чи відображається заголовок демоверсії в цьому браузері.",
      ],
      "Control whether public account links are shown in this browser.": [
        "Визначає, чи відображаються посилання на публічні рахунки в цьому браузері.",
      ],
      "Overrides saved.": ["Перевизначення збережено."],
      "Apply overrides": ["Застосувати перевизначення"],
      "Clear overrides": ["Очистити перевизначення"],
      "Back to bank": ["Назад до банку"],
    },
  },
  domain: "messages",
  plural_forms:
    "nplurals=3; plural=n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2;",
  lang: "uk",
  completeness: 87,
};

strings["ru"] = {
  locale_data: {
    messages: {
      "": {
        domain: "messages",
        lang: "ru",
        plural_forms:
          "nplurals=3; plural=n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2;",
      },
      "Hide password": ["Скрыть пароль"],
      "Show password": ["Показать пароль"],
      "Hide": ["Скрыть"],
      "Show": ["Показать"],
      "Identity verification.": ["Проверка личности."],
      "You do not have permission to access this account.": [
        "У вас нет прав доступа к этому счёту.",
      ],
      "This account is locked. Contact the bank administrator.": [
        "Счёт заблокирован, вход невозможен. Обратитесь к администратору.",
      ],
      "The password is incorrect.": ["Неверный пароль."],
      "Account not found.": ["Учётная запись не найдена"],
      "Could not reach the bank. Check your connection and try again.": [
        "Не удалось связаться с банком. Проверьте соединение и повторите попытку.",
      ],
      "Confirm your password": ["Подтвердите пароль"],
      "Sign in to %1$s": ["Войти в %1$s"],
      "Enter the password for %1$s to continue.": [
        "Введите пароль для %1$s, чтобы продолжить.",
      ],
      "Use your bank account credentials to continue.": [
        "Для продолжения используйте данные своего банковского счёта.",
      ],
      "Need an account?": ["Нужен счёт?"],
      "Create one": ["Создать учётную запись"],
      "Your session expired. Confirm your password to continue.": [
        "Срок действия сеанса истёк. Подтвердите пароль, чтобы продолжить.",
      ],
      "Username": ["Имя пользователя"],
      "Password": ["Пароль"],
      "Sign out": ["Выйти"],
      "Signing in…": ["Выполняется вход…"],
      "Continue": ["Продолжить"],
      "Sign in": ["Войти"],
      "Enter your username.": ["Введите имя пользователя."],
      "Use letters, numbers, or any of these characters: - . _ ~": [
        "Используйте буквы, цифры или любой из следующих символов: - . _ ~",
      ],
      "The username must not exceed 126 characters.": [
        "Имя пользователя не должно превышать 126 символов.",
      ],
      "Enter your password.": ["Введите пароль."],
      "The password must contain at least 8 characters.": [
        "Пароль слишком короткий. Не может содержать менее 8 символов.",
      ],
      "The password must not exceed %1$s characters.": [
        "Пароль не должен превышать %1$s символов.",
      ],
      "IBAN country code not found": ["Код страны IBAN не найден"],
      "IBAN length is invalid for this country": [
        "Длина IBAN недопустима для этой страны",
      ],
      "The IBAN contains invalid characters": [
        "IBAN содержит недопустимые символы",
      ],
      "IBAN number is not valid, checksum is wrong": [
        "Номер IBAN недействителен, контрольная сумма неверна",
      ],
      "The IBAN is not valid": ["IBAN недействителен"],
      "Use letters, numbers or any of these characters: - . _ ~": [
        "Используйте буквы, цифры или любой из следующих символов: - . _ ~",
      ],
      "Failed to load cashouts.": ["Не удалось загрузить выплаты."],
      "Try again": ["Повторить попытку"],
      "Cashout is disabled": ["Выплата отключена"],
      "Cashout should be enabled in the configuration, the conversion rate should be initialized with fee(s), rates and a rounding mode.":
        [
          "Выплата должна быть включена в конфигурации, а обменный курс — инициализирован с комиссией(-ями), ставками и режимом округления.",
        ],
      "Failed to load conversion rate information.": [
        "Не удалось загрузить информацию об обменном курсе.",
      ],
      "Some cashout details could not be loaded.": [
        "Не удалось загрузить некоторые сведения о выплатах.",
      ],
      "The partial list omits cashout IDs: %1$s.": [
        "В неполном списке отсутствуют идентификаторы выплат: %1$s.",
      ],
      "Debited": ["Дебетировано"],
      "Transferred": ["Переведено"],
      "Created": ["Создано"],
      "Actions": ["Действия"],
      "Cashout history": ["История вывода средств"],
      "Profile": ["Профиль"],
      "Security": ["Безопасность"],
      "Merchant integration": ["Интеграция с продавцом"],
      "Back to overview": ["Вернуться к обзору"],
      "My account settings": ["Настройки моего счёта"],
      "Copy": ["Копировать"],
      "Failed to load account details.": ["Не удалось загрузить данные счёта."],
      'Use this information to link your Taler Merchant Backoffice account with the current bank account. You can start by copying the values, then go to your merchant backoffice service provider, login into your account and look for the "import" button in the "bank account" section.':
        [
          'Используйте эту информацию, чтобы связать ваш счёт Taler Merchant Backoffice с текущим банковским счётом. Начните с копирования значений, затем перейдите к поставщику услуг Merchant Backoffice, войдите в свой счёт и найдите кнопку "Импорт" в разделе "Банковский счёт".',
        ],
      "Not available": ["Недоступно"],
      "Merchant integration is not available for this account.": [
        "Интеграция с продавцом недоступна для этого счёта.",
      ],
      "Account type": ["Тип счёта"],
      "Method to use for wire transfer.": [
        "Способ выполнения банковского перевода.",
      ],
      "IBAN": ["IBAN"],
      "International Bank Account Number.": [
        "Международный номер банковского счёта (IBAN).",
      ],
      "Bank host": ["Сервер банка"],
      "Bank host where the service is located.": [
        "Хост банка, на котором расположена служба.",
      ],
      "Account name": ["Название счёта"],
      "Bank account identifier for wire transfers.": [
        "Идентификатор банковского счёта для переводов.",
      ],
      "Address": ["Адрес"],
      "Bitcoin address for this account.": ["Биткойн-адрес этого счёта."],
      "Account address": ["Адрес счёта"],
      "Owner's name": ["Имя владельца"],
      "Legal name of the person holding the account.": [
        "Юридическое имя владельца счёта.",
      ],
      "Account info URL": ["URL информации о счёте"],
      "From where the merchant can download information about incoming wire transfers to this account.":
        [
          "Откуда продавец может загружать информацию о входящих банковских переводах на этот счёт.",
        ],
      "Unable to create a cashout": ["Не удается создать выплату"],
      "The bank configuration does not support cashout operations.": [
        "Конфигурация банка не поддерживает операции выплаты.",
      ],
      "Close": ["Закрыть"],
      "The bank returned incomplete conversion information.": [
        "Банк вернул неполные сведения о конвертации.",
      ],
      "Please contact the bank administrator.": [
        "Обратитесь к администратору банка.",
      ],
      "Authentication required": ["Требуется аутентификация"],
      "Please sign in to create a cashout.": [
        "Войдите, чтобы создать выплату.",
      ],
      "Failed to calculate the conversion fee.": [
        "Не удалось рассчитать комиссию за конвертацию.",
      ],
      "The amount is too small": ["Сумма слишком мала"],
      "Conversion is not implemented.": ["Конвертация не реализована."],
      "The currency is not supported": ["Валюта не поддерживается"],
      "Required": ["Обязательно"],
      "Invalid": ["Недействительно"],
      "The balance is not sufficient": ["Недостаточно средств на балансе"],
      "It is not possible to cash out less than %1$s: %2$s": [
        "Невозможно выполнить выплату на сумму менее %1$s: %2$s",
      ],
      "The total transfer to the destination will be zero": [
        "Итоговый перевод получателю будет равен нулю",
      ],
      "Failed to create the cashout.": ["Не удалось создать выплату."],
      "Cashout": ["Выплата"],
      "Account not found": ["Учётная запись не найдена"],
      "Duplicate request detected, check if the operation succeeded or try again.":
        [
          "Обнаружен дубликат запроса, проверьте, успешно ли выполнена операция, или повторите попытку.",
        ],
      "The conversion rate was applied incorrectly": [
        "Обменный курс был применён неверно",
      ],
      "The account does not have sufficient funds": [
        "На счете недостаточно средств",
      ],
      "Missing cashout URI in the profile": [
        "Отсутствующий URI выплат в профиле",
      ],
      "The amount is below the minimum amount permitted.": [
        "Сумма ниже минимально допустимой.",
      ],
      "Sending the confirmation message failed, retry later or contact the administrator.":
        [
          "Не удалось отправить сообщение с подтверждением, повторите попытку позже или обратитесь к администратору.",
        ],
      "The server doesn't support the current TAN channel.": [
        "Сервер не поддерживает текущий канал TAN.",
      ],
      "Conversion rate": ["Обменный курс"],
      "Balance": ["Баланс"],
      "Fee": ["Комиссия"],
      "No fee": ["Без комиссии"],
      "To account": ["На счёт"],
      "Legal name": ["Юридическое имя"],
      "If this name doesn't match the account holder's name, your transaction may fail.":
        [
          "Если это имя не совпадает с именем владельца счёта, ваша транзакция может завершиться неудачей.",
        ],
      "Unable to cash out": ["Невозможно выполнить выплату"],
      "Before being able to cash out to a bank account, you need to complete your profile":
        [
          "Прежде чем выполнить выплату на банковский счёт, необходимо заполнить профиль",
        ],
      "Send %1$s": ["Отправить %1$s"],
      "Receive %1$s": ["Получить %1$s"],
      "Amount": ["Сумма"],
      "Total cost": ["Общая стоимость"],
      "Balance left": ["Остаток баланса"],
      "Before fee": ["Комиссия до"],
      "Total cashout transfer": ["Общий сумма перевода выплаты"],
      "Cancel": ["Отмена"],
      "Cash out": ["Выплата"],
      "Not valid": ["Недействительно"],
      "Does not follow the pattern": ["Не соответствует шаблону"],
      "The request was invalid or the payto://-URI used unacceptable features.":
        [
          "Запрос был неверным или payto://-URI использовал недопустимую функциональность.",
        ],
      "Not enough permission to complete the operation.": [
        "Не хватает разрешения для завершения операции.",
      ],
      "The bank administrator cannot be the transfer creditor.": [
        "Администратор банка не может быть кредитором перевода.",
      ],
      'The destination account "%1$s" was not found.': [
        'Целевой счет "%1$s" не найден.',
      ],
      "The origin and the destination of the transfer can't be the same.": [
        "Пункт отправления и пункт назначения перевода не могут совпадать.",
      ],
      "Your balance is not sufficient for the operation.": [
        "Вашего баланса недостаточно для выполнения операции.",
      ],
      'The origin account "%1$s" was not found.': [
        'Исходный счёт "%1$s" не найден.',
      ],
      "The attempt to create the transaction has failed. Please try again.": [
        "Попытка создать транзакцию не удалась. Пожалуйста, попробуйте снова.",
      ],
      "Confirm transaction.": ["Подтвердите транзакцию."],
      "Transfer details": ["Подробности перевода"],
      "Enter the recipient, a reference, and the amount to send.": [""],
      "Maximum transfer": ["Максимальная сумма перевода"],
      "Debt limit": ["Лимит задолженности"],
      "This is not your account balance. This account cannot go into debt.": [
        "Это не баланс вашего счёта. Для этого счёта задолженность не разрешена.",
      ],
      "This is not your account balance. It includes borrowing up to the debt limit shown here.":
        [
          "Это не баланс вашего счёта. Сумма включает доступный кредит в пределах указанного здесь лимита задолженности.",
        ],
      "Recipient": ["Получатель"],
      "username": ["имя пользователя"],
      "IBAN of the recipient's account": ["IBAN счета получателя"],
      "What is this transfer for?": [""],
      "Paste a payto URI containing the recipient, amount, and transfer reference.":
        [""],
      "Uniform resource identifier of the target account": [
        "Унифицированный идентификатор ресурса (URI) целевого счёта",
      ],
      "payto://x-taler-bank/[bank-host]/[receiver-account]?message=[subject]&amount=[%1$s:X.Y]":
        [
          "payto://x-taler-bank/[oператор банка]/[cчет получателя]?message=[причина платежа]&amount=[%1$s:X.Y]",
        ],
      "payto://iban/[receiver-iban]?message=[subject]&amount=[%1$s:X.Y]": [
        "payto://iban/[iban получателя]?message=[причина платежа]&amount=[%1$s:X.Y]",
      ],
      "Bank fee": ["Комиссия банка"],
      "Total debited": ["Всего списано"],
      "Need to move money out of this bank?": [""],
      'Only "x-taler-bank" targets are supported': [
        'Поддерживаются только цели "x-taler-bank"',
      ],
      'Only this host is allowed. Use "%1$s"': [
        'Разрешён только этот хост. Используйте "%1$s"',
      ],
      "Account name is missing": ["Отсутствует название счёта"],
      'Only "IBAN" targets are supported': [
        'Поддерживаются только цели "IBAN"',
      ],
      'Missing "amount" parameter to specify the amount to be transferred': [
        'Отсутствует параметр "amount" для указания суммы перевода',
      ],
      'The "amount" parameter is not valid': [
        'Параметр "amount" недействителен',
      ],
      '"message" parameters to specify a reference text for the transfer are missing':
        ['Отсутствуют параметры "message" для указания текста перевода'],
      'The only currency allowed is "%1$s"': [
        'Единственная допустимая валюта — "%1$s"',
      ],
      "You cannot transfer an amount of zero.": [
        "Нельзя перевести нулевую сумму.",
      ],
      "Please enter a longer subject": [
        "Пожалуйста, введите более длинную причину",
      ],
      "Email and SMS authentication were disabled because their contact details were removed.":
        [
          "Аутентификация по электронной почте и SMS отключена, поскольку соответствующие контактные данные были удалены.",
        ],
      "Email authentication was disabled because the email address was removed.":
        [
          "Аутентификация по электронной почте отключена, поскольку адрес электронной почты был удалён.",
        ],
      "SMS authentication was disabled because the phone number was removed.": [
        "Аутентификация по SMS отключена, поскольку номер телефона был удалён.",
      ],
      "Invalid email format": ["Неверный формат email"],
      "Should start with +": ["Должен начинаться с +"],
      "A phone number consists of numbers only": [
        "Номер телефона может содержать только цифры",
      ],
      "Login username": ["Имя Пользователя"],
      "Account ID for authentication": [
        "Идентификатор счёта для аутентификации",
      ],
      "Full name": ["Полное имя"],
      "Name of the account holder": ["Имя владельца счёта"],
      "Internal account": ["Внутренний счёт"],
      "Copy and share this account address to receive transfers.": [
        "Скопируйте и передайте этот адрес счёта, чтобы получать переводы.",
      ],
      "Email": ["Email"],
      "To be used when second factor authentication is enabled": [
        "Используется при включённой двухфакторной аутентификации",
      ],
      "Phone": ["Телефон"],
      "Enable second factor authentication": [
        "Включить двухфакторную аутентификацию",
      ],
      "Using email": ["Используя email"],
      "Add an email in your profile to enable this option": [
        "Добавьте email в профиль, чтобы включить эту опцию",
      ],
      "Using SMS": ["Используя SMS"],
      "Add a phone number in your profile to enable this option": [
        "Добавьте номер телефона в профиль, чтобы включить эту опцию",
      ],
      "Cashout account": ["Счёт для выплат"],
      "External account to which cashout transfers are sent.": [""],
      "Max debt": ["Максимальная задолженность"],
      "How much the balance can go below zero.": [
        "Насколько баланс может опускаться ниже нуля.",
      ],
      "Is this account public?": ["Является ли этот счёт общедоступным?"],
      "Public accounts expose their balance and complete transaction history, including subjects and both account addresses, to anonymous visitors.":
        [
          "Публичные счета раскрывают анонимным посетителям свой баланс и полную историю транзакций, включая назначения платежей и адреса обоих счетов.",
        ],
      "Does this account belong to a Payment Service Provider?": [
        "Принадлежит ли этот счёт поставщику платёжных услуг?",
      ],
      "Account updated": ["Счёт обновлён"],
      "Failed to update the account.": ["Не удалось обновить счёт."],
      "The rights to change the account are not sufficient": [
        "Недостаточно прав на изменение счёта",
      ],
      "The username was not found": ["Имя пользователя не найдено"],
      "You can't change the legal name, please contact your account administrator.":
        [
          "Вы не можете изменить официальное имя, обратитесь к администратору вашей учетной записи.",
        ],
      "You can't change the debt limit, please contact your account administrator.":
        [
          "Вы не можете изменить лимит задолженности, обратитесь к администратору счёта.",
        ],
      "You can't change the cashout address, please contact your account administrator.":
        [
          "Вы не можете изменить адрес для выплаты, пожалуйста, свяжитесь с администратором вашего счёта.",
        ],
      "No information for the selected authentication channel.": [
        "Нет информации о выбранном канале аутентификации.",
      ],
      "Account update": ["Обновление счёта"],
      "Authentication channel is not supported.": [
        "Канал аутентификации не поддерживается.",
      ],
      "Only the administrator can change the conversion rate.": [
        "Только администратор может изменять обменный курс.",
      ],
      "The conversion rate class doesn't exist.": [
        "Класс обменного курса не существует.",
      ],
      "The password is too short. Can't have less than 8 characters.": [
        "Пароль слишком короткий. Не может содержать менее 8 символов.",
      ],
      "The password is too long. Can't have more than 64 characters.": [
        "Пароль слишком длинный. Не может содержать более 64 символов.",
      ],
      'Account "%1$s"': ['Счет "%1$s"'],
      "Removed": ["Удалено"],
      "This account can't be used.": ["Этот счёт нельзя использовать."],
      "Account details": ["Данные счёта"],
      "Not configured": ["Не настроено"],
      "Change details": ["Изменение реквизитов"],
      "Update": ["Обновить"],
      "Delete account": ["Удалить счёт"],
      "Permanently remove this bank account. The account must have a zero balance before it can be deleted.":
        [
          "Удалить этот банковский счёт навсегда. Перед удалением баланс счёта должен быть нулевым.",
        ],
      "The passwords do not match.": ["Пароли не совпадают"],
      "Failed to update the password.": ["Не удалось обновить пароль."],
      "Not authorized to change the password, maybe the session is invalid.": [
        "Нет прав на изменение пароля, возможно, сессия недействительна.",
      ],
      "You need to provide the old password. If you don't have it contact your account administrator.":
        [
          "Необходимо указать старый пароль. Если у вас его нет, обратитесь к администратору счёта.",
        ],
      "The current password is incorrect, so the password cannot be changed.": [
        "",
      ],
      "Password update": ["Обновление пароля"],
      "You don't have the rights to change the password.": [
        "У вас нет прав на изменение пароля.",
      ],
      "Update password": ["Обновить пароль"],
      "Current password": ["Текущий пароль"],
      "Your current password, for security": [
        "Ваш текущий пароль, для безопасности",
      ],
      "New password": ["Новый пароль"],
      "Failed to load transactions.": ["Не удалось загрузить транзакции."],
      "Unknown account": ["Неизвестный счёт"],
      "Recent activity": ["Недавняя активность"],
      "Transactions": ["Транзакции"],
      "Subject": ["Причина"],
      "Today": ["Сегодня"],
      "Yesterday": ["Вчера"],
      "Invalid value": ["Недопустимое значение"],
      "View all transactions": ["Показать все транзакции"],
      "No transactions yet.": ["Пока нет транзакций."],
      "Your account activity will appear here.": [
        "Здесь появится активность вашего счёта.",
      ],
      "Date": ["Дата"],
      "Counterparty": ["Контрасчет"],
      "Pagination": ["Постраничная навигация"],
      "Newer": ["Более новые"],
      "Older": ["Более старые"],
      "Withdraw to Taler Wallet": ["Вывести в кошелёк Taler"],
      "Move digital cash to your Taler Wallet.": [
        "Переведите цифровые деньги в свой кошелёк Taler.",
      ],
      "Send bank transfer": ["Отправить банковский перевод"],
      "Transfer money to another bank account.": [
        "Переведите деньги на другой банковский счёт.",
      ],
      "Convert regional currency and send it to your cashout account.": [
        "Конвертируйте региональную валюту и отправьте её на счёт вывода средств.",
      ],
      "Copy account address": ["Копировать адрес счёта"],
      "Current balance": ["Текущий баланс"],
      "Go to account details": ["Перейти к данным счёта"],
      "Failed to load the admin account.": [
        "Не удалось загрузить счёт администратора.",
      ],
      "Admin account": ["Счёт администратора"],
      "Admin account activity": ["Активность счёта администратора"],
      "Failed to load the monitor info.": [
        "Не удалось загрузить данные монитора.",
      ],
      "Failed to load cashout info.": [
        "Не удалось загрузить данные о выплате.",
      ],
      "Querying for the current stats failed": [
        "Запрос текущей статистики завершился ошибкой",
      ],
      "The user is unauthorized": ["Пользователь не авторизован"],
      "Querying for the previous stats failed": [
        "Не удалось запросить предыдущую статистику",
      ],
      "Bank activity": ["Активность банка"],
      "Select a section": ["Выберите раздел"],
      "Last hour": ["Последний час"],
      "Previous day": ["Предыдущий день"],
      "Last month": ["Последний месяц"],
      "Last year": ["Последний год"],
      "Tabs": ["Вкладки"],
      "Last Year": ["Прошлый год"],
      "Trading volume from %1$s to %2$s": ["Объём торгов с %1$s по %2$s"],
      "Cash in": ["Ввод средств"],
      "Transferred from an external account to an account in this bank.": [
        "Переведено с внешнего счёта на счёт в этом банке.",
      ],
      "Transferred from an account in this bank to an external account.": [
        "Переведено со счёта в этом банке на внешний счёт.",
      ],
      "Taler pay-in": ["Внесение в Taler"],
      "Transferred from an account to a Taler exchange.": [
        "Переведено со счёта в обменник Taler.",
      ],
      "Transfers": ["Переводы"],
      "Taler payout": ["Выплата Taler"],
      "Transferred from a Taler exchange to another account.": [
        "Переведено из обменника Taler на другой счёт.",
      ],
      "Download stats as CSV": ["Скачать статистику в формате CSV"],
      "previous": ["предыдущий"],
      "Decreased by": ["Уменьшилось на"],
      "Increased by": ["Увеличение на"],
      'Account created with password "%1$s".': [
        'Учётная запись создана с паролем "%1$s".',
      ],
      "Failed to create a new account.": ["Не удалось создать новый счёт."],
      "Server replied that phone or email is invalid": [
        "Сервер сообщил, что телефон или email недействителен",
      ],
      "The rights to perform the operation are not sufficient": [
        "Недостаточно прав для выполнения операции",
      ],
      "Account username is already taken": [
        "Имя пользователя счёта уже занято",
      ],
      "Account ID is already taken": ["Идентификатор счёта уже занят"],
      "Bank ran out of bonus credit.": ["У банка закончился бонусный кредит."],
      "Only an administrator is allowed to set the debt limit.": [
        "Только администратор может устанавливать лимит задолженности.",
      ],
      "Only admin can create accounts with second factor authentication.": [
        "Только администратор может создавать учетные записи со второй аутентификацией.",
      ],
      "Can't create accounts": ["Невозможно создать счета"],
      "New bank account": ["Новый банковский счёт"],
      "Create an account and configure its initial access and profile.": [""],
      "Create account": ["Создать учётную запись"],
      "Failed to download statistics.": ["Не удалось скачать статистику."],
      "A statistics request failed. Please try again.": [
        "Не удалось выполнить запрос статистики. Повторите попытку.",
      ],
      "only admin can download stats": [
        "только администратор может скачивать статистику",
      ],
      "Choose which reporting periods to include in the CSV file.": [""],
      "Include hour metric": ["Включить часовую метрику"],
      "Include day metric": ["Включить дневную метрику"],
      "Include month metric": ["Включить месячную метрику"],
      "Include year metric": ["Включить годовую метрику"],
      "Include table header": ["Включить заголовок таблицы"],
      "Add previous metric for comparison": [
        "Добавить предыдущую метрику для сравнения",
      ],
      "Fail on first error": ["Сбой при первой ошибке"],
      "Download": ["Скачивать"],
      "Download completed with missing data": [
        "Скачивание завершено с неполными данными",
      ],
      "Download completed": ["Скачивание завершено"],
      "%1$s statistics requests failed. The file contains only the data that could be retrieved. Click here to save it.":
        [
          "Не удалось выполнить запросы статистики в количестве %1$s. Файл содержит только те данные, которые удалось получить. Нажмите здесь, чтобы сохранить его.",
        ],
      "Click here to save the file on your computer.": [
        "Нажмите здесь, чтобы сохранить файл на вашем компьютере.",
      ],
      "Name doesn't match": ["Название не совпадает"],
      "Faild to delete the account.": ["Не удалось удалить счёт."],
      "Not enough permission to delete the account.": [
        "Недостаточно прав для удаления счёта.",
      ],
      "The username was not found.": ["Имя пользователя не найдено."],
      "Can't delete a reserved username.": [
        "Невозможно удалить зарезервированное имя пользователя.",
      ],
      "Can't delete an account with balance different than zero.": [
        "Невозможно удалить счёт с ненулевым балансом.",
      ],
      "Account deletion": ["Удаление счёта"],
      "there was an error reading the balance": [
        "произошла ошибка при чтении баланса",
      ],
      "Can't delete the account": ["Невозможно удалить счёт"],
      "The account can't be deleted while still holding some balance. First make sure that the owner makes a complete cashout.":
        [
          "Счёт нельзя удалить, пока на нём есть баланс. Сначала убедитесь, что владелец выполнил полную выплату.",
        ],
      "Go back": [""],
      "All account data will be permanently removed.": [""],
      "Verification": ["Проверка"],
      "Enter the account name that is going to be deleted": [
        "Введите название удаляемого счёта",
      ],
      "Withdraw without setting amount": ["Снятие без указания суммы"],
      "Show install wallet first": ["Сначала показать как установить кошелёк"],
      "Introduction": ["Введение"],
      "Bank": ["Банк"],
      "Essay Shop": ["Магазин эссе"],
      "Donations": ["Пожертвования"],
      "GNU Taler logo": ["Логотип GNU Taler"],
      "Withdraw toy currency into your GNU Taler wallet.": [
        "Выведите игрушечную валюту в свой кошелёк GNU Taler.",
      ],
      "Demo pages": ["Демонстрационные страницы"],
      "You were signed out locally, but the bank could not confirm that the server token was revoked. Close other sessions or sign in again to review active tokens.":
        [
          "Вы вышли из системы локально, но банк не смог подтвердить отзыв серверного токена. Закройте другие сеансы или войдите снова, чтобы проверить активные токены.",
        ],
      "Dismiss": ["Скрыть"],
      "Public accounts": ["Публичные счета"],
      "Open interface preferences": ["Открыть настройки интерфейса"],
      "Interface preferences": ["Настройки интерфейса"],
      "Choose how this bank interface behaves on this browser.": [
        "Выберите, как этот интерфейс банка будет работать в данном браузере.",
      ],
      "Close interface preferences": ["Закрыть настройки интерфейса"],
      "Show debug information": ["Показать отладочную информацию"],
      "Done": ["Готово"],
      "Welcome": ["Добро пожаловать"],
      "Welcome, %1$s": ["Добро пожаловать, %1$s"],
      "Failed to load conversion rate.": [
        "Не удалось загрузить обменный курс.",
      ],
      "Not enough permission to access the conversion rate list.": [
        "Недостаточно прав для доступа к списку обменных курсов.",
      ],
      "Conversion list not implemented.": ["Список конвертации не реализован."],
      "Conversion rate classes": ["Классы обменного курса"],
      "Configure different cash-in and cashout terms for groups of accounts.": [
        "",
      ],
      "Default conversion rate": ["Обменный курс по умолчанию"],
      "Create conversion rate class": ["Создать класс обменного курса"],
      "Name": ["Название"],
      "Description": ["Описание"],
      "Cashin": ["Пополнение"],
      "First page": ["Первая страница"],
      "Next": ["Далее"],
      "min:": ["мин.:"],
      "fee:": ["комиссия:"],
      "only admin can setup conversion": [
        "только администратор может настраивать конверсию",
      ],
      "Failed to calculate cashout fee.": [
        "Не удалось рассчитать комиссию выплаты.",
      ],
      "Failed to update the conversion rate.": [
        "Не удалось обновить обменный курс.",
      ],
      "Wrong credentials": ["Неверные учётные данные"],
      "Conversion is disabled": ["Конверсия отключена"],
      "Review the default terms or choose a direction to update its settings.":
        [""],
      "Details": ["Подробности"],
      "Bad ratios": ["Неверные коэффициенты"],
      "Initial amount": ["Начальная сумма"],
      "Use it to test how the conversion will affect the amount.": [
        "Используйте это, чтобы проверить, как конверсия повлияет на сумму.",
      ],
      "Sending to this bank": ["Отправка в этот банк"],
      "Converted": ["Конвертировано"],
      "Cashin after fee": ["Пополнение после комиссии"],
      "Sending from this bank": ["Отправка из этого банка"],
      "Cashout after fee": ["Выплата после комиссии"],
      "Bad configuration": ["Неверная конфигурация"],
      "This configuration allows users to cash out more of what has been cashed in.":
        [
          "Эта конфигурация позволяет пользователям выводить больше средств, чем было внесено при пополнении.",
        ],
      "Must be > 0": ["Должно быть > 0"],
      "Ratio": ["Коэффициент"],
      "Zero": ["Ноль"],
      "Up": ["Вверх"],
      "Nearest": ["Ближайшее"],
      "Minimum amount": ["Минимальная сумма"],
      "Only cashout operations above this threshold will be allowed.": [
        "Разрешены только операции выплаты выше этого порога.",
      ],
      "Conversion ratio between currencies": [
        "Коэффициент конверсии между валютами",
      ],
      "Example conversion": ["Пример конверсии"],
      "1 %1$s will be converted into %2$s %3$s": [
        "1 %1$s будет конвертирован в %2$s %3$s",
      ],
      "Tiny amount": ["Малая сумма"],
      "Rounding mode": ["Режим округления"],
      "Amount will be rounded below to the largest possible value smaller than the input.":
        [
          "Сумма будет округлена вниз до наибольшего возможного значения, меньшего входного.",
        ],
      "Amount will be rounded up to the smallest possible value larger than the input.":
        [
          "Сумма будет округлена вверх до наименьшего возможного значения, большего входного.",
        ],
      "Amount will be rounded to the closest possible value.": [
        "Сумма будет округлена до ближайшего возможного значения.",
      ],
      'If none specified the fallback value is "%1$s ".': [
        'Если значение не указано, используется значение по умолчанию "%1$s ".',
      ],
      "Examples": ["Примеры"],
      "Rounding an amount of 1.24 with rounding value 0.1": [
        "Округление суммы 1.24 с шагом округления 0.1",
      ],
      "Given the rounding value of 0.1 the possible values closest to 1.24 are: 1.1, 1.2, 1.3, 1.4.":
        [
          "При шаге округления 0.1 ближайшие возможные значения к 1.24: 1.1, 1.2, 1.3, 1.4.",
        ],
      'With the "zero" mode the value will be rounded to 1.2': [
        'В режиме "ноль" значение будет округлено до 1.2',
      ],
      'With the "nearest" mode the value will be rounded to 1.2': [
        'В режиме "ближайшее" значение будет округлено до 1.2',
      ],
      'With the "up" mode the value will be rounded to 1.3': [
        'В режиме "вверх" значение будет округлено до 1.3',
      ],
      "Rounding an amount of 1.26 with rounding value 0.1": [
        "Округление суммы 1.26 с шагом округления 0.1",
      ],
      'With the "nearest" mode the value will be rounded to 1.3': [
        'В режиме "ближайшее" значение будет округлено до 1.3',
      ],
      "Rounding an amount of 1.24 with rounding value 0.3": [
        "Округление суммы 1.24 с шагом округления 0.3",
      ],
      "Given the rounding value of 0.3 the possible values closest to 1.24 are: 0.9, 1.2, 1.5, 1.8.":
        [
          "При шаге округления 0.3 ближайшие возможные значения к 1.24: 0.9, 1.2, 1.5, 1.8.",
        ],
      'With the "up" mode the value will be rounded to 1.5': [
        'В режиме "вверх" значение будет округлено до 1.5',
      ],
      "Rounding an amount of 1.26 with rounding value 0.3": [
        "Округление суммы 1.26 с шагом округления 0.3",
      ],
      "Amount to be deducted before amount is credited.": [
        "Сумма, вычитаемая перед зачислением суммы.",
      ],
      "Failed to load conversion details.": [
        "Не удалось загрузить сведения о конверсии.",
      ],
      "Conversion should be enabled in the configuration, the conversion rate should be initialized with fee(s), rates and a rounding mode.":
        [
          "Конверсия должна быть включена в конфигурации, обменный курс должен быть инициализирован с комиссией(-ями), коэффициентами и режимом округления.",
        ],
      "Failed to delete conversion rate class": [
        "Не удалось удалить класс обменного курса",
      ],
      "Unauthorized": ["Не авторизован"],
      "Forbidden": ["Запрещено"],
      "Failed to update conversion rate class.": [
        "Не удалось обновить класс обменного курса.",
      ],
      "Not Found": ["Не найдено"],
      "Not implemented": ["Не реализовано"],
      "The name of the conversion is already used.": [
        "Это название конверсии уже используется.",
      ],
      "Accounts": ["Счета"],
      "identification": ["идентификация"],
      "Users": ["Пользователи"],
      "Delete": ["Удалить"],
      "Failed to calculate the cashout fee.": [
        "Не удалось рассчитать комиссию выплаты.",
      ],
      "Can't remove the conversion rate class": [
        "Невозможно удалить класс обменного курса",
      ],
      "There are some users associated with this class. You need to remove them first.":
        ["С этим классом связаны некоторые пользователи. Сначала удалите их."],
      "You are going to remove the conversion rate class": [
        "Вы собираетесь удалить класс обменного курса",
      ],
      "This step can't be undone.": ["Это действие нельзя отменить."],
      "Class": ["Класс"],
      "Action": ["Действие"],
      "Failed to update conversion class membership.": [
        "Не удалось обновить принадлежность к классу конвертации.",
      ],
      "The account could not be updated. Please try again.": [
        "Не удалось обновить счёт. Повторите попытку.",
      ],
      "Conversion rate information is unavailable for these accounts.": [
        "Для этих счетов недоступны сведения о курсе конвертации.",
      ],
      "Failed to load users in conversion class.": [
        "Не удалось загрузить пользователей класса конверсии.",
      ],
      "Filters": ["Фильтры"],
      "Show from other classes": ["Показать из других классов"],
      "Account": ["Счёт"],
      "Group ID": ["Идентификатор группы"],
      "No users in this conversion rate class": [
        "В этом классе обменного курса нет пользователей",
      ],
      "Remove": ["Удалить"],
      "Add": ["Добавить"],
      "Conversion rate name": ["Название обменного курса"],
      "Short description of the class": ["Краткое описание класса"],
      "Failed to create conversion class.": [
        "Не удалось создать класс конверсии.",
      ],
      "New conversion rate class": ["Новый класс обменного курса"],
      "Create a named set of conversion terms that can be assigned to accounts.":
        [""],
      "Failed to load public accounts.": [
        "Не удалось загрузить публичные счета.",
      ],
      "Browse transaction histories shared by public bank accounts.": [
        "Просмотр истории транзакций, опубликованной владельцами банковских счетов.",
      ],
      "No public accounts are available.": ["Публичные счета недоступны."],
      "View previous cashouts": ["Показать предыдущие выводы средств"],
      "Failed to load cashout details.": [
        "Не удалось загрузить сведения о выплате.",
      ],
      "Amounts recorded for this completed cashout transfer.": [""],
      "Enter your full name.": ["Введите полное имя."],
      "Repeat your password.": ["Повторите Пароль"],
      "Create your bank account": ["Создать учётную запись"],
      "Choose the credentials you will use to sign in.": [
        "Выберите учётные данные, которые будете использовать для входа.",
      ],
      "Already have an account?": ["Уже есть счёт?"],
      "Confirm password": ["Подтвердите пароль"],
      "Use between 8 and 64 characters. A longer, unique password is easier to keep secure.":
        [
          "Используйте от 8 до 64 символов. Более длинный уникальный пароль проще сохранить безопасным.",
        ],
      "Creating account…": ["Создание счёта…"],
      "Check the account details and try again.": [
        "Проверьте данные счёта и повторите попытку.",
      ],
      "You are not authorized to create this account.": [
        "У вас нет прав на создание этого счёта.",
      ],
      "Registration is unavailable because the bank cannot grant the account credit.":
        [
          "Регистрация недоступна, поскольку банк не может предоставить счёту кредит.",
        ],
      "That username is reserved. Choose another username.": [
        "Это имя пользователя зарезервировано. Выберите другое.",
      ],
      "That username is already taken.": [
        "Это имя пользователя уже используется.",
      ],
      "That account ID is already taken.": [
        "Этот идентификатор счёта уже занят.",
      ],
      "The bank is missing information for the selected authentication channel.":
        ["Нет информации о выбранном канале аутентификации."],
      "The selected authentication channel is not supported.": [
        "Канал аутентификации не поддерживается.",
      ],
      "Only an administrator may set the debt limit.": [
        "Только администратор может устанавливать лимит задолженности.",
      ],
      "Only an administrator may select a conversion rate class.": [
        "Только администратор может выбрать класс обменного курса.",
      ],
      "The selected conversion rate class does not exist.": [
        "Класс обменного курса не существует.",
      ],
      "Only an administrator may enable two-factor authentication while creating an account.":
        [
          "Только администратор может включить двухфакторную аутентификацию при создании счёта.",
        ],
      "Account registration is unavailable": ["Регистрация счёта"],
      "This bank is not accepting new account registrations.": [
        "В настоящее время банк не принимает новые регистрации!",
      ],
      "Return to sign in": ["Вернуться ко входу"],
      "Contact the bank administrator if you need an account.": [
        "Обратитесь к администратору банка.",
      ],
      "Failed to load withdrawal details.": [
        "Не удалось загрузить данные снятия.",
      ],
      "Abort this withdrawal?": ["Отменить это снятие?"],
      "This stops the withdrawal. No money will be transferred, and this operation cannot be resumed.":
        [
          "Снятие будет отменено. Деньги не будут переведены, и эту операцию нельзя будет возобновить.",
        ],
      "Keep withdrawal": ["Не отменять снятие"],
      "Abort withdrawal": ["Отменить снятие"],
      'The payto URI returned by the server is invalid: "%1$s".': [
        'URI payto, возвращённый сервером, недействителен: "%1$s".',
      ],
      'The withdrawal URI returned by the server is invalid: "%1$s".': [
        'URI вывода средств, возвращённый сервером, недействителен: "%1$s".',
      ],
      'The reserve public key returned by the server is invalid: "%1$s".': [
        'Открытый ключ резерва, возвращённый сервером, недействителен: "%1$s".',
      ],
      "Enter an amount.": ["Введите сумму."],
      "Enter a valid amount.": ["Введите допустимую сумму."],
      "The amount must be greater than zero.": [
        "Сумма должна быть больше нуля.",
      ],
      "The amount is below the bank's minimum.": [
        "Сумма меньше установленного банком минимума.",
      ],
      "The amount is above the bank's maximum.": [
        "Сумма превышает установленный банком максимум.",
      ],
      "Failed to abort the withdrawal.": ["Не удалось отменить снятие."],
      "The server did not understand the request.": ["Сервер не понял запрос."],
      "The operation was not found.": ["Операция не найдена."],
      "The withdrawal operation has already been confirmed and cannot be aborted.":
        ["Операция снятия уже подтверждена и не может быть отменена."],
      "The bank could not be reached. Please try again.": [
        "Не удалось связаться с банком. Повторите попытку.",
      ],
      "Withdrawal confirmation": ["Подтверждение снятия"],
      "Failed to confirm the withdrawal.": ["Не удалось подтвердить снятие."],
      "The account does not have sufficient funds or the amount is outside the limits.":
        [
          "На счёте недостаточно средств, либо сумма выходит за установленные пределы.",
        ],
      "The withdrawal has been aborted and cannot be confirmed.": [
        "Снятие было отменено и не может быть подтверждено.",
      ],
      "The wallet has not finished selecting an exchange account.": [
        "Кошелёк ещё не завершил выбор счёта обменника.",
      ],
      "The withdrawal amount changed. Review the current amount and try again.":
        [
          "Сумма снятия изменилась. Проверьте текущую сумму и повторите попытку.",
        ],
      "Enter an amount before confirming the withdrawal.": [
        "Перед подтверждением снятия введите сумму.",
      ],
      "Selected exchange": ["Выбранный обменник"],
      "Sign in to confirm the withdrawal": [
        "Войдите, чтобы подтвердить снятие",
      ],
      "Sign in as %1$s before reviewing and confirming this withdrawal.": [
        "Войдите как %1$s, прежде чем проверять и подтверждать это снятие.",
      ],
      "You are signed in as %1$s, but this withdrawal belongs to %2$s.": [
        "Вы вошли как %1$s, но это снятие относится к учётной записи %2$s.",
      ],
      "Finish later": ["Завершить позже"],
      "Confirm wallet withdrawal": ["Подтвердить снятие в кошелёк"],
      "Review how much will leave your bank account before confirming.": [
        "Перед подтверждением проверьте сумму, которая будет списана с банковского счёта.",
      ],
      "Unsupported exchange account": ["Неподдерживаемый счёт обменника"],
      "The exchange account does not use the transfer type configured by this bank. This withdrawal cannot be confirmed.":
        [
          "Счёт обменника не использует тип перевода, настроенный этим банком. Это снятие нельзя подтвердить.",
        ],
      "Withdrawal amount missing": ["Не указана сумма снятия"],
      "The bank did not provide an amount for this withdrawal. It cannot be confirmed.":
        ["Банк не указал сумму для этого снятия. Его нельзя подтвердить."],
      "Bank amount configuration invalid": [
        "Настройка сумм в банке недействительна",
      ],
      "The withdrawal amount and bank fee could not be combined safely. This withdrawal cannot be confirmed.":
        [
          "Сумму снятия и комиссию банка невозможно безопасно сложить. Это снятие нельзя подтвердить.",
        ],
      "Wallet receives": ["Кошелёк получит"],
      "Amount to your Taler Wallet": ["Сумма для кошелька Taler"],
      "Allowed amount": ["Допустимая сумма"],
      "Maximum amount": ["Максимальная сумма"],
      "Amount unavailable": ["Сумма недоступна"],
      "From": ["Со счёта"],
      "To": ["Получатель"],
      "Taler Wallet": ["Кошелёк Taler"],
      "Exchange": ["Обменник"],
      "Unavailable": ["Недоступно"],
      "Exchange details": ["Сведения об обменнике"],
      "Exchange IBAN": ["IBAN обменника"],
      "Bank hostname": ["Имя сервера банка"],
      "Exchange account": ["Счёт обменника"],
      "No money is withdrawn until you confirm. You can finish this later from your account overview.":
        [
          "Деньги не будут сняты до подтверждения. Вы можете завершить позже на странице обзора счёта.",
        ],
      "Confirm withdrawal": ["Подтвердить снятие"],
      "Unauthorized to make the operation, maybe the session has expired or the password changed.":
        [
          "Неавторизированное выполнение операции, возможно истек сеанс или изменён пароль.",
        ],
      "The operation was rejected due to insufficient funds.": [
        "Операция отклонена из-за нехватки средств.",
      ],
      "Withdrawal aborted": ["Снятие средств отменено"],
      "Withdrawal confirmed": ["Вывод подтверждён"],
      "The bank transfer to the Taler exchange has been initiated. Your Taler Wallet will receive the withdrawn amount shortly.":
        [
          "Банковский перевод в обменник Taler инициирован. Снятая сумма вскоре поступит в ваш кошелёк Taler.",
        ],
      "Back to account": ["Вернуться к счёту"],
      "Complete withdrawal with your Taler Wallet": [
        "Завершите снятие с помощью кошелька Taler",
      ],
      "Scan this QR code with your Taler Wallet. Your wallet will select an exchange and prepare the withdrawal.":
        [
          "Отсканируйте этот QR-код кошельком Taler. Кошелёк выберет обменник и подготовит снятие.",
        ],
      "Withdrawal amount": ["Сумма снятия"],
      "Suggested amount": ["Предлагаемая сумма"],
      "You can change this amount in your wallet.": [
        "Эту сумму можно изменить в кошельке.",
      ],
      "QR code to continue the withdrawal in a Taler Wallet.": [
        "QR-код для продолжения снятия в кошельке Taler.",
      ],
      "Open Taler Wallet manually": ["Открыть кошелёк Taler вручную"],
      "Don't have a Taler Wallet?": ["У вас нет кошелька Taler?"],
      "Get a wallet": ["Получить кошелёк"],
      "No money will be transferred until you return here to review and confirm the withdrawal.":
        [
          "Деньги не будут переведены, пока вы не вернётесь сюда, чтобы проверить и подтвердить снятие.",
        ],
      "Sign in to abort this withdrawal": [
        "Войдите, чтобы отменить это снятие",
      ],
      "The withdrawal operation has been confirmed previously and can not be aborted.":
        [
          "Операция снятия уже была подтверждена ранее и не может быть отменена.",
        ],
      "Withdrawal ready for confirmation": ["Снятие готово к подтверждению"],
      "Withdrawal waiting for your wallet": [
        "Операция снятия ожидает действий в кошельке",
      ],
      "The pending withdrawal could not be checked": [
        "Не удалось проверить ожидающую операцию снятия",
      ],
      "Checking the pending withdrawal…": [
        "Проверка ожидающей операции снятия…",
      ],
      "Review withdrawal": ["Проверить снятие"],
      "Retry": ["Повторить"],
      "Resume withdrawal": ["Возобновить снятие"],
      "Finish or abort this withdrawal before starting another one.": [
        "Завершите или отмените это снятие, прежде чем начинать новое.",
      ],
      "Dashboard": ["Панель управления"],
      "Admin activity": ["Активность администратора"],
      "Conversion": ["Конвертация"],
      "My account": ["Мой счёт"],
      "Bank administration": ["Управление банком"],
      "Failed to load the account list.": [
        "Не удалось загрузить список счетов.",
      ],
      "Search accounts": ["Поиск счетов"],
      "Search by username or name": ["Поиск по имени пользователя или имени"],
      "Search": ["Поиск"],
      "Clear": ["Очистить"],
      "Unknown": ["Неизвестно"],
      "Change password": ["Изменить пароль"],
      "Previous": ["Предыдущая"],
      "The amount exceeds what is available to withdraw.": [""],
      "The server replied with an invalid taler://withdraw URI": [
        "Сервер вернул недопустимый URI taler://withdraw",
      ],
      "Withdraw URI: %1$s": ["URI вывода: %1$s"],
      "Failed to create the withdrawal.": ["Не удалось создать снятие."],
      "The operation was rejected due to insufficient funds": [
        "Операция отклонена из-за нехватки средств.",
      ],
      "Please sign in again.": ["Войдите снова."],
      "The bank's withdrawal limits or fee are configured incorrectly.": [""],
      "Maximum withdrawal": ["Максимальная сумма снятия"],
      "There is not enough available balance to cover a withdrawal and the bank fee.":
        [""],
      "Dismiss wallet installation hint": [""],
      "Unable to start a withdrawal.": ["Не удалось начать вывод средств."],
      "Your account was created. Sign in to continue.": [
        "Счёт создан. Войдите, чтобы продолжить.",
      ],
      "Home": ["Главная"],
      "Page not found": ["Страница не найдена"],
      "The requested bank page does not exist.": [
        "Запрошенная страница банка не существует.",
      ],
      "Unknown challenge.": ["Неизвестный запрос проверки."],
      "Failed to validate the verification code.": [
        "Не удалось проверить код подтверждения.",
      ],
      "Too many challenges are active. Wait or confirm an existing challenge.":
        [
          "Сейчас активно слишком много запросов проверки, вам нужно подождать или подтвердить текущие запросы.",
        ],
      "The verification code is incorrect.": ["Неверный код подтверждения."],
      "The verification code has expired.": [
        "Срок действия кода подтверждения истёк.",
      ],
      "Submit the transmitted code number.": ["Введите присланный код."],
      "The verification code sent to the email address starting with %1$s": [
        "Код подтверждения отправлен на адрес email, начинающийся с %1$s",
      ],
      "The verification code sent to the phone number ending with %1$s": [
        "Код подтверждения отправлен на номер телефона, заканчивающийся на %1$s",
      ],
      "Code": ["Код"],
      "Authentication code": ["Код аутентификации"],
      "It will expire at %1$s": ["Он истечёт в %1$s"],
      "This challenge is terminal and cannot be retransmitted.": [
        "Этот запрос аутентификации завершён, и его нельзя передать повторно.",
      ],
      "Restart authentication": ["Перезапустить аутентификацию"],
      "Back": ["Назад"],
      "Verifying…": ["Проверка…"],
      "Verify": ["Проверить"],
      "Complete": ["Завершить"],
      "Failed to start the challenge.": ["Не удалось начать запрос проверки."],
      "Unable to send the verification code.": [
        "Не удалось отправить код подтверждения.",
      ],
      "The request was valid, but the server is refusing action.": [
        "Запрос был корректен, но сервер отказывается выполнять действие.",
      ],
      "The backend is not aware of the specified MFA challenge.": [
        "Бэкенду ничего не известно об указанном запросе многофакторной аутентификации.",
      ],
      "It is too early to request another transmission of the challenge.": [
        "Пока рано запрашивать повторную отправку запроса проверки.",
      ],
      "Code transmission failed.": ["Не удалось отправить код."],
      "Multi-factor authentication required": [
        "Требуется многофакторная аутентификация",
      ],
      "This operation is protected with second factor authentication. In order to complete it we need to verify your identity using the authentication channel you provided.":
        [
          "Эта операция защищена двухфакторной аутентификацией. Чтобы её завершить, нам нужно подтвердить вашу личность через указанный вами канал аутентификации.",
        ],
      "The next challenge needs to be completed to confirm the operation.": [
        "Чтобы подтвердить операцию, нужно выполнить следующий запрос проверки.",
      ],
      "All the next challenges need to be completed to confirm the operation.":
        [
          "Чтобы подтвердить операцию, нужно выполнить все следующие запросы проверки.",
        ],
      "One of the next challenges needs to be completed to confirm the operation.":
        [
          "Чтобы подтвердить операцию, нужно выполнить один из следующих запросов проверки.",
        ],
      'To a phone ending with "%1$s"': [
        'На телефон, заканчивающийся на "%1$s"',
      ],
      'To an email starting with " %1$s"': ['На email, начинающийся с " %1$s"'],
      "I have a code": ["У меня есть код"],
      "Send me a message": ["Отправить мне сообщение"],
      "You have to wait until %1$s to send a new code.": [
        "Вам нужно подождать до %1$s, чтобы отправить новый код.",
      ],
      "Use configured value (enabled)": [
        "Использовать настроенное значение (включено)",
      ],
      "Use configured value (disabled)": [
        "Использовать настроенное значение (отключено)",
      ],
      "Force enabled": ["Принудительно включить"],
      "Force disabled": ["Принудительно отключить"],
      "Enter a valid HTTP or HTTPS URL.": [
        "Введите допустимый URL-адрес HTTP или HTTPS.",
      ],
      "Development settings": ["Настройки разработки"],
      "These overrides are stored only in this browser.": [
        "Эти переопределения хранятся только в этом браузере.",
      ],
      "Corebank API base URL": ["Базовый URL API Corebank"],
      "Leave empty to use the configured URL: %1$s": [
        "Оставьте поле пустым, чтобы использовать настроенный URL: %1$s",
      ],
      "Leave empty to derive the URL from this page.": [
        "Оставьте поле пустым, чтобы определить URL по этой странице.",
      ],
      "Demo header": ["Заголовок демоверсии"],
      "Control whether the demo header is shown in this browser.": [
        "Определяет, отображается ли заголовок демоверсии в этом браузере.",
      ],
      "Control whether public account links are shown in this browser.": [
        "Определяет, отображаются ли ссылки на публичные счета в этом браузере.",
      ],
      "Overrides saved.": ["Переопределения сохранены."],
      "Apply overrides": ["Применить переопределения"],
      "Clear overrides": ["Сбросить переопределения"],
      "Back to bank": ["Вернуться в банк"],
    },
  },
  domain: "messages",
  plural_forms:
    "nplurals=3; plural=n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2;",
  lang: "ru",
  completeness: 87,
};

strings["it"] = {
  locale_data: {
    messages: {
      "": {
        domain: "messages",
        lang: "it",
        plural_forms: "nplurals=2; plural=n != 1;",
      },
      "Hide password": ["Nascondi password"],
      "Show password": ["Mostra password"],
      "Hide": ["Nascondi"],
      "Show": ["Mostra"],
      "Identity verification.": ["Verifica dell'identità."],
      "You do not have permission to access this account.": [
        "Non disponi dei permessi per accedere a questo conto.",
      ],
      "This account is locked. Contact the bank administrator.": [
        "Il conto è bloccato e non può accedere. Contatta l'amministratore.",
      ],
      "The password is incorrect.": ["La password non è corretta."],
      "Account not found.": ["Conto non trovato"],
      "Could not reach the bank. Check your connection and try again.": [
        "Impossibile contattare la banca. Controlla la connessione e riprova.",
      ],
      "Confirm your password": ["Conferma la password"],
      "Sign in to %1$s": ["Accedi a %1$s"],
      "Enter the password for %1$s to continue.": [
        "Inserisci la password di %1$s per continuare.",
      ],
      "Use your bank account credentials to continue.": [
        "Usa le credenziali del tuo conto bancario per continuare.",
      ],
      "Need an account?": ["Ti serve un conto?"],
      "Create one": ["Crea conto"],
      "Your session expired. Confirm your password to continue.": [
        "La sessione è scaduta. Conferma la password per continuare.",
      ],
      "Username": ["Nome utente"],
      "Password": ["Password"],
      "Sign out": ["Esci"],
      "Signing in…": ["Accesso in corso…"],
      "Continue": ["Continua"],
      "Sign in": ["Accedi"],
      "Enter your username.": ["Inserisci il nome utente."],
      "Use letters, numbers, or any of these characters: - . _ ~": [
        "Usa lettere, numeri o uno di questi caratteri: - . _ ~",
      ],
      "The username must not exceed 126 characters.": [
        "Il nome utente non può superare 126 caratteri.",
      ],
      "Enter your password.": ["Inserisci la password."],
      "The password must contain at least 8 characters.": [
        "La password è troppo corta. Non può avere meno di 8 caratteri.",
      ],
      "The password must not exceed %1$s characters.": [
        "La password non può superare %1$s caratteri.",
      ],
      "IBAN country code not found": ["Codice paese IBAN non trovato"],
      "The IBAN must not exceed 34 characters.": [
        "L’IBAN non deve superare 34 caratteri.",
      ],
      "The IBAN must contain at least 4 characters.": [
        "L’IBAN deve contenere almeno 4 caratteri.",
      ],
      "IBAN length is invalid for this country": [
        "La lunghezza dell’IBAN non è valida per questo Paese",
      ],
      "The IBAN contains invalid characters": [
        "L’IBAN contiene caratteri non validi",
      ],
      "IBAN number is not valid, checksum is wrong": [
        "Il numero IBAN non è valido, il checksum è errato",
      ],
      "The IBAN is not valid": ["L’IBAN non è valido"],
      "Use letters, numbers or any of these characters: - . _ ~": [
        "Usa lettere, numeri o uno di questi caratteri: - . _ ~",
      ],
      "Failed to load cashouts.": ["Impossibile caricare i Cashout."],
      "Try again": ["Riprova"],
      "Cashout is disabled": ["Il Cashout è disabilitato"],
      "Cashout should be enabled in the configuration, the conversion rate should be initialized with fee(s), rates and a rounding mode.":
        [
          "Il Cashout deve essere abilitato nella configurazione, il tasso di cambio deve essere inizializzato con commissioni, tassi e una modalità di arrotondamento.",
        ],
      "No cashouts have been created yet.": [
        "Non è stato ancora creato alcun Cashout.",
      ],
      "Failed to load conversion rate information.": [
        "Impossibile caricare le informazioni sul tasso di cambio.",
      ],
      "Some cashout details could not be loaded.": [
        "Non è stato possibile caricare alcuni dettagli dei prelievi.",
      ],
      "The partial list omits cashout IDs: %1$s.": [
        "L’elenco parziale omette i seguenti identificativi di prelievo: %1$s.",
      ],
      "View details": ["Visualizza dettagli"],
      "Debited": ["Addebitato"],
      "Transferred": ["Trasferito"],
      "Created": ["Creato"],
      "Transfer reference": ["Causale del bonifico"],
      "Actions": ["Azioni"],
      "Cashout history": ["Cronologia dei prelievi"],
      "Review previous transfers to your configured cashout account.": [
        "Consulta i bonifici precedenti verso il conto di Cashout configurato.",
      ],
      "Profile": ["Profilo"],
      "Security": ["Sicurezza"],
      "Merchant integration": ["Integrazione venditore"],
      "Back to overview": ["Torna alla panoramica"],
      "My account settings": ["Impostazioni del mio conto"],
      "Copy": ["Copia"],
      "Failed to load account details.": [
        "Impossibile caricare i dettagli del conto.",
      ],
      'Use this information to link your Taler Merchant Backoffice account with the current bank account. You can start by copying the values, then go to your merchant backoffice service provider, login into your account and look for the "import" button in the "bank account" section.':
        [
          'Usa queste informazioni per collegare il tuo conto Taler Merchant Backoffice al conto bancario attuale. Puoi iniziare copiando i valori, poi vai al tuo fornitore del servizio di backoffice del venditore, accedi al tuo conto e cerca il pulsante "importa" nella sezione "conto bancario".',
        ],
      "Not available": ["Non disponibile"],
      "Merchant integration is not available for this account.": [
        "L’integrazione venditore non è disponibile per questo conto.",
      ],
      "Account type": ["Tipo di conto"],
      "Method to use for wire transfer.": [
        "Metodo da usare per il bonifico bancario.",
      ],
      "IBAN": ["IBAN"],
      "International Bank Account Number.": [
        "Numero di conto bancario internazionale.",
      ],
      "Bank host": ["Host della banca"],
      "Bank host where the service is located.": [
        "Host della banca dove si trova il servizio.",
      ],
      "Account name": ["Nome del conto"],
      "Bank account identifier for wire transfers.": [
        "Identificativo del conto bancario per i bonifici.",
      ],
      "Address": ["Indirizzo"],
      "Bitcoin address for this account.": [
        "Indirizzo Bitcoin di questo conto.",
      ],
      "Account address": ["Indirizzo del conto"],
      "Owner's name": ["Nome del titolare"],
      "Legal name of the person holding the account.": [
        "Nome legale della persona titolare del conto.",
      ],
      "Account info URL": ["URL informazioni conto"],
      "From where the merchant can download information about incoming wire transfers to this account.":
        [
          "Da dove il venditore può scaricare le informazioni sui bonifici in entrata su questo conto.",
        ],
      "Unable to create a cashout": ["Impossibile creare un Cashout"],
      "The bank configuration does not support cashout operations.": [
        "La configurazione della banca non supporta le operazioni di Cashout.",
      ],
      "Close": ["Chiudi"],
      "The bank returned incomplete conversion information.": [
        "La banca ha restituito informazioni di conversione incomplete.",
      ],
      "Please contact the bank administrator.": [
        "Contatta l’amministratore della banca.",
      ],
      "Authentication required": ["Autenticazione richiesta"],
      "Please sign in to create a cashout.": ["Accedi per creare un prelievo."],
      "Failed to calculate the conversion fee.": [
        "Impossibile calcolare la commissione di cambio.",
      ],
      "The amount is too small": ["L'importo è troppo piccolo"],
      "Conversion is not implemented.": ["Il cambio non è implementato."],
      "At least a debit or credit amount must be provided.": [
        "È necessario fornire almeno un importo di addebito o accredito.",
      ],
      "The amount has an invalid format.": [
        "L’importo ha un formato non valido.",
      ],
      "The currency is not supported": ["La valuta non è supportata"],
      "Required": ["Obbligatorio"],
      "Invalid": ["Non valido"],
      "The balance is not sufficient": ["Il saldo non è sufficiente"],
      "It is not possible to cash out less than %1$s: %2$s": [
        "Non è possibile incassare meno di %1$s: %2$s",
      ],
      "The total transfer to the destination will be zero": [
        "Il trasferimento totale verso la destinazione sarà pari a zero",
      ],
      "Failed to create the cashout.": ["Impossibile creare il Cashout."],
      "Cashout": ["Cashout"],
      "Account not found": ["Conto non trovato"],
      "Duplicate request detected, check if the operation succeeded or try again.":
        [
          "Rilevata una richiesta duplicata, verifica se l'operazione è andata a buon fine o riprova.",
        ],
      "The conversion rate was applied incorrectly": [
        "Il tasso di cambio è stato applicato in modo errato",
      ],
      "The account does not have sufficient funds": [
        "Il conto non dispone di fondi sufficienti",
      ],
      "Missing cashout URI in the profile": [
        "URI di Cashout mancante nel profilo",
      ],
      "The amount is below the minimum amount permitted.": [
        "L'importo è inferiore all'importo minimo consentito.",
      ],
      "Sending the confirmation message failed, retry later or contact the administrator.":
        [
          "Invio del messaggio di conferma non riuscito, riprova più tardi o contatta l'amministratore.",
        ],
      "The server doesn't support the current TAN channel.": [
        "Il server non supporta il canale TAN attuale.",
      ],
      "Cashout details": ["Dettagli del Cashout"],
      "Review the destination account and conversion terms.": [
        "Verifica il conto di destinazione e le condizioni di conversione.",
      ],
      "Conversion rate": ["Tasso di cambio"],
      "Balance": ["Saldo"],
      "Fee": ["Commissione"],
      "No fee": ["Nessuna commissione"],
      "To account": ["Al conto"],
      "Legal name": ["Nome legale"],
      "If this name doesn't match the account holder's name, your transaction may fail.":
        [
          "Se questo nome non corrisponde al nome del titolare del conto, la transazione potrebbe non riuscire.",
        ],
      "Unable to cash out": ["Impossibile incassare"],
      "Before being able to cash out to a bank account, you need to complete your profile":
        [
          "Prima di poter incassare su un conto bancario, devi completare il tuo profilo",
        ],
      "What is this cashout for?": ["Qual è la causale di questo Cashout?"],
      "Enter the amount to send or receive": [
        "Inserisci l’importo da inviare o ricevere",
      ],
      "Send %1$s": ["Invia %1$s"],
      "Receive %1$s": ["Ricevi %1$s"],
      "Amount": ["Importo"],
      "Total cost": ["Costo totale"],
      "Balance left": ["Saldo rimanente"],
      "Before fee": ["Prima della commissione"],
      "Total cashout transfer": ["Trasferimento totale del Cashout"],
      "Cancel": ["Annullare"],
      "Cash out": ["Cashout"],
      "Not valid": ["Non valido"],
      "Does not follow the pattern": ["Non rispetta il formato richiesto"],
      "Failed to create the transaction.": [
        "Impossibile creare la transazione.",
      ],
      "The request was invalid or the payto://-URI used unacceptable features.":
        [
          "La richiesta non era valida oppure l'URI payto:// utilizzato conteneva funzionalità non accettabili.",
        ],
      "Not enough permission to complete the operation.": [
        "Permessi insufficienti per completare l'operazione.",
      ],
      "The bank administrator cannot be the transfer creditor.": [
        "L'amministratore della banca non può essere il beneficiario del trasferimento.",
      ],
      'The destination account "%1$s" was not found.': [
        'Il conto di destinazione "%1$s" non è stato trovato.',
      ],
      "The origin and the destination of the transfer can't be the same.": [
        "L'origine e la destinazione del trasferimento non possono coincidere.",
      ],
      "Your balance is not sufficient for the operation.": [
        "Il tuo saldo non è sufficiente per l'operazione.",
      ],
      'The origin account "%1$s" was not found.': [
        'Il conto di origine "%1$s" non è stato trovato.',
      ],
      "The attempt to create the transaction has failed. Please try again.": [
        "Il tentativo di creare la transazione non è riuscito. Riprova.",
      ],
      "Confirm transaction.": ["Conferma transazione."],
      "Transfer details": ["Dettagli del bonifico"],
      "Enter the recipient, a reference, and the amount to send.": [
        "Inserisci il destinatario, una causale e l’importo da inviare.",
      ],
      "Maximum transfer": ["Trasferimento massimo"],
      "Debt limit": ["Limite di debito"],
      "This is not your account balance. This account cannot go into debt.": [
        "Questo non è il saldo del tuo conto. Questo conto non può andare in rosso.",
      ],
      "This is not your account balance. It includes borrowing up to the debt limit shown here.":
        [
          "Questo non è il saldo del tuo conto. Include il credito disponibile fino al limite di debito mostrato qui.",
        ],
      "Transfer input method": ["Metodo di inserimento del bonifico"],
      "Enter details": ["Inserisci i dati"],
      "Paste payto URI": ["Incolla URI payto"],
      "Recipient": ["Destinatario"],
      "Account name of the recipient": ["Nome del conto del destinatario"],
      "username": ["nome utente"],
      "IBAN of the recipient's account": ["IBAN del conto del destinatario"],
      "What is this transfer for?": ["Qual è la causale di questo bonifico?"],
      "Payto URI": ["URI payto"],
      "Paste a payto URI containing the recipient, amount, and transfer reference.":
        [
          "Incolla un URI payto contenente il destinatario, l’importo e la causale del bonifico.",
        ],
      "Uniform resource identifier of the target account": [
        "Identificatore uniforme di risorsa del conto di destinazione",
      ],
      "payto://x-taler-bank/[bank-host]/[receiver-account]?message=[subject]&amount=[%1$s:X.Y]":
        [
          "payto://x-taler-bank/[bank-host]/[receiver-account]?message=[subject]&amount=[%1$s:X.Y]",
        ],
      "payto://iban/[receiver-iban]?message=[subject]&amount=[%1$s:X.Y]": [
        "payto://iban/[receiver-iban]?message=[subject]&amount=[%1$s:X.Y]",
      ],
      "Recipient receives": ["Il destinatario riceve"],
      "Bank fee": ["Commissione bancaria"],
      "Total debited": ["Totale addebitato"],
      "Need to move money out of this bank?": [
        "Vuoi trasferire denaro fuori da questa banca?",
      ],
      "Start a cashout": ["Avvia un Cashout"],
      "Send transfer": ["Invia bonifico"],
      'Only "x-taler-bank" targets are supported': [
        'Sono supportate solo destinazioni "x-taler-bank"',
      ],
      'Only this host is allowed. Use "%1$s"': [
        'È consentito solo questo host. Usa "%1$s"',
      ],
      "Account name is missing": ["Il nome del conto è mancante"],
      'Only "IBAN" targets are supported': [
        'Sono supportate solo destinazioni "IBAN"',
      ],
      'Missing "amount" parameter to specify the amount to be transferred': [
        'Parametro "amount" mancante per specificare l\'importo da trasferire',
      ],
      'The "amount" parameter is not valid': [
        'Il parametro "amount" non è valido',
      ],
      '"message" parameters to specify a reference text for the transfer are missing':
        [
          'I parametri "message" per specificare un testo di riferimento per il trasferimento sono mancanti',
        ],
      'The only currency allowed is "%1$s"': [
        'L\'unica valuta consentita è "%1$s"',
      ],
      "You cannot transfer an amount of zero.": [
        "Non puoi trasferire un importo pari a zero.",
      ],
      "Please enter a longer subject": ["Inserisci un soggetto più lungo"],
      "Email and SMS authentication were disabled because their contact details were removed.":
        [
          "L’autenticazione tramite e-mail e SMS è stata disabilitata perché i relativi dati di contatto sono stati rimossi.",
        ],
      "Email authentication was disabled because the email address was removed.":
        [
          "L’autenticazione tramite e-mail è stata disabilitata perché l’indirizzo e-mail è stato rimosso.",
        ],
      "SMS authentication was disabled because the phone number was removed.": [
        "L’autenticazione tramite SMS è stata disabilitata perché il numero di telefono è stato rimosso.",
      ],
      "Invalid email format": ["Formato email non valido"],
      "Should start with +": ["Deve iniziare con +"],
      "A phone number consists of numbers only": [
        "Un numero di telefono è composto solo da numeri",
      ],
      "Login username": ["Nome utente di accesso"],
      "Account ID for authentication": ["ID conto per l'autenticazione"],
      "Full name": ["Nome completo"],
      "Name of the account holder": [
        "Nome del titolare del conto corrente bancario",
      ],
      "Internal account": ["Conto interno"],
      "Copy and share this account address to receive transfers.": [
        "Copia e condividi questo indirizzo del conto per ricevere trasferimenti.",
      ],
      "Email": ["Email"],
      "To be used when second factor authentication is enabled": [
        "Da usare quando l'autenticazione a due fattori è abilitata",
      ],
      "Phone": ["Telefono"],
      "Enable second factor authentication": [
        "Abilita l'autenticazione a due fattori",
      ],
      "Using email": ["Tramite email"],
      "Add an email in your profile to enable this option": [
        "Aggiungi un'email al tuo profilo per abilitare questa opzione",
      ],
      "Using SMS": ["Tramite SMS"],
      "Add a phone number in your profile to enable this option": [
        "Aggiungi un numero di telefono al tuo profilo per abilitare questa opzione",
      ],
      "Cashout account": ["Conto di cashout"],
      "External account to which cashout transfers are sent.": [
        "Conto esterno a cui vengono inviati i bonifici di cashout.",
      ],
      "Max debt": ["Debito massimo"],
      "How much the balance can go below zero.": [
        "Di quanto il saldo può scendere sotto zero.",
      ],
      "Is this account public?": ["Questo conto è pubblico?"],
      "Public accounts expose their balance and complete transaction history, including subjects and both account addresses, to anonymous visitors.":
        [
          "I conti pubblici espongono ai visitatori anonimi il saldo e la cronologia completa delle transazioni, incluse le causali e gli indirizzi di entrambi i conti.",
        ],
      "Does this account belong to a Payment Service Provider?": [
        "Questo conto appartiene a un fornitore di servizi di pagamento?",
      ],
      "Account updated": ["Conto aggiornato"],
      "Failed to update the account.": ["Impossibile aggiornare il conto."],
      "The rights to change the account are not sufficient": [
        "I permessi per modificare il conto non sono sufficienti",
      ],
      "The username was not found": ["Il nome utente non è stato trovato"],
      "You can't change the legal name, please contact your account administrator.":
        [
          "Non puoi modificare il nome legale, contatta l'amministratore del tuo conto.",
        ],
      "You can't change the debt limit, please contact your account administrator.":
        [
          "Non puoi modificare il limite di debito, contatta l'amministratore del tuo conto.",
        ],
      "You can't change the cashout address, please contact your account administrator.":
        [
          "Non puoi modificare l'indirizzo di Cashout, contatta l'amministratore del tuo conto.",
        ],
      "No information for the selected authentication channel.": [
        "Nessuna informazione per il canale di autenticazione selezionato.",
      ],
      "Account update": ["Aggiornamento del conto"],
      "Authentication channel is not supported.": [
        "Il canale di autenticazione non è supportato.",
      ],
      "Only the administrator can change the conversion rate.": [
        "Solo l'amministratore può modificare il tasso di cambio.",
      ],
      "The conversion rate class doesn't exist.": [
        "La classe di tasso di cambio non esiste.",
      ],
      "The password is too short. Can't have less than 8 characters.": [
        "La password è troppo corta. Non può avere meno di 8 caratteri.",
      ],
      "The password is too long. Can't have more than 64 characters.": [
        "La password è troppo lunga. Non può avere più di 64 caratteri.",
      ],
      'Account "%1$s"': ['Conto "%1$s"'],
      "Removed": ["Rimosso"],
      "This account can't be used.": ["Questo conto non può essere usato."],
      "Account details": ["Dettagli del conto"],
      "Not configured": ["Non configurato"],
      "Change details": ["Modifica dettagli"],
      "Update": ["Aggiorna"],
      "Delete account": ["Elimina conto"],
      "Permanently remove this bank account. The account must have a zero balance before it can be deleted.":
        [
          "Elimina definitivamente questo conto bancario. Il saldo deve essere pari a zero prima che il conto possa essere eliminato.",
        ],
      "The passwords do not match.": ["Le password non corrispondono."],
      "Failed to update the password.": ["Impossibile aggiornare la password."],
      "Not authorized to change the password, maybe the session is invalid.": [
        "Non autorizzato a modificare la password, la sessione potrebbe non essere valida.",
      ],
      "You need to provide the old password. If you don't have it contact your account administrator.":
        [
          "Devi fornire la vecchia password. Se non ne disponi, contatta l'amministratore del tuo conto.",
        ],
      "The current password is incorrect, so the password cannot be changed.": [
        "La password attuale non è corretta, quindi non può essere modificata.",
      ],
      "Password update": ["Aggiornamento password"],
      "You don't have the rights to change the password.": [
        "Non disponi dei permessi per modificare la password.",
      ],
      "Update password": ["Aggiorna password"],
      "Choose a new password for your bank account.": [
        "Scegli una nuova password per il tuo conto bancario.",
      ],
      'Choose a new password for account "%1$s".': [
        "Scegli una nuova password per il conto «%1$s».",
      ],
      "Current password": ["Password attuale"],
      "Your current password, for security": [
        "La tua password attuale, per motivi di sicurezza",
      ],
      "New password": ["Nuova password"],
      "Confirm new password": ["Conferma la nuova password"],
      "Enter the new password again.": [
        "Inserisci nuovamente la nuova password.",
      ],
      "Failed to load transactions.": ["Impossibile caricare le transazioni."],
      "Unknown account": ["Conto sconosciuto"],
      "Recent activity": ["Attività recente"],
      "Transactions": ["Transazioni"],
      "Subject": ["Soggetto"],
      "Today": ["Oggi"],
      "Yesterday": ["Ieri"],
      "Invalid value": ["Valore non valido"],
      "View all transactions": ["Mostra tutte le transazioni"],
      "No transactions yet.": ["Nessuna transazione ancora."],
      "Your account activity will appear here.": [
        "L'attività del tuo conto apparirà qui.",
      ],
      "Date": ["Data"],
      "Counterparty": ["Controparte"],
      "Pagination": ["Paginazione"],
      "Newer": ["Più recenti"],
      "Older": ["Meno recenti"],
      "Withdraw to Taler Wallet": ["Preleva nel portafoglio Taler"],
      "Move digital cash to your Taler Wallet.": [
        "Trasferisci denaro digitale nel tuo portafoglio Taler.",
      ],
      "Send bank transfer": ["Invia bonifico bancario"],
      "Transfer money to another bank account.": [
        "Trasferisci denaro a un altro conto bancario.",
      ],
      "Convert regional currency and send it to your cashout account.": [
        "Converti la valuta regionale e inviala al tuo conto di prelievo.",
      ],
      "Copy account address": ["Copia l’indirizzo del conto"],
      "Current balance": ["Saldo attuale"],
      "Go to account details": ["Vai ai dettagli del conto"],
      "Failed to load the admin account.": [
        "Impossibile caricare il conto amministratore.",
      ],
      "Admin account": ["Conto amministratore"],
      "Admin account activity": ["Attività del conto amministratore"],
      "Failed to load the monitor info.": [
        "Impossibile caricare le informazioni di monitoraggio.",
      ],
      "Failed to load cashout info.": [
        "Impossibile caricare le informazioni sul Cashout.",
      ],
      "Querying for the current stats failed": [
        "Interrogazione delle statistiche attuali non riuscita",
      ],
      "The request parameters are invalid.": [
        "I parametri della richiesta non sono validi.",
      ],
      "The user is unauthorized": ["L'utente non è autorizzato"],
      "Querying for the previous stats failed": [
        "Interrogazione delle statistiche precedenti non riuscita",
      ],
      "Bank activity": ["Attività bancaria"],
      "Select a section": ["Seleziona una sezione"],
      "Last hour": ["Ultima ora"],
      "Previous day": ["Giorno precedente"],
      "Last month": ["Ultimo mese"],
      "Last year": ["Ultimo anno"],
      "Tabs": ["Schede"],
      "Last Year": ["Ultimo anno"],
      "Trading volume from %1$s to %2$s": ["Volume di scambio da %1$s a %2$s"],
      "Cash in": ["Entrata di fondi"],
      "Transferred from an external account to an account in this bank.": [
        "Trasferito da un conto esterno a un conto di questa banca.",
      ],
      "Transferred from an account in this bank to an external account.": [
        "Trasferito da un conto di questa banca a un conto esterno.",
      ],
      "Taler pay-in": ["Versamento Taler"],
      "Transferred from an account to a Taler exchange.": [
        "Trasferito da un conto a un Exchange Taler.",
      ],
      "Transfers": ["Trasferimenti"],
      "Taler payout": ["Pagamento in uscita Taler"],
      "Transferred from a Taler exchange to another account.": [
        "Trasferito da un Exchange Taler a un altro conto.",
      ],
      "Download stats as CSV": ["Scarica le statistiche come CSV"],
      "previous": ["precedente"],
      "Decreased by": ["Diminuito di"],
      "Increased by": ["Aumentato di"],
      'Account created with password "%1$s".': [
        'Account creato con la password "%1$s".',
      ],
      "Failed to create a new account.": ["Impossibile creare un nuovo conto."],
      "Server replied that phone or email is invalid": [
        "Il server ha risposto che il telefono o l'email non è valido",
      ],
      "The rights to perform the operation are not sufficient": [
        "I permessi per eseguire l'operazione non sono sufficienti",
      ],
      "Account username is already taken": [
        "Il nome utente del conto è già in uso",
      ],
      "Account ID is already taken": ["L'ID conto è già in uso"],
      "Bank ran out of bonus credit.": [
        "La banca ha esaurito il credito bonus.",
      ],
      "This account username is reserved and cannot be used.": [
        "Questo nome utente è riservato e non può essere utilizzato.",
      ],
      "Only an administrator is allowed to set the debt limit.": [
        "Solo un amministratore può impostare il limite di debito.",
      ],
      "Only admin can create accounts with second factor authentication.": [
        "Solo l'amministratore può creare conti con autenticazione a due fattori.",
      ],
      "Can't create accounts": ["Impossibile creare conti"],
      "Only a system administrator can create accounts.": [
        "Solo un amministratore di sistema può creare conti.",
      ],
      "Back to accounts": ["Torna ai conti"],
      "New bank account": ["Nuovo conto bancario"],
      "Create an account and configure its initial access and profile.": [
        "Crea un conto e configurane l’accesso iniziale e il profilo.",
      ],
      "Create account": ["Crea conto"],
      "Failed to download statistics.": [
        "Impossibile scaricare le statistiche.",
      ],
      "A statistics request failed. Please try again.": [
        "Una richiesta di statistiche non è riuscita. Riprova.",
      ],
      "only admin can download stats": [
        "solo l'amministratore può scaricare le statistiche",
      ],
      "Back to dashboard": ["Torna alla panoramica"],
      "Download bank statistics": ["Scarica le statistiche della banca"],
      "Choose which reporting periods to include in the CSV file.": [
        "Scegli quali periodi di rendicontazione includere nel file CSV.",
      ],
      "Include hour metric": ["Includi la metrica oraria"],
      "Include day metric": ["Includi la metrica giornaliera"],
      "Include month metric": ["Includi la metrica mensile"],
      "Include year metric": ["Includi la metrica annuale"],
      "Include table header": ["Includi l'intestazione della tabella"],
      "Add previous metric for comparison": [
        "Aggiungi la metrica precedente per il confronto",
      ],
      "Fail on first error": ["Interrompi al primo errore"],
      "Download": ["Scarica"],
      "Downloading… %1$s": ["Scaricamento in corso… %1$s"],
      "Download completed with missing data": [
        "Scaricamento completato con dati mancanti",
      ],
      "Download completed": ["Download completato"],
      "%1$s statistics requests failed. The file contains only the data that could be retrieved. Click here to save it.":
        [
          "%1$s richieste di statistiche non sono riuscite. Il file contiene soltanto i dati che è stato possibile recuperare. Fai clic qui per salvarlo.",
        ],
      "Click here to save the file on your computer.": [
        "Clicca qui per salvare il file sul tuo computer.",
      ],
      "Name doesn't match": ["Il nome non corrisponde"],
      "Faild to delete the account.": ["Impossibile eliminare il conto."],
      "Not enough permission to delete the account.": [
        "Permessi insufficienti per eliminare il conto.",
      ],
      "The username was not found.": ["Il nome utente non è stato trovato."],
      "Can't delete a reserved username.": [
        "Impossibile eliminare un nome utente riservato.",
      ],
      "Can't delete an account with balance different than zero.": [
        "Impossibile eliminare un conto con un saldo diverso da zero.",
      ],
      "Account deletion": ["Eliminazione del conto"],
      "there was an error reading the balance": [
        "si è verificato un errore durante la lettura del saldo",
      ],
      "Can't delete the account": ["Impossibile eliminare il conto"],
      "The account can't be deleted while still holding some balance. First make sure that the owner makes a complete cashout.":
        [
          "Il conto non può essere eliminato se possiede ancora un saldo. Assicurati prima che il titolare effettui un Cashout completo.",
        ],
      "Go back": ["Indietro"],
      'Delete account "%1$s"': ["Elimina il conto «%1$s»"],
      "This action cannot be undone": [
        "Questa azione non può essere annullata",
      ],
      "All account data will be permanently removed.": [
        "Tutti i dati del conto verranno eliminati definitivamente.",
      ],
      "Verification": ["Verifica"],
      "Enter the account name that is going to be deleted": [
        "Inserisci il nome del conto che stai per eliminare",
      ],
      "Withdraw without setting amount": ["Preleva senza impostare l'importo"],
      "Show install wallet first": [
        "Mostra prima l'installazione del portafoglio",
      ],
      "Introduction": ["Introduzione"],
      "Bank": ["Banca"],
      "Essay Shop": ["Negozio di saggi"],
      "Donations": ["Donazioni"],
      "GNU Taler logo": ["Logo di GNU Taler"],
      "Withdraw toy currency into your GNU Taler wallet.": [
        "Preleva valuta di prova nel tuo portafoglio GNU Taler.",
      ],
      "Demo pages": ["Pagine dimostrative"],
      "You were signed out locally, but the bank could not confirm that the server token was revoked. Close other sessions or sign in again to review active tokens.":
        [
          "La sessione locale è stata chiusa, ma la banca non ha potuto confermare la revoca del token del server. Chiudi le altre sessioni o accedi di nuovo per controllare i token attivi.",
        ],
      "Dismiss": ["Ignora"],
      "Public accounts": ["Conti pubblici"],
      "Open interface preferences": ["Apri preferenze dell’interfaccia"],
      "Interface preferences": ["Preferenze dell’interfaccia"],
      "Choose how this bank interface behaves on this browser.": [
        "Scegli come si comporta questa interfaccia bancaria in questo browser.",
      ],
      "Close interface preferences": ["Chiudi preferenze dell’interfaccia"],
      "Show debug information": ["Mostra le informazioni di debug"],
      "Done": ["Fine"],
      "Welcome": ["Benvenuto"],
      "Welcome, %1$s": ["Benvenuto, %1$s"],
      "Failed to load conversion rate.": [
        "Impossibile caricare il tasso di cambio.",
      ],
      "Not enough permission to access the conversion rate list.": [
        "Permessi insufficienti per accedere all'elenco dei tassi di cambio.",
      ],
      "The conversion-rate list was not found. Conversion may not be supported.":
        [
          "L’elenco dei tassi di cambio non è stato trovato. La conversione potrebbe non essere supportata.",
        ],
      "Conversion list not implemented.": [
        "Elenco dei cambi non implementato.",
      ],
      "Conversion rate classes": ["Classi di tasso di cambio"],
      "Configure different cash-in and cashout terms for groups of accounts.": [
        "Configura condizioni diverse di Cash-in e Cashout per gruppi di conti.",
      ],
      "Default conversion rate": ["Tasso di conversione predefinito"],
      "Create conversion rate class": ["Crea classe di tasso di cambio"],
      "No conversion rate classes": ["Nessuna classe di tasso di cambio"],
      "All accounts currently use the default conversion rate.": [
        "Attualmente tutti i conti usano il tasso di cambio predefinito.",
      ],
      "Name": ["Nome"],
      "Description": ["Descrizione"],
      "Cashin": ["Cashin"],
      "First page": ["Prima pagina"],
      "Next": ["Successivo"],
      "min:": ["min:"],
      "fee:": ["commissione:"],
      "only admin can setup conversion": [
        "solo l'amministratore può configurare il cambio",
      ],
      "Failed to calculate cashout fee.": [
        "Impossibile calcolare la commissione di Cashout.",
      ],
      "Failed to update the conversion rate.": [
        "Impossibile aggiornare il tasso di cambio.",
      ],
      "Wrong credentials": ["Credenziali errate"],
      "Conversion is disabled": ["Il cambio è disabilitato"],
      "Back to conversion settings": ["Torna alle impostazioni di conversione"],
      "Review the default terms or choose a direction to update its settings.":
        [
          "Verifica le condizioni predefinite oppure scegli una direzione per modificarne le impostazioni.",
        ],
      "Conversion view": ["Vista della conversione"],
      "Details": ["Dettagli"],
      "Cashout settings": ["Impostazioni di Cashout"],
      "Cash-in settings": ["Impostazioni di Cash-in"],
      "Bad ratios": ["Rapporti non validi"],
      "One ratio must be greater than or equal to 1, and the other must be less than or equal to 1.":
        [
          "Un rapporto deve essere maggiore o uguale a 1 e l’altro minore o uguale a 1.",
        ],
      "Initial amount": ["Importo iniziale"],
      "Use it to test how the conversion will affect the amount.": [
        "Usalo per verificare come il cambio influirà sull'importo.",
      ],
      "Sending to this bank": ["Invio verso questa banca"],
      "Converted": ["Convertito"],
      "Cashin after fee": ["Cashin dopo la commissione"],
      "Sending from this bank": ["Invio da questa banca"],
      "Cashout after fee": ["Cashout dopo la commissione"],
      "Bad configuration": ["Configurazione non valida"],
      "This configuration allows users to cash out more of what has been cashed in.":
        [
          "Questa configurazione permette agli utenti di effettuare un Cashout superiore a quanto versato con il Cashin.",
        ],
      "Must be > 0": ["Deve essere > 0"],
      "Ratio": ["Rapporto"],
      "Zero": ["Zero"],
      "Up": ["Su"],
      "Nearest": ["Più vicino"],
      "Minimum amount": ["Importo minimo"],
      "Only cashout operations above this threshold will be allowed.": [
        "Saranno consentite solo le operazioni di Cashout superiori a questa soglia.",
      ],
      "Conversion ratio between currencies": ["Rapporto di cambio tra valute"],
      "Example conversion": ["Esempio di cambio"],
      "1 %1$s will be converted into %2$s %3$s": [
        "1 %1$s verrà convertito in %2$s %3$s",
      ],
      "Tiny amount": ["Piccolo importo"],
      "Rounding mode": ["Modalità di arrotondamento"],
      "Amount will be rounded below to the largest possible value smaller than the input.":
        [
          "L'importo verrà arrotondato per difetto al valore più grande possibile inferiore all'input.",
        ],
      "Amount will be rounded up to the smallest possible value larger than the input.":
        [
          "L'importo verrà arrotondato per eccesso al valore più piccolo possibile superiore all'input.",
        ],
      "Amount will be rounded to the closest possible value.": [
        "L'importo verrà arrotondato al valore possibile più vicino.",
      ],
      'If none specified the fallback value is "%1$s ".': [
        'Se non specificato, il valore predefinito è "%1$s ".',
      ],
      "Examples": ["Esempi"],
      "Rounding an amount of 1.24 with rounding value 0.1": [
        "Arrotondamento di un importo di 1.24 con valore di arrotondamento 0.1",
      ],
      "Given the rounding value of 0.1 the possible values closest to 1.24 are: 1.1, 1.2, 1.3, 1.4.":
        [
          "Dato il valore di arrotondamento di 0.1, i valori possibili più vicini a 1.24 sono: 1.1, 1.2, 1.3, 1.4.",
        ],
      'With the "zero" mode the value will be rounded to 1.2': [
        'Con la modalità "zero" il valore verrà arrotondato a 1.2',
      ],
      'With the "nearest" mode the value will be rounded to 1.2': [
        'Con la modalità "più vicino" il valore verrà arrotondato a 1.2',
      ],
      'With the "up" mode the value will be rounded to 1.3': [
        'Con la modalità "su" il valore verrà arrotondato a 1.3',
      ],
      "Rounding an amount of 1.26 with rounding value 0.1": [
        "Arrotondamento di un importo di 1.26 con valore di arrotondamento 0.1",
      ],
      'With the "nearest" mode the value will be rounded to 1.3': [
        'Con la modalità "più vicino" il valore verrà arrotondato a 1.3',
      ],
      "Rounding an amount of 1.24 with rounding value 0.3": [
        "Arrotondamento di un importo di 1.24 con valore di arrotondamento 0.3",
      ],
      "Given the rounding value of 0.3 the possible values closest to 1.24 are: 0.9, 1.2, 1.5, 1.8.":
        [
          "Dato il valore di arrotondamento di 0.3, i valori possibili più vicini a 1.24 sono: 0.9, 1.2, 1.5, 1.8.",
        ],
      'With the "up" mode the value will be rounded to 1.5': [
        'Con la modalità "su" il valore verrà arrotondato a 1.5',
      ],
      "Rounding an amount of 1.26 with rounding value 0.3": [
        "Arrotondamento di un importo di 1.26 con valore di arrotondamento 0.3",
      ],
      "Amount to be deducted before amount is credited.": [
        "Importo da detrarre prima che l'importo venga accreditato.",
      ],
      "Failed to load conversion details.": [
        "Impossibile caricare i dettagli del cambio.",
      ],
      "Conversion should be enabled in the configuration, the conversion rate should be initialized with fee(s), rates and a rounding mode.":
        [
          "Il cambio deve essere abilitato nella configurazione, il tasso di cambio deve essere inizializzato con commissioni, tassi e una modalità di arrotondamento.",
        ],
      "Failed to delete conversion rate class": [
        "Impossibile eliminare la classe di tasso di cambio",
      ],
      "Unauthorized": ["Non autorizzato"],
      "Forbidden": ["Vietato"],
      "Conversion rate class was not found.": [
        "La classe di tasso di cambio non è stata trovata.",
      ],
      "Deleting conversion rate classes is not supported by this bank.": [
        "Questa banca non consente di eliminare le classi di tasso di cambio.",
      ],
      "Failed to update conversion rate class.": [
        "Impossibile aggiornare la classe di tasso di cambio.",
      ],
      "Not Found": ["Non trovato"],
      "Not implemented": ["Non implementato"],
      "The name of the conversion is already used.": [
        "Il nome del cambio è già utilizzato.",
      ],
      "Accounts": ["Conti"],
      "Test conversion": ["Prova la conversione"],
      "Delete class": ["Elimina classe"],
      "Manage this conversion rate class and the accounts assigned to it.": [
        "Gestisci questa classe di tasso di cambio e i conti che le sono assegnati.",
      ],
      "Conversion rate class sections": [
        "Sezioni della classe di tasso di cambio",
      ],
      "identification": ["identificazione"],
      "Conversion rate class name": ["Nome della classe di tasso di cambio"],
      "Conversion rate class description": [
        "Descrizione della classe di tasso di cambio",
      ],
      "Users": ["Utenti"],
      "Delete": ["Elimina"],
      "Failed to calculate the cashout fee.": [
        "Impossibile calcolare la commissione di Cashout.",
      ],
      "Can't remove the conversion rate class": [
        "Impossibile rimuovere la classe di tasso di cambio",
      ],
      "There are some users associated with this class. You need to remove them first.":
        [
          "Ci sono alcuni utenti associati a questa classe. Devi prima rimuoverli.",
        ],
      "You are going to remove the conversion rate class": [
        "Stai per rimuovere la classe di tasso di cambio",
      ],
      "This step can't be undone.": [
        "Questo passaggio non può essere annullato.",
      ],
      "Class": ["Classe"],
      "Action": ["Azione"],
      "Failed to update conversion class membership.": [
        "Impossibile aggiornare l’appartenenza alla classe di conversione.",
      ],
      "The account could not be updated. Please try again.": [
        "Non è stato possibile aggiornare il conto. Riprova.",
      ],
      "Conversion rate information is unavailable for these accounts.": [
        "Le informazioni sul tasso di conversione non sono disponibili per questi conti.",
      ],
      "Failed to load users in conversion class.": [
        "Impossibile caricare gli utenti nella classe di cambio.",
      ],
      "Filters": ["Filtri"],
      "Show from other classes": ["Mostra da altre classi"],
      "Account": ["Conto"],
      "Group ID": ["ID gruppo"],
      "No users in this conversion rate class": [
        "Nessun utente in questa classe di tasso di cambio",
      ],
      "Remove": ["Rimuovi"],
      "Add": ["Aggiungi"],
      "Conversion rate name": ["Nome del tasso di cambio"],
      "Short description of the class": ["Breve descrizione della classe"],
      "Failed to create conversion class.": [
        "Impossibile creare la classe di cambio.",
      ],
      "New conversion rate class": ["Nuova classe di tasso di cambio"],
      "Create a named set of conversion terms that can be assigned to accounts.":
        [
          "Crea un insieme denominato di condizioni di conversione da assegnare ai conti.",
        ],
      "Create class": ["Crea classe"],
      "Failed to load public accounts.": [
        "Impossibile caricare i conti pubblici.",
      ],
      "Browse transaction histories shared by public bank accounts.": [
        "Consulta lo storico delle transazioni condiviso dai conti bancari pubblici.",
      ],
      "No public accounts are available.": [
        "Non sono disponibili conti pubblici.",
      ],
      "View previous cashouts": ["Mostra i prelievi precedenti"],
      "Cashout ID must be a number.": [
        "L’ID del Cashout deve essere un numero.",
      ],
      "Failed to load cashout details.": [
        "Impossibile caricare i dettagli del Cashout.",
      ],
      "This cashout was not found. It may already have been aborted.": [
        "Questo Cashout non è stato trovato. Potrebbe essere già stato annullato.",
      ],
      "Back to cashout history": ["Torna alla cronologia dei Cashout"],
      "Amounts recorded for this completed cashout transfer.": [
        "Importi registrati per questo trasferimento di Cashout completato.",
      ],
      "Amount debited": ["Importo addebitato"],
      "Amount transferred": ["Importo trasferito"],
      "Enter your full name.": ["Inserisci il nome completo."],
      "Repeat your password.": ["Ripeti la password"],
      "Create your bank account": ["Crea conto"],
      "Choose the credentials you will use to sign in.": [
        "Scegli le credenziali che userai per accedere.",
      ],
      "Already have an account?": ["Hai già un conto?"],
      "Confirm password": ["Conferma password"],
      "Use between 8 and 64 characters. A longer, unique password is easier to keep secure.":
        [
          "Usa tra 8 e 64 caratteri. Una password più lunga e univoca è più facile da mantenere sicura.",
        ],
      "Creating account…": ["Creazione del conto…"],
      "Check the account details and try again.": [
        "Controlla i dati del conto e riprova.",
      ],
      "You are not authorized to create this account.": [
        "Non sei autorizzato a creare questo conto.",
      ],
      "Registration is unavailable because the bank cannot grant the account credit.":
        [
          "La registrazione non è disponibile perché la banca non può concedere credito al conto.",
        ],
      "That username is reserved. Choose another username.": [
        "Questo nome utente è riservato. Scegline un altro.",
      ],
      "That username is already taken.": ["Quel nome utente è già in uso."],
      "That account ID is already taken.": ["Quell'ID conto è già in uso."],
      "The bank is missing information for the selected authentication channel.":
        ["Nessuna informazione per il canale di autenticazione selezionato."],
      "The selected authentication channel is not supported.": [
        "Il canale di autenticazione non è supportato.",
      ],
      "Only an administrator may set the debt limit.": [
        "Solo un amministratore può impostare il limite di debito.",
      ],
      "Only an administrator may select a conversion rate class.": [
        "Solo un amministratore può selezionare una classe di tasso di cambio.",
      ],
      "The selected conversion rate class does not exist.": [
        "La classe di tasso di cambio non esiste.",
      ],
      "Only an administrator may enable two-factor authentication while creating an account.":
        [
          "Solo un amministratore può attivare l’autenticazione a due fattori durante la creazione di un conto.",
        ],
      "Account registration is unavailable": ["Registrazione del conto"],
      "This bank is not accepting new account registrations.": [
        "Al momento la banca non accetta nuove registrazioni!",
      ],
      "Return to sign in": ["Torna all’accesso"],
      "Contact the bank administrator if you need an account.": [
        "Contatta l’amministratore della banca.",
      ],
      "Send money from this account to another bank account.": [
        "Invia denaro da questo conto a un altro conto bancario.",
      ],
      "Failed to load withdrawal details.": [
        "Impossibile caricare i dettagli del prelievo.",
      ],
      "Choose amount": ["Scegli importo"],
      "Open wallet": ["Apri il portafoglio"],
      "Review": ["Verifica"],
      "Withdrawal progress": ["Avanzamento del prelievo"],
      "Abort this withdrawal?": ["Annullare questo prelievo?"],
      "This stops the withdrawal. No money will be transferred, and this operation cannot be resumed.":
        [
          "Il prelievo verrà annullato. Non verrà trasferito denaro e non sarà possibile riprendere l’operazione.",
        ],
      "Keep withdrawal": ["Mantieni il prelievo"],
      "Abort withdrawal": ["Annulla il prelievo"],
      'The payto URI returned by the server is invalid: "%1$s".': [
        'L\'URI payto restituito dal server non è valido: "%1$s".',
      ],
      'The withdrawal URI returned by the server is invalid: "%1$s".': [
        'L\'URI di prelievo restituito dal server non è valido: "%1$s".',
      ],
      'The reserve public key returned by the server is invalid: "%1$s".': [
        'La chiave pubblica della riserva restituita dal server non è valida: "%1$s".',
      ],
      "Enter an amount.": ["Inserisci un importo."],
      "Enter a valid amount.": ["Inserisci un importo valido."],
      "The amount must be greater than zero.": [
        "L’importo deve essere maggiore di zero.",
      ],
      "The amount is below the bank's minimum.": [
        "L’importo è inferiore al minimo della banca.",
      ],
      "The amount is above the bank's maximum.": [
        "L’importo è superiore al massimo della banca.",
      ],
      "Failed to abort the withdrawal.": ["Impossibile annullare il prelievo."],
      "The server did not understand the request.": [
        "Il server non ha compreso la richiesta.",
      ],
      "The operation was not found.": ["L'operazione non è stata trovata."],
      "The withdrawal operation has already been confirmed and cannot be aborted.":
        [
          "L’operazione di prelievo è già stata confermata e non può essere annullata.",
        ],
      "The bank could not be reached. Please try again.": [
        "Non è stato possibile contattare la banca. Riprova.",
      ],
      "Withdrawal confirmation": ["Conferma del prelievo"],
      "Failed to confirm the withdrawal.": [
        "Impossibile confermare il prelievo.",
      ],
      "The account does not have sufficient funds or the amount is outside the limits.":
        [
          "Il conto non dispone di fondi sufficienti oppure l'importo è fuori dai limiti.",
        ],
      "The withdrawal has been aborted and cannot be confirmed.": [
        "Il prelievo è stato annullato e non può essere confermato.",
      ],
      "The wallet has not finished selecting an exchange account.": [
        "Il portafoglio non ha ancora terminato la selezione di un conto dell’Exchange.",
      ],
      "The withdrawal amount changed. Review the current amount and try again.":
        [
          "L’importo del prelievo è cambiato. Controlla l’importo attuale e riprova.",
        ],
      "Enter an amount before confirming the withdrawal.": [
        "Inserisci un importo prima di confermare il prelievo.",
      ],
      "Selected exchange": ["Exchange selezionato"],
      "Sign in to confirm the withdrawal": [
        "Accedi per confermare il prelievo",
      ],
      "Sign in as %1$s before reviewing and confirming this withdrawal.": [
        "Accedi come %1$s prima di controllare e confermare questo prelievo.",
      ],
      "You are signed in as %1$s, but this withdrawal belongs to %2$s.": [
        "Hai effettuato l’accesso come %1$s, ma questo prelievo appartiene a %2$s.",
      ],
      "Finish later": ["Termina più tardi"],
      "Confirm wallet withdrawal": ["Conferma il prelievo nel portafoglio"],
      "Review how much will leave your bank account before confirming.": [
        "Controlla quanto verrà prelevato dal tuo conto bancario prima di confermare.",
      ],
      "Unsupported exchange account": ["Conto dell’Exchange non supportato"],
      "The exchange account does not use the transfer type configured by this bank. This withdrawal cannot be confirmed.":
        [
          "Il conto dell’Exchange non usa il tipo di bonifico configurato da questa banca. Questo prelievo non può essere confermato.",
        ],
      "Withdrawal amount missing": ["Importo del prelievo mancante"],
      "The bank did not provide an amount for this withdrawal. It cannot be confirmed.":
        [
          "La banca non ha fornito un importo per questo prelievo. Non può essere confermato.",
        ],
      "Bank amount configuration invalid": [
        "La configurazione degli importi della banca non è valida",
      ],
      "The withdrawal amount and bank fee could not be combined safely. This withdrawal cannot be confirmed.":
        [
          "L’importo del prelievo e la commissione bancaria non possono essere sommati in modo sicuro. Questo prelievo non può essere confermato.",
        ],
      "Wallet receives": ["Il portafoglio riceve"],
      "Amount to your Taler Wallet": ["Importo per il tuo portafoglio Taler"],
      "Allowed amount": ["Importo consentito"],
      "Maximum amount": ["Importo massimo"],
      "Amount unavailable": ["Importo non disponibile"],
      "From": ["Da"],
      "To": ["A"],
      "Taler Wallet": ["Portafoglio Taler"],
      "Exchange": ["Exchange"],
      "Unavailable": ["Non disponibile"],
      "Exchange details": ["Dettagli dell’Exchange"],
      "Exchange IBAN": ["IBAN dell’Exchange"],
      "Bank hostname": ["Nome host della banca"],
      "Exchange account": ["Conto dell’Exchange"],
      "No money is withdrawn until you confirm. You can finish this later from your account overview.":
        [
          "Nessun denaro viene prelevato finché non confermi. Puoi terminare più tardi dal riepilogo del conto.",
        ],
      "Confirm withdrawal": ["Conferma prelievo"],
      "Unauthorized to make the operation, maybe the session has expired or the password changed.":
        [
          "Non autorizzato a effettuare l'operazione, la sessione potrebbe essere scaduta o la password potrebbe essere cambiata.",
        ],
      "The operation was rejected due to insufficient funds.": [
        "L'operazione è stata rifiutata per fondi insufficienti.",
      ],
      "Withdrawal aborted": ["Prelievo annullato"],
      "Withdrawal confirmed": ["Prelievo confermato"],
      "The bank transfer to the Taler exchange has been initiated. Your Taler Wallet will receive the withdrawn amount shortly.":
        [
          "Il bonifico bancario verso l’Exchange Taler è stato avviato. Il tuo portafoglio Taler riceverà a breve l’importo prelevato.",
        ],
      "Back to account": ["Torna al conto"],
      "Complete withdrawal with your Taler Wallet": [
        "Completa il prelievo con il tuo portafoglio Taler",
      ],
      "Scan this QR code with your Taler Wallet. Your wallet will select an exchange and prepare the withdrawal.":
        [
          "Scansiona questo codice QR con il tuo portafoglio Taler. Il portafoglio selezionerà un Exchange e preparerà il prelievo.",
        ],
      "Withdrawal amount": ["Importo del prelievo"],
      "Suggested amount": ["Importo suggerito"],
      "You can change this amount in your wallet.": [
        "Puoi modificare questo importo nel portafoglio.",
      ],
      "QR code to continue the withdrawal in a Taler Wallet.": [
        "Codice QR per continuare il prelievo in un portafoglio Taler.",
      ],
      "Open Taler Wallet manually": ["Apri manualmente il portafoglio Taler"],
      "Don't have a Taler Wallet?": ["Non hai un portafoglio Taler?"],
      "Get a wallet": ["Ottieni un portafoglio"],
      "No money will be transferred until you return here to review and confirm the withdrawal.":
        [
          "Nessun importo verrà trasferito finché non tornerai qui per verificare e confermare il prelievo.",
        ],
      "Sign in to abort this withdrawal": [
        "Accedi per annullare questo prelievo",
      ],
      "The withdrawal operation has been confirmed previously and can not be aborted.":
        [
          "L'operazione di prelievo è già stata confermata in precedenza e non può essere annullata.",
        ],
      "Withdrawal ready for confirmation": ["Prelievo pronto per la conferma"],
      "Withdrawal waiting for your wallet": [
        "Prelievo in attesa del portafoglio",
      ],
      "The pending withdrawal could not be checked": [
        "Non è stato possibile verificare il prelievo in sospeso",
      ],
      "Checking the pending withdrawal…": ["Verifica del prelievo in sospeso…"],
      "Review withdrawal": ["Controlla il prelievo"],
      "Retry": ["Riprova"],
      "Resume withdrawal": ["Riprendi il prelievo"],
      "Finish or abort this withdrawal before starting another one.": [
        "Completa o annulla questo prelievo prima di iniziarne un altro.",
      ],
      "Dashboard": ["Pannello di controllo"],
      "Admin activity": ["Attività amministratore"],
      "Conversion": ["Cambio"],
      "My account": ["Il mio conto"],
      "Bank administration": ["Amministrazione bancaria"],
      "Failed to load the account list.": [
        "Impossibile caricare l'elenco dei conti.",
      ],
      "Search accounts": ["Cerca conti"],
      "Search by username or name": ["Cerca per nome utente o nome"],
      "Search": ["Cerca"],
      "Clear": ["Cancella"],
      "Unknown": ["Sconosciuto"],
      "Change password": ["Modifica password"],
      "Previous": ["Precedente"],
      "The amount exceeds what is available to withdraw.": [
        "L’importo supera la somma disponibile per il prelievo.",
      ],
      "The server replied with an invalid taler://withdraw URI": [
        "Il server ha risposto con un URI taler://withdraw non valido",
      ],
      "Withdraw URI: %1$s": ["URI di prelievo: %1$s"],
      "Failed to create the withdrawal.": ["Impossibile creare il prelievo."],
      "The operation was rejected due to insufficient funds": [
        "L'operazione è stata rifiutata per fondi insufficienti",
      ],
      "Please sign in again.": ["Accedi di nuovo."],
      "Choose an amount. Next, open your wallet and return here to review and confirm the withdrawal.":
        [
          "Scegli un importo. Quindi apri il portafoglio e torna qui per verificare e confermare il prelievo.",
        ],
      "Unable to calculate the withdrawal amount": [
        "Impossibile calcolare l’importo del prelievo",
      ],
      "The bank's withdrawal limits or fee are configured incorrectly.": [
        "I limiti o la commissione di prelievo della banca non sono configurati correttamente.",
      ],
      "Maximum withdrawal": ["Prelievo massimo"],
      "There is not enough available balance to cover a withdrawal and the bank fee.":
        [
          "Il saldo disponibile non è sufficiente a coprire il prelievo e la commissione bancaria.",
        ],
      "Use maximum available": ["Usa il massimo disponibile"],
      "No money moves until you review and confirm the withdrawal.": [
        "Il denaro non verrà trasferito finché non verifichi e confermi il prelievo.",
      ],
      "Need a Taler Wallet?": ["Hai bisogno di un portafoglio Taler?"],
      "Get the wallet": ["Ottieni il portafoglio"],
      "Dismiss wallet installation hint": [
        "Chiudi il suggerimento per l’installazione del portafoglio",
      ],
      "Continue to wallet": ["Continua nel portafoglio"],
      "Unable to start a withdrawal.": ["Impossibile avviare il prelievo."],
      "Your account was created. Sign in to continue.": [
        "Il conto è stato creato. Accedi per continuare.",
      ],
      "Conversion rate class ID “%1$s” is not a number.": [
        "L’ID della classe di tasso di cambio «%1$s» non è un numero.",
      ],
      "Home": ["Pagina iniziale"],
      "Page not found": ["Pagina non trovata"],
      "The requested bank page does not exist.": [
        "La pagina della banca richiesta non esiste.",
      ],
      "Unknown challenge.": ["Verifica sconosciuta."],
      "Failed to validate the verification code.": [
        "Impossibile convalidare il codice di verifica.",
      ],
      "Too many challenges are active. Wait or confirm an existing challenge.":
        [
          "Ci sono troppe verifiche attive in questo momento, devi attendere o confermare le verifiche in corso.",
        ],
      "The verification code is incorrect.": [
        "Il codice di verifica non è corretto.",
      ],
      "The verification code has expired.": [
        "Il codice di verifica è scaduto.",
      ],
      "Submit the transmitted code number.": [
        "Invia il numero di codice ricevuto.",
      ],
      "The verification code sent to the email address starting with %1$s": [
        "Il codice di verifica inviato all'indirizzo email che inizia con %1$s",
      ],
      "The verification code sent to the phone number ending with %1$s": [
        "Il codice di verifica inviato al numero di telefono che termina con %1$s",
      ],
      "Code": ["Codice"],
      "Authentication code": ["Codice di autenticazione"],
      "It will expire at %1$s": ["Scadrà alle %1$s"],
      "This challenge is terminal and cannot be retransmitted.": [
        "Questa procedura di verifica è terminata e non può essere ritrasmessa.",
      ],
      "Restart authentication": ["Riavvia l’autenticazione"],
      "Back": ["Indietro"],
      "Verifying…": ["Verifica in corso…"],
      "Verify": ["Verifica"],
      "Complete": ["Completa"],
      "Failed to start the challenge.": ["Impossibile avviare la verifica."],
      "Unable to send the verification code.": [
        "Impossibile inviare il codice di verifica.",
      ],
      "The request was valid, but the server is refusing action.": [
        "La richiesta era valida, ma il server rifiuta di eseguire l'azione.",
      ],
      "The backend is not aware of the specified MFA challenge.": [
        "Il backend non è a conoscenza della verifica MFA specificata.",
      ],
      "It is too early to request another transmission of the challenge.": [
        "È troppo presto per richiedere un nuovo invio della verifica.",
      ],
      "Code transmission failed.": ["Invio del codice non riuscito."],
      "Multi-factor authentication required": [
        "Autenticazione a più fattori richiesta",
      ],
      "This operation is protected with second factor authentication. In order to complete it we need to verify your identity using the authentication channel you provided.":
        [
          "Questa operazione è protetta con l'autenticazione a due fattori. Per completarla dobbiamo verificare la tua identità utilizzando il canale di autenticazione che hai fornito.",
        ],
      "The next challenge needs to be completed to confirm the operation.": [
        "La prossima verifica deve essere completata per confermare l'operazione.",
      ],
      "All the next challenges need to be completed to confirm the operation.":
        [
          "Tutte le prossime verifiche devono essere completate per confermare l'operazione.",
        ],
      "One of the next challenges needs to be completed to confirm the operation.":
        [
          "Una delle prossime verifiche deve essere completata per confermare l'operazione.",
        ],
      'To a phone ending with "%1$s"': ['A un telefono che termina con "%1$s"'],
      'To an email starting with " %1$s"': [
        'A un\'email che inizia con " %1$s"',
      ],
      "I have a code": ["Ho un codice"],
      "Send me a message": ["Inviami un messaggio"],
      "You have to wait until %1$s to send a new code.": [
        "Devi attendere fino alle %1$s per inviare un nuovo codice.",
      ],
      "Use configured value (enabled)": [
        "Usa il valore configurato (abilitato)",
      ],
      "Use configured value (disabled)": [
        "Usa il valore configurato (disabilitato)",
      ],
      "Force enabled": ["Forza l’abilitazione"],
      "Force disabled": ["Forza la disabilitazione"],
      "Enter a valid HTTP or HTTPS URL.": [
        "Inserisci un URL HTTP o HTTPS valido.",
      ],
      "Development settings": ["Impostazioni di sviluppo"],
      "These overrides are stored only in this browser.": [
        "Queste sostituzioni vengono memorizzate solo in questo browser.",
      ],
      "Corebank API base URL": ["URL di base dell'API Corebank"],
      "Leave empty to use the configured URL: %1$s": [
        "Lascia vuoto per usare l'URL configurato: %1$s",
      ],
      "Leave empty to derive the URL from this page.": [
        "Lascia vuoto per ricavare l'URL da questa pagina.",
      ],
      "Demo header": ["Intestazione demo"],
      "Control whether the demo header is shown in this browser.": [
        "Determina se l’intestazione demo viene mostrata in questo browser.",
      ],
      "Control whether public account links are shown in this browser.": [
        "Determina se i collegamenti ai conti pubblici vengono mostrati in questo browser.",
      ],
      "Overrides saved.": ["Sostituzioni salvate."],
      "Apply overrides": ["Applica sostituzioni"],
      "Clear overrides": ["Cancella sostituzioni"],
      "Back to bank": ["Torna alla banca"],
    },
  },
  domain: "messages",
  plural_forms: "nplurals=2; plural=n != 1;",
  lang: "it",
  completeness: 100,
};

strings["he"] = {
  locale_data: {
    messages: {
      "": {
        domain: "messages",
        lang: "he",
        plural_forms:
          "nplurals=4; plural=(n == 1) ? 0 : ((n == 2) ? 1 : ((n > 10 && n % 10 == 0) ? 2 : 3));",
      },
      "Hide password": ["הסתרת הסיסמה"],
      "Show password": ["הצגת הסיסמה"],
      "Hide": ["הסתרה"],
      "Show": ["הצגה"],
      "Identity verification.": ["אימות זהות."],
      "You do not have permission to access this account.": [
        "אין לכם הרשאה לגשת לחשבון זה.",
      ],
      "This account is locked. Contact the bank administrator.": [
        "החשבון נעול ולא ניתן להתחבר אליו. פנו למנהל המערכת.",
      ],
      "The password is incorrect.": ["הסיסמה שגויה."],
      "Account not found.": ["החשבון לא נמצא"],
      "Could not reach the bank. Check your connection and try again.": [
        "לא ניתן ליצור קשר עם הבנק. בדקו את החיבור ונסו שוב.",
      ],
      "Confirm your password": ["אישור הסיסמה"],
      "Sign in to %1$s": ["כניסה אל %1$s"],
      "Enter the password for %1$s to continue.": [
        "הזינו את הסיסמה של %1$s כדי להמשיך.",
      ],
      "Use your bank account credentials to continue.": [
        "השתמשו בפרטי חשבון הבנק כדי להמשיך.",
      ],
      "Need an account?": ["צריכים חשבון?"],
      "Create one": ["יצירת חשבון"],
      "Your session expired. Confirm your password to continue.": [
        "פג תוקף ההפעלה. אשרו את הסיסמה כדי להמשיך.",
      ],
      "Username": ["שם משתמש"],
      "Password": ["סיסמה"],
      "Sign out": ["יציאה"],
      "Signing in…": ["מתבצעת כניסה…"],
      "Continue": ["המשך"],
      "Sign in": ["כניסה"],
      "Enter your username.": ["הזינו את שם המשתמש."],
      "Use letters, numbers, or any of these characters: - . _ ~": [
        "יש להשתמש באותיות, מספרים או בתווים הבאים: - . _ ~",
      ],
      "The username must not exceed 126 characters.": [
        "שם המשתמש לא יכול להכיל יותר מ־126 תווים.",
      ],
      "Enter your password.": ["הזינו את הסיסמה."],
      "The password must contain at least 8 characters.": [
        "הסיסמה קצרה מדי. אינה יכולה להכיל פחות מ-8 תווים.",
      ],
      "The password must not exceed %1$s characters.": [
        "הסיסמה לא יכולה להכיל יותר מ־%1$s תווים.",
      ],
      "IBAN country code not found": ["קוד המדינה של ה-IBAN לא נמצא"],
      "IBAN length is invalid for this country": [
        "אורך ה-IBAN אינו תקין עבור מדינה זו",
      ],
      "The IBAN contains invalid characters": ["ה-IBAN מכיל תווים לא חוקיים"],
      "IBAN number is not valid, checksum is wrong": [
        "מספר ה-IBAN אינו תקין, ספרת הביקורת שגויה",
      ],
      "The IBAN is not valid": ["ה-IBAN אינו תקין"],
      "Use letters, numbers or any of these characters: - . _ ~": [
        "יש להשתמש באותיות, מספרים או בתווים הבאים: - . _ ~",
      ],
      "Failed to load cashouts.": ["טעינת הפדיונות נכשלה."],
      "Try again": ["נסו שוב"],
      "Cashout is disabled": ["הפדיון מושבת"],
      "Cashout should be enabled in the configuration, the conversion rate should be initialized with fee(s), rates and a rounding mode.":
        [
          "יש להפעיל את הפדיון בתצורה, ולאתחל את שער ההמרה עם עמלה/ות, שערים ומצב עיגול.",
        ],
      "Failed to load conversion rate information.": [
        "טעינת נתוני שער ההמרה נכשלה.",
      ],
      "Some cashout details could not be loaded.": [
        "לא ניתן לטעון חלק מפרטי משיכות המזומן.",
      ],
      "The partial list omits cashout IDs: %1$s.": [
        "הרשימה החלקית אינה כוללת את מזהי משיכות המזומן הבאים: %1$s.",
      ],
      "Debited": ["חויב"],
      "Transferred": ["הועבר"],
      "Created": ["נוצר"],
      "Actions": ["פעולות"],
      "Cashout history": ["היסטוריית משיכות מזומן"],
      "Profile": ["פרופיל"],
      "Security": ["אבטחה"],
      "Merchant integration": ["שילוב עם סוחר"],
      "Back to overview": ["חזרה לסקירה הכללית"],
      "My account settings": ["הגדרות החשבון שלי"],
      "Copy": ["העתקה"],
      "Failed to load account details.": ["טעינת פרטי החשבון נכשלה."],
      'Use this information to link your Taler Merchant Backoffice account with the current bank account. You can start by copying the values, then go to your merchant backoffice service provider, login into your account and look for the "import" button in the "bank account" section.':
        [
          'השתמשו במידע זה כדי לקשר את חשבון ה-Backoffice של הסוחר ב-Taler שלכם לחשבון הבנק הנוכחי. אפשר להתחיל בהעתקת הערכים, ולאחר מכן לעבור לספק שירות ה-Backoffice של הסוחר, להתחבר לחשבון שלכם ולחפש את הכפתור "ייבוא" בסעיף "חשבון בנק".',
        ],
      "Not available": ["לא זמין"],
      "Merchant integration is not available for this account.": [
        "שילוב עם סוחר אינו זמין עבור חשבון זה.",
      ],
      "Account type": ["סוג חשבון"],
      "Method to use for wire transfer.": ["שיטה לשימוש בהעברה בנקאית."],
      "IBAN": ["IBAN"],
      "International Bank Account Number.": ["מספר חשבון בנק בינלאומי (IBAN)."],
      "Bank host": ["שרת הבנק"],
      "Bank host where the service is located.": ["מארח הבנק שבו נמצא השירות."],
      "Account name": ["שם החשבון"],
      "Bank account identifier for wire transfers.": [
        "מזהה חשבון בנק להעברות בנקאיות.",
      ],
      "Address": ["כתובת"],
      "Bitcoin address for this account.": ["כתובת Bitcoin עבור חשבון זה."],
      "Account address": ["כתובת החשבון"],
      "Owner's name": ["שם הבעלים"],
      "Legal name of the person holding the account.": [
        "השם המשפטי של האדם המחזיק בחשבון.",
      ],
      "Account info URL": ["כתובת URL של פרטי החשבון"],
      "From where the merchant can download information about incoming wire transfers to this account.":
        [
          "המקום שממנו הסוחר יכול להוריד מידע על העברות בנקאיות נכנסות לחשבון זה.",
        ],
      "Unable to create a cashout": ["לא ניתן ליצור פדיון"],
      "The bank configuration does not support cashout operations.": [
        "תצורת הבנק אינה תומכת בפעולות פדיון.",
      ],
      "Close": ["סגור"],
      "The bank returned incomplete conversion information.": [
        "הבנק החזיר מידע חלקי על ההמרה.",
      ],
      "Please contact the bank administrator.": ["נא לפנות למנהל הבנק."],
      "Authentication required": ["נדרש אימות"],
      "Please sign in to create a cashout.": [
        "נא להתחבר כדי ליצור משיכת מזומן.",
      ],
      "Failed to calculate the conversion fee.": ["חישוב עמלת ההמרה נכשל."],
      "The amount is too small": ["הסכום קטן מדי"],
      "Conversion is not implemented.": ["ההמרה אינה ממומשת."],
      "The currency is not supported": ["המטבע אינו נתמך"],
      "Required": ["שדה חובה"],
      "Invalid": ["לא תקין"],
      "The balance is not sufficient": ["היתרה אינה מספיקה"],
      "It is not possible to cash out less than %1$s: %2$s": [
        "לא ניתן לפדות פחות מ-%1$s: %2$s",
      ],
      "The total transfer to the destination will be zero": [
        "סך ההעברה ליעד יהיה אפס",
      ],
      "Failed to create the cashout.": ["יצירת הפדיון נכשלה."],
      "Cashout": ["פדיון"],
      "Account not found": ["החשבון לא נמצא"],
      "Duplicate request detected, check if the operation succeeded or try again.":
        ["זוהתה בקשה כפולה, בדקו אם הפעולה הצליחה או נסו שוב."],
      "The conversion rate was applied incorrectly": [
        "שער ההמרה הוחל בצורה שגויה",
      ],
      "The account does not have sufficient funds": ["אין בחשבון מספיק כספים"],
      "Missing cashout URI in the profile": ["כתובת URI לפדיון חסרה בפרופיל"],
      "The amount is below the minimum amount permitted.": [
        "הסכום נמוך מהסכום המינימלי המותר.",
      ],
      "Sending the confirmation message failed, retry later or contact the administrator.":
        ["שליחת הודעת האישור נכשלה, נסו שוב מאוחר יותר או פנו למנהל המערכת."],
      "The server doesn't support the current TAN channel.": [
        "השרת אינו תומך בערוץ ה-TAN הנוכחי.",
      ],
      "Conversion rate": ["שער המרה"],
      "Balance": ["יתרה"],
      "Fee": ["עמלה"],
      "No fee": ["ללא עמלה"],
      "To account": ["לחשבון"],
      "Legal name": ["שם משפטי"],
      "If this name doesn't match the account holder's name, your transaction may fail.":
        ["אם שם זה אינו תואם לשם בעל החשבון, ייתכן שהעסקה שלכם תיכשל."],
      "Unable to cash out": ["לא ניתן לפדות"],
      "Before being able to cash out to a bank account, you need to complete your profile":
        ["לפני שתוכלו לפדות לחשבון בנק, עליכם להשלים את הפרופיל שלכם"],
      "Send %1$s": ["שליחת %1$s"],
      "Receive %1$s": ["קבלת %1$s"],
      "Amount": ["סכום"],
      "Total cost": ["עלות כוללת"],
      "Balance left": ["יתרה נותרת"],
      "Before fee": ["לפני עמלה"],
      "Total cashout transfer": ["סך העברת הפדיון"],
      "Cancel": ["בטל"],
      "Cash out": ["פדיון"],
      "Not valid": ["לא תקין"],
      "Does not follow the pattern": ["אינו תואם לתבנית"],
      "The request was invalid or the payto://-URI used unacceptable features.":
        [
          "הבקשה לא הייתה תקינה, או שכתובת ה-payto:// שבה נעשה שימוש כללה מאפיינים בלתי קבילים.",
        ],
      "Not enough permission to complete the operation.": [
        "אין הרשאה מספקת להשלמת הפעולה.",
      ],
      "The bank administrator cannot be the transfer creditor.": [
        "מנהל הבנק אינו יכול להיות הזכאי בהעברה.",
      ],
      'The destination account "%1$s" was not found.': [
        'חשבון היעד "%1$s" לא נמצא.',
      ],
      "The origin and the destination of the transfer can't be the same.": [
        "מקור ויעד ההעברה לא יכולים להיות זהים.",
      ],
      "Your balance is not sufficient for the operation.": [
        "היתרה שלכם אינה מספיקה לביצוע הפעולה.",
      ],
      'The origin account "%1$s" was not found.': [
        'חשבון המקור "%1$s" לא נמצא.',
      ],
      "The attempt to create the transaction has failed. Please try again.": [
        "הניסיון ליצור את העסקה נכשל. נסו שוב.",
      ],
      "Confirm transaction.": ["אשרו את העסקה."],
      "Enter the recipient, a reference, and the amount to send.": [""],
      "Maximum transfer": ["העברה מרבית"],
      "Debt limit": ["מגבלת חוב"],
      "This is not your account balance. This account cannot go into debt.": [
        "זו אינה יתרת החשבון שלכם. חשבון זה אינו יכול להיכנס לחוב.",
      ],
      "This is not your account balance. It includes borrowing up to the debt limit shown here.":
        [
          "זו אינה יתרת החשבון שלכם. הסכום כולל אשראי זמין עד למגבלת החוב המוצגת כאן.",
        ],
      "Recipient": ["נמען"],
      "username": ["שם משתמש"],
      "IBAN of the recipient's account": ["IBAN של חשבון הנמען"],
      "What is this transfer for?": [""],
      "Paste a payto URI containing the recipient, amount, and transfer reference.":
        [""],
      "Uniform resource identifier of the target account": [
        "מזהה משאב אחיד (URI) של חשבון היעד",
      ],
      "payto://x-taler-bank/[bank-host]/[receiver-account]?message=[subject]&amount=[%1$s:X.Y]":
        [
          "payto://x-taler-bank/[bank-host]/[receiver-account]?message=[subject]&amount=[%1$s:X.Y]",
        ],
      "payto://iban/[receiver-iban]?message=[subject]&amount=[%1$s:X.Y]": [
        "payto://iban/[receiver-iban]?message=[subject]&amount=[%1$s:X.Y]",
      ],
      "Bank fee": ["עמלת בנק"],
      "Total debited": ["סך הכול לחיוב"],
      "Need to move money out of this bank?": [""],
      'Only "x-taler-bank" targets are supported': [
        'רק יעדי "x-taler-bank" נתמכים',
      ],
      'Only this host is allowed. Use "%1$s"': [
        'מותר רק מארח זה. השתמשו ב-"%1$s"',
      ],
      "Account name is missing": ["שם החשבון חסר"],
      'Only "IBAN" targets are supported': ['רק יעדי "IBAN" נתמכים'],
      'Missing "amount" parameter to specify the amount to be transferred': [
        'הפרמטר "amount" לציון הסכום להעברה חסר',
      ],
      'The "amount" parameter is not valid': ['הפרמטר "amount" אינו תקין'],
      '"message" parameters to specify a reference text for the transfer are missing':
        ['הפרמטרים "message" לציון טקסט התייחסות להעברה חסרים'],
      'The only currency allowed is "%1$s"': ['המטבע היחיד המותר הוא "%1$s"'],
      "You cannot transfer an amount of zero.": ["אי אפשר להעביר סכום של אפס."],
      "Please enter a longer subject": ["אנא הזינו פרטי העברה ארוכים יותר"],
      "Email and SMS authentication were disabled because their contact details were removed.":
        ["אימות בדוא״ל וב-SMS הושבת משום שפרטי הקשר שלהם הוסרו."],
      "Email authentication was disabled because the email address was removed.":
        ["אימות בדוא״ל הושבת משום שכתובת הדוא״ל הוסרה."],
      "SMS authentication was disabled because the phone number was removed.": [
        "אימות ב-SMS הושבת משום שמספר הטלפון הוסר.",
      ],
      "Invalid email format": ["פורמט אימייל לא תקין"],
      "Should start with +": ["צריך להתחיל ב-+"],
      "A phone number consists of numbers only": [
        "מספר טלפון מורכב ממספרים בלבד",
      ],
      "Login username": ["שם משתמש לכניסה"],
      "Account ID for authentication": ["מזהה חשבון לאימות"],
      "Full name": ["שם מלא"],
      "Name of the account holder": ["שם בעל החשבון"],
      "Internal account": ["חשבון פנימי"],
      "Copy and share this account address to receive transfers.": [
        "העתיקו ושתפו את כתובת החשבון הזו כדי לקבל העברות.",
      ],
      "Email": ["אימייל"],
      "To be used when second factor authentication is enabled": [
        "ישמש כאשר אימות דו-שלבי מופעל",
      ],
      "Phone": ["טלפון"],
      "Enable second factor authentication": ["הפעלת אימות דו-שלבי"],
      "Using email": ["באמצעות אימייל"],
      "Add an email in your profile to enable this option": [
        "הוסיפו אימייל לפרופיל שלכם כדי להפעיל אפשרות זו",
      ],
      "Using SMS": ["באמצעות SMS"],
      "Add a phone number in your profile to enable this option": [
        "הוסיפו מספר טלפון לפרופיל שלכם כדי להפעיל אפשרות זו",
      ],
      "Cashout account": ["חשבון פדיון"],
      "External account to which cashout transfers are sent.": [""],
      "Max debt": ["חוב מקסימלי"],
      "How much the balance can go below zero.": [
        "עד כמה היתרה יכולה לרדת מתחת לאפס.",
      ],
      "Is this account public?": ["האם חשבון זה ציבורי?"],
      "Public accounts expose their balance and complete transaction history, including subjects and both account addresses, to anonymous visitors.":
        [
          "חשבונות ציבוריים חושפים בפני מבקרים אנונימיים את יתרתם ואת היסטוריית העסקאות המלאה שלהם, לרבות נושאי העסקאות וכתובות שני החשבונות.",
        ],
      "Does this account belong to a Payment Service Provider?": [
        "האם חשבון זה שייך לספק שירותי תשלום?",
      ],
      "Account updated": ["החשבון עודכן"],
      "Failed to update the account.": ["עדכון החשבון נכשל."],
      "The rights to change the account are not sufficient": [
        "ההרשאות לשינוי החשבון אינן מספיקות",
      ],
      "The username was not found": ["שם המשתמש לא נמצא"],
      "You can't change the legal name, please contact your account administrator.":
        ["לא ניתן לשנות את השם המשפטי, אנא פנו למנהל החשבון שלכם."],
      "You can't change the debt limit, please contact your account administrator.":
        ["לא ניתן לשנות את מגבלת החוב, אנא פנו למנהל החשבון שלכם."],
      "You can't change the cashout address, please contact your account administrator.":
        ["לא ניתן לשנות את כתובת הפדיון, אנא פנו למנהל החשבון שלכם."],
      "No information for the selected authentication channel.": [
        "אין מידע עבור ערוץ האימות שנבחר.",
      ],
      "Account update": ["עדכון חשבון"],
      "Authentication channel is not supported.": ["ערוץ האימות אינו נתמך."],
      "Only the administrator can change the conversion rate.": [
        "רק מנהל המערכת יכול לשנות את שער ההמרה.",
      ],
      "The conversion rate class doesn't exist.": [
        "מחלקת שער ההמרה אינה קיימת.",
      ],
      "The password is too short. Can't have less than 8 characters.": [
        "הסיסמה קצרה מדי. אינה יכולה להכיל פחות מ-8 תווים.",
      ],
      "The password is too long. Can't have more than 64 characters.": [
        "הסיסמה ארוכה מדי. אינה יכולה להכיל יותר מ-64 תווים.",
      ],
      'Account "%1$s"': ['חשבון "%1$s"'],
      "Removed": ["הוסר"],
      "This account can't be used.": ["לא ניתן להשתמש בחשבון זה."],
      "Account details": ["פרטי החשבון"],
      "Not configured": ["לא מוגדר"],
      "Change details": ["שינוי פרטים"],
      "Update": ["עדכן"],
      "Delete account": ["מחיקת חשבון"],
      "Permanently remove this bank account. The account must have a zero balance before it can be deleted.":
        [
          "מחיקה לצמיתות של חשבון בנק זה. יתרת החשבון חייבת להיות אפס לפני שניתן למחוק אותו.",
        ],
      "The passwords do not match.": ["הסיסמאות אינן תואמות"],
      "Failed to update the password.": ["עדכון הסיסמה נכשל."],
      "Not authorized to change the password, maybe the session is invalid.": [
        "אין הרשאה לשנות את הסיסמה, ייתכן שההפעלה אינה תקינה.",
      ],
      "You need to provide the old password. If you don't have it contact your account administrator.":
        ["עליכם לספק את הסיסמה הישנה. אם אינה ברשותכם, פנו למנהל החשבון שלכם."],
      "The current password is incorrect, so the password cannot be changed.": [
        "",
      ],
      "Password update": ["עדכון סיסמה"],
      "You don't have the rights to change the password.": [
        "אין לכם הרשאה לשנות את הסיסמה.",
      ],
      "Update password": ["עדכון סיסמה"],
      "Current password": ["סיסמה נוכחית"],
      "Your current password, for security": [
        "הסיסמה הנוכחית שלכם, לצורך אבטחה",
      ],
      "New password": ["סיסמה חדשה"],
      "Failed to load transactions.": ["טעינת העסקאות נכשלה."],
      "Unknown account": ["חשבון לא ידוע"],
      "Recent activity": ["פעילות אחרונה"],
      "Transactions": ["עסקאות"],
      "Subject": ["פרטי העברה"],
      "Today": ["היום"],
      "Yesterday": ["אתמול"],
      "Invalid value": ["ערך לא תקין"],
      "View all transactions": ["הצגת כל העסקאות"],
      "No transactions yet.": ["אין עדיין עסקאות."],
      "Your account activity will appear here.": [
        "פעילות החשבון שלך תופיע כאן.",
      ],
      "Date": ["תאריך"],
      "Counterparty": ["צד שכנגד"],
      "Pagination": ["עימוד"],
      "Newer": ["חדשות יותר"],
      "Older": ["ישנות יותר"],
      "Withdraw to Taler Wallet": ["משיכה לארנק Taler"],
      "Move digital cash to your Taler Wallet.": [
        "העברת כסף דיגיטלי לארנק Taler שלך.",
      ],
      "Send bank transfer": ["שליחת העברה בנקאית"],
      "Transfer money to another bank account.": ["העברת כסף לחשבון בנק אחר."],
      "Convert regional currency and send it to your cashout account.": [
        "המרת מטבע אזורי ושליחתו לחשבון משיכת המזומן שלך.",
      ],
      "Copy account address": ["העתקת כתובת החשבון"],
      "Current balance": ["יתרה נוכחית"],
      "Go to account details": ["מעבר לפרטי החשבון"],
      "Failed to load the admin account.": ["טעינת חשבון מנהל המערכת נכשלה."],
      "Admin account": ["חשבון מנהל המערכת"],
      "Admin account activity": ["פעילות חשבון מנהל המערכת"],
      "Failed to load the monitor info.": ["טעינת נתוני הניטור נכשלה."],
      "Failed to load cashout info.": ["טעינת נתוני הפדיון נכשלה."],
      "Querying for the current stats failed": [
        "השאילתה לנתונים הסטטיסטיים הנוכחיים נכשלה",
      ],
      "The user is unauthorized": ["המשתמש אינו מורשה"],
      "Querying for the previous stats failed": [
        "השאילתה לנתונים הסטטיסטיים הקודמים נכשלה",
      ],
      "Bank activity": ["פעילות הבנק"],
      "Select a section": ["בחרו סעיף"],
      "Last hour": ["השעה האחרונה"],
      "Previous day": ["היום הקודם"],
      "Last month": ["החודש האחרון"],
      "Last year": ["השנה האחרונה"],
      "Tabs": ["כרטיסיות"],
      "Last Year": ["השנה האחרונה"],
      "Trading volume from %1$s to %2$s": ["היקף מסחר מ-%1$s עד %2$s"],
      "Cash in": ["הפקדת מזומן"],
      "Transferred from an external account to an account in this bank.": [
        "הועבר מחשבון חיצוני לחשבון בבנק זה.",
      ],
      "Transferred from an account in this bank to an external account.": [
        "הועבר מחשבון בבנק זה לחשבון חיצוני.",
      ],
      "Taler pay-in": ["תשלום נכנס של Taler"],
      "Transferred from an account to a Taler exchange.": [
        "הועבר מחשבון לחלפן Taler.",
      ],
      "Transfers": ["העברות"],
      "Taler payout": ["תשלום יוצא של Taler"],
      "Transferred from a Taler exchange to another account.": [
        "הועבר מחלפן Taler לחשבון אחר.",
      ],
      "Download stats as CSV": ["הורדת נתונים סטטיסטיים כ-CSV"],
      "previous": ["קודם"],
      "Decreased by": ["ירד ב-"],
      "Increased by": ["עלה ב-"],
      'Account created with password "%1$s".': [
        'החשבון נוצר עם הסיסמה "%1$s".',
      ],
      "Failed to create a new account.": ["יצירת חשבון חדש נכשלה."],
      "Server replied that phone or email is invalid": [
        "השרת השיב שהטלפון או האימייל אינם תקינים",
      ],
      "The rights to perform the operation are not sufficient": [
        "ההרשאות לביצוע הפעולה אינן מספיקות",
      ],
      "Account username is already taken": ["שם המשתמש של החשבון כבר תפוס"],
      "Account ID is already taken": ["מזהה החשבון כבר תפוס"],
      "Bank ran out of bonus credit.": ["אזל אשראי הבונוס של הבנק."],
      "Only an administrator is allowed to set the debt limit.": [
        "רק מנהל מערכת רשאי להגדיר את מגבלת החוב.",
      ],
      "Only admin can create accounts with second factor authentication.": [
        "רק מנהל מערכת יכול ליצור חשבונות עם אימות דו-שלבי.",
      ],
      "Can't create accounts": ["לא ניתן ליצור חשבונות"],
      "New bank account": ["חשבון בנק חדש"],
      "Create an account and configure its initial access and profile.": [""],
      "Create account": ["יצירת חשבון"],
      "Failed to download statistics.": ["הורדת הנתונים הסטטיסטיים נכשלה."],
      "A statistics request failed. Please try again.": [
        "בקשה לנתונים סטטיסטיים נכשלה. נסו שוב.",
      ],
      "only admin can download stats": [
        "רק מנהל מערכת יכול להוריד נתונים סטטיסטיים",
      ],
      "Choose which reporting periods to include in the CSV file.": [""],
      "Include hour metric": ["כלול מדד שעתי"],
      "Include day metric": ["כלול מדד יומי"],
      "Include month metric": ["כלול מדד חודשי"],
      "Include year metric": ["כלול מדד שנתי"],
      "Include table header": ["כלול כותרת טבלה"],
      "Add previous metric for comparison": ["הוסף מדד קודם לצורך השוואה"],
      "Fail on first error": ["הפסק בשגיאה הראשונה"],
      "Download": ["הורדה"],
      "Download completed with missing data": ["ההורדה הושלמה עם נתונים חסרים"],
      "Download completed": ["ההורדה הושלמה"],
      "%1$s statistics requests failed. The file contains only the data that could be retrieved. Click here to save it.":
        [
          "%1$s בקשות לנתונים סטטיסטיים נכשלו. הקובץ מכיל רק את הנתונים שניתן היה לאחזר. לחצו כאן כדי לשמור אותו.",
        ],
      "Click here to save the file on your computer.": [
        "לחצו כאן כדי לשמור את הקובץ במחשב שלכם.",
      ],
      "Name doesn't match": ["השם אינו תואם"],
      "Faild to delete the account.": ["מחיקת החשבון נכשלה."],
      "Not enough permission to delete the account.": [
        "אין מספיק הרשאה למחיקת החשבון.",
      ],
      "The username was not found.": ["שם המשתמש לא נמצא."],
      "Can't delete a reserved username.": ["לא ניתן למחוק שם משתמש שמור."],
      "Can't delete an account with balance different than zero.": [
        "לא ניתן למחוק חשבון עם יתרה שאינה אפס.",
      ],
      "Account deletion": ["מחיקת חשבון"],
      "there was an error reading the balance": ["אירעה שגיאה בקריאת היתרה"],
      "Can't delete the account": ["לא ניתן למחוק את החשבון"],
      "The account can't be deleted while still holding some balance. First make sure that the owner makes a complete cashout.":
        [
          "לא ניתן למחוק את החשבון כל עוד יש בו יתרה. ודאו תחילה שהבעלים ביצע פדיון מלא.",
        ],
      "Go back": [""],
      "All account data will be permanently removed.": [""],
      "Verification": ["אימות"],
      "Enter the account name that is going to be deleted": [
        "הזינו את שם החשבון שעומד להימחק",
      ],
      "Withdraw without setting amount": ["משיכה ללא הגדרת סכום"],
      "Show install wallet first": ["הצג תחילה התקנת ארנק"],
      "Introduction": ["מבוא"],
      "Bank": ["בנק"],
      "Essay Shop": ["חנות מאמרים"],
      "Donations": ["תרומות"],
      "GNU Taler logo": ["הלוגו של GNU Taler"],
      "Withdraw toy currency into your GNU Taler wallet.": [
        "משיכת מטבע לדוגמה לארנק GNU Taler שלך.",
      ],
      "Demo pages": ["דפי הדגמה"],
      "You were signed out locally, but the bank could not confirm that the server token was revoked. Close other sessions or sign in again to review active tokens.":
        [
          "יצאתם מהמערכת באופן מקומי, אך הבנק לא הצליח לאשר שאסימון השרת בוטל. סגרו הפעלות אחרות או התחברו שוב כדי לבדוק אסימונים פעילים.",
        ],
      "Dismiss": ["התעלמות"],
      "Public accounts": ["חשבונות ציבוריים"],
      "Open interface preferences": ["פתיחת העדפות הממשק"],
      "Interface preferences": ["העדפות הממשק"],
      "Choose how this bank interface behaves on this browser.": [
        "בחרו כיצד ממשק הבנק יתנהג בדפדפן זה.",
      ],
      "Close interface preferences": ["סגירת העדפות הממשק"],
      "Show debug information": ["הצג מידע לניפוי באגים"],
      "Done": ["סיום"],
      "Welcome": ["ברוכים הבאים"],
      "Welcome, %1$s": ["ברוכים הבאים, %1$s"],
      "Failed to load conversion rate.": ["טעינת שער ההמרה נכשלה."],
      "Not enough permission to access the conversion rate list.": [
        "אין מספיק הרשאה לגישה לרשימת שערי ההמרה.",
      ],
      "Conversion list not implemented.": ["רשימת ההמרה אינה ממומשת."],
      "Conversion rate classes": ["מחלקות שער המרה"],
      "Configure different cash-in and cashout terms for groups of accounts.": [
        "",
      ],
      "Default conversion rate": ["שער המרה ברירת מחדל"],
      "Create conversion rate class": ["יצירת מחלקת שער המרה"],
      "Name": ["שם"],
      "Description": ["תיאור"],
      "Cashin": ["הפקדה"],
      "First page": ["עמוד ראשון"],
      "Next": ["הבא"],
      "min:": ["מינימום:"],
      "fee:": ["עמלה:"],
      "only admin can setup conversion": ["רק מנהל מערכת יכול להגדיר המרה"],
      "Failed to calculate cashout fee.": ["חישוב עמלת הפדיון נכשל."],
      "Failed to update the conversion rate.": ["עדכון שער ההמרה נכשל."],
      "Wrong credentials": ["פרטי התחברות שגויים"],
      "Conversion is disabled": ["ההמרה מושבתת"],
      "Review the default terms or choose a direction to update its settings.":
        [""],
      "Details": ["פרטים"],
      "Bad ratios": ["יחסים שגויים"],
      "Initial amount": ["סכום התחלתי"],
      "Use it to test how the conversion will affect the amount.": [
        "השתמשו בו כדי לבדוק כיצד ההמרה תשפיע על הסכום.",
      ],
      "Sending to this bank": ["שליחה לבנק זה"],
      "Converted": ["הומר"],
      "Cashin after fee": ["הפקדה לאחר עמלה"],
      "Sending from this bank": ["שליחה מבנק זה"],
      "Cashout after fee": ["פדיון לאחר עמלה"],
      "Bad configuration": ["תצורה שגויה"],
      "This configuration allows users to cash out more of what has been cashed in.":
        ["תצורה זו מאפשרת למשתמשים לפדות יותר ממה שהופקד."],
      "Must be > 0": ["חייב להיות > 0"],
      "Ratio": ["יחס"],
      "Zero": ["אפס"],
      "Up": ["מעלה"],
      "Nearest": ["קרוב ביותר"],
      "Minimum amount": ["סכום מינימלי"],
      "Only cashout operations above this threshold will be allowed.": [
        "רק פעולות פדיון מעל סף זה יורשו.",
      ],
      "Conversion ratio between currencies": ["יחס המרה בין מטבעות"],
      "Example conversion": ["דוגמת המרה"],
      "1 %1$s will be converted into %2$s %3$s": ["1 %1$s יומר ל-%2$s %3$s"],
      "Tiny amount": ["סכום זעיר"],
      "Rounding mode": ["מצב עיגול"],
      "Amount will be rounded below to the largest possible value smaller than the input.":
        ["הסכום יעוגל כלפי מטה לערך הגדול ביותר האפשרי הקטן מהקלט."],
      "Amount will be rounded up to the smallest possible value larger than the input.":
        ["הסכום יעוגל כלפי מעלה לערך הקטן ביותר האפשרי הגדול מהקלט."],
      "Amount will be rounded to the closest possible value.": [
        "הסכום יעוגל לערך האפשרי הקרוב ביותר.",
      ],
      'If none specified the fallback value is "%1$s ".': [
        'אם לא צוין ערך, ערך ברירת המחדל הוא "%1$s ".',
      ],
      "Examples": ["דוגמאות"],
      "Rounding an amount of 1.24 with rounding value 0.1": [
        "עיגול סכום של 1.24 עם ערך עיגול של 0.1",
      ],
      "Given the rounding value of 0.1 the possible values closest to 1.24 are: 1.1, 1.2, 1.3, 1.4.":
        [
          "בהינתן ערך עיגול של 0.1, הערכים האפשריים הקרובים ביותר ל-1.24 הם: 1.1, 1.2, 1.3, 1.4.",
        ],
      'With the "zero" mode the value will be rounded to 1.2': [
        'במצב "אפס" הערך יעוגל ל-1.2',
      ],
      'With the "nearest" mode the value will be rounded to 1.2': [
        'במצב "קרוב ביותר" הערך יעוגל ל-1.2',
      ],
      'With the "up" mode the value will be rounded to 1.3': [
        'במצב "מעלה" הערך יעוגל ל-1.3',
      ],
      "Rounding an amount of 1.26 with rounding value 0.1": [
        "עיגול סכום של 1.26 עם ערך עיגול של 0.1",
      ],
      'With the "nearest" mode the value will be rounded to 1.3': [
        'במצב "קרוב ביותר" הערך יעוגל ל-1.3',
      ],
      "Rounding an amount of 1.24 with rounding value 0.3": [
        "עיגול סכום של 1.24 עם ערך עיגול של 0.3",
      ],
      "Given the rounding value of 0.3 the possible values closest to 1.24 are: 0.9, 1.2, 1.5, 1.8.":
        [
          "בהינתן ערך עיגול של 0.3, הערכים האפשריים הקרובים ביותר ל-1.24 הם: 0.9, 1.2, 1.5, 1.8.",
        ],
      'With the "up" mode the value will be rounded to 1.5': [
        'במצב "מעלה" הערך יעוגל ל-1.5',
      ],
      "Rounding an amount of 1.26 with rounding value 0.3": [
        "עיגול סכום של 1.26 עם ערך עיגול של 0.3",
      ],
      "Amount to be deducted before amount is credited.": [
        "סכום שיופחת לפני זיכוי הסכום.",
      ],
      "Failed to load conversion details.": ["טעינת פרטי ההמרה נכשלה."],
      "Conversion should be enabled in the configuration, the conversion rate should be initialized with fee(s), rates and a rounding mode.":
        [
          "יש להפעיל את ההמרה בתצורה, ולאתחל את שער ההמרה עם עמלה/ות, שערים ומצב עיגול.",
        ],
      "Failed to delete conversion rate class": ["מחיקת מחלקת שער ההמרה נכשלה"],
      "Unauthorized": ["לא מורשה"],
      "Forbidden": ["אסור"],
      "Failed to update conversion rate class.": [
        "עדכון מחלקת שער ההמרה נכשל.",
      ],
      "Not Found": ["לא נמצא"],
      "Not implemented": ["לא ממומש"],
      "The name of the conversion is already used.": ["שם ההמרה כבר בשימוש."],
      "Accounts": ["חשבונות"],
      "identification": ["זיהוי"],
      "Users": ["משתמשים"],
      "Delete": ["מחק"],
      "Failed to calculate the cashout fee.": ["חישוב עמלת הפדיון נכשל."],
      "Can't remove the conversion rate class": [
        "לא ניתן להסיר את מחלקת שער ההמרה",
      ],
      "There are some users associated with this class. You need to remove them first.":
        ["יש משתמשים המשויכים למחלקה זו. עליכם להסיר אותם תחילה."],
      "You are going to remove the conversion rate class": [
        "אתם עומדים להסיר את מחלקת שער ההמרה",
      ],
      "This step can't be undone.": ["לא ניתן לבטל שלב זה."],
      "Class": ["מחלקה"],
      "Action": ["פעולה"],
      "Failed to update conversion class membership.": [
        "עדכון השיוך למחלקת ההמרה נכשל.",
      ],
      "The account could not be updated. Please try again.": [
        "לא ניתן היה לעדכן את החשבון. נסו שוב.",
      ],
      "Conversion rate information is unavailable for these accounts.": [
        "מידע על שער ההמרה אינו זמין עבור חשבונות אלה.",
      ],
      "Failed to load users in conversion class.": [
        "טעינת המשתמשים במחלקת ההמרה נכשלה.",
      ],
      "Filters": ["מסננים"],
      "Show from other classes": ["הצג ממחלקות אחרות"],
      "Account": ["חשבון"],
      "Group ID": ["מזהה קבוצה"],
      "No users in this conversion rate class": [
        "אין משתמשים במחלקת שער ההמרה הזו",
      ],
      "Remove": ["הסר"],
      "Add": ["הוסף"],
      "Conversion rate name": ["שם שער ההמרה"],
      "Short description of the class": ["תיאור קצר של המחלקה"],
      "Failed to create conversion class.": ["יצירת מחלקת ההמרה נכשלה."],
      "New conversion rate class": ["מחלקת שער המרה חדשה"],
      "Create a named set of conversion terms that can be assigned to accounts.":
        [""],
      "Failed to load public accounts.": ["טעינת החשבונות הציבוריים נכשלה."],
      "Browse transaction histories shared by public bank accounts.": [
        "עיון בהיסטוריית העסקאות שחשבונות בנק ציבוריים משתפים.",
      ],
      "No public accounts are available.": ["אין חשבונות ציבוריים זמינים."],
      "View previous cashouts": ["הצגת משיכות מזומן קודמות"],
      "Failed to load cashout details.": ["טעינת פרטי הפדיון נכשלה."],
      "Amounts recorded for this completed cashout transfer.": [""],
      "Enter your full name.": ["הזינו את השם המלא."],
      "Repeat your password.": ["חזרה על הסיסמה"],
      "Create your bank account": ["יצירת חשבון"],
      "Choose the credentials you will use to sign in.": [
        "בחרו את פרטי ההזדהות שבהם תשתמשו לכניסה.",
      ],
      "Already have an account?": ["כבר יש לכם חשבון?"],
      "Confirm password": ["אישור סיסמה"],
      "Use between 8 and 64 characters. A longer, unique password is easier to keep secure.":
        [
          "השתמשו ב־8 עד 64 תווים. קל יותר לשמור על סיסמה ארוכה וייחודית באופן מאובטח.",
        ],
      "Creating account…": ["החשבון נוצר…"],
      "Check the account details and try again.": [
        "בדקו את פרטי החשבון ונסו שוב.",
      ],
      "You are not authorized to create this account.": [
        "אינכם מורשים ליצור חשבון זה.",
      ],
      "Registration is unavailable because the bank cannot grant the account credit.":
        ["ההרשמה אינה זמינה מכיוון שהבנק אינו יכול להעניק אשראי לחשבון."],
      "That username is reserved. Choose another username.": [
        "שם המשתמש הזה שמור. בחרו שם אחר.",
      ],
      "That username is already taken.": ["שם המשתמש הזה כבר תפוס."],
      "That account ID is already taken.": ["מזהה החשבון הזה כבר תפוס."],
      "The bank is missing information for the selected authentication channel.":
        ["אין מידע עבור ערוץ האימות שנבחר."],
      "The selected authentication channel is not supported.": [
        "ערוץ האימות אינו נתמך.",
      ],
      "Only an administrator may set the debt limit.": [
        "רק מנהל מערכת רשאי להגדיר את מגבלת החוב.",
      ],
      "Only an administrator may select a conversion rate class.": [
        "רק מנהל מערכת רשאי לבחור מחלקת שער המרה.",
      ],
      "The selected conversion rate class does not exist.": [
        "מחלקת שער ההמרה אינה קיימת.",
      ],
      "Only an administrator may enable two-factor authentication while creating an account.":
        ["רק מנהל מערכת רשאי להפעיל אימות דו־שלבי בעת יצירת חשבון."],
      "Account registration is unavailable": ["רישום חשבון"],
      "This bank is not accepting new account registrations.": [
        "כרגע הבנק אינו מקבל הרשמות חדשות!",
      ],
      "Return to sign in": ["חזרה לכניסה"],
      "Contact the bank administrator if you need an account.": [
        "נא לפנות למנהל הבנק.",
      ],
      "Failed to load withdrawal details.": ["טעינת פרטי המשיכה נכשלה."],
      "Abort this withdrawal?": ["לבטל את המשיכה הזו?"],
      "This stops the withdrawal. No money will be transferred, and this operation cannot be resumed.":
        ["המשיכה תבוטל. לא יועבר כסף ולא יהיה ניתן להמשיך את הפעולה."],
      "Keep withdrawal": ["להשאיר את המשיכה"],
      "Abort withdrawal": ["ביטול משיכה"],
      'The payto URI returned by the server is invalid: "%1$s".': [
        'כתובת ה־payto שהשרת החזיר אינה תקינה: "%1$s".',
      ],
      'The withdrawal URI returned by the server is invalid: "%1$s".': [
        'כתובת המשיכה שהשרת החזיר אינה תקינה: "%1$s".',
      ],
      'The reserve public key returned by the server is invalid: "%1$s".': [
        'המפתח הציבורי של העתודה שהשרת החזיר אינו תקין: "%1$s".',
      ],
      "Enter an amount.": ["נא להזין סכום."],
      "Enter a valid amount.": ["נא להזין סכום תקין."],
      "The amount must be greater than zero.": ["הסכום חייב להיות גדול מאפס."],
      "The amount is below the bank's minimum.": [
        "הסכום נמוך מהסכום המזערי של הבנק.",
      ],
      "The amount is above the bank's maximum.": [
        "הסכום גבוה מהסכום המרבי של הבנק.",
      ],
      "Failed to abort the withdrawal.": ["ביטול המשיכה נכשל."],
      "The server did not understand the request.": ["השרת לא הבין את הבקשה."],
      "The operation was not found.": ["הפעולה לא נמצאה."],
      "The withdrawal operation has already been confirmed and cannot be aborted.":
        ["פעולת המשיכה כבר אושרה ולא ניתן לבטל אותה."],
      "The bank could not be reached. Please try again.": [
        "לא ניתן ליצור קשר עם הבנק. נא לנסות שוב.",
      ],
      "Withdrawal confirmation": ["אישור משיכה"],
      "Failed to confirm the withdrawal.": ["אישור המשיכה נכשל."],
      "The account does not have sufficient funds or the amount is outside the limits.":
        ["אין בחשבון מספיק כספים, או שהסכום חורג מהמגבלות."],
      "The withdrawal has been aborted and cannot be confirmed.": [
        "המשיכה בוטלה ולא ניתן לאשר אותה.",
      ],
      "The wallet has not finished selecting an exchange account.": [
        "הארנק טרם סיים לבחור חשבון של בורסת חליפין.",
      ],
      "The withdrawal amount changed. Review the current amount and try again.":
        ["סכום המשיכה השתנה. יש לבדוק את הסכום הנוכחי ולנסות שוב."],
      "Enter an amount before confirming the withdrawal.": [
        "נא להזין סכום לפני אישור המשיכה.",
      ],
      "Selected exchange": ["בורסת החליפין שנבחרה"],
      "Sign in to confirm the withdrawal": ["יש להיכנס כדי לאשר את המשיכה"],
      "Sign in as %1$s before reviewing and confirming this withdrawal.": [
        "יש להיכנס בתור %1$s לפני בדיקת המשיכה ואישורה.",
      ],
      "You are signed in as %1$s, but this withdrawal belongs to %2$s.": [
        "נכנסת בתור %1$s, אך המשיכה הזו שייכת אל %2$s.",
      ],
      "Finish later": ["לסיים מאוחר יותר"],
      "Confirm wallet withdrawal": ["אישור משיכה לארנק"],
      "Review how much will leave your bank account before confirming.": [
        "יש לבדוק כמה ייגרע מחשבון הבנק שלך לפני האישור.",
      ],
      "Unsupported exchange account": ["חשבון בורסת חליפין שאינו נתמך"],
      "The exchange account does not use the transfer type configured by this bank. This withdrawal cannot be confirmed.":
        [
          "חשבון בורסת החליפין אינו משתמש בסוג ההעברה שהוגדר בבנק. לא ניתן לאשר את המשיכה הזו.",
        ],
      "Withdrawal amount missing": ["סכום המשיכה חסר"],
      "The bank did not provide an amount for this withdrawal. It cannot be confirmed.":
        ["הבנק לא סיפק סכום למשיכה הזו. לא ניתן לאשר אותה."],
      "Bank amount configuration invalid": ["הגדרת הסכומים של הבנק אינה תקינה"],
      "The withdrawal amount and bank fee could not be combined safely. This withdrawal cannot be confirmed.":
        [
          "לא ניתן לצרף בבטחה את סכום המשיכה ועמלת הבנק. לא ניתן לאשר את המשיכה הזו.",
        ],
      "Wallet receives": ["הארנק מקבל"],
      "Amount to your Taler Wallet": ["סכום לארנק Taler שלך"],
      "Allowed amount": ["סכום מותר"],
      "Maximum amount": ["סכום מרבי"],
      "Amount unavailable": ["הסכום אינו זמין"],
      "From": ["מאת"],
      "To": ["אל"],
      "Taler Wallet": ["ארנק Taler"],
      "Exchange": ["בורסת חליפין"],
      "Unavailable": ["לא זמין"],
      "Exchange details": ["פרטי בורסת החליפין"],
      "Exchange IBAN": ["IBAN של בורסת החליפין"],
      "Bank hostname": ["שם המארח של הבנק"],
      "Exchange account": ["חשבון בורסת החליפין"],
      "No money is withdrawn until you confirm. You can finish this later from your account overview.":
        ["לא יימשך כסף עד לאישור. אפשר לסיים מאוחר יותר מסקירת החשבון."],
      "Confirm withdrawal": ["אישור המשיכה"],
      "Unauthorized to make the operation, maybe the session has expired or the password changed.":
        ["אין הרשאה לבצע את הפעולה, ייתכן שההפעלה פגה או שהסיסמה שונתה."],
      "The operation was rejected due to insufficient funds.": [
        "הפעולה נדחתה עקב חוסר בכספים.",
      ],
      "Withdrawal aborted": ["המשיכה בוטלה"],
      "Withdrawal confirmed": ["המשיכה אושרה"],
      "The bank transfer to the Taler exchange has been initiated. Your Taler Wallet will receive the withdrawn amount shortly.":
        [
          "ההעברה הבנקאית לבורסת Taler החלה. ארנק Taler שלך יקבל את הסכום שנמשך בקרוב.",
        ],
      "Back to account": ["חזרה לחשבון"],
      "Complete withdrawal with your Taler Wallet": [
        "השלמת המשיכה באמצעות ארנק Taler",
      ],
      "Scan this QR code with your Taler Wallet. Your wallet will select an exchange and prepare the withdrawal.":
        [
          "סרקו את קוד ה־QR הזה באמצעות ארנק Taler. הארנק יבחר בורסת חליפין ויכין את המשיכה.",
        ],
      "Withdrawal amount": ["סכום המשיכה"],
      "Suggested amount": ["סכום מוצע"],
      "You can change this amount in your wallet.": [
        "תוכלו לשנות את הסכום הזה בארנק.",
      ],
      "QR code to continue the withdrawal in a Taler Wallet.": [
        "קוד QR להמשך המשיכה בארנק Taler.",
      ],
      "Open Taler Wallet manually": ["פתיחת ארנק Taler באופן ידני"],
      "Don't have a Taler Wallet?": ["אין לכם ארנק Taler?"],
      "Get a wallet": ["קבלת ארנק"],
      "No money will be transferred until you return here to review and confirm the withdrawal.":
        ["לא יועבר כסף עד שתחזרו לכאן כדי לבדוק ולאשר את המשיכה."],
      "Sign in to abort this withdrawal": ["התחברו כדי לבטל את המשיכה הזו"],
      "The withdrawal operation has been confirmed previously and can not be aborted.":
        ["פעולת המשיכה כבר אושרה בעבר ולא ניתן לבטל אותה."],
      "Withdrawal ready for confirmation": ["המשיכה מוכנה לאישור"],
      "Withdrawal waiting for your wallet": ["המשיכה ממתינה לארנק שלך"],
      "The pending withdrawal could not be checked": [
        "לא ניתן לבדוק את המשיכה הממתינה",
      ],
      "Checking the pending withdrawal…": ["המשיכה הממתינה נבדקת…"],
      "Review withdrawal": ["בדיקת המשיכה"],
      "Retry": ["ניסיון חוזר"],
      "Resume withdrawal": ["המשך המשיכה"],
      "Finish or abort this withdrawal before starting another one.": [
        "יש להשלים או לבטל את המשיכה הזו לפני התחלת משיכה אחרת.",
      ],
      "Dashboard": ["לוח בקרה"],
      "Admin activity": ["פעילות מנהל המערכת"],
      "Conversion": ["המרה"],
      "My account": ["החשבון שלי"],
      "Bank administration": ["ניהול הבנק"],
      "Failed to load the account list.": ["טעינת רשימת החשבונות נכשלה."],
      "Search accounts": ["חיפוש חשבונות"],
      "Search by username or name": ["חיפוש לפי שם משתמש או שם"],
      "Search": ["חיפוש"],
      "Clear": ["נקה"],
      "Unknown": ["לא ידוע"],
      "Change password": ["שינוי סיסמה"],
      "Previous": ["הקודם"],
      "The amount exceeds what is available to withdraw.": [""],
      "The server replied with an invalid taler://withdraw URI": [
        "השרת השיב עם URI לא תקין מסוג taler://withdraw",
      ],
      "Withdraw URI: %1$s": ["URI למשיכה: %1$s"],
      "Failed to create the withdrawal.": ["יצירת המשיכה נכשלה."],
      "The operation was rejected due to insufficient funds": [
        "הפעולה נדחתה עקב חוסר בכספים",
      ],
      "Please sign in again.": ["יש להתחבר שוב."],
      "The bank's withdrawal limits or fee are configured incorrectly.": [""],
      "Maximum withdrawal": ["משיכה מרבית"],
      "There is not enough available balance to cover a withdrawal and the bank fee.":
        [""],
      "Dismiss wallet installation hint": [""],
      "Unable to start a withdrawal.": ["לא ניתן להתחיל משיכה."],
      "Your account was created. Sign in to continue.": [
        "החשבון נוצר. היכנסו כדי להמשיך.",
      ],
      "Home": ["דף הבית"],
      "Page not found": ["הדף לא נמצא"],
      "The requested bank page does not exist.": ["דף הבנק המבוקש אינו קיים."],
      "Unknown challenge.": ["אתגר לא ידוע."],
      "Failed to validate the verification code.": ["אימות קוד האימות נכשל."],
      "Too many challenges are active. Wait or confirm an existing challenge.":
        [
          "יותר מדי אתגרים פעילים כרגע, עליכם להמתין או לאשר את האתגרים הנוכחיים.",
        ],
      "The verification code is incorrect.": ["קוד האימות שגוי."],
      "The verification code has expired.": ["פג תוקף קוד האימות."],
      "Submit the transmitted code number.": ["שלחו את מספר הקוד שנשלח."],
      "The verification code sent to the email address starting with %1$s": [
        "קוד האימות נשלח לכתובת האימייל המתחילה ב-%1$s",
      ],
      "The verification code sent to the phone number ending with %1$s": [
        "קוד האימות נשלח למספר הטלפון המסתיים ב-%1$s",
      ],
      "Code": ["קוד"],
      "Authentication code": ["קוד אימות"],
      "It will expire at %1$s": ["פג תוקפו ב-%1$s"],
      "This challenge is terminal and cannot be retransmitted.": [
        "אתגר זה הגיע למצב סופי ולא ניתן לשדר אותו מחדש.",
      ],
      "Restart authentication": ["הפעלה מחדש של האימות"],
      "Back": ["חזור"],
      "Verifying…": ["מתבצע אימות…"],
      "Verify": ["אמת"],
      "Complete": ["השלם"],
      "Failed to start the challenge.": ["התחלת האתגר נכשלה."],
      "Unable to send the verification code.": ["לא ניתן לשלוח את קוד האימות."],
      "The request was valid, but the server is refusing action.": [
        "הבקשה הייתה תקינה, אך השרת מסרב לפעול.",
      ],
      "The backend is not aware of the specified MFA challenge.": [
        "ה-backend אינו מכיר את אתגר האימות הרב-שלבי (MFA) שצוין.",
      ],
      "It is too early to request another transmission of the challenge.": [
        "מוקדם מדי לבקש שידור נוסף של האתגר.",
      ],
      "Code transmission failed.": ["שידור הקוד נכשל."],
      "Multi-factor authentication required": ["נדרש אימות רב-שלבי"],
      "This operation is protected with second factor authentication. In order to complete it we need to verify your identity using the authentication channel you provided.":
        [
          "פעולה זו מוגנת באמצעות אימות דו-שלבי. כדי להשלים אותה עלינו לאמת את זהותכם באמצעות ערוץ האימות שסיפקתם.",
        ],
      "The next challenge needs to be completed to confirm the operation.": [
        "יש להשלים את האתגר הבא כדי לאשר את הפעולה.",
      ],
      "All the next challenges need to be completed to confirm the operation.":
        ["יש להשלים את כל האתגרים הבאים כדי לאשר את הפעולה."],
      "One of the next challenges needs to be completed to confirm the operation.":
        ["יש להשלים אחד מהאתגרים הבאים כדי לאשר את הפעולה."],
      'To a phone ending with "%1$s"': ['לטלפון המסתיים ב-"%1$s"'],
      'To an email starting with " %1$s"': ['לאימייל המתחיל ב-" %1$s"'],
      "I have a code": ["יש לי קוד"],
      "Send me a message": ["שלחו לי הודעה"],
      "You have to wait until %1$s to send a new code.": [
        "עליכם להמתין עד %1$s כדי לשלוח קוד חדש.",
      ],
      "Use configured value (enabled)": ["שימוש בערך שהוגדר (מופעל)"],
      "Use configured value (disabled)": ["שימוש בערך שהוגדר (מושבת)"],
      "Force enabled": ["אילוץ הפעלה"],
      "Force disabled": ["אילוץ השבתה"],
      "Enter a valid HTTP or HTTPS URL.": ["הזן כתובת HTTP או HTTPS תקינה."],
      "Development settings": ["הגדרות פיתוח"],
      "These overrides are stored only in this browser.": [
        "הדריסות האלה נשמרות בדפדפן הזה בלבד.",
      ],
      "Corebank API base URL": ["כתובת הבסיס של Corebank API"],
      "Leave empty to use the configured URL: %1$s": [
        "יש להשאיר ריק כדי להשתמש בכתובת שהוגדרה: %1$s",
      ],
      "Leave empty to derive the URL from this page.": [
        "יש להשאיר ריק כדי לגזור את הכתובת מדף זה.",
      ],
      "Demo header": ["כותרת הדגמה"],
      "Control whether the demo header is shown in this browser.": [
        "קביעה אם כותרת ההדגמה תוצג בדפדפן זה.",
      ],
      "Control whether public account links are shown in this browser.": [
        "קביעה אם קישורים לחשבונות ציבוריים יוצגו בדפדפן זה.",
      ],
      "Overrides saved.": ["הדריסות נשמרו."],
      "Apply overrides": ["החלת דריסות"],
      "Clear overrides": ["ניקוי דריסות"],
      "Back to bank": ["חזרה לבנק"],
    },
  },
  domain: "messages",
  plural_forms:
    "nplurals=4; plural=(n == 1) ? 0 : ((n == 2) ? 1 : ((n > 10 && n % 10 == 0) ? 2 : 3));",
  lang: "he",
  completeness: 87,
};

strings["fr"] = {
  locale_data: {
    messages: {
      "": {
        domain: "messages",
        lang: "fr",
        plural_forms: "nplurals=2; plural=n > 1;",
      },
      "Hide password": ["Masquer le mot de passe"],
      "Show password": ["Afficher le mot de passe"],
      "Hide": ["Masquer"],
      "Show": ["Afficher"],
      "Identity verification.": ["Vérification d'identité."],
      "You do not have permission to access this account.": [
        "Vous n'avez pas la permission d'accéder à ce compte.",
      ],
      "This account is locked. Contact the bank administrator.": [
        "Le compte est verrouillé et ne peut pas se connecter. Contactez l'administrateur.",
      ],
      "The password is incorrect.": ["Le mot de passe est incorrect."],
      "Account not found.": ["Compte non trouvé"],
      "Could not reach the bank. Check your connection and try again.": [
        "Impossible de joindre la banque. Vérifiez votre connexion et réessayez.",
      ],
      "Confirm your password": ["Confirmez votre mot de passe"],
      "Sign in to %1$s": ["Se connecter à %1$s"],
      "Enter the password for %1$s to continue.": [
        "Saisissez le mot de passe de %1$s pour continuer.",
      ],
      "Use your bank account credentials to continue.": [
        "Utilisez les identifiants de votre compte bancaire pour continuer.",
      ],
      "Need an account?": ["Besoin d’un compte ?"],
      "Create one": ["Créer un compte"],
      "Your session expired. Confirm your password to continue.": [
        "Votre session a expiré. Confirmez votre mot de passe pour continuer.",
      ],
      "Username": ["Nom d'utilisateur"],
      "Password": ["Mot de passe"],
      "Sign out": ["Se déconnecter"],
      "Signing in…": ["Connexion…"],
      "Continue": ["Continuer"],
      "Sign in": ["Se connecter"],
      "Enter your username.": ["Saisissez votre nom d’utilisateur."],
      "Use letters, numbers, or any of these characters: - . _ ~": [
        "Utilisez des lettres, des chiffres ou l'un de ces caractères : - . _ ~",
      ],
      "The username must not exceed 126 characters.": [
        "Le nom d’utilisateur ne doit pas dépasser 126 caractères.",
      ],
      "Enter your password.": ["Saisissez votre mot de passe."],
      "The password must contain at least 8 characters.": [
        "Le mot de passe est trop court. Il ne peut pas comporter moins de 8 caractères.",
      ],
      "The password must not exceed %1$s characters.": [
        "Le mot de passe ne doit pas dépasser %1$s caractères.",
      ],
      "IBAN country code not found": [
        "Le code pays de l'IBAN n'a pas été trouvé",
      ],
      "The IBAN must not exceed 34 characters.": [
        "L’IBAN ne doit pas dépasser 34 caractères.",
      ],
      "The IBAN must contain at least 4 characters.": [
        "L’IBAN doit contenir au moins 4 caractères.",
      ],
      "IBAN length is invalid for this country": [
        "La longueur de l’IBAN n’est pas valide pour ce pays",
      ],
      "The IBAN contains invalid characters": [
        "L’IBAN contient des caractères non valides",
      ],
      "IBAN number is not valid, checksum is wrong": [
        "Le numéro IBAN n'est pas valide, la somme de contrôle est incorrecte",
      ],
      "The IBAN is not valid": ["L’IBAN n’est pas valide"],
      "Use letters, numbers or any of these characters: - . _ ~": [
        "Utilisez des lettres, des chiffres ou l'un de ces caractères : - . _ ~",
      ],
      "Failed to load cashouts.": ["Échec du chargement des encaissements."],
      "Try again": ["Réessayer"],
      "Cashout is disabled": ["L'encaissement est désactivé"],
      "Cashout should be enabled in the configuration, the conversion rate should be initialized with fee(s), rates and a rounding mode.":
        [
          "L'encaissement doit être activé dans la configuration, le taux de conversion doit être initialisé avec des frais, des taux et un mode d'arrondi.",
        ],
      "No cashouts have been created yet.": [
        "Aucun encaissement n’a encore été créé.",
      ],
      "Failed to load conversion rate information.": [
        "Échec du chargement des informations sur le taux de conversion.",
      ],
      "Some cashout details could not be loaded.": [
        "Certains détails des retraits n’ont pas pu être chargés.",
      ],
      "The partial list omits cashout IDs: %1$s.": [
        "La liste partielle omet les identifiants de retrait suivants : %1$s.",
      ],
      "View details": ["Afficher les détails"],
      "Debited": ["Débité"],
      "Transferred": ["Transféré"],
      "Created": ["Créée"],
      "Transfer reference": ["Référence du virement"],
      "Actions": ["Actions"],
      "Cashout history": ["Historique des retraits"],
      "Review previous transfers to your configured cashout account.": [
        "Consultez les virements précédents vers votre compte d’encaissement configuré.",
      ],
      "Profile": ["Profil"],
      "Security": ["Sécurité"],
      "Merchant integration": ["Intégration des commerçants"],
      "Back to overview": ["Retour à la vue d’ensemble"],
      "My account settings": ["Paramètres de mon compte"],
      "Copy": ["Copier"],
      "Failed to load account details.": [
        "Échec du chargement des détails du compte.",
      ],
      'Use this information to link your Taler Merchant Backoffice account with the current bank account. You can start by copying the values, then go to your merchant backoffice service provider, login into your account and look for the "import" button in the "bank account" section.':
        [
          'Utilisez ces informations pour relier votre compte Taler Merchant Backoffice au compte bancaire actuel. Vous pouvez commencer par copier les valeurs, puis vous rendre chez votre fournisseur de services de backoffice marchand, vous connecter à votre compte et chercher le bouton "importer" dans la section "compte bancaire".',
        ],
      "Not available": ["Indisponible"],
      "Merchant integration is not available for this account.": [
        "L’intégration des commerçants n’est pas disponible pour ce compte.",
      ],
      "Account type": ["Type de compte"],
      "Method to use for wire transfer.": [
        "Méthode à utiliser pour un virement bancaire.",
      ],
      "IBAN": ["IBAN"],
      "International Bank Account Number.": [
        "Numéro de compte bancaire international (IBAN).",
      ],
      "Bank host": ["Hôte de la banque"],
      "Bank host where the service is located.": [
        "Serveur de la banque où se trouve le service.",
      ],
      "Account name": ["Intitulé du compte"],
      "Bank account identifier for wire transfers.": [
        "Identifiant du compte bancaire pour les virements bancaires.",
      ],
      "Address": ["Adresse"],
      "Bitcoin address for this account.": ["Adresse Bitcoin de ce compte."],
      "Account address": ["Adresse du compte"],
      "Owner's name": ["Nom du propriétaire"],
      "Legal name of the person holding the account.": [
        "Nom légal de la personne titulaire du compte.",
      ],
      "Account info URL": ["URL d'information de compte"],
      "From where the merchant can download information about incoming wire transfers to this account.":
        [
          "Endroit d'où le commerçant peut télécharger des informations sur les virements bancaires entrants sur ce compte.",
        ],
      "Unable to create a cashout": ["Impossible de créer un encaissement"],
      "The bank configuration does not support cashout operations.": [
        "La configuration bancaire ne prend pas en charge les opérations d'encaissement.",
      ],
      "Close": ["Fermer"],
      "The bank returned incomplete conversion information.": [
        "La banque a renvoyé des informations de conversion incomplètes.",
      ],
      "Please contact the bank administrator.": [
        "Veuillez contacter l’administrateur de la banque.",
      ],
      "Authentication required": ["Authentification obligatoire"],
      "Please sign in to create a cashout.": [
        "Veuillez vous connecter pour créer un retrait.",
      ],
      "Failed to calculate the conversion fee.": [
        "Échec du calcul des frais de conversion.",
      ],
      "The amount is too small": ["Le montant est trop faible"],
      "Conversion is not implemented.": [
        "La conversion n'est pas implémentée.",
      ],
      "At least a debit or credit amount must be provided.": [
        "Au moins un montant de débit ou de crédit doit être indiqué.",
      ],
      "The amount has an invalid format.": [
        "Le montant a un format non valide.",
      ],
      "The currency is not supported": ["La devise n'est pas prise en charge"],
      "Required": ["Obligatoire"],
      "Invalid": ["Invalide"],
      "The balance is not sufficient": ["Le solde n'est pas suffisant"],
      "It is not possible to cash out less than %1$s: %2$s": [
        "Il n'est pas possible d'encaisser moins de %1$s : %2$s",
      ],
      "The total transfer to the destination will be zero": [
        "Le montant total transféré vers la destination sera nul",
      ],
      "Failed to create the cashout.": [
        "Échec de la création de l'encaissement.",
      ],
      "Cashout": ["Encaissement"],
      "Account not found": ["Compte non trouvé"],
      "Duplicate request detected, check if the operation succeeded or try again.":
        [
          "Requête dupliquée détectée, vérifiez si l'opération a réussi ou réessayez.",
        ],
      "The conversion rate was applied incorrectly": [
        "Le taux de conversion a été appliqué de manière incorrecte",
      ],
      "The account does not have sufficient funds": [
        "Le compte ne dispose pas de fonds suffisants",
      ],
      "Missing cashout URI in the profile": [
        "URI d'encaissement manquante dans le profil",
      ],
      "The amount is below the minimum amount permitted.": [
        "Le montant est inférieur au montant minimum autorisé.",
      ],
      "Sending the confirmation message failed, retry later or contact the administrator.":
        [
          "L'envoi du message de confirmation a échoué, réessayez plus tard ou contactez l'administrateur.",
        ],
      "The server doesn't support the current TAN channel.": [
        "Le serveur ne prend pas en charge le canal TAN actuel.",
      ],
      "Cashout details": ["Détails de l’encaissement"],
      "Review the destination account and conversion terms.": [
        "Vérifiez le compte destinataire et les conditions de conversion.",
      ],
      "Conversion rate": ["Taux de conversion"],
      "Balance": ["Solde"],
      "Fee": ["Frais"],
      "No fee": ["Aucuns frais"],
      "To account": ["Compte de destination"],
      "Legal name": ["Nom légal"],
      "If this name doesn't match the account holder's name, your transaction may fail.":
        [
          "Si ce nom ne correspond pas au nom du titulaire du compte, votre transaction peut échouer.",
        ],
      "Unable to cash out": ["Impossible d'encaisser"],
      "Before being able to cash out to a bank account, you need to complete your profile":
        [
          "Avant de pouvoir effectuer un encaissement vers un compte bancaire, vous devez compléter votre profil",
        ],
      "What is this cashout for?": ["Quel est le motif de cet encaissement ?"],
      "Enter the amount to send or receive": [
        "Saisissez le montant à envoyer ou à recevoir",
      ],
      "Send %1$s": ["Envoyer %1$s"],
      "Receive %1$s": ["Recevoir %1$s"],
      "Amount": ["Montant"],
      "Total cost": ["Montant total des frais"],
      "Balance left": ["Solde restant"],
      "Before fee": ["Avant les frais"],
      "Total cashout transfer": ["Transfert total d'encaissement"],
      "Cancel": ["Annuler"],
      "Cash out": ["Encaissement"],
      "Not valid": ["Non valide"],
      "Does not follow the pattern": ["Ne suit pas le modèle"],
      "Failed to create the transaction.": [
        "La transaction n’a pas pu être créée.",
      ],
      "The request was invalid or the payto://-URI used unacceptable features.":
        [
          "La requête n'était pas valide ou l'URI payto:// a utilisé des fonctionnalités inacceptables.",
        ],
      "Not enough permission to complete the operation.": [
        "Autorisation insuffisante pour terminer l'opération.",
      ],
      "The bank administrator cannot be the transfer creditor.": [
        "L'administrateur de la banque ne peut pas être le destinataire du transfert.",
      ],
      'The destination account "%1$s" was not found.': [
        'Le compte de destination "%1$s" n\'a pas été trouvé.',
      ],
      "The origin and the destination of the transfer can't be the same.": [
        "L'origine et la destination du transfert ne peuvent pas être les mêmes.",
      ],
      "Your balance is not sufficient for the operation.": [
        "Votre solde n'est pas suffisant pour l'opération.",
      ],
      'The origin account "%1$s" was not found.': [
        'Le compte d\'origine "%1$s" est introuvable.',
      ],
      "The attempt to create the transaction has failed. Please try again.": [
        "La tentative de création de la transaction a échoué. Essayez à nouveau.",
      ],
      "Confirm transaction.": ["Confirmer la transaction."],
      "Transfer details": ["Détails du virement"],
      "Enter the recipient, a reference, and the amount to send.": [
        "Saisissez le destinataire, une référence et le montant à envoyer.",
      ],
      "Maximum transfer": ["Virement maximal"],
      "Debt limit": ["Limite d’endettement"],
      "This is not your account balance. This account cannot go into debt.": [
        "Il ne s’agit pas du solde de votre compte. Ce compte ne peut pas être à découvert.",
      ],
      "This is not your account balance. It includes borrowing up to the debt limit shown here.":
        [
          "Il ne s’agit pas du solde de votre compte. Ce montant inclut le crédit disponible jusqu’à la limite d’endettement indiquée ici.",
        ],
      "Transfer input method": ["Mode de saisie du virement"],
      "Enter details": ["Saisir les détails"],
      "Paste payto URI": ["Coller l’URI payto"],
      "Recipient": ["Destinataire"],
      "Account name of the recipient": ["Nom du compte destinataire"],
      "username": ["nom d'utilisateur"],
      "IBAN of the recipient's account": ["IBAN du compte du destinataire"],
      "What is this transfer for?": ["Quel est le motif de ce virement ?"],
      "Payto URI": ["URI payto"],
      "Paste a payto URI containing the recipient, amount, and transfer reference.":
        [
          "Collez une URI payto contenant le destinataire, le montant et la référence du virement.",
        ],
      "Uniform resource identifier of the target account": [
        "Identifiant de ressource uniforme (URI en anglais) du compte cible",
      ],
      "payto://x-taler-bank/[bank-host]/[receiver-account]?message=[subject]&amount=[%1$s:X.Y]":
        [
          "payto://x-taler-bank/[serveur-de-la-banque]/[compte-destinataire]?message=[reference]&amount=[%1$s:X.Y]",
        ],
      "payto://iban/[receiver-iban]?message=[subject]&amount=[%1$s:X.Y]": [
        "payto://iban/[IBAN du destinataire]?message=[référence]&amount=[%1$s:X.Y]",
      ],
      "Recipient receives": ["Le destinataire reçoit"],
      "Bank fee": ["Frais bancaires"],
      "Total debited": ["Total débité"],
      "Need to move money out of this bank?": [
        "Vous souhaitez transférer de l’argent hors de cette banque ?",
      ],
      "Start a cashout": ["Démarrer un encaissement"],
      "Send transfer": ["Envoyer le virement"],
      'Only "x-taler-bank" targets are supported': [
        'Seule la destination "x-taler-bank" est prise en charge',
      ],
      'Only this host is allowed. Use "%1$s"': [
        'Seul cet hôte est autorisé. Utilisez "%1$s"',
      ],
      "Account name is missing": ["Le nom du compte est manquant"],
      'Only "IBAN" targets are supported': [
        '"IBAN" est la seule destination supportée',
      ],
      'Missing "amount" parameter to specify the amount to be transferred': [
        'Paramètre "montant" manquant pour spécifier le montant à transférer',
      ],
      'The "amount" parameter is not valid': [
        'Le paramètre "montant" n\'est pas valide',
      ],
      '"message" parameters to specify a reference text for the transfer are missing':
        [
          'Les paramètres "message" pour spécifier un texte de référence pour le transfert sont manquants',
        ],
      'The only currency allowed is "%1$s"': [
        'La seule devise autorisée est "%1$s"',
      ],
      "You cannot transfer an amount of zero.": [
        "Vous ne pouvez pas transférer un montant égal à zéro.",
      ],
      "Please enter a longer subject": [
        "Veuillez saisir une référence plus longue",
      ],
      "Email and SMS authentication were disabled because their contact details were removed.":
        [
          "L’authentification par e-mail et par SMS a été désactivée, car les coordonnées correspondantes ont été supprimées.",
        ],
      "Email authentication was disabled because the email address was removed.":
        [
          "L’authentification par e-mail a été désactivée, car l’adresse e-mail a été supprimée.",
        ],
      "SMS authentication was disabled because the phone number was removed.": [
        "L’authentification par SMS a été désactivée, car le numéro de téléphone a été supprimé.",
      ],
      "Invalid email format": ["Format de courriel invalide"],
      "Should start with +": ["Doit commencer par +"],
      "A phone number consists of numbers only": [
        "Un numéro de téléphone se compose uniquement de chiffres",
      ],
      "Login username": ["Nom d'utilisateur pour le login"],
      "Account ID for authentication": [
        "Identifiant de compte pour l'authentification",
      ],
      "Full name": ["Nom complet"],
      "Name of the account holder": ["Nom du titulaire du compte"],
      "Internal account": ["Compte interne"],
      "Copy and share this account address to receive transfers.": [
        "Copiez et partagez cette adresse de compte pour recevoir des virements.",
      ],
      "Email": ["Courriel"],
      "To be used when second factor authentication is enabled": [
        "À utiliser lorsque l'authentification par deuxième facteur est activée",
      ],
      "Phone": ["Téléphone"],
      "Enable second factor authentication": [
        "Activer l'authentification à deux facteurs",
      ],
      "Using email": ["Utilisation du courriel"],
      "Add an email in your profile to enable this option": [
        "Ajoutez un courriel à votre profil pour activer cette option",
      ],
      "Using SMS": ["Utilisation des SMS"],
      "Add a phone number in your profile to enable this option": [
        "Ajoutez un numéro de téléphone à votre profil pour activer cette option",
      ],
      "Cashout account": ["Compte d'encaissement"],
      "External account to which cashout transfers are sent.": [
        "Compte externe vers lequel les virements d’encaissement sont envoyés.",
      ],
      "Max debt": ["Créance maximale"],
      "How much the balance can go below zero.": [
        "De combien le solde peut-il descendre en dessous de zéro.",
      ],
      "Is this account public?": ["Ce compte est-il public ?"],
      "Public accounts expose their balance and complete transaction history, including subjects and both account addresses, to anonymous visitors.":
        [
          "Les comptes publics exposent leur solde et l’historique complet de leurs transactions, y compris les libellés et les adresses des deux comptes, aux visiteurs anonymes.",
        ],
      "Does this account belong to a Payment Service Provider?": [
        "Ce compte appartient-il à un prestataire de services de paiement ?",
      ],
      "Account updated": ["Compte mis à jour"],
      "Failed to update the account.": ["Échec de la mise à jour du compte."],
      "The rights to change the account are not sufficient": [
        "Les droits de modification du compte ne sont pas suffisants",
      ],
      "The username was not found": ["Le nom d'utilisateur n'a pas été trouvé"],
      "You can't change the legal name, please contact your account administrator.":
        [
          "Vous ne pouvez pas modifier le nom légal, veuillez contacter l'administrateur de votre compte.",
        ],
      "You can't change the debt limit, please contact your account administrator.":
        [
          "Vous ne pouvez pas modifier la limite d'endettement, veuillez contacter l'administrateur de votre compte.",
        ],
      "You can't change the cashout address, please contact your account administrator.":
        [
          "Vous ne pouvez pas modifier l'adresse d'encaissement, veuillez contacter l'administrateur de votre compte.",
        ],
      "No information for the selected authentication channel.": [
        "Aucune information pour le canal d'authentification sélectionné.",
      ],
      "Account update": ["Mise à jour du compte"],
      "Authentication channel is not supported.": [
        "Le canal d'authentification n'est pas pris en charge.",
      ],
      "Only the administrator can change the conversion rate.": [
        "Seul l'administrateur peut modifier le taux de conversion.",
      ],
      "The conversion rate class doesn't exist.": [
        "La classe de taux de conversion n'existe pas.",
      ],
      "The password is too short. Can't have less than 8 characters.": [
        "Le mot de passe est trop court. Il ne peut pas comporter moins de 8 caractères.",
      ],
      "The password is too long. Can't have more than 64 characters.": [
        "Le mot de passe est trop long. Il ne peut pas comporter plus de 64 caractères.",
      ],
      'Account "%1$s"': ['Compte "%1$s"'],
      "Removed": ["Supprimé"],
      "This account can't be used.": ["Ce compte ne peut pas être utilisé."],
      "Account details": ["Détails du compte"],
      "Not configured": ["Non configuré"],
      "Change details": ["Modifier les détails"],
      "Update": ["Modifier"],
      "Delete account": ["Supprimer le compte"],
      "Permanently remove this bank account. The account must have a zero balance before it can be deleted.":
        [
          "Supprimez définitivement ce compte bancaire. Son solde doit être nul avant de pouvoir le supprimer.",
        ],
      "The passwords do not match.": [
        "Les mots de passe ne correspondent pas.",
      ],
      "Failed to update the password.": [
        "Échec de la mise à jour du mot de passe.",
      ],
      "Not authorized to change the password, maybe the session is invalid.": [
        "Pas autorisé à changer le mot de passe, peut-être que la session n'est pas valide.",
      ],
      "You need to provide the old password. If you don't have it contact your account administrator.":
        [
          "Vous devez fournir l'ancien mot de passe. Si vous ne l'avez pas, veuillez contacter l'administrateur.",
        ],
      "The current password is incorrect, so the password cannot be changed.": [
        "Le mot de passe actuel est incorrect et ne peut donc pas être modifié.",
      ],
      "Password update": ["Mise à jour du mot de passe"],
      "You don't have the rights to change the password.": [
        "Vous n'avez pas le droit de modifier le mot de passe.",
      ],
      "Update password": ["Modifier le mot de passe"],
      "Choose a new password for your bank account.": [
        "Choisissez un nouveau mot de passe pour votre compte bancaire.",
      ],
      'Choose a new password for account "%1$s".': [
        "Choisissez un nouveau mot de passe pour le compte « %1$s ».",
      ],
      "Current password": ["Mot de passe actuel"],
      "Your current password, for security": [
        "Votre mot de passe actuel, par sécurité",
      ],
      "New password": ["Nouveau mot de passe"],
      "Confirm new password": ["Confirmer le nouveau mot de passe"],
      "Enter the new password again.": [
        "Saisissez à nouveau le nouveau mot de passe.",
      ],
      "Failed to load transactions.": ["Échec du chargement des transactions."],
      "Unknown account": ["Compte inconnu"],
      "Recent activity": ["Activité récente"],
      "Transactions": ["Transactions"],
      "Subject": ["Référence"],
      "Today": ["Aujourd'hui"],
      "Yesterday": ["Hier"],
      "Invalid value": ["Valeur non valide"],
      "View all transactions": ["Afficher toutes les transactions"],
      "No transactions yet.": ["Aucune transaction n'a encore été effectuée."],
      "Your account activity will appear here.": [
        "L'activité de votre compte apparaîtra ici.",
      ],
      "Date": ["Date"],
      "Counterparty": ["Contrepartie"],
      "Pagination": ["Navigation par pages"],
      "Newer": ["Plus récentes"],
      "Older": ["Plus anciennes"],
      "Withdraw to Taler Wallet": ["Retirer vers le portefeuille Taler"],
      "Move digital cash to your Taler Wallet.": [
        "Transférez de l'argent numérique vers votre portefeuille Taler.",
      ],
      "Send bank transfer": ["Envoyer un virement bancaire"],
      "Transfer money to another bank account.": [
        "Transférez de l'argent vers un autre compte bancaire.",
      ],
      "Convert regional currency and send it to your cashout account.": [
        "Convertissez la monnaie régionale et envoyez-la vers votre compte de retrait.Convertissez votre solde régional et envoyez-le sur votre compte d’encaissement.",
      ],
      "Copy account address": ["Copier l’adresse du compte"],
      "Current balance": ["Solde actuel"],
      "Go to account details": ["Accéder aux détails du compte"],
      "Failed to load the admin account.": [
        "Impossible de charger le compte administrateur.",
      ],
      "Admin account": ["Compte administrateur"],
      "Admin account activity": ["Activité du compte administrateur"],
      "Failed to load the monitor info.": [
        "Échec du chargement des informations de surveillance.",
      ],
      "Failed to load cashout info.": [
        "Échec du chargement des informations d'encaissement.",
      ],
      "Querying for the current stats failed": [
        "Échec de la requête pour les statistiques actuelles",
      ],
      "The request parameters are invalid.": [
        "Les paramètres de la requête ne sont pas valides.",
      ],
      "The user is unauthorized": ["L'utilisateur n'est pas autorisé"],
      "Querying for the previous stats failed": [
        "La requête des statistiques précédentes a échoué",
      ],
      "Bank activity": ["Activité bancaire"],
      "Select a section": ["Sélectionner une section"],
      "Last hour": ["Dernière heure"],
      "Previous day": ["Jour précédent"],
      "Last month": ["Dernier mois"],
      "Last year": ["Dernière année"],
      "Tabs": ["Onglets"],
      "Last Year": ["Dernière année"],
      "Trading volume from %1$s to %2$s": [
        "Volume des transactions du %1$s au %2$s",
      ],
      "Cash in": ["Entrée de fonds"],
      "Transferred from an external account to an account in this bank.": [
        "Transféré d'un compte externe vers un compte de cette banque.",
      ],
      "Transferred from an account in this bank to an external account.": [
        "Transféré d'un compte de cette banque vers un compte externe.",
      ],
      "Taler pay-in": ["Versement Taler"],
      "Transferred from an account to a Taler exchange.": [
        "Transféré d'un compte vers un exchange Taler.",
      ],
      "Transfers": ["Virements"],
      "Taler payout": ["Paiement sortant Taler"],
      "Transferred from a Taler exchange to another account.": [
        "Transféré d'un exchange Taler vers un autre compte.",
      ],
      "Download stats as CSV": ["Télécharger les statistiques au format CSV"],
      "previous": ["précédent"],
      "Decreased by": ["Diminué de"],
      "Increased by": ["Augmenté de"],
      'Account created with password "%1$s".': [
        "Compte créé avec le mot de passe « %1$s ».",
      ],
      "Failed to create a new account.": [
        "Échec de la création d'un nouveau compte.",
      ],
      "Server replied that phone or email is invalid": [
        "Le serveur a répondu que le téléphone ou le courriel est invalide",
      ],
      "The rights to perform the operation are not sufficient": [
        "Les droits pour effectuer l'opération sont insuffisants",
      ],
      "Account username is already taken": [
        "Le nom d'utilisateur du compte est déjà pris",
      ],
      "Account ID is already taken": ["L'identifiant du compte est déjà pris"],
      "Bank ran out of bonus credit.": ["La banque n'a plus de crédit bonus."],
      "This account username is reserved and cannot be used.": [
        "Ce nom d’utilisateur est réservé et ne peut pas être utilisé.",
      ],
      "Only an administrator is allowed to set the debt limit.": [
        "Seul un administrateur est autorisé à fixer la limite d'endettement.",
      ],
      "Only admin can create accounts with second factor authentication.": [
        "Seul l'administrateur peut créer des comptes avec l'authentification à deuxième facteur.",
      ],
      "Can't create accounts": ["Impossible de créer des comptes"],
      "Only a system administrator can create accounts.": [
        "Seul un administrateur système peut créer des comptes.",
      ],
      "Back to accounts": ["Retour aux comptes"],
      "New bank account": ["Nouveau compte bancaire"],
      "Create an account and configure its initial access and profile.": [
        "Créez un compte et configurez son accès initial et son profil.",
      ],
      "Create account": ["Créer un compte"],
      "Failed to download statistics.": [
        "Impossible de télécharger les statistiques.",
      ],
      "A statistics request failed. Please try again.": [
        "Une demande de statistiques a échoué. Veuillez réessayer.",
      ],
      "only admin can download stats": [
        "seul l'administrateur peut télécharger les statistiques",
      ],
      "Back to dashboard": ["Retour au tableau de bord"],
      "Download bank statistics": ["Télécharger les statistiques de la banque"],
      "Choose which reporting periods to include in the CSV file.": [
        "Choisissez les périodes de rapport à inclure dans le fichier CSV.",
      ],
      "Include hour metric": ["Inclure la métrique horaire"],
      "Include day metric": ["Inclure la métrique journalière"],
      "Include month metric": ["Inclure la métrique mensuelle"],
      "Include year metric": ["Inclure la métrique annuelle"],
      "Include table header": ["Inclure l'en-tête du tableau"],
      "Add previous metric for comparison": [
        "Ajouter la métrique précédente pour comparaison",
      ],
      "Fail on first error": ["Échouer à la première erreur"],
      "Download": ["Télécharger"],
      "Downloading… %1$s": ["Téléchargement… %1$s"],
      "Download completed with missing data": [
        "Téléchargement terminé avec des données manquantes",
      ],
      "Download completed": ["Téléchargement terminé"],
      "%1$s statistics requests failed. The file contains only the data that could be retrieved. Click here to save it.":
        [
          "%1$s demandes de statistiques ont échoué. Le fichier contient uniquement les données qui ont pu être récupérées. Cliquez ici pour l’enregistrer.",
        ],
      "Click here to save the file on your computer.": [
        "Cliquez ici pour enregistrer le fichier sur votre ordinateur.",
      ],
      "Name doesn't match": ["Le nom ne correspond pas"],
      "Faild to delete the account.": ["Échec de la suppression du compte."],
      "Not enough permission to delete the account.": [
        "Permissions insuffisantes pour supprimer le compte.",
      ],
      "The username was not found.": ["Le nom d'utilisateur est introuvable."],
      "Can't delete a reserved username.": [
        "Impossible de supprimer un nom d'utilisateur réservé.",
      ],
      "Can't delete an account with balance different than zero.": [
        "Impossible de supprimer un compte dont le solde est différent de zéro.",
      ],
      "Account deletion": ["Suppression du compte"],
      "there was an error reading the balance": [
        "une erreur s'est produite lors de la lecture du solde",
      ],
      "Can't delete the account": ["Impossible de supprimer le compte"],
      "The account can't be deleted while still holding some balance. First make sure that the owner makes a complete cashout.":
        [
          "Le compte ne peut pas être supprimé tant qu'il détient un solde. Assurez-vous d'abord que le titulaire effectue un encaissement complet.",
        ],
      "Go back": ["Retour"],
      'Delete account "%1$s"': ["Supprimer le compte « %1$s »"],
      "This action cannot be undone": ["Cette action est irréversible"],
      "All account data will be permanently removed.": [
        "Toutes les données du compte seront définitivement supprimées.",
      ],
      "Verification": ["Vérification"],
      "Enter the account name that is going to be deleted": [
        "Saisissez le nom du compte qui va être supprimé",
      ],
      "Withdraw without setting amount": ["Retirer sans fixer le montant"],
      "Show install wallet first": [
        "Afficher d'abord le portefeuille d'installation",
      ],
      "Introduction": ["Introduction"],
      "Bank": ["Banque"],
      "Essay Shop": ["Boutique d’essais"],
      "Donations": ["Dons"],
      "GNU Taler logo": ["Logo de GNU Taler"],
      "Withdraw toy currency into your GNU Taler wallet.": [
        "Retirez de la monnaie factice dans votre portefeuille GNU Taler.",
      ],
      "Demo pages": ["Pages de démonstration"],
      "You were signed out locally, but the bank could not confirm that the server token was revoked. Close other sessions or sign in again to review active tokens.":
        [
          "Vous avez été déconnecté localement, mais la banque n’a pas pu confirmer la révocation du jeton du serveur. Fermez les autres sessions ou reconnectez-vous pour vérifier les jetons actifs.",
        ],
      "Dismiss": ["Ignorer"],
      "Public accounts": ["Comptes publics"],
      "Open interface preferences": ["Ouvrir les préférences de l’interface"],
      "Interface preferences": ["Préférences de l’interface"],
      "Choose how this bank interface behaves on this browser.": [
        "Choisissez le comportement de cette interface bancaire dans ce navigateur.",
      ],
      "Close interface preferences": ["Fermer les préférences de l’interface"],
      "Show debug information": ["Afficher les informations de débogage"],
      "Done": ["Terminé"],
      "Welcome": ["Bienvenue"],
      "Welcome, %1$s": ["Bienvenue, %1$s"],
      "Failed to load conversion rate.": [
        "Échec du chargement du taux de conversion.",
      ],
      "Not enough permission to access the conversion rate list.": [
        "Permissions insuffisantes pour accéder à la liste des taux de conversion.",
      ],
      "The conversion-rate list was not found. Conversion may not be supported.":
        [
          "La liste des taux de conversion est introuvable. La conversion n’est peut-être pas prise en charge.",
        ],
      "Conversion list not implemented.": [
        "Liste de conversion non implémentée.",
      ],
      "Conversion rate classes": ["Classes de taux de conversion"],
      "Configure different cash-in and cashout terms for groups of accounts.": [
        "Configurez différentes conditions d’entrée et de sortie de fonds pour des groupes de comptes.",
      ],
      "Default conversion rate": ["Taux de conversion par défaut"],
      "Create conversion rate class": [
        "Créer une classe de taux de conversion",
      ],
      "No conversion rate classes": ["Aucune classe de taux de conversion"],
      "All accounts currently use the default conversion rate.": [
        "Tous les comptes utilisent actuellement le taux de conversion par défaut.",
      ],
      "Name": ["Nom"],
      "Description": ["Description"],
      "Cashin": ["Versement"],
      "First page": ["Première page"],
      "Next": ["Suivant"],
      "min:": ["min :"],
      "fee:": ["frais :"],
      "only admin can setup conversion": [
        "seul l'administrateur peut configurer la conversion",
      ],
      "Failed to calculate cashout fee.": [
        "Échec du calcul des frais d'encaissement.",
      ],
      "Failed to update the conversion rate.": [
        "Échec de la mise à jour du taux de conversion.",
      ],
      "Wrong credentials": ["Identifiants incorrects"],
      "Conversion is disabled": ["La conversion est désactivée"],
      "Back to conversion settings": ["Retour aux paramètres de conversion"],
      "Review the default terms or choose a direction to update its settings.":
        [
          "Vérifiez les conditions par défaut ou choisissez un sens pour modifier ses paramètres.",
        ],
      "Conversion view": ["Vue de la conversion"],
      "Details": ["Détails"],
      "Cashout settings": ["Paramètres d’encaissement"],
      "Cash-in settings": ["Paramètres d’entrée de fonds"],
      "Bad ratios": ["Ratios incorrects"],
      "One ratio must be greater than or equal to 1, and the other must be less than or equal to 1.":
        [
          "Un rapport doit être supérieur ou égal à 1 et l’autre inférieur ou égal à 1.",
        ],
      "Initial amount": ["Montant initial"],
      "Use it to test how the conversion will affect the amount.": [
        "Utilisez-le pour tester comment la conversion affectera le montant.",
      ],
      "Sending to this bank": ["Envoi vers cette banque"],
      "Converted": ["Converti"],
      "Cashin after fee": ["Versement après frais"],
      "Sending from this bank": ["Envoi depuis cette banque"],
      "Cashout after fee": ["Encaissement après frais"],
      "Bad configuration": ["Configuration incorrecte"],
      "This configuration allows users to cash out more of what has been cashed in.":
        [
          "Cette configuration permet aux utilisateurs d'encaisser plus que ce qui a été versé.",
        ],
      "Must be > 0": ["Doit être > 0"],
      "Ratio": ["Ratio"],
      "Zero": ["Zéro"],
      "Up": ["Vers le haut"],
      "Nearest": ["Le plus proche"],
      "Minimum amount": ["Montant minimum"],
      "Only cashout operations above this threshold will be allowed.": [
        "Seules les opérations d'encaissement supérieures à ce seuil seront autorisées.",
      ],
      "Conversion ratio between currencies": [
        "Ratio de conversion entre devises",
      ],
      "Example conversion": ["Exemple de conversion"],
      "1 %1$s will be converted into %2$s %3$s": [
        "1 %1$s sera converti en %2$s %3$s",
      ],
      "Tiny amount": ["Montant minime"],
      "Rounding mode": ["Mode d'arrondi"],
      "Amount will be rounded below to the largest possible value smaller than the input.":
        [
          "Le montant sera arrondi à la valeur possible la plus grande inférieure à la saisie.",
        ],
      "Amount will be rounded up to the smallest possible value larger than the input.":
        [
          "Le montant sera arrondi à la valeur possible la plus petite supérieure à la saisie.",
        ],
      "Amount will be rounded to the closest possible value.": [
        "Le montant sera arrondi à la valeur possible la plus proche.",
      ],
      'If none specified the fallback value is "%1$s ".': [
        "Si aucune n'est spécifiée, la valeur par défaut est « %1$s ».",
      ],
      "Examples": ["Exemples"],
      "Rounding an amount of 1.24 with rounding value 0.1": [
        "Arrondi d'un montant de 1.24 avec une valeur d'arrondi de 0.1",
      ],
      "Given the rounding value of 0.1 the possible values closest to 1.24 are: 1.1, 1.2, 1.3, 1.4.":
        [
          "Avec une valeur d'arrondi de 0.1, les valeurs possibles les plus proches de 1.24 sont : 1.1, 1.2, 1.3, 1.4.",
        ],
      'With the "zero" mode the value will be rounded to 1.2': [
        "Avec le mode « zéro », la valeur sera arrondie à 1.2",
      ],
      'With the "nearest" mode the value will be rounded to 1.2': [
        "Avec le mode « le plus proche », la valeur sera arrondie à 1.2",
      ],
      'With the "up" mode the value will be rounded to 1.3': [
        "Avec le mode « vers le haut », la valeur sera arrondie à 1.3",
      ],
      "Rounding an amount of 1.26 with rounding value 0.1": [
        "Arrondi d'un montant de 1.26 avec une valeur d'arrondi de 0.1",
      ],
      'With the "nearest" mode the value will be rounded to 1.3': [
        "Avec le mode « le plus proche », la valeur sera arrondie à 1.3",
      ],
      "Rounding an amount of 1.24 with rounding value 0.3": [
        "Arrondi d'un montant de 1.24 avec une valeur d'arrondi de 0.3",
      ],
      "Given the rounding value of 0.3 the possible values closest to 1.24 are: 0.9, 1.2, 1.5, 1.8.":
        [
          "Avec une valeur d'arrondi de 0.3, les valeurs possibles les plus proches de 1.24 sont : 0.9, 1.2, 1.5, 1.8.",
        ],
      'With the "up" mode the value will be rounded to 1.5': [
        "Avec le mode « vers le haut », la valeur sera arrondie à 1.5",
      ],
      "Rounding an amount of 1.26 with rounding value 0.3": [
        "Arrondi d'un montant de 1.26 avec une valeur d'arrondi de 0.3",
      ],
      "Amount to be deducted before amount is credited.": [
        "Montant à déduire avant que le montant soit crédité.",
      ],
      "Failed to load conversion details.": [
        "Échec du chargement des détails de conversion.",
      ],
      "Conversion should be enabled in the configuration, the conversion rate should be initialized with fee(s), rates and a rounding mode.":
        [
          "La conversion doit être activée dans la configuration, le taux de conversion doit être initialisé avec des frais, des taux et un mode d'arrondi.",
        ],
      "Failed to delete conversion rate class": [
        "Échec de la suppression de la classe de taux de conversion",
      ],
      "Unauthorized": ["Non autorisé"],
      "Forbidden": ["Interdit"],
      "Conversion rate class was not found.": [
        "La classe de taux de conversion est introuvable.",
      ],
      "Deleting conversion rate classes is not supported by this bank.": [
        "Cette banque ne permet pas de supprimer les classes de taux de conversion.",
      ],
      "Failed to update conversion rate class.": [
        "Échec de la mise à jour de la classe de taux de conversion.",
      ],
      "Not Found": ["Non trouvé"],
      "Not implemented": ["Non implémenté"],
      "The name of the conversion is already used.": [
        "Le nom de la conversion est déjà utilisé.",
      ],
      "Accounts": ["Comptes"],
      "Test conversion": ["Tester la conversion"],
      "Delete class": ["Supprimer la classe"],
      "Manage this conversion rate class and the accounts assigned to it.": [
        "Gérez cette classe de taux de conversion et les comptes qui lui sont attribués.",
      ],
      "Conversion rate class sections": [
        "Sections de la classe de taux de conversion",
      ],
      "identification": ["identification"],
      "Conversion rate class name": ["Nom de la classe de taux de conversion"],
      "Conversion rate class description": [
        "Description de la classe de taux de conversion",
      ],
      "Users": ["Utilisateurs"],
      "Delete": ["Supprimer"],
      "Failed to calculate the cashout fee.": [
        "Échec du calcul des frais d'encaissement.",
      ],
      "Can't remove the conversion rate class": [
        "Impossible de supprimer la classe de taux de conversion",
      ],
      "There are some users associated with this class. You need to remove them first.":
        [
          "Des utilisateurs sont associés à cette classe. Vous devez d'abord les retirer.",
        ],
      "You are going to remove the conversion rate class": [
        "Vous êtes sur le point de supprimer la classe de taux de conversion",
      ],
      "This step can't be undone.": ["Cette étape est irréversible."],
      "Class": ["Classe"],
      "Action": ["Action"],
      "Failed to update conversion class membership.": [
        "Impossible de mettre à jour l’appartenance à la classe de conversion.",
      ],
      "The account could not be updated. Please try again.": [
        "Le compte n’a pas pu être mis à jour. Veuillez réessayer.",
      ],
      "Conversion rate information is unavailable for these accounts.": [
        "Les informations sur le taux de conversion ne sont pas disponibles pour ces comptes.",
      ],
      "Failed to load users in conversion class.": [
        "Échec du chargement des utilisateurs de la classe de conversion.",
      ],
      "Filters": ["Filtres"],
      "Show from other classes": ["Afficher depuis d'autres classes"],
      "Account": ["Compte"],
      "Group ID": ["ID de groupe"],
      "No users in this conversion rate class": [
        "Aucun utilisateur dans cette classe de taux de conversion",
      ],
      "Remove": ["Supprimer"],
      "Add": ["Ajouter"],
      "Conversion rate name": ["Nom du taux de conversion"],
      "Short description of the class": ["Brève description de la classe"],
      "Failed to create conversion class.": [
        "Échec de la création de la classe de conversion.",
      ],
      "New conversion rate class": ["Nouvelle classe de taux de conversion"],
      "Create a named set of conversion terms that can be assigned to accounts.":
        [
          "Créez un ensemble nommé de conditions de conversion pouvant être attribué à des comptes.",
        ],
      "Create class": ["Créer la classe"],
      "Failed to load public accounts.": [
        "Impossible de charger les comptes publics.",
      ],
      "Browse transaction histories shared by public bank accounts.": [
        "Consultez les historiques de transactions partagés par les comptes bancaires publics.",
      ],
      "No public accounts are available.": [
        "Aucun compte public n’est disponible.",
      ],
      "View previous cashouts": ["Afficher les retraits précédents"],
      "Cashout ID must be a number.": [
        "L’identifiant d’encaissement doit être un nombre.",
      ],
      "Failed to load cashout details.": [
        "Échec du chargement des détails de l'encaissement.",
      ],
      "This cashout was not found. It may already have been aborted.": [
        "Cet encaissement est introuvable. Il a peut-être déjà été annulé.",
      ],
      "Back to cashout history": ["Retour à l’historique des encaissements"],
      "Amounts recorded for this completed cashout transfer.": [
        "Montants enregistrés pour ce transfert d’encaissement terminé.",
      ],
      "Amount debited": ["Montant débité"],
      "Amount transferred": ["Montant transféré"],
      "Enter your full name.": ["Saisissez votre nom complet."],
      "Repeat your password.": ["Répétez le mot de passe"],
      "Create your bank account": ["Créer un compte"],
      "Choose the credentials you will use to sign in.": [
        "Choisissez les identifiants que vous utiliserez pour vous connecter.",
      ],
      "Already have an account?": ["Vous avez déjà un compte ?"],
      "Confirm password": ["Confirmer le mot de passe"],
      "Use between 8 and 64 characters. A longer, unique password is easier to keep secure.":
        [
          "Utilisez entre 8 et 64 caractères. Un mot de passe plus long et unique est plus facile à sécuriser.",
        ],
      "Creating account…": ["Création du compte…"],
      "Check the account details and try again.": [
        "Vérifiez les informations du compte et réessayez.",
      ],
      "You are not authorized to create this account.": [
        "Vous n'êtes pas autorisé à créer ce compte.",
      ],
      "Registration is unavailable because the bank cannot grant the account credit.":
        [
          "L’inscription n’est pas disponible, car la banque ne peut pas accorder de crédit au compte.",
        ],
      "That username is reserved. Choose another username.": [
        "Ce nom d’utilisateur est réservé. Choisissez-en un autre.",
      ],
      "That username is already taken.": [
        "Désolé, ce nom d’utilisateur est déjà pris.",
      ],
      "That account ID is already taken.": [
        "Désolé, cet identifiant de compte est déjà pris.",
      ],
      "The bank is missing information for the selected authentication channel.":
        ["Aucune information pour le canal d'authentification sélectionné."],
      "The selected authentication channel is not supported.": [
        "Le canal d'authentification n'est pas pris en charge.",
      ],
      "Only an administrator may set the debt limit.": [
        "Seul un administrateur est autorisé à fixer la limite d'endettement.",
      ],
      "Only an administrator may select a conversion rate class.": [
        "Seul un administrateur peut sélectionner une classe de taux de conversion.",
      ],
      "The selected conversion rate class does not exist.": [
        "La classe de taux de conversion n'existe pas.",
      ],
      "Only an administrator may enable two-factor authentication while creating an account.":
        [
          "Seul un administrateur peut activer l’authentification à deux facteurs lors de la création d’un compte.",
        ],
      "Account registration is unavailable": ["Inscription du compte"],
      "This bank is not accepting new account registrations.": [
        "Actuellement, la banque n'accepte pas de nouvelles inscriptions !",
      ],
      "Return to sign in": ["Revenir à la connexion"],
      "Contact the bank administrator if you need an account.": [
        "Veuillez contacter l’administrateur de la banque.",
      ],
      "Send money from this account to another bank account.": [
        "Envoyez de l’argent de ce compte vers un autre compte bancaire.",
      ],
      "Failed to load withdrawal details.": [
        "Échec du chargement des détails du retrait.",
      ],
      "Choose amount": ["Choisir le montant"],
      "Open wallet": ["Ouvrir le portefeuille"],
      "Review": ["Vérifier"],
      "Withdrawal progress": ["Progression du retrait"],
      "Abort this withdrawal?": ["Annuler ce retrait ?"],
      "This stops the withdrawal. No money will be transferred, and this operation cannot be resumed.":
        [
          "Cela annule le retrait. Aucun argent ne sera transféré et cette opération ne pourra pas être reprise.",
        ],
      "Keep withdrawal": ["Conserver le retrait"],
      "Abort withdrawal": ["Annuler le retrait"],
      'The payto URI returned by the server is invalid: "%1$s".': [
        'L’URI payto renvoyé par le serveur n’est pas valide : "%1$s".',
      ],
      'The withdrawal URI returned by the server is invalid: "%1$s".': [
        'L’URI de retrait renvoyé par le serveur n’est pas valide : "%1$s".',
      ],
      'The reserve public key returned by the server is invalid: "%1$s".': [
        'La clé publique de réserve renvoyée par le serveur n’est pas valide : "%1$s".',
      ],
      "Enter an amount.": ["Saisissez un montant."],
      "Enter a valid amount.": ["Saisissez un montant valide."],
      "The amount must be greater than zero.": [
        "Le montant doit être supérieur à zéro.",
      ],
      "The amount is below the bank's minimum.": [
        "Le montant est inférieur au minimum de la banque.",
      ],
      "The amount is above the bank's maximum.": [
        "Le montant est supérieur au maximum de la banque.",
      ],
      "Failed to abort the withdrawal.": ["Échec de l'annulation du retrait."],
      "The server did not understand the request.": [
        "Le serveur n'a pas compris la requête.",
      ],
      "The operation was not found.": ["L'opération est introuvable."],
      "The withdrawal operation has already been confirmed and cannot be aborted.":
        [
          "L’opération de retrait a déjà été confirmée et ne peut pas être annulée.",
        ],
      "The bank could not be reached. Please try again.": [
        "La banque est injoignable. Réessayez.",
      ],
      "Withdrawal confirmation": ["Confirmation du retrait"],
      "Failed to confirm the withdrawal.": [
        "Échec de la confirmation du retrait.",
      ],
      "The account does not have sufficient funds or the amount is outside the limits.":
        [
          "Le compte ne dispose pas de fonds suffisants ou le montant est hors limites.",
        ],
      "The withdrawal has been aborted and cannot be confirmed.": [
        "Le retrait a été annulé et ne peut pas être confirmé.",
      ],
      "The wallet has not finished selecting an exchange account.": [
        "Le portefeuille n’a pas encore terminé la sélection d’un compte de l’exchange.",
      ],
      "The withdrawal amount changed. Review the current amount and try again.":
        [
          "Le montant du retrait a changé. Vérifiez le montant actuel et réessayez.",
        ],
      "Enter an amount before confirming the withdrawal.": [
        "Saisissez un montant avant de confirmer le retrait.",
      ],
      "Selected exchange": ["Exchange sélectionné"],
      "Sign in to confirm the withdrawal": [
        "Connectez-vous pour confirmer le retrait",
      ],
      "Sign in as %1$s before reviewing and confirming this withdrawal.": [
        "Connectez-vous en tant que %1$s avant de vérifier et confirmer ce retrait.",
      ],
      "You are signed in as %1$s, but this withdrawal belongs to %2$s.": [
        "Vous êtes connecté en tant que %1$s, mais ce retrait appartient à %2$s.",
      ],
      "Finish later": ["Terminer plus tard"],
      "Confirm wallet withdrawal": ["Confirmer le retrait du portefeuille"],
      "Review how much will leave your bank account before confirming.": [
        "Vérifiez le montant qui quittera votre compte bancaire avant de confirmer.",
      ],
      "Unsupported exchange account": [
        "Compte de l’exchange non pris en charge",
      ],
      "The exchange account does not use the transfer type configured by this bank. This withdrawal cannot be confirmed.":
        [
          "Le compte de l’exchange n’utilise pas le type de virement configuré par cette banque. Ce retrait ne peut pas être confirmé.",
        ],
      "Withdrawal amount missing": ["Montant du retrait manquant"],
      "The bank did not provide an amount for this withdrawal. It cannot be confirmed.":
        [
          "La banque n’a pas fourni de montant pour ce retrait. Il ne peut pas être confirmé.",
        ],
      "Bank amount configuration invalid": [
        "La configuration des montants de la banque est invalide",
      ],
      "The withdrawal amount and bank fee could not be combined safely. This withdrawal cannot be confirmed.":
        [
          "Le montant du retrait et les frais bancaires ne peuvent pas être additionnés de façon sûre. Ce retrait ne peut pas être confirmé.",
        ],
      "Wallet receives": ["Le portefeuille reçoit"],
      "Amount to your Taler Wallet": ["Montant vers votre portefeuille Taler"],
      "Allowed amount": ["Montant autorisé"],
      "Maximum amount": ["Montant maximal"],
      "Amount unavailable": ["Montant indisponible"],
      "From": ["De"],
      "To": ["Vers"],
      "Taler Wallet": ["Portefeuille Taler"],
      "Exchange": ["exchange"],
      "Unavailable": ["Indisponible"],
      "Exchange details": ["Détails de l’exchange"],
      "Exchange IBAN": ["IBAN de l’exchange"],
      "Bank hostname": ["Nom d’hôte de la banque"],
      "Exchange account": ["Compte de l’exchange"],
      "No money is withdrawn until you confirm. You can finish this later from your account overview.":
        [
          "Aucun argent n’est retiré avant votre confirmation. Vous pouvez terminer plus tard depuis la vue d’ensemble de votre compte.",
        ],
      "Confirm withdrawal": ["Confirmer le retrait"],
      "Unauthorized to make the operation, maybe the session has expired or the password changed.":
        [
          "Non autorisé à effectuer l'opération, peut-être que la session a expiré ou que le mot de passe a été modifié.",
        ],
      "The operation was rejected due to insufficient funds.": [
        "L'opération a été rejetée en raison de fonds insuffisants.",
      ],
      "Withdrawal aborted": ["Retrait annulé"],
      "Withdrawal confirmed": ["Retrait confirmé"],
      "The bank transfer to the Taler exchange has been initiated. Your Taler Wallet will receive the withdrawn amount shortly.":
        [
          "Le virement bancaire vers l’exchange Taler a été lancé. Votre portefeuille Taler recevra bientôt le montant retiré.",
        ],
      "Back to account": ["Retour au compte"],
      "Complete withdrawal with your Taler Wallet": [
        "Terminez le retrait avec votre portefeuille Taler",
      ],
      "Scan this QR code with your Taler Wallet. Your wallet will select an exchange and prepare the withdrawal.":
        [
          "Scannez ce code QR avec votre portefeuille Taler. Votre portefeuille sélectionnera un exchange et préparera le retrait.",
        ],
      "Withdrawal amount": ["Montant du retrait"],
      "Suggested amount": ["Montant suggéré"],
      "You can change this amount in your wallet.": [
        "Vous pouvez modifier ce montant dans votre portefeuille.",
      ],
      "QR code to continue the withdrawal in a Taler Wallet.": [
        "Code QR permettant de poursuivre le retrait dans un portefeuille Taler.",
      ],
      "Open Taler Wallet manually": [
        "Ouvrir manuellement le portefeuille Taler",
      ],
      "Don't have a Taler Wallet?": ["Vous n’avez pas de portefeuille Taler ?"],
      "Get a wallet": ["Obtenir un portefeuille"],
      "No money will be transferred until you return here to review and confirm the withdrawal.":
        [
          "Aucun transfert d’argent ne sera effectué tant que vous ne serez pas revenu ici pour vérifier et confirmer le retrait.",
        ],
      "Sign in to abort this withdrawal": [
        "Connectez-vous pour annuler ce retrait",
      ],
      "The withdrawal operation has been confirmed previously and can not be aborted.":
        [
          "L'opération de retrait a déjà été confirmée et ne peut pas être annulée.",
        ],
      "Withdrawal ready for confirmation": ["Retrait prêt à être confirmé"],
      "Withdrawal waiting for your wallet": [
        "Retrait en attente de votre portefeuille",
      ],
      "The pending withdrawal could not be checked": [
        "Le retrait en attente n’a pas pu être vérifié",
      ],
      "Checking the pending withdrawal…": [
        "Vérification du retrait en attente…",
      ],
      "Review withdrawal": ["Vérifier le retrait"],
      "Retry": ["Réessayer"],
      "Resume withdrawal": ["Reprendre le retrait"],
      "Finish or abort this withdrawal before starting another one.": [
        "Terminez ou annulez ce retrait avant d’en commencer un autre.",
      ],
      "Dashboard": ["Tableau de bord"],
      "Admin activity": ["Activité administrateur"],
      "Conversion": ["Conversion"],
      "My account": ["Mon compte"],
      "Bank administration": ["Administration bancaire"],
      "Failed to load the account list.": [
        "Échec du chargement de la liste des comptes.",
      ],
      "Search accounts": ["Rechercher des comptes"],
      "Search by username or name": ["Rechercher par nom d'utilisateur ou nom"],
      "Search": ["Rechercher"],
      "Clear": ["Effacer"],
      "Unknown": ["Inconnu"],
      "Change password": ["Changer le mot de passe"],
      "Previous": ["Précédent"],
      "The amount exceeds what is available to withdraw.": [
        "Le montant dépasse la somme disponible pour le retrait.",
      ],
      "The server replied with an invalid taler://withdraw URI": [
        "Le serveur a répondu avec un URI taler://withdraw invalide",
      ],
      "Withdraw URI: %1$s": ["URI de retrait : %1$s"],
      "Failed to create the withdrawal.": ["Échec de la création du retrait."],
      "The operation was rejected due to insufficient funds": [
        "L'opération a été rejetée pour cause de fonds insuffisants",
      ],
      "Please sign in again.": ["Veuillez vous reconnecter."],
      "Choose an amount. Next, open your wallet and return here to review and confirm the withdrawal.":
        [
          "Choisissez un montant. Ouvrez ensuite votre portefeuille et revenez ici pour vérifier et confirmer le retrait.",
        ],
      "Unable to calculate the withdrawal amount": [
        "Impossible de calculer le montant du retrait",
      ],
      "The bank's withdrawal limits or fee are configured incorrectly.": [
        "Les limites ou les frais de retrait de la banque sont mal configurés.",
      ],
      "Maximum withdrawal": ["Retrait maximal"],
      "There is not enough available balance to cover a withdrawal and the bank fee.":
        [
          "Le solde disponible ne suffit pas à couvrir le retrait et les frais bancaires.",
        ],
      "Use maximum available": ["Utiliser le maximum disponible"],
      "No money moves until you review and confirm the withdrawal.": [
        "Aucun argent ne sera transféré avant que vous ayez vérifié et confirmé le retrait.",
      ],
      "Need a Taler Wallet?": ["Besoin d’un portefeuille Taler ?"],
      "Get the wallet": ["Obtenir le portefeuille"],
      "Dismiss wallet installation hint": [
        "Fermer le conseil d’installation du portefeuille",
      ],
      "Continue to wallet": ["Continuer vers le portefeuille"],
      "Unable to start a withdrawal.": ["Impossible de démarrer le retrait."],
      "Your account was created. Sign in to continue.": [
        "Votre compte a été créé. Connectez-vous pour continuer.",
      ],
      "Conversion rate class ID “%1$s” is not a number.": [
        "L’identifiant de classe de taux de conversion « %1$s » n’est pas un nombre.",
      ],
      "Home": ["Accueil"],
      "Page not found": ["Page introuvable"],
      "The requested bank page does not exist.": [
        "La page bancaire demandée n’existe pas.",
      ],
      "Unknown challenge.": ["Vérification inconnue."],
      "Failed to validate the verification code.": [
        "Échec de la validation du code de vérification.",
      ],
      "Too many challenges are active. Wait or confirm an existing challenge.":
        [
          "Trop de vérifications sont actives actuellement, vous devez attendre ou confirmer les vérifications en cours.",
        ],
      "The verification code is incorrect.": [
        "Le code de vérification est incorrect.",
      ],
      "The verification code has expired.": [
        "Le code de vérification a expiré.",
      ],
      "Submit the transmitted code number.": [
        "Envoyez le numéro de code transmis.",
      ],
      "The verification code sent to the email address starting with %1$s": [
        "Le code de vérification envoyé à l'adresse courriel commençant par %1$s",
      ],
      "The verification code sent to the phone number ending with %1$s": [
        "Le code de vérification envoyé au numéro de téléphone se terminant par %1$s",
      ],
      "Code": ["Code"],
      "Authentication code": ["Code d’authentification"],
      "It will expire at %1$s": ["Date d'expiration %1$s"],
      "This challenge is terminal and cannot be retransmitted.": [
        "Cette demande d’authentification est terminée et ne peut pas être retransmise.",
      ],
      "Restart authentication": ["Recommencer l’authentification"],
      "Back": ["Retour"],
      "Verifying…": ["Vérification…"],
      "Verify": ["Vérifier"],
      "Complete": ["Terminer"],
      "Failed to start the challenge.": [
        "Échec du démarrage de la vérification.",
      ],
      "Unable to send the verification code.": [
        "Impossible d'envoyer le code de vérification.",
      ],
      "The request was valid, but the server is refusing action.": [
        "La requête était valide, mais le serveur refuse d'agir.",
      ],
      "The backend is not aware of the specified MFA challenge.": [
        "Le backend n'a pas connaissance de la vérification MFA spécifiée.",
      ],
      "It is too early to request another transmission of the challenge.": [
        "Il est trop tôt pour demander une nouvelle transmission de la vérification.",
      ],
      "Code transmission failed.": ["Échec de la transmission du code."],
      "Multi-factor authentication required": [
        "Authentification à plusieurs facteurs requise",
      ],
      "This operation is protected with second factor authentication. In order to complete it we need to verify your identity using the authentication channel you provided.":
        [
          "Cette opération est protégée par une authentification à deuxième facteur. Pour la mener à bien, nous devons vérifier votre identité à l'aide du canal d'authentification que vous avez fourni.",
        ],
      "The next challenge needs to be completed to confirm the operation.": [
        "La prochaine vérification doit être complétée pour confirmer l'opération.",
      ],
      "All the next challenges need to be completed to confirm the operation.":
        [
          "Toutes les prochaines vérifications doivent être complétées pour confirmer l'opération.",
        ],
      "One of the next challenges needs to be completed to confirm the operation.":
        [
          "L'une des prochaines vérifications doit être complétée pour confirmer l'opération.",
        ],
      'To a phone ending with "%1$s"': [
        "Vers un téléphone se terminant par « %1$s »",
      ],
      'To an email starting with " %1$s"': [
        "Vers un courriel commençant par « %1$s »",
      ],
      "I have a code": ["J'ai un code"],
      "Send me a message": ["Envoyez-moi un message"],
      "You have to wait until %1$s to send a new code.": [
        "Vous devez attendre jusqu'à %1$s pour envoyer un nouveau code.",
      ],
      "Use configured value (enabled)": [
        "Utiliser la valeur configurée (activée)",
      ],
      "Use configured value (disabled)": [
        "Utiliser la valeur configurée (désactivée)",
      ],
      "Force enabled": ["Forcer l’activation"],
      "Force disabled": ["Forcer la désactivation"],
      "Enter a valid HTTP or HTTPS URL.": [
        "Saisissez une URL HTTP ou HTTPS valide.",
      ],
      "Development settings": ["Paramètres de développement"],
      "These overrides are stored only in this browser.": [
        "Ces substitutions sont stockées uniquement dans ce navigateur.",
      ],
      "Corebank API base URL": ["URL de base de l’API Corebank"],
      "Leave empty to use the configured URL: %1$s": [
        "Laissez ce champ vide pour utiliser l’URL configurée : %1$s",
      ],
      "Leave empty to derive the URL from this page.": [
        "Laissez ce champ vide pour déduire l’URL de cette page.",
      ],
      "Demo header": ["En-tête de démonstration"],
      "Control whether the demo header is shown in this browser.": [
        "Détermine si l’en-tête de démonstration est affiché dans ce navigateur.",
      ],
      "Control whether public account links are shown in this browser.": [
        "Détermine si les liens vers les comptes publics sont affichés dans ce navigateur.",
      ],
      "Overrides saved.": ["Substitutions enregistrées."],
      "Apply overrides": ["Appliquer les substitutions"],
      "Clear overrides": ["Effacer les substitutions"],
      "Back to bank": ["Retour à la banque"],
    },
  },
  domain: "messages",
  plural_forms: "nplurals=2; plural=n > 1;",
  lang: "fr",
  completeness: 100,
};

strings["es"] = {
  locale_data: {
    messages: {
      "": {
        domain: "messages",
        lang: "es_AR",
        plural_forms: "nplurals=2; plural=n != 1;",
      },
      "Hide password": ["Ocultar contraseña"],
      "Show password": ["Mostrar contraseña"],
      "Hide": ["Ocultar"],
      "Show": ["Mostrar"],
      "Identity verification.": ["Verificación de identidad."],
      "You do not have permission to access this account.": [
        "No tienes permiso para acceder a esta cuenta.",
      ],
      "This account is locked. Contact the bank administrator.": [
        "La cuenta está bloqueada y no puede iniciar sesión. Contacta al administrador.",
      ],
      "The password is incorrect.": ["La contraseña es incorrecta."],
      "Account not found.": ["Cuenta no encontrada"],
      "Could not reach the bank. Check your connection and try again.": [
        "No se pudo contactar con el banco. Compruebe su conexión y vuelva a intentarlo.",
      ],
      "Confirm your password": ["Confirme su contraseña"],
      "Sign in to %1$s": ["Iniciar sesión en %1$s"],
      "Enter the password for %1$s to continue.": [
        "Introduzca la contraseña de %1$s para continuar.",
      ],
      "Use your bank account credentials to continue.": [
        "Utilice las credenciales de su cuenta bancaria para continuar.",
      ],
      "Need an account?": ["¿Necesita una cuenta?"],
      "Create one": ["Crear cuenta"],
      "Your session expired. Confirm your password to continue.": [
        "Su sesión ha caducado. Confirme su contraseña para continuar.",
      ],
      "Username": ["Usuario"],
      "Password": ["Contraseña"],
      "Sign out": ["Cerrar sesión"],
      "Signing in…": ["Iniciando sesión…"],
      "Continue": ["Continuar"],
      "Sign in": ["Iniciar sesión"],
      "Enter your username.": ["Introduzca su nombre de usuario."],
      "Use letters, numbers, or any of these characters: - . _ ~": [
        "Usa letras, números o cualquiera de estos caracteres: - . _ ~",
      ],
      "The username must not exceed 126 characters.": [
        "El nombre de usuario no debe superar los 126 caracteres.",
      ],
      "Enter your password.": ["Introduzca su contraseña."],
      "The password must contain at least 8 characters.": [
        "La contraseña es demasiado corta. Debe tener al menos 8 caracteres.",
      ],
      "The password must not exceed %1$s characters.": [
        "La contraseña no debe superar los %1$s caracteres.",
      ],
      "IBAN country code not found": ["Código de país del IBAN no encontrado"],
      "IBAN length is invalid for this country": [
        "La longitud del IBAN no es válida para este país",
      ],
      "The IBAN contains invalid characters": [
        "El IBAN contiene caracteres no válidos",
      ],
      "IBAN number is not valid, checksum is wrong": [
        "El número IBAN no es válido, falló la verificación",
      ],
      "The IBAN is not valid": ["El IBAN no es válido"],
      "Use letters, numbers or any of these characters: - . _ ~": [
        "Usa letras, números o cualquiera de estos caracteres: - . _ ~",
      ],
      "Failed to load cashouts.": ["No se pudieron cargar los egresos."],
      "Try again": ["Volver a intentarlo"],
      "Cashout is disabled": ["El egreso está deshabilitado"],
      "Cashout should be enabled in the configuration, the conversion rate should be initialized with fee(s), rates and a rounding mode.":
        [
          "El egreso debe estar habilitado en la configuración, la tasa de conversión debe estar inicializada con comisión(es), tasas y un modo de redondeo.",
        ],
      "Failed to load conversion rate information.": [
        "No se pudo cargar la información de la tasa de conversión.",
      ],
      "Some cashout details could not be loaded.": [
        "No se pudieron cargar algunos detalles de las retiradas.",
      ],
      "The partial list omits cashout IDs: %1$s.": [
        "La lista parcial omite los identificadores de retirada siguientes: %1$s.",
      ],
      "Debited": ["Debitado"],
      "Transferred": ["Transferido"],
      "Created": ["Creado"],
      "Actions": ["Acciones"],
      "Cashout history": ["Historial de retiros"],
      "Profile": ["Perfil"],
      "Security": ["Seguridad"],
      "Merchant integration": ["Integración con el comerciante"],
      "Back to overview": ["Volver al resumen"],
      "My account settings": ["Configuración de mi cuenta"],
      "Copy": ["Copiar"],
      "Failed to load account details.": [
        "No se pudieron cargar los detalles de la cuenta.",
      ],
      'Use this information to link your Taler Merchant Backoffice account with the current bank account. You can start by copying the values, then go to your merchant backoffice service provider, login into your account and look for the "import" button in the "bank account" section.':
        [
          'Usa esta información para vincular tu cuenta de Taler Merchant Backoffice con la cuenta bancaria actual. Puedes comenzar copiando los valores, luego ir a tu proveedor de backoffice de comercio, iniciar sesión y buscar el botón "importar" en la sección "cuenta bancaria".',
        ],
      "Not available": ["No disponible"],
      "Merchant integration is not available for this account.": [
        "La integración con el comerciante no está disponible para esta cuenta.",
      ],
      "Account type": ["Tipo de cuenta"],
      "Method to use for wire transfer.": [
        "Método a usar para la transferencia bancaria.",
      ],
      "IBAN": ["IBAN"],
      "International Bank Account Number.": [
        "Número de Cuenta Bancaria Internacional.",
      ],
      "Bank host": ["Servidor del banco"],
      "Bank host where the service is located.": [
        "Host bancario donde se encuentra el servicio.",
      ],
      "Account name": ["Nombre de la cuenta"],
      "Bank account identifier for wire transfers.": [
        "Identificador de cuenta bancaria para transferencias bancarias.",
      ],
      "Address": ["Dirección"],
      "Bitcoin address for this account.": [
        "Dirección de Bitcoin de esta cuenta.",
      ],
      "Account address": ["Dirección de la cuenta"],
      "Owner's name": ["Nombre del titular"],
      "Legal name of the person holding the account.": [
        "Nombre legal de la persona titular de la cuenta.",
      ],
      "Account info URL": ["URL de información de la cuenta"],
      "From where the merchant can download information about incoming wire transfers to this account.":
        [
          "Desde donde el comerciante puede descargar información sobre las transferencias bancarias entrantes a esta cuenta.",
        ],
      "Unable to create a cashout": ["No se puede crear un egreso"],
      "The bank configuration does not support cashout operations.": [
        "La configuración del banco no soporta operaciones de egreso.",
      ],
      "Close": ["Cerrar"],
      "The bank returned incomplete conversion information.": [
        "El banco devolvió información de conversión incompleta.",
      ],
      "Please contact the bank administrator.": [
        "Póngase en contacto con el administrador del banco.",
      ],
      "Authentication required": ["Se requiere autenticación"],
      "Please sign in to create a cashout.": [
        "Inicie sesión para crear una retirada.",
      ],
      "Failed to calculate the conversion fee.": [
        "No se pudo calcular la comisión de conversión.",
      ],
      "The amount is too small": ["El monto es demasiado pequeño"],
      "Conversion is not implemented.": ["La conversión no está implementada."],
      "The currency is not supported": ["La divisa no está soportada"],
      "Required": ["Requerido"],
      "Invalid": ["Inválido"],
      "The balance is not sufficient": ["El saldo no es suficiente"],
      "It is not possible to cash out less than %1$s: %2$s": [
        "No es posible retirar menos de %1$s: %2$s",
      ],
      "The total transfer to the destination will be zero": [
        "El total de la transferencia al destino será cero",
      ],
      "Failed to create the cashout.": ["No se pudo crear el egreso."],
      "Cashout": ["Egreso"],
      "Account not found": ["Cuenta no encontrada"],
      "Duplicate request detected, check if the operation succeeded or try again.":
        [
          "Se detectó una petición duplicada, verifica si la operación tuvo éxito o intenta nuevamente.",
        ],
      "The conversion rate was applied incorrectly": [
        "La tasa de conversión se aplicó de forma incorrecta",
      ],
      "The account does not have sufficient funds": [
        "La cuenta no tiene fondos suficientes",
      ],
      "Missing cashout URI in the profile": [
        "Falta la dirección de egreso en el perfil",
      ],
      "The amount is below the minimum amount permitted.": [
        "El monto está por debajo del mínimo permitido.",
      ],
      "Sending the confirmation message failed, retry later or contact the administrator.":
        [
          "El envío del mensaje de confirmación falló, intenta más tarde o contacta al administrador.",
        ],
      "The server doesn't support the current TAN channel.": [
        "El servidor no soporta el canal TAN actual.",
      ],
      "Conversion rate": ["Tasa de conversión"],
      "Balance": ["Saldo"],
      "Fee": ["Comisión"],
      "No fee": ["Sin comisión"],
      "To account": ["Hacia la cuenta"],
      "Legal name": ["Nombre legal"],
      "If this name doesn't match the account holder's name, your transaction may fail.":
        [
          "Si este nombre no coincide con el titular de la cuenta, tu transacción podría fallar.",
        ],
      "Unable to cash out": ["No se puede realizar el egreso"],
      "Before being able to cash out to a bank account, you need to complete your profile":
        [
          "Antes de poder hacer un egreso a una cuenta bancaria, necesitas completar tu perfil",
        ],
      "Send %1$s": ["Enviar %1$s"],
      "Receive %1$s": ["Recibir %1$s"],
      "Amount": ["Monto"],
      "Total cost": ["Costo total"],
      "Balance left": ["Saldo restante"],
      "Before fee": ["Antes de la comisión"],
      "Total cashout transfer": ["Total del egreso"],
      "Cancel": ["Cancelar"],
      "Cash out": ["Retirar fondos"],
      "Not valid": ["No válido"],
      "Does not follow the pattern": ["No sigue el formato esperado"],
      "The request was invalid or the payto://-URI used unacceptable features.":
        [
          "El pedido era inválido o el URI payto:// usado tiene características inaceptables.",
        ],
      "Not enough permission to complete the operation.": [
        "No tienes permisos suficientes para completar la operación.",
      ],
      "The bank administrator cannot be the transfer creditor.": [
        "El administrador del banco no puede ser el destinatario de la transferencia.",
      ],
      'The destination account "%1$s" was not found.': [
        'La cuenta de destino "%1$s" no fue encontrada.',
      ],
      "The origin and the destination of the transfer can't be the same.": [
        "El origen y el destino de la transferencia no pueden ser iguales.",
      ],
      "Your balance is not sufficient for the operation.": [
        "Tu saldo no es suficiente para la operación.",
      ],
      'The origin account "%1$s" was not found.': [
        'La cuenta origen "%1$s" no fue encontrada.',
      ],
      "The attempt to create the transaction has failed. Please try again.": [
        "El intento de crear la transacción falló. Por favor intenta nuevamente.",
      ],
      "Confirm transaction.": ["Confirmar transacción."],
      "Enter the recipient, a reference, and the amount to send.": [""],
      "Maximum transfer": ["Transferencia máxima"],
      "Debt limit": ["Límite de deuda"],
      "This is not your account balance. This account cannot go into debt.": [
        "Este no es el saldo de su cuenta. Esta cuenta no puede quedar en descubierto.",
      ],
      "This is not your account balance. It includes borrowing up to the debt limit shown here.":
        [
          "Este no es el saldo de su cuenta. Incluye el crédito disponible hasta el límite de deuda que se muestra aquí.",
        ],
      "Recipient": ["Destinatario"],
      "username": ["usuario"],
      "IBAN of the recipient's account": ["IBAN de la cuenta del destinatario"],
      "What is this transfer for?": [""],
      "Paste a payto URI containing the recipient, amount, and transfer reference.":
        [""],
      "Uniform resource identifier of the target account": [
        "Identificador de recurso uniforme de la cuenta destino",
      ],
      "payto://x-taler-bank/[bank-host]/[receiver-account]?message=[subject]&amount=[%1$s:X.Y]":
        [
          "payto://x-taler-bank/[operador bancario]/[cuenta bancaria del destinatario]?message=[asunto]&amount=[%1$s:X.Y]",
        ],
      "payto://iban/[receiver-iban]?message=[subject]&amount=[%1$s:X.Y]": [
        "payto://iban/[IBAN del destinatario]?message=[asunto]&amount=[%1$s:X.Y]",
      ],
      "Bank fee": ["Comisión bancaria"],
      "Total debited": ["Total debitado"],
      "Need to move money out of this bank?": [""],
      'Only "x-taler-bank" targets are supported': [
        'Solo se soportan destinos "x-taler-bank"',
      ],
      'Only this host is allowed. Use "%1$s"': [
        'Solo este host está permitido. Usa "%1$s"',
      ],
      "Account name is missing": ["Falta el nombre de la cuenta"],
      'Only "IBAN" targets are supported': ['Solo se soportan destinos "IBAN"'],
      'Missing "amount" parameter to specify the amount to be transferred': [
        'Falta el parámetro "amount" para indicar el monto a transferir',
      ],
      'The "amount" parameter is not valid': [
        'El parámetro "amount" no es válido',
      ],
      '"message" parameters to specify a reference text for the transfer are missing':
        [
          'Falta el parámetro "message" para indicar un texto de referencia en la transferencia',
        ],
      'The only currency allowed is "%1$s"': [
        'La única divisa permitida es "%1$s"',
      ],
      "You cannot transfer an amount of zero.": [
        "No puedes transferir un monto de cero.",
      ],
      "Please enter a longer subject": [
        "Por favor ingresa un asunto más largo",
      ],
      "Email and SMS authentication were disabled because their contact details were removed.":
        [
          "La autenticación por correo electrónico y SMS se desactivó porque se eliminaron sus datos de contacto.",
        ],
      "Email authentication was disabled because the email address was removed.":
        [
          "La autenticación por correo electrónico se desactivó porque se eliminó la dirección de correo electrónico.",
        ],
      "SMS authentication was disabled because the phone number was removed.": [
        "La autenticación por SMS se desactivó porque se eliminó el número de teléfono.",
      ],
      "Invalid email format": ["Formato de correo electrónico inválido"],
      "Should start with +": ["Debe comenzar con +"],
      "A phone number consists of numbers only": [
        "Un número de teléfono solo puede contener números",
      ],
      "Login username": ["Nombre de usuario"],
      "Account ID for authentication": ["ID de cuenta para autenticación"],
      "Full name": ["Nombre completo"],
      "Name of the account holder": ["Nombre del titular de la cuenta"],
      "Internal account": ["Cuenta interna"],
      "Copy and share this account address to receive transfers.": [
        "Copie y comparta esta dirección de cuenta para recibir transferencias.",
      ],
      "Email": ["Correo electrónico"],
      "To be used when second factor authentication is enabled": [
        "Se usa cuando la autenticación de segundo factor está habilitada",
      ],
      "Phone": ["Teléfono"],
      "Enable second factor authentication": [
        "Habilitar autenticación de segundo factor",
      ],
      "Using email": ["Usando correo electrónico"],
      "Add an email in your profile to enable this option": [
        "Añade un correo electrónico en tu perfil para habilitar esta opción",
      ],
      "Using SMS": ["Usando SMS"],
      "Add a phone number in your profile to enable this option": [
        "Añade un número de teléfono en tu perfil para habilitar esta opción",
      ],
      "Cashout account": ["Cuenta de egreso"],
      "External account to which cashout transfers are sent.": [""],
      "Max debt": ["Deuda máxima"],
      "How much the balance can go below zero.": [
        "Cuánto puede quedar el saldo por debajo de cero.",
      ],
      "Is this account public?": ["¿Esta cuenta es pública?"],
      "Public accounts expose their balance and complete transaction history, including subjects and both account addresses, to anonymous visitors.":
        [
          "Las cuentas públicas exponen su saldo y su historial completo de transacciones, incluidos los conceptos y las direcciones de ambas cuentas, a los visitantes anónimos.",
        ],
      "Does this account belong to a Payment Service Provider?": [
        "¿Esta cuenta pertenece a un Proveedor de Servicios de Pago?",
      ],
      "Account updated": ["Cuenta actualizada"],
      "Failed to update the account.": ["No se pudo actualizar la cuenta."],
      "The rights to change the account are not sufficient": [
        "Los permisos para modificar la cuenta no son suficientes",
      ],
      "The username was not found": ["El nombre de usuario no fue encontrado"],
      "You can't change the legal name, please contact your account administrator.":
        [
          "No puedes cambiar el nombre legal; por favor contacta al administrador de tu cuenta.",
        ],
      "You can't change the debt limit, please contact your account administrator.":
        [
          "No puedes cambiar el límite de deuda; por favor contacta al administrador de tu cuenta.",
        ],
      "You can't change the cashout address, please contact your account administrator.":
        [
          "No puedes cambiar la dirección de egreso; por favor contacta al administrador de tu cuenta.",
        ],
      "No information for the selected authentication channel.": [
        "No hay información para el canal de autenticación seleccionado.",
      ],
      "Account update": ["Actualización de cuenta"],
      "Authentication channel is not supported.": [
        "El canal de autenticación no está soportado.",
      ],
      "Only the administrator can change the conversion rate.": [
        "Solo el administrador puede cambiar la tasa de conversión.",
      ],
      "The conversion rate class doesn't exist.": [
        "La clase de tasa de conversión no existe.",
      ],
      "The password is too short. Can't have less than 8 characters.": [
        "La contraseña es demasiado corta. Debe tener al menos 8 caracteres.",
      ],
      "The password is too long. Can't have more than 64 characters.": [
        "La contraseña es demasiado larga. No puede tener más de 64 caracteres.",
      ],
      'Account "%1$s"': ['Cuenta "%1$s"'],
      "Removed": ["Eliminada"],
      "This account can't be used.": ["Esta cuenta no puede usarse."],
      "Account details": ["Detalles de la cuenta"],
      "Not configured": ["Sin configurar"],
      "Change details": ["Cambiar datos"],
      "Update": ["Actualizar"],
      "Delete account": ["Eliminar cuenta"],
      "Permanently remove this bank account. The account must have a zero balance before it can be deleted.":
        [
          "Elimine permanentemente esta cuenta bancaria. La cuenta debe tener saldo cero antes de poder eliminarla.",
        ],
      "The passwords do not match.": ["Las contraseñas no coinciden"],
      "Failed to update the password.": [
        "No se pudo actualizar la contraseña.",
      ],
      "Not authorized to change the password, maybe the session is invalid.": [
        "No estás autorizado a cambiar la contraseña, quizás la sesión es inválida.",
      ],
      "You need to provide the old password. If you don't have it contact your account administrator.":
        [
          "Necesitas ingresar la contraseña anterior. Si no la tienes, contacta al administrador de tu cuenta.",
        ],
      "The current password is incorrect, so the password cannot be changed.": [
        "",
      ],
      "Password update": ["Actualización de contraseña"],
      "You don't have the rights to change the password.": [
        "No tienes permisos para cambiar la contraseña.",
      ],
      "Update password": ["Actualizar contraseña"],
      "Current password": ["Contraseña actual"],
      "Your current password, for security": [
        "Tu contraseña actual, por seguridad",
      ],
      "New password": ["Nueva contraseña"],
      "Failed to load transactions.": [
        "No se pudieron cargar las transacciones.",
      ],
      "Unknown account": ["Cuenta desconocida"],
      "Recent activity": ["Actividad reciente"],
      "Transactions": ["Transacciones"],
      "Subject": ["Asunto"],
      "Today": ["Hoy"],
      "Yesterday": ["Ayer"],
      "Invalid value": ["Valor inválido"],
      "View all transactions": ["Ver todas las transacciones"],
      "No transactions yet.": ["Aún no hay transacciones."],
      "Your account activity will appear here.": [
        "La actividad de tu cuenta aparecerá aquí.",
      ],
      "Date": ["Fecha"],
      "Counterparty": ["Contraparte"],
      "Pagination": ["Paginación"],
      "Newer": ["Más recientes"],
      "Older": ["Más antiguas"],
      "Withdraw to Taler Wallet": ["Retirar a la cartera Taler"],
      "Move digital cash to your Taler Wallet.": [
        "Transfiere dinero digital a tu cartera Taler.",
      ],
      "Send bank transfer": ["Enviar transferencia bancaria"],
      "Transfer money to another bank account.": [
        "Transfiere dinero a otra cuenta bancaria.",
      ],
      "Convert regional currency and send it to your cashout account.": [
        "Convierte la moneda regional y envíala a tu cuenta de retiro.",
      ],
      "Copy account address": ["Copiar la dirección de la cuenta"],
      "Current balance": ["Saldo actual"],
      "Go to account details": ["Ir a los detalles de la cuenta"],
      "Failed to load the admin account.": [
        "No se pudo cargar la cuenta de administración.",
      ],
      "Admin account": ["Cuenta de administración"],
      "Admin account activity": ["Actividad de la cuenta de administración"],
      "Failed to load the monitor info.": [
        "No se pudo cargar la información de monitoreo.",
      ],
      "Failed to load cashout info.": [
        "No se pudo cargar la información del egreso.",
      ],
      "Querying for the current stats failed": [
        "Falló la consulta de estadísticas actuales",
      ],
      "The user is unauthorized": ["El usuario no está autorizado"],
      "Querying for the previous stats failed": [
        "Falló la consulta de estadísticas anteriores",
      ],
      "Bank activity": ["Actividad bancaria"],
      "Select a section": ["Selecciona una sección"],
      "Last hour": ["Última hora"],
      "Previous day": ["Día anterior"],
      "Last month": ["Último mes"],
      "Last year": ["Último año"],
      "Tabs": ["Pestañas"],
      "Last Year": ["Último año"],
      "Trading volume from %1$s to %2$s": [
        "Volumen de operaciones del %1$s al %2$s",
      ],
      "Cash in": ["Ingreso de efectivo"],
      "Transferred from an external account to an account in this bank.": [
        "Transferido desde una cuenta externa a una cuenta en este banco.",
      ],
      "Transferred from an account in this bank to an external account.": [
        "Transferido desde una cuenta de este banco a una cuenta externa.",
      ],
      "Taler pay-in": ["Ingreso en Taler"],
      "Transferred from an account to a Taler exchange.": [
        "Transferido desde una cuenta a un exchange Taler.",
      ],
      "Transfers": ["Transferencias"],
      "Taler payout": ["Pago saliente de Taler"],
      "Transferred from a Taler exchange to another account.": [
        "Transferido desde un exchange Taler a otra cuenta.",
      ],
      "Download stats as CSV": ["Descargar estadísticas en CSV"],
      "previous": ["anterior"],
      "Decreased by": ["Disminuyó en"],
      "Increased by": ["Aumentó en"],
      'Account created with password "%1$s".': [
        'Cuenta creada con la contraseña "%1$s".',
      ],
      "Failed to create a new account.": ["No se pudo crear una nueva cuenta."],
      "Server replied that phone or email is invalid": [
        "El servidor respondió que el teléfono o el correo electrónico son inválidos",
      ],
      "The rights to perform the operation are not sufficient": [
        "Los permisos para ejecutar la operación no son suficientes",
      ],
      "Account username is already taken": [
        "El nombre de usuario de la cuenta ya está en uso",
      ],
      "Account ID is already taken": ["El ID de cuenta ya está en uso"],
      "Bank ran out of bonus credit.": [
        "El banco se quedó sin crédito de bonificación.",
      ],
      "Only an administrator is allowed to set the debt limit.": [
        "Solo un administrador puede establecer el límite de deuda.",
      ],
      "Only admin can create accounts with second factor authentication.": [
        "Solo el administrador puede crear cuentas con autenticación de segundo factor.",
      ],
      "Can't create accounts": ["No se pueden crear cuentas"],
      "New bank account": ["Nueva cuenta bancaria"],
      "Create an account and configure its initial access and profile.": [""],
      "Create account": ["Crear cuenta"],
      "Failed to download statistics.": [
        "No se pudieron descargar las estadísticas.",
      ],
      "A statistics request failed. Please try again.": [
        "Una solicitud de estadísticas falló. Vuelva a intentarlo.",
      ],
      "only admin can download stats": [
        "Solo el administrador puede descargar estadísticas",
      ],
      "Choose which reporting periods to include in the CSV file.": [""],
      "Include hour metric": ["Incluir métrica por hora"],
      "Include day metric": ["Incluir métrica diaria"],
      "Include month metric": ["Incluir métrica mensual"],
      "Include year metric": ["Incluir métrica anual"],
      "Include table header": ["Incluir encabezado de tabla"],
      "Add previous metric for comparison": [
        "Añadir métrica anterior para comparar",
      ],
      "Fail on first error": ["Detener en el primer error"],
      "Download": ["Descargar"],
      "Download completed with missing data": [
        "Descarga completada con datos ausentes",
      ],
      "Download completed": ["Descarga completada"],
      "%1$s statistics requests failed. The file contains only the data that could be retrieved. Click here to save it.":
        [
          "Fallaron %1$s solicitudes de estadísticas. El archivo solo contiene los datos que se pudieron recuperar. Haga clic aquí para guardarlo.",
        ],
      "Click here to save the file on your computer.": [
        "Haz clic aquí para guardar el archivo en tu computadora.",
      ],
      "Name doesn't match": ["El nombre no coincide"],
      "Faild to delete the account.": ["No se pudo eliminar la cuenta."],
      "Not enough permission to delete the account.": [
        "No tienes permisos suficientes para eliminar la cuenta.",
      ],
      "The username was not found.": [
        "El nombre de usuario no fue encontrado.",
      ],
      "Can't delete a reserved username.": [
        "No se puede eliminar un nombre de usuario reservado.",
      ],
      "Can't delete an account with balance different than zero.": [
        "No se puede eliminar una cuenta con saldo distinto de cero.",
      ],
      "Account deletion": ["Eliminación de cuenta"],
      "there was an error reading the balance": [
        "hubo un error al leer el saldo",
      ],
      "Can't delete the account": ["No se puede eliminar la cuenta"],
      "The account can't be deleted while still holding some balance. First make sure that the owner makes a complete cashout.":
        [
          "La cuenta no puede eliminarse mientras tenga saldo. Primero asegúrate de que el titular realice un egreso completo.",
        ],
      "Go back": [""],
      "All account data will be permanently removed.": [""],
      "Verification": ["Verificación"],
      "Enter the account name that is going to be deleted": [
        "Ingresa el nombre de la cuenta que va a ser eliminada",
      ],
      "Withdraw without setting amount": ["Retirar sin especificar monto"],
      "Show install wallet first": [
        "Mostrar primero la instalación de la cartera",
      ],
      "Introduction": ["Introducción"],
      "Bank": ["Banco"],
      "Essay Shop": ["Tienda de ensayos"],
      "Donations": ["Donaciones"],
      "GNU Taler logo": ["Logotipo de GNU Taler"],
      "Withdraw toy currency into your GNU Taler wallet.": [
        "Retira moneda de prueba en tu cartera GNU Taler.",
      ],
      "Demo pages": ["Páginas de demostración"],
      "You were signed out locally, but the bank could not confirm that the server token was revoked. Close other sessions or sign in again to review active tokens.":
        [
          "Se cerró su sesión localmente, pero el banco no pudo confirmar que se revocara el token del servidor. Cierre las demás sesiones o vuelva a iniciar sesión para revisar los tokens activos.",
        ],
      "Dismiss": ["Descartar"],
      "Public accounts": ["Cuentas públicas"],
      "Open interface preferences": ["Abrir preferencias de la interfaz"],
      "Interface preferences": ["Preferencias de la interfaz"],
      "Choose how this bank interface behaves on this browser.": [
        "Elija cómo se comporta esta interfaz bancaria en este navegador.",
      ],
      "Close interface preferences": ["Cerrar preferencias de la interfaz"],
      "Show debug information": ["Mostrar información de depuración"],
      "Done": ["Listo"],
      "Welcome": ["Bienvenido/a"],
      "Welcome, %1$s": ["Bienvenido/a, %1$s"],
      "Failed to load conversion rate.": [
        "No se pudo cargar la tasa de conversión.",
      ],
      "Not enough permission to access the conversion rate list.": [
        "No tienes permisos suficientes para acceder a la lista de tasas de conversión.",
      ],
      "Conversion list not implemented.": [
        "La lista de conversiones no está implementada.",
      ],
      "Conversion rate classes": ["Clases de tasa de conversión"],
      "Configure different cash-in and cashout terms for groups of accounts.": [
        "",
      ],
      "Default conversion rate": ["Tasa de conversión predeterminada"],
      "Create conversion rate class": ["Crear clase de tasa de conversión"],
      "Name": ["Nombre"],
      "Description": ["Descripción"],
      "Cashin": ["Ingreso"],
      "First page": ["Primera página"],
      "Next": ["Siguiente"],
      "min:": ["mín:"],
      "fee:": ["comisión:"],
      "only admin can setup conversion": [
        "Solo el administrador puede configurar la conversión",
      ],
      "Failed to calculate cashout fee.": [
        "No se pudo calcular la comisión del egreso.",
      ],
      "Failed to update the conversion rate.": [
        "No se pudo actualizar la tasa de conversión.",
      ],
      "Wrong credentials": ["Credenciales incorrectas"],
      "Conversion is disabled": ["La conversión está deshabilitada"],
      "Review the default terms or choose a direction to update its settings.":
        [""],
      "Details": ["Detalles"],
      "Bad ratios": ["Tasas incorrectas"],
      "Initial amount": ["Monto inicial"],
      "Use it to test how the conversion will affect the amount.": [
        "Usalo para probar cómo la conversión afectará el monto.",
      ],
      "Sending to this bank": ["Enviando a este banco"],
      "Converted": ["Convertido"],
      "Cashin after fee": ["Ingreso después de la comisión"],
      "Sending from this bank": ["Enviando desde este banco"],
      "Cashout after fee": ["Egreso después de la comisión"],
      "Bad configuration": ["Configuración incorrecta"],
      "This configuration allows users to cash out more of what has been cashed in.":
        [
          "Esta configuración permite a los usuarios retirar más de lo que ingresaron.",
        ],
      "Must be > 0": ["Debe ser mayor que 0"],
      "Ratio": ["Tasa"],
      "Zero": ["Hacia cero"],
      "Up": ["Hacia arriba"],
      "Nearest": ["Al más cercano"],
      "Minimum amount": ["Monto mínimo"],
      "Only cashout operations above this threshold will be allowed.": [
        "Solo se permitirán operaciones de egreso por encima de este umbral.",
      ],
      "Conversion ratio between currencies": [
        "Tasa de conversión entre divisas",
      ],
      "Example conversion": ["Ejemplo de conversión"],
      "1 %1$s will be converted into %2$s %3$s": [
        "1 %1$s se convertirá en %2$s %3$s",
      ],
      "Tiny amount": ["Monto mínimo de redondeo"],
      "Rounding mode": ["Modo de redondeo"],
      "Amount will be rounded below to the largest possible value smaller than the input.":
        [
          "El monto se redondeará hacia abajo al mayor valor posible menor que el ingresado.",
        ],
      "Amount will be rounded up to the smallest possible value larger than the input.":
        [
          "El monto se redondeará hacia arriba al menor valor posible mayor que el ingresado.",
        ],
      "Amount will be rounded to the closest possible value.": [
        "El monto se redondeará al valor más cercano posible.",
      ],
      'If none specified the fallback value is "%1$s ".': [
        'Si no se especifica ninguno, el valor por defecto es "%1$s".',
      ],
      "Examples": ["Ejemplos"],
      "Rounding an amount of 1.24 with rounding value 0.1": [
        "Redondeo de un monto de 1,24 con valor de redondeo 0,1",
      ],
      "Given the rounding value of 0.1 the possible values closest to 1.24 are: 1.1, 1.2, 1.3, 1.4.":
        [
          "Con un valor de redondeo de 0,1, los valores más cercanos a 1,24 son: 1,1; 1,2; 1,3; 1,4.",
        ],
      'With the "zero" mode the value will be rounded to 1.2': [
        'Con el modo "hacia cero" el valor se redondeará a 1,2',
      ],
      'With the "nearest" mode the value will be rounded to 1.2': [
        'Con el modo "al más cercano" el valor se redondeará a 1,2',
      ],
      'With the "up" mode the value will be rounded to 1.3': [
        'Con el modo "hacia arriba" el valor se redondeará a 1,3',
      ],
      "Rounding an amount of 1.26 with rounding value 0.1": [
        "Redondeo de un monto de 1,26 con valor de redondeo 0,1",
      ],
      'With the "nearest" mode the value will be rounded to 1.3': [
        'Con el modo "al más cercano" el valor se redondeará a 1,3',
      ],
      "Rounding an amount of 1.24 with rounding value 0.3": [
        "Redondeo de un monto de 1,24 con valor de redondeo 0,3",
      ],
      "Given the rounding value of 0.3 the possible values closest to 1.24 are: 0.9, 1.2, 1.5, 1.8.":
        [
          "Con un valor de redondeo de 0,3, los valores más cercanos a 1,24 son: 0,9; 1,2; 1,5; 1,8.",
        ],
      'With the "up" mode the value will be rounded to 1.5': [
        'Con el modo "hacia arriba" el valor se redondeará a 1,5',
      ],
      "Rounding an amount of 1.26 with rounding value 0.3": [
        "Redondeo de un monto de 1,26 con valor de redondeo 0,3",
      ],
      "Amount to be deducted before amount is credited.": [
        "Monto a deducir antes de acreditar el importe.",
      ],
      "Failed to load conversion details.": [
        "No se pudieron cargar los detalles de la conversión.",
      ],
      "Conversion should be enabled in the configuration, the conversion rate should be initialized with fee(s), rates and a rounding mode.":
        [
          "La conversión debe estar habilitada en la configuración, y la tasa de conversión debe estar inicializada con comisión(es), tasas y modo de redondeo.",
        ],
      "Failed to delete conversion rate class": [
        "No se pudo eliminar la clase de tasa de conversión",
      ],
      "Unauthorized": ["No autorizado"],
      "Forbidden": ["Prohibido"],
      "Failed to update conversion rate class.": [
        "No se pudo actualizar la clase de tasa de conversión.",
      ],
      "Not Found": ["No encontrado"],
      "Not implemented": ["No implementado"],
      "The name of the conversion is already used.": [
        "El nombre de la conversión ya está en uso.",
      ],
      "Accounts": ["Cuentas"],
      "identification": ["identificación"],
      "Users": ["Usuarios"],
      "Delete": ["Eliminar"],
      "Failed to calculate the cashout fee.": [
        "No se pudo calcular la comisión del egreso.",
      ],
      "Can't remove the conversion rate class": [
        "No se puede eliminar la clase de tasa de conversión",
      ],
      "There are some users associated with this class. You need to remove them first.":
        [
          "Hay usuarios asociados a esta clase. Primero tienes que eliminarlos.",
        ],
      "You are going to remove the conversion rate class": [
        "Estás por eliminar la clase de tasa de conversión",
      ],
      "This step can't be undone.": ["Este paso no puede deshacerse."],
      "Class": ["Clase"],
      "Action": ["Acción"],
      "Failed to update conversion class membership.": [
        "No se pudo actualizar la pertenencia a la clase de conversión.",
      ],
      "The account could not be updated. Please try again.": [
        "No se pudo actualizar la cuenta. Vuelva a intentarlo.",
      ],
      "Conversion rate information is unavailable for these accounts.": [
        "La información del tipo de conversión no está disponible para estas cuentas.",
      ],
      "Failed to load users in conversion class.": [
        "No se pudieron cargar los usuarios de la clase de conversión.",
      ],
      "Filters": ["Filtros"],
      "Show from other classes": ["Mostrar de otras clases"],
      "Account": ["Cuenta"],
      "Group ID": ["ID de grupo"],
      "No users in this conversion rate class": [
        "No hay usuarios en esta clase de tasa de conversión",
      ],
      "Remove": ["Quitar"],
      "Add": ["Añadir"],
      "Conversion rate name": ["Nombre de la tasa de conversión"],
      "Short description of the class": ["Descripción breve de la clase"],
      "Failed to create conversion class.": [
        "No se pudo crear la clase de conversión.",
      ],
      "New conversion rate class": ["Nueva clase de tasa de conversión"],
      "Create a named set of conversion terms that can be assigned to accounts.":
        [""],
      "Failed to load public accounts.": [
        "No se pudieron cargar las cuentas públicas.",
      ],
      "Browse transaction histories shared by public bank accounts.": [
        "Consulte los historiales de transacciones compartidos por cuentas bancarias públicas.",
      ],
      "No public accounts are available.": [
        "No hay cuentas públicas disponibles.",
      ],
      "View previous cashouts": ["Ver retiros anteriores"],
      "Failed to load cashout details.": [
        "No se pudieron cargar los detalles del egreso.",
      ],
      "Amounts recorded for this completed cashout transfer.": [""],
      "Enter your full name.": ["Introduzca su nombre completo."],
      "Repeat your password.": ["Repetir contraseña"],
      "Create your bank account": ["Crear cuenta"],
      "Choose the credentials you will use to sign in.": [
        "Elija las credenciales que utilizará para iniciar sesión.",
      ],
      "Already have an account?": ["¿Ya tiene una cuenta?"],
      "Confirm password": ["Confirmar contraseña"],
      "Use between 8 and 64 characters. A longer, unique password is easier to keep secure.":
        [
          "Utilice entre 8 y 64 caracteres. Una contraseña más larga y única es más fácil de mantener segura.",
        ],
      "Creating account…": ["Creando la cuenta…"],
      "Check the account details and try again.": [
        "Revise los datos de la cuenta y vuelva a intentarlo.",
      ],
      "You are not authorized to create this account.": [
        "No estás autorizado a crear esta cuenta.",
      ],
      "Registration is unavailable because the bank cannot grant the account credit.":
        [
          "El registro no está disponible porque el banco no puede conceder crédito a la cuenta.",
        ],
      "That username is reserved. Choose another username.": [
        "Este nombre de usuario está reservado. Elija otro.",
      ],
      "That username is already taken.": [
        "Ese nombre de usuario ya está en uso.",
      ],
      "That account ID is already taken.": ["Ese ID de cuenta ya está en uso."],
      "The bank is missing information for the selected authentication channel.":
        ["No hay información para el canal de autenticación seleccionado."],
      "The selected authentication channel is not supported.": [
        "El canal de autenticación no está soportado.",
      ],
      "Only an administrator may set the debt limit.": [
        "Solo un administrador puede establecer el límite de deuda.",
      ],
      "Only an administrator may select a conversion rate class.": [
        "Solo un administrador puede seleccionar una clase de tasa de conversión.",
      ],
      "The selected conversion rate class does not exist.": [
        "La clase de tasa de conversión no existe.",
      ],
      "Only an administrator may enable two-factor authentication while creating an account.":
        [
          "Solo un administrador puede activar la autenticación de dos factores al crear una cuenta.",
        ],
      "Account registration is unavailable": ["Registro de cuenta"],
      "This bank is not accepting new account registrations.": [
        "¡El banco no está aceptando nuevos registros en este momento!",
      ],
      "Return to sign in": ["Volver a iniciar sesión"],
      "Contact the bank administrator if you need an account.": [
        "Póngase en contacto con el administrador del banco.",
      ],
      "Failed to load withdrawal details.": [
        "No se pudieron cargar los detalles de la retirada.",
      ],
      "Abort this withdrawal?": ["¿Cancelar esta retirada?"],
      "This stops the withdrawal. No money will be transferred, and this operation cannot be resumed.":
        [
          "Esto cancela la retirada. No se transferirá dinero y esta operación no se podrá reanudar.",
        ],
      "Keep withdrawal": ["Mantener la retirada"],
      "Abort withdrawal": ["Cancelar retirada"],
      'The payto URI returned by the server is invalid: "%1$s".': [
        'El URI payto devuelto por el servidor no es válido: "%1$s".',
      ],
      'The withdrawal URI returned by the server is invalid: "%1$s".': [
        'El URI de retirada devuelto por el servidor no es válido: "%1$s".',
      ],
      'The reserve public key returned by the server is invalid: "%1$s".': [
        'La clave pública de reserva devuelta por el servidor no es válida: "%1$s".',
      ],
      "Enter an amount.": ["Introduce un importe."],
      "Enter a valid amount.": ["Introduce un importe válido."],
      "The amount must be greater than zero.": [
        "El importe debe ser mayor que cero.",
      ],
      "The amount is below the bank's minimum.": [
        "El importe es inferior al mínimo del banco.",
      ],
      "The amount is above the bank's maximum.": [
        "El importe es superior al máximo del banco.",
      ],
      "Failed to abort the withdrawal.": ["No se pudo cancelar la retirada."],
      "The server did not understand the request.": [
        "El servidor no entendió la solicitud.",
      ],
      "The operation was not found.": ["La operación no fue encontrada."],
      "The withdrawal operation has already been confirmed and cannot be aborted.":
        ["La operación de retirada ya se confirmó y no puede cancelarse."],
      "The bank could not be reached. Please try again.": [
        "No se pudo contactar con el banco. Inténtalo de nuevo.",
      ],
      "Withdrawal confirmation": ["Confirmación de retirada"],
      "Failed to confirm the withdrawal.": [
        "No se pudo confirmar la retirada.",
      ],
      "The account does not have sufficient funds or the amount is outside the limits.":
        [
          "La cuenta no tiene fondos suficientes o el monto está fuera de los límites.",
        ],
      "The withdrawal has been aborted and cannot be confirmed.": [
        "La retirada se canceló y no se puede confirmar.",
      ],
      "The wallet has not finished selecting an exchange account.": [
        "La cartera aún no ha terminado de seleccionar una cuenta de casa de cambio.",
      ],
      "The withdrawal amount changed. Review the current amount and try again.":
        [
          "El importe de la retirada ha cambiado. Revisa el importe actual e inténtalo de nuevo.",
        ],
      "Enter an amount before confirming the withdrawal.": [
        "Introduce un importe antes de confirmar la retirada.",
      ],
      "Selected exchange": ["Casa de cambio seleccionada"],
      "Sign in to confirm the withdrawal": [
        "Inicia sesión para confirmar la retirada",
      ],
      "Sign in as %1$s before reviewing and confirming this withdrawal.": [
        "Inicia sesión como %1$s antes de revisar y confirmar esta retirada.",
      ],
      "You are signed in as %1$s, but this withdrawal belongs to %2$s.": [
        "Has iniciado sesión como %1$s, pero esta retirada pertenece a %2$s.",
      ],
      "Finish later": ["Terminar más tarde"],
      "Confirm wallet withdrawal": ["Confirmar la retirada a la cartera"],
      "Review how much will leave your bank account before confirming.": [
        "Revisa cuánto saldrá de tu cuenta bancaria antes de confirmar.",
      ],
      "Unsupported exchange account": ["Cuenta de casa de cambio no admitida"],
      "The exchange account does not use the transfer type configured by this bank. This withdrawal cannot be confirmed.":
        [
          "La cuenta de la casa de cambio no usa el tipo de transferencia configurado por este banco. Esta retirada no se puede confirmar.",
        ],
      "Withdrawal amount missing": ["Falta el importe de la retirada"],
      "The bank did not provide an amount for this withdrawal. It cannot be confirmed.":
        [
          "El banco no proporcionó un importe para esta retirada. No se puede confirmar.",
        ],
      "Bank amount configuration invalid": [
        "La configuración de importes del banco no es válida",
      ],
      "The withdrawal amount and bank fee could not be combined safely. This withdrawal cannot be confirmed.":
        [
          "El importe de la retirada y la comisión bancaria no se pueden combinar de forma segura. Esta retirada no se puede confirmar.",
        ],
      "Wallet receives": ["La cartera recibe"],
      "Amount to your Taler Wallet": ["Importe para tu cartera Taler"],
      "Allowed amount": ["Importe permitido"],
      "Maximum amount": ["Importe máximo"],
      "Amount unavailable": ["Importe no disponible"],
      "From": ["De"],
      "To": ["A"],
      "Taler Wallet": ["Cartera Taler"],
      "Exchange": ["Casa de cambio"],
      "Unavailable": ["No disponible"],
      "Exchange details": ["Detalles de la casa de cambio"],
      "Exchange IBAN": ["IBAN de la casa de cambio"],
      "Bank hostname": ["Nombre de host del banco"],
      "Exchange account": ["Cuenta de la casa de cambio"],
      "No money is withdrawn until you confirm. You can finish this later from your account overview.":
        [
          "No se retirará dinero hasta que confirmes. Puedes terminar más tarde desde el resumen de tu cuenta.",
        ],
      "Confirm withdrawal": ["Confirmar retirada"],
      "Unauthorized to make the operation, maybe the session has expired or the password changed.":
        [
          "No estás autorizado para realizar la operación, quizás la sesión expiró o la contraseña cambió.",
        ],
      "The operation was rejected due to insufficient funds.": [
        "La operación fue rechazada por fondos insuficientes.",
      ],
      "Withdrawal aborted": ["Retirada cancelada"],
      "Withdrawal confirmed": ["Retirada confirmada"],
      "The bank transfer to the Taler exchange has been initiated. Your Taler Wallet will receive the withdrawn amount shortly.":
        [
          "Se ha iniciado la transferencia bancaria a la casa de cambio Taler. Tu cartera Taler recibirá en breve el importe retirado.",
        ],
      "Back to account": ["Volver a la cuenta"],
      "Complete withdrawal with your Taler Wallet": [
        "Complete la retirada con su monedero Taler",
      ],
      "Scan this QR code with your Taler Wallet. Your wallet will select an exchange and prepare the withdrawal.":
        [
          "Escanee este código QR con su monedero Taler. El monedero seleccionará una casa de cambio y preparará la retirada.",
        ],
      "Withdrawal amount": ["Importe de la retirada"],
      "Suggested amount": ["Importe sugerido"],
      "You can change this amount in your wallet.": [
        "Puede cambiar este importe en su monedero.",
      ],
      "QR code to continue the withdrawal in a Taler Wallet.": [
        "Código QR para continuar la retirada en un monedero Taler.",
      ],
      "Open Taler Wallet manually": ["Abrir el monedero Taler manualmente"],
      "Don't have a Taler Wallet?": ["¿No tiene un monedero Taler?"],
      "Get a wallet": ["Obtener un monedero"],
      "No money will be transferred until you return here to review and confirm the withdrawal.":
        [
          "No se transferirá dinero hasta que vuelva aquí para revisar y confirmar el retirada.",
        ],
      "Sign in to abort this withdrawal": [
        "Inicie sesión para cancelar esta retirada",
      ],
      "The withdrawal operation has been confirmed previously and can not be aborted.":
        [
          "La operación de retirada ya fue confirmada anteriormente y no se puede cancelar.",
        ],
      "Withdrawal ready for confirmation": ["Retirada lista para confirmar"],
      "Withdrawal waiting for your wallet": [
        "Retirada a la espera de tu cartera",
      ],
      "The pending withdrawal could not be checked": [
        "No se pudo comprobar la retirada pendiente",
      ],
      "Checking the pending withdrawal…": [
        "Comprobando la retirada pendiente…",
      ],
      "Review withdrawal": ["Revisar retirada"],
      "Retry": ["Reintentar"],
      "Resume withdrawal": ["Reanudar retirada"],
      "Finish or abort this withdrawal before starting another one.": [
        "Completa o cancela esta retirada antes de iniciar otra.",
      ],
      "Dashboard": ["Panel"],
      "Admin activity": ["Actividad de administración"],
      "Conversion": ["Conversión"],
      "My account": ["Mi cuenta"],
      "Bank administration": ["Administración bancaria"],
      "Failed to load the account list.": [
        "No se pudo cargar la lista de cuentas.",
      ],
      "Search accounts": ["Buscar cuentas"],
      "Search by username or name": ["Buscar por nombre de usuario o nombre"],
      "Search": ["Buscar"],
      "Clear": ["Limpiar"],
      "Unknown": ["Desconocido"],
      "Change password": ["Cambiar contraseña"],
      "Previous": ["Anterior"],
      "The amount exceeds what is available to withdraw.": [""],
      "The server replied with an invalid taler://withdraw URI": [
        "El servidor respondió con un URI taler://withdraw inválido",
      ],
      "Withdraw URI: %1$s": ["URI de extracción: %1$s"],
      "Failed to create the withdrawal.": ["No se pudo crear la retirada."],
      "The operation was rejected due to insufficient funds": [
        "La operación fue rechazada por fondos insuficientes",
      ],
      "Please sign in again.": ["Vuelve a iniciar sesión."],
      "The bank's withdrawal limits or fee are configured incorrectly.": [""],
      "Maximum withdrawal": ["Retirada máxima"],
      "There is not enough available balance to cover a withdrawal and the bank fee.":
        [""],
      "Dismiss wallet installation hint": [""],
      "Unable to start a withdrawal.": ["No se puede iniciar el retiro."],
      "Your account was created. Sign in to continue.": [
        "Su cuenta se ha creado. Inicie sesión para continuar.",
      ],
      "Home": ["Inicio"],
      "Page not found": ["Página no encontrada"],
      "The requested bank page does not exist.": [
        "La página del banco solicitada no existe.",
      ],
      "Unknown challenge.": ["Desafío desconocido."],
      "Failed to validate the verification code.": [
        "No se pudo validar el código de verificación.",
      ],
      "Too many challenges are active. Wait or confirm an existing challenge.":
        [
          "Hay demasiados desafíos activos en este momento, tienes que esperar o confirmar los desafíos actuales.",
        ],
      "The verification code is incorrect.": [
        "El código de verificación es incorrecto.",
      ],
      "The verification code has expired.": [
        "El código de verificación ha caducado.",
      ],
      "Submit the transmitted code number.": [
        "Ingresa el código que te fue enviado.",
      ],
      "The verification code sent to the email address starting with %1$s": [
        "El código de verificación enviado a la dirección de correo que empieza con %1$s",
      ],
      "The verification code sent to the phone number ending with %1$s": [
        "El código de verificación se envió al número de teléfono que termina en %1$s",
      ],
      "Code": ["Código"],
      "Authentication code": ["Código de autenticación"],
      "It will expire at %1$s": ["Expirará el %1$s"],
      "This challenge is terminal and cannot be retransmitted.": [
        "Este desafío ha finalizado y no puede retransmitirse.",
      ],
      "Restart authentication": ["Reiniciar la autenticación"],
      "Back": ["Volver"],
      "Verifying…": ["Verificando…"],
      "Verify": ["Verificar"],
      "Complete": ["Completar"],
      "Failed to start the challenge.": ["No se pudo iniciar el desafío."],
      "Unable to send the verification code.": [
        "No se pudo enviar el código de verificación.",
      ],
      "The request was valid, but the server is refusing action.": [
        "El pedido era válido, pero el servidor está rechazando la acción.",
      ],
      "The backend is not aware of the specified MFA challenge.": [
        "El backend no reconoce el desafío MFA especificado.",
      ],
      "It is too early to request another transmission of the challenge.": [
        "Es demasiado pronto para solicitar otro envío del desafío.",
      ],
      "Code transmission failed.": ["El envío del código falló."],
      "Multi-factor authentication required": [
        "Se requiere autenticación de múltiples factores",
      ],
      "This operation is protected with second factor authentication. In order to complete it we need to verify your identity using the authentication channel you provided.":
        [
          "Esta operación está protegida con autenticación de segundo factor. Para completarla necesitamos verificar tu identidad usando el canal de autenticación que proporcionaste.",
        ],
      "The next challenge needs to be completed to confirm the operation.": [
        "El siguiente desafío debe completarse para confirmar la operación.",
      ],
      "All the next challenges need to be completed to confirm the operation.":
        [
          "Todos los desafíos siguientes deben completarse para confirmar la operación.",
        ],
      "One of the next challenges needs to be completed to confirm the operation.":
        [
          "Uno de los siguientes desafíos debe completarse para confirmar la operación.",
        ],
      'To a phone ending with "%1$s"': ['A un teléfono que termina en "%1$s"'],
      'To an email starting with " %1$s"': [
        'A un correo que empieza con "%1$s"',
      ],
      "I have a code": ["Tengo un código"],
      "Send me a message": ["Enviame un mensaje"],
      "You have to wait until %1$s to send a new code.": [
        "Tienes que esperar hasta el %1$s para enviar un nuevo código.",
      ],
      "Use configured value (enabled)": [
        "Usar el valor configurado (activado)",
      ],
      "Use configured value (disabled)": [
        "Usar el valor configurado (desactivado)",
      ],
      "Force enabled": ["Forzar la activación"],
      "Force disabled": ["Forzar la desactivación"],
      "Enter a valid HTTP or HTTPS URL.": [
        "Introduce una URL HTTP o HTTPS válida.",
      ],
      "Development settings": ["Configuración de desarrollo"],
      "These overrides are stored only in this browser.": [
        "Estas anulaciones se guardan solo en este navegador.",
      ],
      "Corebank API base URL": ["URL base de la API de Corebank"],
      "Leave empty to use the configured URL: %1$s": [
        "Déjalo vacío para usar la URL configurada: %1$s",
      ],
      "Leave empty to derive the URL from this page.": [
        "Déjalo vacío para obtener la URL de esta página.",
      ],
      "Demo header": ["Cabecera de demostración"],
      "Control whether the demo header is shown in this browser.": [
        "Controla si la cabecera de demostración se muestra en este navegador.",
      ],
      "Control whether public account links are shown in this browser.": [
        "Controla si los enlaces a cuentas públicas se muestran en este navegador.",
      ],
      "Overrides saved.": ["Anulaciones guardadas."],
      "Apply overrides": ["Aplicar anulaciones"],
      "Clear overrides": ["Borrar anulaciones"],
      "Back to bank": ["Volver al banco"],
    },
  },
  domain: "messages",
  plural_forms: "nplurals=2; plural=n != 1;",
  lang: "es_AR",
  completeness: 87,
};

strings["de"] = {
  locale_data: {
    messages: {
      "": {
        domain: "messages",
        lang: "de",
        plural_forms: "nplurals=2; plural=n != 1;",
      },
      "Hide password": ["Passwort ausblenden"],
      "Show password": ["Passwort anzeigen"],
      "Hide": ["Ausblenden"],
      "Show": ["Anzeigen"],
      "Identity verification.": ["Identitätsüberprüfung."],
      "You do not have permission to access this account.": [
        "Sie haben keine Berechtigung, auf dieses Konto zuzugreifen.",
      ],
      "This account is locked. Contact the bank administrator.": [
        "Das Konto ist gesperrt und kann sich nicht anmelden. Wenden Sie sich an den Administrator.",
      ],
      "The password is incorrect.": ["Das Passwort ist falsch."],
      "Account not found.": ["Konto nicht gefunden"],
      "Could not reach the bank. Check your connection and try again.": [
        "Die Bank konnte nicht erreicht werden. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
      ],
      "Confirm your password": ["Bestätigen Sie Ihr Passwort"],
      "Sign in to %1$s": ["Bei %1$s anmelden"],
      "Enter the password for %1$s to continue.": [
        "Geben Sie das Passwort für %1$s ein, um fortzufahren.",
      ],
      "Use your bank account credentials to continue.": [
        "Verwenden Sie Ihre Bankkontodaten, um fortzufahren.",
      ],
      "Need an account?": ["Benötigen Sie ein Konto?"],
      "Create one": ["Konto anlegen"],
      "Your session expired. Confirm your password to continue.": [
        "Ihre Sitzung ist abgelaufen. Bestätigen Sie Ihr Passwort, um fortzufahren.",
      ],
      "Username": ["Benutzername"],
      "Password": ["Passwort"],
      "Sign out": ["Abmelden"],
      "Signing in…": ["Anmeldung läuft…"],
      "Continue": ["Weiter"],
      "Sign in": ["Anmelden"],
      "Enter your username.": ["Geben Sie Ihren Benutzernamen ein."],
      "Use letters, numbers, or any of these characters: - . _ ~": [
        "Verwenden Sie nur Buchstaben und Zahlen sowie als Sonderzeichen - . _ ~",
      ],
      "The username must not exceed 126 characters.": [
        "Der Benutzername darf höchstens 126 Zeichen lang sein.",
      ],
      "Enter your password.": ["Geben Sie Ihr Passwort ein."],
      "The password must contain at least 8 characters.": [
        "Das Passwort ist zu kurz. Es darf nicht weniger als 8 Zeichen haben.",
      ],
      "The password must not exceed %1$s characters.": [
        "Das Passwort darf höchstens %1$s Zeichen lang sein.",
      ],
      "IBAN country code not found": [
        "Der IBAN-Ländercode wurde nicht gefunden",
      ],
      "The IBAN must not exceed 34 characters.": [
        "Die IBAN darf höchstens 34 Zeichen lang sein.",
      ],
      "The IBAN must contain at least 4 characters.": [
        "Die IBAN muss mindestens 4 Zeichen enthalten.",
      ],
      "IBAN length is invalid for this country": [
        "Die IBAN-Länge ist für dieses Land ungültig",
      ],
      "The IBAN contains invalid characters": [
        "Die IBAN enthält ungültige Zeichen",
      ],
      "IBAN number is not valid, checksum is wrong": [
        "Die IBAN-Nummer ist ungültig, die Prüfsumme ist falsch",
      ],
      "The IBAN is not valid": ["Die IBAN ist ungültig"],
      "Use letters, numbers or any of these characters: - . _ ~": [
        "Verwenden Sie nur Buchstaben und Zahlen sowie als Sonderzeichen - . _ ~",
      ],
      "Failed to load cashouts.": [
        "Auszahlungen konnten nicht geladen werden.",
      ],
      "Try again": ["Erneut versuchen"],
      "Cashout is disabled": ["Auszahlungen aufs Konto sind deaktiviert"],
      "Cashout should be enabled in the configuration, the conversion rate should be initialized with fee(s), rates and a rounding mode.":
        [
          "In den Einstellungen müssen die Auszahlungen aufs Konto aktiviert und der Umrechnungskurs einschließlich aller Gebühren, Kurse und einem Rundungsverfahren initialisiert worden sein.",
        ],
      "No cashouts have been created yet.": [
        "Es wurden noch keine Auszahlungen erstellt.",
      ],
      "Failed to load conversion rate information.": [
        "Informationen zum Umrechnungskurs konnten nicht geladen werden.",
      ],
      "Some cashout details could not be loaded.": [
        "Einige Auszahlungsdetails konnten nicht geladen werden.",
      ],
      "The partial list omits cashout IDs: %1$s.": [
        "In der unvollständigen Liste fehlen die Auszahlungs-IDs %1$s.",
      ],
      "View details": ["Details anzeigen"],
      "Debited": ["Belastet"],
      "Transferred": ["Überwiesen"],
      "Created": ["Erzeugt"],
      "Transfer reference": ["Überweisungsreferenz"],
      "Actions": ["Aktionen"],
      "Cashout history": ["Auszahlungsverlauf"],
      "Review previous transfers to your configured cashout account.": [
        "Frühere Überweisungen an Ihr konfiguriertes Auszahlungskonto anzeigen.",
      ],
      "Profile": ["Profil"],
      "Security": ["Sicherheit"],
      "Merchant integration": ["Händler-Integration"],
      "Back to overview": ["Zurück zur Übersicht"],
      "My account settings": ["Meine Kontoeinstellungen"],
      "Copy": ["Kopieren"],
      "Failed to load account details.": [
        "Kontodetails konnten nicht geladen werden.",
      ],
      'Use this information to link your Taler Merchant Backoffice account with the current bank account. You can start by copying the values, then go to your merchant backoffice service provider, login into your account and look for the "import" button in the "bank account" section.':
        [
          'Verwenden Sie diese Information, um Ihr Konto im Taler Merchant-Backend mit dem normalen Bankkonto zu verknüpfen. Sie können dafür die im Onlinebanking angezeigten Angaben kopieren und mit der "Import"-Taste im Abschnitt "Bankkonto" des Taler Merchant-Backend selbst einfügen bzw. Ihren Dienste-Verwalter eintragen lassen.',
        ],
      "Not available": ["Nicht verfügbar"],
      "Merchant integration is not available for this account.": [
        "Die Händler-Integration ist für dieses Konto nicht verfügbar.",
      ],
      "Account type": ["Kontentyp"],
      "Method to use for wire transfer.": [
        "Für Banküberweisungen zu verwendende Methode.",
      ],
      "IBAN": ["IBAN"],
      "International Bank Account Number.": [
        "IBAN (Internationale Bankkontonummer).",
      ],
      "Bank host": ["Bank-Host"],
      "Bank host where the service is located.": [
        "Adresse des Bankservers, der den Dienst anbietet.",
      ],
      "Account name": ["Kontobezeichnung"],
      "Bank account identifier for wire transfers.": [
        "Kennung des Bankkontos für Banküberweisungen.",
      ],
      "Address": ["Adresse"],
      "Bitcoin address for this account.": [
        "Bitcoin-Adresse für dieses Konto.",
      ],
      "Account address": ["Kontoadresse"],
      "Owner's name": ["Name des Kontoinhabers"],
      "Legal name of the person holding the account.": [
        "Rechtsgültiger Name des Kontoinhabers.",
      ],
      "Account info URL": ["URL für Kontoinformationen"],
      "From where the merchant can download information about incoming wire transfers to this account.":
        [
          "Von wo der Händler Informationen über eingehende Banküberweisungen auf dieses Konto herunterladen kann.",
        ],
      "Unable to create a cashout": [
        "Es war nicht möglich, eine Auszahlung auszuführen",
      ],
      "The bank configuration does not support cashout operations.": [
        "Die Konfiguration der Bankverbindung unterstützt keine Auszahlungen.",
      ],
      "Close": ["Schließen"],
      "The bank returned incomplete conversion information.": [
        "Die Bank hat unvollständige Umrechnungsinformationen zurückgegeben.",
      ],
      "Please contact the bank administrator.": [
        "Bitte wenden Sie sich an den Bankadministrator.",
      ],
      "Authentication required": ["Authentifizierung erforderlich"],
      "Please sign in to create a cashout.": [
        "Bitte melden Sie sich an, um eine Auszahlung zu erstellen.",
      ],
      "Failed to calculate the conversion fee.": [
        "Die Umrechnungsgebühr konnte nicht berechnet werden.",
      ],
      "The amount is too small": ["Der Betrag ist zu klein"],
      "Conversion is not implemented.": ["Umrechnung ist nicht implementiert."],
      "At least a debit or credit amount must be provided.": [
        "Mindestens ein Belastungs- oder Gutschriftsbetrag muss angegeben werden.",
      ],
      "The amount has an invalid format.": [
        "Der Betrag hat ein ungültiges Format.",
      ],
      "The currency is not supported": ["Die Währung wird nicht unterstützt"],
      "Required": ["Erforderlich"],
      "Invalid": ["Ungültig"],
      "The balance is not sufficient": ["Das Guthaben ist nicht ausreichend"],
      "It is not possible to cash out less than %1$s: %2$s": [
        "Es ist nicht möglich, einen geringeren Betrag als %1$s: %2$s einzuzahlen",
      ],
      "The total transfer to the destination will be zero": [
        "Der zu übertragende Gesamtbetrag beträgt Null",
      ],
      "Failed to create the cashout.": [
        "Die Auszahlung konnte nicht erstellt werden.",
      ],
      "Cashout": ["Auszahlung"],
      "Account not found": ["Konto nicht gefunden"],
      "Duplicate request detected, check if the operation succeeded or try again.":
        [
          "Eine gleichartige Anfrage wurde bereits gestellt, bitte überprüfen Sie den Vorgang oder versuchen Sie es erneut.",
        ],
      "The conversion rate was applied incorrectly": [
        "Der Umrechnungskurs wurde fehlerhaft angewendet",
      ],
      "The account does not have sufficient funds": [
        "Das Konto verfügt über kein ausreichendes Guthaben",
      ],
      "Missing cashout URI in the profile": [
        "Die Auszahlungs-URI dieses Profils fehlt",
      ],
      "The amount is below the minimum amount permitted.": [
        "Der Betrag ist unterhalb des zulässigen Minimums.",
      ],
      "Sending the confirmation message failed, retry later or contact the administrator.":
        [
          "Der Versand der Bestätigung ist fehlgeschlagen, versuchen Sie den Vorgang bittespäter erneut oder kontaktieren Sie den Administrator.",
        ],
      "The server doesn't support the current TAN channel.": [
        "Der Server unterstützt nicht die aktuell gewählte TAN-Methode.",
      ],
      "Cashout details": ["Auszahlungsdetails"],
      "Review the destination account and conversion terms.": [
        "Zielkonto und Umrechnungsbedingungen prüfen.",
      ],
      "Conversion rate": ["Umrechnungskurs"],
      "Balance": ["Saldo"],
      "Fee": ["Gebühr"],
      "No fee": ["Keine Gebühr"],
      "To account": ["Auf Bankkonto"],
      "Legal name": ["Rechtlicher Name"],
      "If this name doesn't match the account holder's name, your transaction may fail.":
        [
          "Falls dieser Name nicht mit dem des wirtschaftlich Berechtigten des Bankkontos übereinstimmt, könnte Ihre Überweisung fehlschlagen.",
        ],
      "Unable to cash out": ["Auszahlung nicht möglich"],
      "Before being able to cash out to a bank account, you need to complete your profile":
        [
          "Bevor Sie auf ein Bankkonto einzahlen können, müssen Sie Ihr Profil vervollständigen",
        ],
      "What is this cashout for?": ["Wofür ist diese Auszahlung?"],
      "Enter the amount to send or receive": [
        "Den zu sendenden oder zu empfangenden Betrag eingeben",
      ],
      "Send %1$s": ["%1$s übertragen"],
      "Receive %1$s": ["%1$s erhalten"],
      "Amount": ["Betrag"],
      "Total cost": ["Gesamte Gebühren"],
      "Balance left": ["Verbleibendes Guthaben"],
      "Before fee": ["Vor Abzug von Gebühren"],
      "Total cashout transfer": ["Gesamter Auszahlungsbetrag"],
      "Cancel": ["Abbrechen"],
      "Cash out": ["Auszahlung"],
      "Not valid": ["Nicht gültig"],
      "Does not follow the pattern": ["Weicht vom Muster ab"],
      "Failed to create the transaction.": [
        "Die Transaktion konnte nicht erstellt werden.",
      ],
      "The request was invalid or the payto://-URI used unacceptable features.":
        [
          "Die Anfrage war ungültig oder die payto://-URI nutzte inakzeptable Merkmale.",
        ],
      "Not enough permission to complete the operation.": [
        "Es besteht keine ausreichende Berechtigung, um den Vorgang abzuschließen.",
      ],
      "The bank administrator cannot be the transfer creditor.": [
        "Der Bankbetreiber kann nicht gleichzeitig Begünstigter von Überweisungen sein.",
      ],
      'The destination account "%1$s" was not found.': [
        'Das Empfängerkonto "%1$s" wurde nicht gefunden.',
      ],
      "The origin and the destination of the transfer can't be the same.": [
        "Ursprung und Ziel des Transfers können nicht gleich sein.",
      ],
      "Your balance is not sufficient for the operation.": [
        "Das Guthaben reicht für den Vorgang nicht aus.",
      ],
      'The origin account "%1$s" was not found.': [
        'Das Ursprungskonto "%1$s" wurde nicht gefunden.',
      ],
      "The attempt to create the transaction has failed. Please try again.": [
        "Die Vorbereitung der Transaktion hat nicht funktioniert. Bitte versuchen Sie es erneut.",
      ],
      "Confirm transaction.": ["Transaktion bestätigen."],
      "Transfer details": ["Überweisungsdetails"],
      "Enter the recipient, a reference, and the amount to send.": [
        "Empfänger, Referenz und zu sendenden Betrag eingeben.",
      ],
      "Maximum transfer": ["Maximaler Überweisungsbetrag"],
      "Debt limit": ["Kreditlimit"],
      "This is not your account balance. This account cannot go into debt.": [
        "Dies ist nicht Ihr Kontostand. Dieses Konto darf nicht ins Minus gehen.",
      ],
      "This is not your account balance. It includes borrowing up to the debt limit shown here.":
        [
          "Dies ist nicht Ihr Kontostand. Der Betrag schließt den verfügbaren Kredit bis zum hier angezeigten Kreditlimit ein.",
        ],
      "Transfer input method": ["Eingabemethode für die Überweisung"],
      "Enter details": ["Details eingeben"],
      "Paste payto URI": ["payto-URI einfügen"],
      "Recipient": ["Empfänger"],
      "Account name of the recipient": ["Name des Empfängerkontos"],
      "username": ["Benutzername"],
      "IBAN of the recipient's account": ["IBAN des Empfängerkontos"],
      "What is this transfer for?": ["Wofür ist diese Überweisung?"],
      "Payto URI": ["payto-URI"],
      "Paste a payto URI containing the recipient, amount, and transfer reference.":
        [
          "Eine payto-URI mit Empfänger, Betrag und Überweisungsreferenz einfügen.",
        ],
      "Uniform resource identifier of the target account": [
        "URI (Uniform Resource Identifier) des Empfängerkontos",
      ],
      "payto://x-taler-bank/[bank-host]/[receiver-account]?message=[subject]&amount=[%1$s:X.Y]":
        [
          "payto://x-taler-bank/[Bankbetreiber]/[Empfängerkonto]?message=[Buchungsvermerk]&amount=[%1$s:X.Y]",
        ],
      "payto://iban/[receiver-iban]?message=[subject]&amount=[%1$s:X.Y]": [
        "payto://iban/[IBAN des Empfängers]?message=[Buchungsvermerk]&amount=[%1$s:X.Y]",
      ],
      "Recipient receives": ["Empfänger erhält"],
      "Bank fee": ["Bankgebühr"],
      "Total debited": ["Gesamtbelastung"],
      "Need to move money out of this bank?": [
        "Möchten Sie Geld aus dieser Bank auszahlen?",
      ],
      "Start a cashout": ["Auszahlung starten"],
      "Send transfer": ["Überweisung senden"],
      'Only "x-taler-bank" targets are supported': [
        'Nur "x-taler-bank"-Ziele werden unterstützt',
      ],
      'Only this host is allowed. Use "%1$s"': [
        'Nur dieser Bankbetreiber ist zulässig. Bitte verwenden Sie "%1$s"',
      ],
      "Account name is missing": ["Name oder Bezeichnung des Kontos fehlt"],
      'Only "IBAN" targets are supported': [
        "Nur IBAN-Ziele werden unterstützt",
      ],
      'Missing "amount" parameter to specify the amount to be transferred': [
        "Bitte geben Sie einen Betrag an, der übertragen werden soll",
      ],
      'The "amount" parameter is not valid': ["Der Betrag ist nicht gültig"],
      '"message" parameters to specify a reference text for the transfer are missing':
        [
          "Es fehlen Parameter für einen Referenz-Buchungsvermerk der Überweisungen",
        ],
      'The only currency allowed is "%1$s"': [
        'Die einzig zulässige Währung ist "%1$s"',
      ],
      "You cannot transfer an amount of zero.": [
        "Sie können keinen Betrag überweisen, der Null ist.",
      ],
      "Please enter a longer subject": [
        "Bitte geben Sie einen längeren Buchungsvermerk der Überweisung an",
      ],
      "Email and SMS authentication were disabled because their contact details were removed.":
        [
          "Die Authentifizierung per E-Mail und SMS wurde deaktiviert, weil die zugehörigen Kontaktdaten entfernt wurden.",
        ],
      "Email authentication was disabled because the email address was removed.":
        [
          "Die Authentifizierung per E-Mail wurde deaktiviert, weil die E-Mail-Adresse entfernt wurde.",
        ],
      "SMS authentication was disabled because the phone number was removed.": [
        "Die Authentifizierung per SMS wurde deaktiviert, weil die Telefonnummer entfernt wurde.",
      ],
      "Invalid email format": ["Ungültiges E-Mail-Format"],
      "Should start with +": ["Die Nummer sollte mit + beginnen"],
      "A phone number consists of numbers only": [
        "Eine Telefonnummer besteht nur aus Ziffern",
      ],
      "Login username": ["Nutzername zum Anmelden"],
      "Account ID for authentication": ["Konto-ID zur Authentifizierung"],
      "Full name": ["Vollständiger Name"],
      "Name of the account holder": ["Name des Kontoinhabers"],
      "Internal account": ["Internes Konto"],
      "Copy and share this account address to receive transfers.": [
        "Kopieren und teilen Sie diese Kontoadresse, um Überweisungen zu empfangen.",
      ],
      "Email": ["E-Mail"],
      "To be used when second factor authentication is enabled": [
        "Dies wird verwendet, wenn die Zwei-Faktor-Authentifizierung aktiviert ist",
      ],
      "Phone": ["Telefon"],
      "Enable second factor authentication": [
        "Zwei-Faktor-Authentifizierung aktivieren",
      ],
      "Using email": ["Per E-Mail"],
      "Add an email in your profile to enable this option": [
        "Fügen Sie Ihrem Profil eine E-Mail-Adresse hinzu, um diese Option zu aktivieren",
      ],
      "Using SMS": ["Per SMS"],
      "Add a phone number in your profile to enable this option": [
        "Fügen Sie Ihrem Profil eine Telefonnummer hinzu, um diese Option zu aktivieren",
      ],
      "Cashout account": ["Auszahlungskonto"],
      "External account to which cashout transfers are sent.": [
        "Externes Konto, an das Auszahlungsüberweisungen gesendet werden.",
      ],
      "Max debt": ["Maximale Kredithöhe"],
      "How much the balance can go below zero.": [
        "Dieser Wert gibt an, wie weit der Saldo ins Minus gehen kann.",
      ],
      "Is this account public?": ["Ist dieses Konto ein öffentliches?"],
      "Public accounts expose their balance and complete transaction history, including subjects and both account addresses, to anonymous visitors.":
        [
          "Bei öffentlichen Konten sind der Kontostand und der vollständige Transaktionsverlauf einschließlich Verwendungszwecken und beider Kontoadressen für anonyme Besucher einsehbar.",
        ],
      "Does this account belong to a Payment Service Provider?": [
        "Gehört dieses Konto dem Anbieter eines Zahlungsdiensts?",
      ],
      "Account updated": ["Das Konto wurde aktualisiert"],
      "Failed to update the account.": [
        "Das Konto konnte nicht aktualisiert werden.",
      ],
      "The rights to change the account are not sufficient": [
        "Es besteht keine ausreichende Berechtigung zum Ändern des Kontos",
      ],
      "The username was not found": [
        "Der Name des Nutzers konnte nicht gefunden werden",
      ],
      "You can't change the legal name, please contact your account administrator.":
        [
          "Sie können den Namen des wirtschaftlichen Berechtigten nicht ändern, bitte benachrichtigen Sie den Administrator des Kontos.",
        ],
      "You can't change the debt limit, please contact your account administrator.":
        [
          "Sie sind nicht befugt, die Kredithöhe zu ändern, bitte verständigen Sie den Administrator des Kontos.",
        ],
      "You can't change the cashout address, please contact your account administrator.":
        [
          "Sie können die Adresse für Auszahlungen nicht ändern, bitte benachrichtigen Sie Ihren Administrator des Kontos.",
        ],
      "No information for the selected authentication channel.": [
        "Es sind keine Informationen für das gewählte Authentifizierungsverfahren verfügbar.",
      ],
      "Account update": ["Kontoaktualisierung"],
      "Authentication channel is not supported.": [
        "Das gewählte Authentifizierungsverfahren wird nicht unterstützt.",
      ],
      "Only the administrator can change the conversion rate.": [
        "Nur der Administrator kann den Umrechnungskurs ändern.",
      ],
      "The conversion rate class doesn't exist.": [
        "Die Umrechnungskurs-Klasse existiert nicht.",
      ],
      "The password is too short. Can't have less than 8 characters.": [
        "Das Passwort ist zu kurz. Es darf nicht weniger als 8 Zeichen haben.",
      ],
      "The password is too long. Can't have more than 64 characters.": [
        "Das Passwort ist zu lang. Es darf nicht mehr als 64 Zeichen haben.",
      ],
      'Account "%1$s"': ['Konto "%1$s"'],
      "Removed": ["Entfernt"],
      "This account can't be used.": [
        "Dieses Konto kann nicht genutzt werden.",
      ],
      "Account details": ["Kontodetails"],
      "Not configured": ["Nicht konfiguriert"],
      "Change details": ["Details ändern"],
      "Update": ["Aktualisieren"],
      "Delete account": ["Konto löschen"],
      "Permanently remove this bank account. The account must have a zero balance before it can be deleted.":
        [
          "Dieses Bankkonto dauerhaft löschen. Das Konto muss einen Saldo von null haben, bevor es gelöscht werden kann.",
        ],
      "The passwords do not match.": ["Die Passwörter stimmen nicht überein."],
      "Failed to update the password.": [
        "Das Passwort konnte nicht aktualisiert werden.",
      ],
      "Not authorized to change the password, maybe the session is invalid.": [
        "Sie sind zum Ändern des Passworts nicht berechtigt, möglicherweise ist die Sitzung nicht mehr gültig.",
      ],
      "You need to provide the old password. If you don't have it contact your account administrator.":
        [
          "Sie müssen das alte Passwort eingeben, sollten Sie es nicht mehr haben, verständigen Sie bitte Ihren Administrator des Kontos.",
        ],
      "The current password is incorrect, so the password cannot be changed.": [
        "Das aktuelle Passwort ist falsch, daher kann es nicht geändert werden.",
      ],
      "Password update": ["Passwortaktualisierung"],
      "You don't have the rights to change the password.": [
        "Sie haben keine Berechtigung, das Passwort zu ändern.",
      ],
      "Update password": ["Passwort erneuern"],
      "Choose a new password for your bank account.": [
        "Wählen Sie ein neues Passwort für Ihr Bankkonto.",
      ],
      'Choose a new password for account "%1$s".': [
        "Wählen Sie ein neues Passwort für das Konto „%1$s“.",
      ],
      "Current password": ["Aktuelles Passwort dieser Instanz"],
      "Your current password, for security": [
        "Zur Sicherheit bitte ihr bisheriges Passwort",
      ],
      "New password": ["Neues Passwort"],
      "Confirm new password": ["Neues Passwort bestätigen"],
      "Enter the new password again.": [
        "Geben Sie das neue Passwort erneut ein.",
      ],
      "Failed to load transactions.": [
        "Transaktionen konnten nicht geladen werden.",
      ],
      "Unknown account": ["Unbekanntes Konto"],
      "Recent activity": ["Letzte Aktivitäten"],
      "Transactions": ["Transaktionen"],
      "Subject": ["Buchungsvermerk"],
      "Today": ["Heute"],
      "Yesterday": ["Gestern"],
      "Invalid value": ["Ungültiger Wert"],
      "View all transactions": ["Alle Transaktionen anzeigen"],
      "No transactions yet.": ["Es liegen noch keine Transaktionen vor."],
      "Your account activity will appear here.": [
        "Ihre Kontoaktivitäten werden hier angezeigt.",
      ],
      "Date": ["Datum"],
      "Counterparty": ["Gegenpartei"],
      "Pagination": ["Seitennavigation"],
      "Newer": ["Neuere"],
      "Older": ["Ältere"],
      "Withdraw to Taler Wallet": ["Auf Taler-Wallet abheben"],
      "Move digital cash to your Taler Wallet.": [
        "Digitales Geld auf Ihre Taler-Wallet übertragen.",
      ],
      "Send bank transfer": ["Banküberweisung senden"],
      "Transfer money to another bank account.": [
        "Geld auf ein anderes Bankkonto überweisen.",
      ],
      "Convert regional currency and send it to your cashout account.": [
        "Regionale Währung umrechnen und an Ihr Auszahlungskonto senden.",
      ],
      "Copy account address": ["Kontoadresse kopieren"],
      "Current balance": ["Aktueller Saldo"],
      "Go to account details": ["Zu den Kontodetails"],
      "Failed to load the admin account.": [
        "Das Administratorkonto konnte nicht geladen werden.",
      ],
      "Admin account": ["Administratorkonto"],
      "Admin account activity": ["Aktivität des Administratorkontos"],
      "Failed to load the monitor info.": [
        "Die Überwachungsinformationen konnten nicht geladen werden.",
      ],
      "Failed to load cashout info.": [
        "Die Auszahlungsinformationen konnten nicht geladen werden.",
      ],
      "Querying for the current stats failed": [
        "Die Abfrage der aktuellen Statistik ist fehlgeschlagen",
      ],
      "The request parameters are invalid.": [
        "Die Anfrageparameter sind ungültig.",
      ],
      "The user is unauthorized": ["Dieser Nutzer ist nicht berechtigt"],
      "Querying for the previous stats failed": [
        "Die Abfrage der vorherigen Statistik ist fehlgeschlagen",
      ],
      "Bank activity": ["Bankaktivität"],
      "Select a section": ["Bitte wählen Sie einen Bereich aus"],
      "Last hour": ["Vergangene Stunde"],
      "Previous day": ["Tag zuvor"],
      "Last month": ["Vergangener Monat"],
      "Last year": ["Letztes Jahr"],
      "Tabs": ["Registerkarten"],
      "Last Year": ["Vergangenes Jahr"],
      "Trading volume from %1$s to %2$s": ["Umsatzvolumen von %1$s bis %2$s"],
      "Cash in": ["Geldeingang"],
      "Transferred from an external account to an account in this bank.": [
        "Überwiesen von einem externen Bankkonto auf das Konto dieser Bank.",
      ],
      "Transferred from an account in this bank to an external account.": [
        "Überwiesen von einem Konto dieser Bank auf ein externes Bankkonto.",
      ],
      "Taler pay-in": ["Taler-Einzahlung"],
      "Transferred from an account to a Taler exchange.": [
        "Überwiesen von einem Bankkonto an einen Taler Exchange.",
      ],
      "Transfers": ["Überweisungen"],
      "Taler payout": ["Taler-Auszahlung"],
      "Transferred from a Taler exchange to another account.": [
        "Überwiesen von einem Taler Exchange auf ein anderes Bankkonto.",
      ],
      "Download stats as CSV": ["Statistik herunterladen als CSV-Datei"],
      "previous": ["vorherige"],
      "Decreased by": ["Verringert um"],
      "Increased by": ["Vermehrt um"],
      'Account created with password "%1$s".': [
        'Das Konto wurde angelegt mit dem Passwort "%1$s".',
      ],
      "Failed to create a new account.": [
        "Ein neues Konto konnte nicht erstellt werden.",
      ],
      "Server replied that phone or email is invalid": [
        "Der Server meldete zurück, dass die Telefonnummer oder die Emailadresse falsch seien",
      ],
      "The rights to perform the operation are not sufficient": [
        "Die Berechtigung zum Durchführen des Vorgangs ist unzureichend",
      ],
      "Account username is already taken": [
        "Dieser Nutzername ist bereits vergeben",
      ],
      "Account ID is already taken": ["Die Konto-ID ist bereits vergeben"],
      "Bank ran out of bonus credit.": [
        "Die Bank verfügt über kein Bonusguthaben mehr.",
      ],
      "This account username is reserved and cannot be used.": [
        "Dieser Nutzername ist reserviert und kann nicht verwendet werden.",
      ],
      "Only an administrator is allowed to set the debt limit.": [
        "Nur ein Administrator ist befugt, die Kredithöhe festzulegen.",
      ],
      "Only admin can create accounts with second factor authentication.": [
        "Nur der Administrator kann Konten mit Zwei-Faktor-Authentifizierung erstellen.",
      ],
      "Can't create accounts": ["Die Anlage von Konten ist nicht möglich"],
      "Only a system administrator can create accounts.": [
        "Nur ein Systemadministrator kann Konten anlegen.",
      ],
      "Back to accounts": ["Zurück zu den Konten"],
      "New bank account": ["Neues Konto"],
      "Create an account and configure its initial access and profile.": [
        "Erstellen Sie ein Konto und richten Sie den anfänglichen Zugang und das Profil ein.",
      ],
      "Create account": ["Konto anlegen"],
      "Failed to download statistics.": [
        "Statistiken konnten nicht heruntergeladen werden.",
      ],
      "A statistics request failed. Please try again.": [
        "Eine Statistikanfrage ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
      ],
      "only admin can download stats": [
        "Nur der Administrator kann Statistiken herunterladen",
      ],
      "Back to dashboard": ["Zurück zur Übersicht"],
      "Download bank statistics": ["Bankstatistik herunterladen"],
      "Choose which reporting periods to include in the CSV file.": [
        "Wählen Sie die Berichtszeiträume aus, die in die CSV-Datei aufgenommen werden sollen.",
      ],
      "Include hour metric": ["Stunden-Metrik einbeziehen"],
      "Include day metric": ["Tages-Metrik einbeziehen"],
      "Include month metric": ["Monats-Metrik einbeziehen"],
      "Include year metric": ["Jahres-Metrik einbeziehen"],
      "Include table header": ["Tabellenkopfzeilen einbeziehen"],
      "Add previous metric for comparison": [
        "Vorherige Metrik zum Vergleich hinzufügen",
      ],
      "Fail on first error": ["Beim ersten Fehler abbrechen"],
      "Download": ["Herunterladen"],
      "Downloading… %1$s": ["Wird heruntergeladen… %1$s"],
      "Download completed with missing data": [
        "Download mit fehlenden Daten abgeschlossen",
      ],
      "Download completed": ["Download abgeschlossen"],
      "%1$s statistics requests failed. The file contains only the data that could be retrieved. Click here to save it.":
        [
          "%1$s Statistikanfragen sind fehlgeschlagen. Die Datei enthält nur die Daten, die abgerufen werden konnten. Klicken Sie hier, um sie zu speichern.",
        ],
      "Click here to save the file on your computer.": [
        "Hier klicken zum Speichern der Datei auf Ihrem Rechner.",
      ],
      "Name doesn't match": ["Der Name stimmt nicht überein"],
      "Faild to delete the account.": [
        "Das Konto konnte nicht gelöscht werden.",
      ],
      "Not enough permission to delete the account.": [
        "Es besteht keine ausreichende Berechtigung zum Löschen des Kontos.",
      ],
      "The username was not found.": ["Der Nutzername wurde nicht gefunden."],
      "Can't delete a reserved username.": [
        "Es ist nicht möglich, den reservierten Nutzernamen zu entfernen.",
      ],
      "Can't delete an account with balance different than zero.": [
        "Es ist nicht möglich, ein Konto mit einem Saldo ungleich Null zu löschen.",
      ],
      "Account deletion": ["Kontolöschung"],
      "there was an error reading the balance": [
        "Beim Lesen des Saldos ist ein Fehler aufgetreten",
      ],
      "Can't delete the account": [
        "Es war nicht möglich, das Konto zu löschen",
      ],
      "The account can't be deleted while still holding some balance. First make sure that the owner makes a complete cashout.":
        [
          "Das Konto kann nicht gelöscht werden, solange es noch ein Guthaben aufweist. Bitte sorgen Sie dafür, dass der Konteninhaber eine vollständige Auszahlung auf das eigene Bankkonto durchführt.",
        ],
      "Go back": ["Zurück"],
      'Delete account "%1$s"': ["Konto „%1$s“ löschen"],
      "This action cannot be undone": [
        "Diese Aktion kann nicht rückgängig gemacht werden",
      ],
      "All account data will be permanently removed.": [
        "Alle Kontodaten werden dauerhaft entfernt.",
      ],
      "Verification": ["Überprüfung"],
      "Enter the account name that is going to be deleted": [
        "Zum Löschen geben Sie den Namen des Kontos an",
      ],
      "Withdraw without setting amount": ["Abheben ohne festgelegten Betrag"],
      "Show install wallet first": ["Hilfstext: Zuerst Wallet installieren"],
      "Introduction": ["Einführung"],
      "Bank": ["Bank"],
      "Essay Shop": ["Essay-Shop"],
      "Donations": ["Spenden"],
      "GNU Taler logo": ["GNU-Taler-Logo"],
      "Withdraw toy currency into your GNU Taler wallet.": [
        "Heben Sie Spielgeld in Ihre GNU-Taler-Wallet ab.",
      ],
      "Demo pages": ["Demo-Seiten"],
      "You were signed out locally, but the bank could not confirm that the server token was revoked. Close other sessions or sign in again to review active tokens.":
        [
          "Sie wurden lokal abgemeldet, aber die Bank konnte nicht bestätigen, dass das Server-Token widerrufen wurde. Schließen Sie andere Sitzungen oder melden Sie sich erneut an, um aktive Tokens zu prüfen.",
        ],
      "Dismiss": ["Ausblenden"],
      "Public accounts": ["Öffentliche Konten"],
      "Open interface preferences": ["Oberflächeneinstellungen öffnen"],
      "Interface preferences": ["Oberflächeneinstellungen"],
      "Choose how this bank interface behaves on this browser.": [
        "Legen Sie fest, wie sich diese Bankoberfläche in diesem Browser verhält.",
      ],
      "Close interface preferences": ["Oberflächeneinstellungen schließen"],
      "Show debug information": ["Debug-Informationen anzeigen"],
      "Done": ["Fertig"],
      "Welcome": ["Willkommen"],
      "Welcome, %1$s": ["Herzlich willkommen, %1$s"],
      "Failed to load conversion rate.": [
        "Der Umrechnungskurs konnte nicht geladen werden.",
      ],
      "Not enough permission to access the conversion rate list.": [
        "Keine ausreichende Berechtigung für den Zugriff auf die Liste der Umrechnungskurse.",
      ],
      "The conversion-rate list was not found. Conversion may not be supported.":
        [
          "Die Umrechnungskursliste wurde nicht gefunden. Möglicherweise wird die Umrechnung nicht unterstützt.",
        ],
      "Conversion list not implemented.": [
        "Umrechnungsliste nicht implementiert.",
      ],
      "Conversion rate classes": ["Umrechnungskurs-Klassen"],
      "Configure different cash-in and cashout terms for groups of accounts.": [
        "Unterschiedliche Einzahlungs- und Auszahlungsbedingungen für Kontogruppen konfigurieren.",
      ],
      "Default conversion rate": ["Standardumrechnungskurs"],
      "Create conversion rate class": ["Umrechnungskurs-Klasse erstellen"],
      "No conversion rate classes": ["Keine Umrechnungskursklassen"],
      "All accounts currently use the default conversion rate.": [
        "Derzeit verwenden alle Konten den Standardumrechnungskurs.",
      ],
      "Name": ["Name"],
      "Description": ["Beschreibung"],
      "Cashin": ["Einzahlung"],
      "First page": ["Erste Seite"],
      "Next": ["Weiter"],
      "min:": ["Min.:"],
      "fee:": ["Gebühr:"],
      "only admin can setup conversion": [
        "Nur ein Administrator kann Umrechnungskurse einrichten",
      ],
      "Failed to calculate cashout fee.": [
        "Die Auszahlungsgebühr konnte nicht berechnet werden.",
      ],
      "Failed to update the conversion rate.": [
        "Der Umrechnungskurs konnte nicht aktualisiert werden.",
      ],
      "Wrong credentials": ["Ungültige Zugangsdaten"],
      "Conversion is disabled": ["Umrechnungen sind deaktiviert"],
      "Back to conversion settings": ["Zurück zu den Umrechnungseinstellungen"],
      "Review the default terms or choose a direction to update its settings.":
        [
          "Prüfen Sie die Standardbedingungen oder wählen Sie eine Richtung aus, deren Einstellungen Sie ändern möchten.",
        ],
      "Conversion view": ["Umrechnungsansicht"],
      "Details": ["Detail-Angaben"],
      "Cashout settings": ["Auszahlungseinstellungen"],
      "Cash-in settings": ["Einzahlungseinstellungen"],
      "Bad ratios": ["Das Verhältnis passt nicht"],
      "One ratio must be greater than or equal to 1, and the other must be less than or equal to 1.":
        [
          "Ein Verhältnis muss größer oder gleich 1 sein, das andere kleiner oder gleich 1.",
        ],
      "Initial amount": ["Guthaben bei Erstanlage des Kontos"],
      "Use it to test how the conversion will affect the amount.": [
        "Hier testen Sie, um die Auswirkung des Umrechnungskurses auf einen Betrag zu prüfen.",
      ],
      "Sending to this bank": ["An diese Bank senden"],
      "Converted": ["Umgetauscht"],
      "Cashin after fee": ["Einzahlung nach Abzug von Gebühren"],
      "Sending from this bank": ["Senden von dieser Bank"],
      "Cashout after fee": ["Auszahlung nach Abzug von Gebühren"],
      "Bad configuration": ["Fehlerhafte Konfiguration"],
      "This configuration allows users to cash out more of what has been cashed in.":
        [
          "Diese Einstellung erlaubt Nutzern, höhere Beträge auf ihre Konten einzuzahlen als sie eingenommen haben.",
        ],
      "Must be > 0": ["Muss > 0 sein"],
      "Ratio": ["Verhältnis"],
      "Zero": ["Null"],
      "Up": ["Aufrunden"],
      "Nearest": ["Am nächsten"],
      "Minimum amount": ["Minimaler Betrag"],
      "Only cashout operations above this threshold will be allowed.": [
        "Nur Auszahlungen oberhalb dieses Schwellenwerts sind zulässig.",
      ],
      "Conversion ratio between currencies": [
        "Umrechnungsverhältnis zwischen den Währungen",
      ],
      "Example conversion": ["Beispiel einer Währungsumrechnung"],
      "1 %1$s will be converted into %2$s %3$s": [
        "1 %1$s wird getauscht zu %2$s %3$s",
      ],
      "Tiny amount": ["Kleinstbetrag"],
      "Rounding mode": ["Rundungsmethode"],
      "Amount will be rounded below to the largest possible value smaller than the input.":
        [
          "Der Betrag wird auf den größtmöglichen Wert abgerundet, der kleiner als die Eingabe ist.",
        ],
      "Amount will be rounded up to the smallest possible value larger than the input.":
        [
          "Der Betrag wird auf den geringstmöglichen Wert aufgerundet, der größer als die Eingabe ist.",
        ],
      "Amount will be rounded to the closest possible value.": [
        "Der Betrag wird auf den nächstmöglichen Wert gerundet.",
      ],
      'If none specified the fallback value is "%1$s ".': [
        'Falls nichts angegeben wird, ist der Standardwert "%1$s ".',
      ],
      "Examples": ["Beispiele"],
      "Rounding an amount of 1.24 with rounding value 0.1": [
        "Rundung eines Betrags von 1,24 mit Rundungswert 0,1",
      ],
      "Given the rounding value of 0.1 the possible values closest to 1.24 are: 1.1, 1.2, 1.3, 1.4.":
        [
          "Angesichts des Rundungswertes von 0,1 sind die möglichen Werte, die am nächsten an 1,24 liegen, folgende: 1.1, 1.2, 1.3, 1.4.",
        ],
      'With the "zero" mode the value will be rounded to 1.2': [
        "Mit der Methode „Null“ wird der Wert auf 1,2 gerundet",
      ],
      'With the "nearest" mode the value will be rounded to 1.2': [
        "Mit der Methode „Nähestens“ wird der Wert auf 1,2 gerundet",
      ],
      'With the "up" mode the value will be rounded to 1.3': [
        "Mit der Methode „Aufrunden“ wird der Wert auf 1,3 gerundet",
      ],
      "Rounding an amount of 1.26 with rounding value 0.1": [
        "Rundung eines Betrags von 1,26 mit Rundungswert 0,1",
      ],
      'With the "nearest" mode the value will be rounded to 1.3': [
        "Mit der Methode „Nähestens“ wird der Wert auf 1,3 gerundet",
      ],
      "Rounding an amount of 1.24 with rounding value 0.3": [
        "Rundung eines Betrags von 1,24 mit Rundungswert 0,3",
      ],
      "Given the rounding value of 0.3 the possible values closest to 1.24 are: 0.9, 1.2, 1.5, 1.8.":
        [
          "Mit einem Rundungswert von 0,3 sind die möglichen Werte, die am nächsten an 1,24 liegen, folgende: 0,9, 1,2, 1,5 und 1,8.",
        ],
      'With the "up" mode the value will be rounded to 1.5': [
        "Mit der Methode „Aufrunden“ wird der Wert auf 1,5 gerundet",
      ],
      "Rounding an amount of 1.26 with rounding value 0.3": [
        "Rundung eines Betrags von 1,26 mit Rundungswert 0,3",
      ],
      "Amount to be deducted before amount is credited.": [
        "Betrag, der vor der Gutschrift abzuziehen ist.",
      ],
      "Failed to load conversion details.": [
        "Die Umrechnungsdetails konnten nicht geladen werden.",
      ],
      "Conversion should be enabled in the configuration, the conversion rate should be initialized with fee(s), rates and a rounding mode.":
        [
          "Die Umrechnung sollte in der Konfiguration aktiviert sein, und der Umrechnungskurs sollte mit Gebühr(en), Kursen und einem Rundungsmodus initialisiert sein.",
        ],
      "Failed to delete conversion rate class": [
        "Die Umrechnungskurs-Klasse konnte nicht gelöscht werden",
      ],
      "Unauthorized": ["Unberechtigter Zugriff"],
      "Forbidden": ["Verboten"],
      "Conversion rate class was not found.": [
        "Die Umrechnungskursklasse wurde nicht gefunden.",
      ],
      "Deleting conversion rate classes is not supported by this bank.": [
        "Diese Bank unterstützt das Löschen von Umrechnungskursklassen nicht.",
      ],
      "Failed to update conversion rate class.": [
        "Die Umrechnungskurs-Klasse konnte nicht aktualisiert werden.",
      ],
      "Not Found": ["Nicht gefunden"],
      "Not implemented": ["Nicht implementiert"],
      "The name of the conversion is already used.": [
        "Der Name der Umrechnung wird bereits verwendet.",
      ],
      "Accounts": ["Konten"],
      "Test conversion": ["Umrechnung testen"],
      "Delete class": ["Klasse löschen"],
      "Manage this conversion rate class and the accounts assigned to it.": [
        "Verwalten Sie diese Umrechnungskursklasse und die ihr zugewiesenen Konten.",
      ],
      "Conversion rate class sections": ["Bereiche der Umrechnungskursklasse"],
      "identification": ["Kennung"],
      "Conversion rate class name": ["Name der Umrechnungskursklasse"],
      "Conversion rate class description": [
        "Beschreibung der Umrechnungskursklasse",
      ],
      "Users": ["Benutzer"],
      "Delete": ["Löschen"],
      "Failed to calculate the cashout fee.": [
        "Die Auszahlungsgebühr konnte nicht berechnet werden.",
      ],
      "Can't remove the conversion rate class": [
        "Die Umrechnungskurs-Klasse kann nicht entfernt werden",
      ],
      "There are some users associated with this class. You need to remove them first.":
        [
          "Dieser Klasse sind Benutzer zugeordnet. Sie müssen diese zuerst entfernen.",
        ],
      "You are going to remove the conversion rate class": [
        "Sie sind dabei, die Umrechnungskurs-Klasse zu entfernen",
      ],
      "This step can't be undone.": [
        "Dieser Schritt kann später nicht mehr rückgängig gemacht werden.",
      ],
      "Class": ["Klasse"],
      "Action": ["Aktion"],
      "Failed to update conversion class membership.": [
        "Die Zugehörigkeit zur Umrechnungsklasse konnte nicht aktualisiert werden.",
      ],
      "The account could not be updated. Please try again.": [
        "Das Konto konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.",
      ],
      "Conversion rate information is unavailable for these accounts.": [
        "Für diese Konten sind keine Umrechnungskursinformationen verfügbar.",
      ],
      "Failed to load users in conversion class.": [
        "Die Benutzer der Umrechnungskurs-Klasse konnten nicht geladen werden.",
      ],
      "Filters": ["Filter"],
      "Show from other classes": ["Aus anderen Klassen anzeigen"],
      "Account": ["Konto"],
      "Group ID": ["Gruppen-ID"],
      "No users in this conversion rate class": [
        "Keine Benutzer in dieser Umrechnungskurs-Klasse",
      ],
      "Remove": ["Entfernen"],
      "Add": ["Hinzufügen"],
      "Conversion rate name": ["Name des Umrechnungskurses"],
      "Short description of the class": ["Kurzbeschreibung der Klasse"],
      "Failed to create conversion class.": [
        "Die Umrechnungskurs-Klasse konnte nicht erstellt werden.",
      ],
      "New conversion rate class": ["Neue Umrechnungskurs-Klasse"],
      "Create a named set of conversion terms that can be assigned to accounts.":
        [
          "Erstellen Sie einen benannten Satz von Umrechnungsbedingungen, der Konten zugewiesen werden kann.",
        ],
      "Create class": ["Klasse erstellen"],
      "Failed to load public accounts.": [
        "Öffentliche Konten konnten nicht geladen werden.",
      ],
      "Browse transaction histories shared by public bank accounts.": [
        "Buchungsverläufe anzeigen, die von öffentlichen Bankkonten freigegeben wurden.",
      ],
      "No public accounts are available.": [
        "Es sind keine öffentlichen Konten verfügbar.",
      ],
      "View previous cashouts": ["Frühere Auszahlungen anzeigen"],
      "Cashout ID must be a number.": [
        "Die Auszahlungs-ID muss eine Zahl sein.",
      ],
      "Failed to load cashout details.": [
        "Die Auszahlungsdetails konnten nicht geladen werden.",
      ],
      "This cashout was not found. It may already have been aborted.": [
        "Diese Auszahlung wurde nicht gefunden. Möglicherweise wurde sie bereits abgebrochen.",
      ],
      "Back to cashout history": ["Zurück zum Auszahlungsverlauf"],
      "Amounts recorded for this completed cashout transfer.": [
        "Für diese abgeschlossene Auszahlung erfasste Beträge.",
      ],
      "Amount debited": ["Abgebuchter Betrag"],
      "Amount transferred": ["Überwiesener Betrag"],
      "Enter your full name.": ["Geben Sie Ihren vollständigen Namen ein."],
      "Repeat your password.": ["Passwort wiederholen"],
      "Create your bank account": ["Konto anlegen"],
      "Choose the credentials you will use to sign in.": [
        "Wählen Sie die Anmeldedaten, mit denen Sie sich anmelden.",
      ],
      "Already have an account?": ["Haben Sie bereits ein Konto?"],
      "Confirm password": ["Passwort bestätigen"],
      "Use between 8 and 64 characters. A longer, unique password is easier to keep secure.":
        [
          "Verwenden Sie 8 bis 64 Zeichen. Ein längeres, einmaliges Passwort lässt sich leichter sicher halten.",
        ],
      "Creating account…": ["Konto wird erstellt…"],
      "Check the account details and try again.": [
        "Prüfen Sie die Kontodaten und versuchen Sie es erneut.",
      ],
      "You are not authorized to create this account.": [
        "Sie sind nicht berechtigt, dieses Konto zu erstellen.",
      ],
      "Registration is unavailable because the bank cannot grant the account credit.":
        [
          "Die Registrierung ist nicht verfügbar, da die Bank dem Konto kein Guthaben gewähren kann.",
        ],
      "That username is reserved. Choose another username.": [
        "Dieser Benutzername ist reserviert. Wählen Sie einen anderen Benutzernamen.",
      ],
      "That username is already taken.": [
        "Dieser Nutzername ist leider bereits vergeben.",
      ],
      "That account ID is already taken.": [
        "Diese Konto-ID ist bereits vergeben.",
      ],
      "The bank is missing information for the selected authentication channel.":
        [
          "Es sind keine Informationen für das gewählte Authentifizierungsverfahren verfügbar.",
        ],
      "The selected authentication channel is not supported.": [
        "Das gewählte Authentifizierungsverfahren wird nicht unterstützt.",
      ],
      "Only an administrator may set the debt limit.": [
        "Nur ein Administrator ist befugt, die Kredithöhe festzulegen.",
      ],
      "Only an administrator may select a conversion rate class.": [
        "Nur ein Administrator darf eine Umrechnungskursklasse auswählen.",
      ],
      "The selected conversion rate class does not exist.": [
        "Die Umrechnungskurs-Klasse existiert nicht.",
      ],
      "Only an administrator may enable two-factor authentication while creating an account.":
        [
          "Nur ein Administrator darf beim Erstellen eines Kontos die Zwei-Faktor-Authentifizierung aktivieren.",
        ],
      "Account registration is unavailable": ["Kontoregistrierung"],
      "This bank is not accepting new account registrations.": [
        "Im Augenblick nimmt die Bank keine Neuregistrierungen an!",
      ],
      "Return to sign in": ["Zurück zur Anmeldung"],
      "Contact the bank administrator if you need an account.": [
        "Bitte wenden Sie sich an den Bankadministrator.",
      ],
      "Send money from this account to another bank account.": [
        "Geld von diesem Konto auf ein anderes Bankkonto überweisen.",
      ],
      "Failed to load withdrawal details.": [
        "Abhebungsdetails konnten nicht geladen werden.",
      ],
      "Choose amount": ["Betrag auswählen"],
      "Open wallet": ["Wallet öffnen"],
      "Review": ["Prüfen"],
      "Withdrawal progress": ["Fortschritt der Abhebung"],
      "Abort this withdrawal?": ["Diese Abhebung abbrechen?"],
      "This stops the withdrawal. No money will be transferred, and this operation cannot be resumed.":
        [
          "Dadurch wird die Abhebung abgebrochen. Es wird kein Geld überwiesen und dieser Vorgang kann nicht fortgesetzt werden.",
        ],
      "Keep withdrawal": ["Abhebung beibehalten"],
      "Abort withdrawal": ["Abhebung abbrechen"],
      'The payto URI returned by the server is invalid: "%1$s".': [
        'Der vom Server zurückgegebene Payto-URI ist ungültig: "%1$s".',
      ],
      'The withdrawal URI returned by the server is invalid: "%1$s".': [
        'Der vom Server zurückgegebene Auszahlungs-URI ist ungültig: "%1$s".',
      ],
      'The reserve public key returned by the server is invalid: "%1$s".': [
        'Der vom Server zurückgegebene öffentliche Reserveschlüssel ist ungültig: "%1$s".',
      ],
      "Enter an amount.": ["Geben Sie einen Betrag ein."],
      "Enter a valid amount.": ["Geben Sie einen gültigen Betrag ein."],
      "The amount must be greater than zero.": [
        "Der Betrag muss größer als null sein.",
      ],
      "The amount is below the bank's minimum.": [
        "Der Betrag liegt unter dem Mindestbetrag der Bank.",
      ],
      "The amount is above the bank's maximum.": [
        "Der Betrag liegt über dem Höchstbetrag der Bank.",
      ],
      "Failed to abort the withdrawal.": [
        "Die Abhebung konnte nicht abgebrochen werden.",
      ],
      "The server did not understand the request.": [
        "Der Server hat die Anfrage nicht verstanden.",
      ],
      "The operation was not found.": [
        "Der Vorgang konnte nicht gefunden werden.",
      ],
      "The withdrawal operation has already been confirmed and cannot be aborted.":
        [
          "Der Abhebungsvorgang wurde bereits bestätigt und kann nicht abgebrochen werden.",
        ],
      "The bank could not be reached. Please try again.": [
        "Die Bank konnte nicht erreicht werden. Versuchen Sie es erneut.",
      ],
      "Withdrawal confirmation": ["Abhebungsbestätigung"],
      "Failed to confirm the withdrawal.": [
        "Die Abhebung konnte nicht bestätigt werden.",
      ],
      "The account does not have sufficient funds or the amount is outside the limits.":
        [
          "Das Konto verfügt nicht über ausreichendes Guthaben, oder der Betrag liegt außerhalb der Grenzen.",
        ],
      "The withdrawal has been aborted and cannot be confirmed.": [
        "Die Abhebung wurde abgebrochen und kann nicht bestätigt werden.",
      ],
      "The wallet has not finished selecting an exchange account.": [
        "Die Wallet hat die Auswahl eines Exchange-Kontos noch nicht abgeschlossen.",
      ],
      "The withdrawal amount changed. Review the current amount and try again.":
        [
          "Der Abhebungsbetrag hat sich geändert. Prüfen Sie den aktuellen Betrag und versuchen Sie es erneut.",
        ],
      "Enter an amount before confirming the withdrawal.": [
        "Geben Sie vor der Bestätigung der Abhebung einen Betrag ein.",
      ],
      "Selected exchange": ["Ausgewählter Exchange"],
      "Sign in to confirm the withdrawal": [
        "Anmelden, um die Abhebung zu bestätigen",
      ],
      "Sign in as %1$s before reviewing and confirming this withdrawal.": [
        "Melden Sie sich als %1$s an, bevor Sie diese Abhebung prüfen und bestätigen.",
      ],
      "You are signed in as %1$s, but this withdrawal belongs to %2$s.": [
        "Sie sind als %1$s angemeldet, aber diese Abhebung gehört zu %2$s.",
      ],
      "Finish later": ["Später fortfahren"],
      "Confirm wallet withdrawal": ["Wallet-Abhebung bestätigen"],
      "Review how much will leave your bank account before confirming.": [
        "Prüfen Sie vor der Bestätigung, wie viel Ihr Bankkonto verlassen wird.",
      ],
      "Unsupported exchange account": ["Nicht unterstütztes Exchange-Konto"],
      "The exchange account does not use the transfer type configured by this bank. This withdrawal cannot be confirmed.":
        [
          "Das Exchange-Konto verwendet nicht die von dieser Bank konfigurierte Überweisungsart. Diese Abhebung kann nicht bestätigt werden.",
        ],
      "Withdrawal amount missing": ["Abhebungsbetrag fehlt"],
      "The bank did not provide an amount for this withdrawal. It cannot be confirmed.":
        [
          "Die Bank hat für diese Abhebung keinen Betrag angegeben. Sie kann nicht bestätigt werden.",
        ],
      "Bank amount configuration invalid": [
        "Die Betragskonfiguration der Bank ist ungültig",
      ],
      "The withdrawal amount and bank fee could not be combined safely. This withdrawal cannot be confirmed.":
        [
          "Abhebungsbetrag und Bankgebühr können nicht sicher zusammengeführt werden. Diese Abhebung kann nicht bestätigt werden.",
        ],
      "Wallet receives": ["Wallet erhält"],
      "Amount to your Taler Wallet": ["Betrag für Ihre Taler-Wallet"],
      "Allowed amount": ["Zulässiger Betrag"],
      "Maximum amount": ["Höchstbetrag"],
      "Amount unavailable": ["Betrag nicht verfügbar"],
      "From": ["Von"],
      "To": ["An"],
      "Taler Wallet": ["Taler-Wallet"],
      "Exchange": ["Exchange"],
      "Unavailable": ["Nicht verfügbar"],
      "Exchange details": ["Details des Exchange"],
      "Exchange IBAN": ["IBAN des Exchange"],
      "Bank hostname": ["Hostname der Bank"],
      "Exchange account": ["Exchange-Konto"],
      "No money is withdrawn until you confirm. You can finish this later from your account overview.":
        [
          "Bis zu Ihrer Bestätigung wird kein Geld abgehoben. Sie können den Vorgang später in Ihrer Kontoübersicht fortsetzen.",
        ],
      "Confirm withdrawal": ["Abhebung bestätigen"],
      "Unauthorized to make the operation, maybe the session has expired or the password changed.":
        [
          "Sie sind nicht berechtigt, den Vorgang durchzuführen, vielleicht ist die Sitzung abgelaufen oder das Passwort wurde geändert.",
        ],
      "The operation was rejected due to insufficient funds.": [
        "Der Vorgang wurde wegen unzureichendem Guthaben zurückgewiesen.",
      ],
      "Withdrawal aborted": ["Abhebung abgebrochen"],
      "Withdrawal confirmed": ["Abhebung bestätigt"],
      "The bank transfer to the Taler exchange has been initiated. Your Taler Wallet will receive the withdrawn amount shortly.":
        [
          "Die Banküberweisung an den Taler Exchange wurde eingeleitet. Ihre Taler-Wallet erhält den abgehobenen Betrag in Kürze.",
        ],
      "Back to account": ["Zurück zum Konto"],
      "Complete withdrawal with your Taler Wallet": [
        "Abhebung mit Ihrer Taler-Wallet abschließen",
      ],
      "Scan this QR code with your Taler Wallet. Your wallet will select an exchange and prepare the withdrawal.":
        [
          "Scannen Sie diesen QR-Code mit Ihrer Taler-Wallet. Ihre Wallet wählt einen Exchange aus und bereitet die Abhebung vor.",
        ],
      "Withdrawal amount": ["Abhebungsbetrag"],
      "Suggested amount": ["Vorgeschlagener Betrag"],
      "You can change this amount in your wallet.": [
        "Sie können diesen Betrag in Ihrer Wallet ändern.",
      ],
      "QR code to continue the withdrawal in a Taler Wallet.": [
        "QR-Code, um die Abhebung in einer Taler-Wallet fortzusetzen.",
      ],
      "Open Taler Wallet manually": ["Taler-Wallet manuell öffnen"],
      "Don't have a Taler Wallet?": ["Sie haben noch keine Taler-Wallet?"],
      "Get a wallet": ["Wallet herunterladen"],
      "No money will be transferred until you return here to review and confirm the withdrawal.":
        [
          "Es wird kein Geld überwiesen, bis Sie hierher zurückkehren, um die Abhebung zu prüfen und zu bestätigen.",
        ],
      "Sign in to abort this withdrawal": [
        "Anmelden, um diese Abhebung abzubrechen",
      ],
      "The withdrawal operation has been confirmed previously and can not be aborted.":
        [
          "Der Abhebungsvorgang wurde bereits zuvor bestätigt und kann nicht abgebrochen werden.",
        ],
      "Withdrawal ready for confirmation": ["Abhebung kann bestätigt werden"],
      "Withdrawal waiting for your wallet": ["Abhebung wartet auf Ihre Wallet"],
      "The pending withdrawal could not be checked": [
        "Die ausstehende Abhebung konnte nicht geprüft werden",
      ],
      "Checking the pending withdrawal…": [
        "Ausstehende Abhebung wird geprüft…",
      ],
      "Review withdrawal": ["Abhebung prüfen"],
      "Retry": ["Erneut versuchen"],
      "Resume withdrawal": ["Abhebung fortsetzen"],
      "Finish or abort this withdrawal before starting another one.": [
        "Schließen Sie diese Abhebung ab oder brechen Sie sie ab, bevor Sie eine neue beginnen.",
      ],
      "Dashboard": ["Übersicht"],
      "Admin activity": ["Administratoraktivität"],
      "Conversion": ["Umrechnung"],
      "My account": ["Mein Konto"],
      "Bank administration": ["Bankverwaltung"],
      "Failed to load the account list.": [
        "Die Kontoliste konnte nicht geladen werden.",
      ],
      "Search accounts": ["Konten durchsuchen"],
      "Search by username or name": ["Nach Benutzername oder Name suchen"],
      "Search": ["Suchen"],
      "Clear": ["Leeren"],
      "Unknown": ["Unbekannt"],
      "Change password": ["Passwort ändern"],
      "Previous": ["Zurück"],
      "The amount exceeds what is available to withdraw.": [
        "Der Betrag übersteigt den verfügbaren Höchstbetrag für die Abhebung.",
      ],
      "The server replied with an invalid taler://withdraw URI": [
        "Der Server antwortete mit einem ungültigen taler://withdraw URI",
      ],
      "Withdraw URI: %1$s": ["Abhebe-URI: %1$s"],
      "Failed to create the withdrawal.": [
        "Die Abhebung konnte nicht erstellt werden.",
      ],
      "The operation was rejected due to insufficient funds": [
        "Der Vorgang wurde wegen unzureichendem Guthaben zurückgewiesen",
      ],
      "Please sign in again.": ["Bitte melden Sie sich erneut an."],
      "Choose an amount. Next, open your wallet and return here to review and confirm the withdrawal.":
        [
          "Wählen Sie einen Betrag aus. Öffnen Sie danach Ihre Wallet und kehren Sie hierher zurück, um die Abhebung zu prüfen und zu bestätigen.",
        ],
      "Unable to calculate the withdrawal amount": [
        "Der Abhebungsbetrag konnte nicht berechnet werden",
      ],
      "The bank's withdrawal limits or fee are configured incorrectly.": [
        "Die Abhebungslimits oder die Gebühr der Bank sind falsch konfiguriert.",
      ],
      "Maximum withdrawal": ["Maximaler Abhebungsbetrag"],
      "There is not enough available balance to cover a withdrawal and the bank fee.":
        [
          "Das verfügbare Guthaben reicht nicht für eine Abhebung und die Bankgebühr aus.",
        ],
      "Use maximum available": ["Verfügbaren Höchstbetrag verwenden"],
      "No money moves until you review and confirm the withdrawal.": [
        "Es wird kein Geld bewegt, bevor Sie die Abhebung geprüft und bestätigt haben.",
      ],
      "Need a Taler Wallet?": ["Benötigen Sie eine Taler-Wallet?"],
      "Get the wallet": ["Wallet herunterladen"],
      "Dismiss wallet installation hint": [
        "Hinweis zur Wallet-Installation schließen",
      ],
      "Continue to wallet": ["Weiter zur Wallet"],
      "Unable to start a withdrawal.": [
        "Die Abhebung konnte nicht gestartet werden.",
      ],
      "Your account was created. Sign in to continue.": [
        "Ihr Konto wurde erstellt. Melden Sie sich an, um fortzufahren.",
      ],
      "Conversion rate class ID “%1$s” is not a number.": [
        "Die ID der Umrechnungskursklasse „%1$s“ ist keine Zahl.",
      ],
      "Home": ["Startseite"],
      "Page not found": ["Seite nicht gefunden"],
      "The requested bank page does not exist.": [
        "Die angeforderte Bankseite existiert nicht.",
      ],
      "Unknown challenge.": ["Unbekannte Challenge."],
      "Failed to validate the verification code.": [
        "Der Bestätigungscode konnte nicht validiert werden.",
      ],
      "Too many challenges are active. Wait or confirm an existing challenge.":
        [
          "Derzeit sind zu viele Challenges aktiv. Sie müssen warten oder die aktuellen Challenges bestätigen.",
        ],
      "The verification code is incorrect.": [
        "Der Bestätigungscode ist falsch.",
      ],
      "The verification code has expired.": [
        "Der Bestätigungscode ist abgelaufen.",
      ],
      "Submit the transmitted code number.": [
        "Übermittelte Codenummer eingeben.",
      ],
      "The verification code sent to the email address starting with %1$s": [
        "Der Bestätigungscode wurde an die E-Mail-Adresse gesendet, die mit %1$s beginnt",
      ],
      "The verification code sent to the phone number ending with %1$s": [
        "Der Bestätigungscode wurde an die Telefonnummer gesendet, die mit %1$s endet",
      ],
      "Code": ["Code"],
      "Authentication code": ["Authentifizierungscode"],
      "It will expire at %1$s": ["Ende der Gültigkeit %1$s"],
      "This challenge is terminal and cannot be retransmitted.": [
        "Diese Authentifizierungsanforderung ist abgeschlossen und kann nicht erneut übertragen werden.",
      ],
      "Restart authentication": ["Authentifizierung neu starten"],
      "Back": ["Zurück"],
      "Verifying…": ["Wird überprüft…"],
      "Verify": ["Überprüfen"],
      "Complete": ["Abschließen"],
      "Failed to start the challenge.": [
        "Die Challenge konnte nicht gestartet werden.",
      ],
      "Unable to send the verification code.": [
        "Der Bestätigungscode konnte nicht gesendet werden.",
      ],
      "The request was valid, but the server is refusing action.": [
        "Die Anfrage war gültig, aber der Server verweigert die Bearbeitung.",
      ],
      "The backend is not aware of the specified MFA challenge.": [
        "Dem Backend ist die angegebene Multi-Faktor-Überprüfung nicht bekannt.",
      ],
      "It is too early to request another transmission of the challenge.": [
        "Es muss noch gewartet werden, um eine weitere Übertragung des Überprüfungscodes zu verlangen.",
      ],
      "Code transmission failed.": ["Die Code-Übertragung ist fehlgeschlagen."],
      "Multi-factor authentication required": [
        "Multi-Faktor-Authentifizierung erforderlich",
      ],
      "This operation is protected with second factor authentication. In order to complete it we need to verify your identity using the authentication channel you provided.":
        [
          "Dieser Vorgang wird durch eine Zwei-Faktor-Authentifizierung geschützt. Um ihn abschließen zu können, müssen wir Ihre Identität durch das von Ihnen gewählte Authentifizierungsverfahren überprüfen.",
        ],
      "The next challenge needs to be completed to confirm the operation.": [
        "Die nächste Challenge muss abgeschlossen werden, um den Vorgang zu bestätigen.",
      ],
      "All the next challenges need to be completed to confirm the operation.":
        [
          "Alle folgenden Challenges müssen abgeschlossen werden, um den Vorgang zu bestätigen.",
        ],
      "One of the next challenges needs to be completed to confirm the operation.":
        [
          "Eine der folgenden Challenges muss abgeschlossen werden, um den Vorgang zu bestätigen.",
        ],
      'To a phone ending with "%1$s"': [
        'An eine Telefonnummer, die mit "%1$s" endet',
      ],
      'To an email starting with " %1$s"': [
        'An eine E-Mail-Adresse, die mit " %1$s" beginnt',
      ],
      "I have a code": ["Ich habe bereits einen gültigen Bestätigungscode"],
      "Send me a message": ["Bestätigungscode zusenden"],
      "You have to wait until %1$s to send a new code.": [
        "Sie müssen bis %1$s warten, damit ein neuer Bestätigungscode gesendet werden kann.",
      ],
      "Use configured value (enabled)": [
        "Konfigurierten Wert verwenden (aktiviert)",
      ],
      "Use configured value (disabled)": [
        "Konfigurierten Wert verwenden (deaktiviert)",
      ],
      "Force enabled": ["Aktivierung erzwingen"],
      "Force disabled": ["Deaktivierung erzwingen"],
      "Enter a valid HTTP or HTTPS URL.": [
        "Geben Sie eine gültige HTTP- oder HTTPS-URL ein.",
      ],
      "Development settings": ["Entwicklungseinstellungen"],
      "These overrides are stored only in this browser.": [
        "Diese Überschreibungen werden nur in diesem Browser gespeichert.",
      ],
      "Corebank API base URL": ["Corebank-API-Basis-URL"],
      "Leave empty to use the configured URL: %1$s": [
        "Leer lassen, um die konfigurierte URL zu verwenden: %1$s",
      ],
      "Leave empty to derive the URL from this page.": [
        "Leer lassen, um die URL aus dieser Seite abzuleiten.",
      ],
      "Demo header": ["Demo-Kopfbereich"],
      "Control whether the demo header is shown in this browser.": [
        "Legt fest, ob der Demo-Kopfbereich in diesem Browser angezeigt wird.",
      ],
      "Control whether public account links are shown in this browser.": [
        "Legt fest, ob Links zu öffentlichen Konten in diesem Browser angezeigt werden.",
      ],
      "Overrides saved.": ["Überschreibungen gespeichert."],
      "Apply overrides": ["Überschreibungen anwenden"],
      "Clear overrides": ["Überschreibungen löschen"],
      "Back to bank": ["Zurück zur Bank"],
    },
  },
  domain: "messages",
  plural_forms: "nplurals=2; plural=n != 1;",
  lang: "de",
  completeness: 100,
};

strings["de-CH"] = {
  locale_data: {
    messages: {
      "": {
        domain: "messages",
        lang: "de-CH",
        plural_forms: "nplurals=2; plural=n != 1;",
      },
      "Hide password": ["Passwort ausblenden"],
      "Show password": ["Passwort anzeigen"],
      "Hide": ["Ausblenden"],
      "Show": ["Anzeigen"],
      "Identity verification.": ["Identitätsüberprüfung."],
      "You do not have permission to access this account.": [
        "Sie haben keine Berechtigung, auf dieses Konto zuzugreifen.",
      ],
      "This account is locked. Contact the bank administrator.": [
        "Das Konto ist gesperrt und kann sich nicht anmelden. Wenden Sie sich an den Administrator.",
      ],
      "The password is incorrect.": ["Das Passwort ist falsch."],
      "Account not found.": ["Konto nicht gefunden"],
      "Could not reach the bank. Check your connection and try again.": [
        "Die Bank konnte nicht erreicht werden. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
      ],
      "Confirm your password": ["Bestätigen Sie Ihr Passwort"],
      "Sign in to %1$s": ["Bei %1$s anmelden"],
      "Enter the password for %1$s to continue.": [
        "Geben Sie das Passwort für %1$s ein, um fortzufahren.",
      ],
      "Use your bank account credentials to continue.": [
        "Verwenden Sie Ihre Bankkontodaten, um fortzufahren.",
      ],
      "Need an account?": ["Benötigen Sie ein Konto?"],
      "Create one": ["Konto anlegen"],
      "Your session expired. Confirm your password to continue.": [
        "Ihre Sitzung ist abgelaufen. Bestätigen Sie Ihr Passwort, um fortzufahren.",
      ],
      "Username": ["Benutzername"],
      "Password": ["Passwort"],
      "Sign out": ["Abmelden"],
      "Signing in…": ["Anmeldung läuft…"],
      "Continue": ["Weiter"],
      "Sign in": ["Anmelden"],
      "Enter your username.": ["Geben Sie Ihren Benutzernamen ein."],
      "Use letters, numbers, or any of these characters: - . _ ~": [
        "Verwenden Sie nur Buchstaben und Zahlen sowie als Sonderzeichen - . _ ~",
      ],
      "The username must not exceed 126 characters.": [
        "Der Benutzername darf höchstens 126 Zeichen lang sein.",
      ],
      "Enter your password.": ["Geben Sie Ihr Passwort ein."],
      "The password must contain at least 8 characters.": [
        "Das Passwort ist zu kurz. Es darf nicht weniger als 8 Zeichen haben.",
      ],
      "The password must not exceed %1$s characters.": [
        "Das Passwort darf höchstens %1$s Zeichen lang sein.",
      ],
      "IBAN country code not found": [
        "Der IBAN-Ländercode wurde nicht gefunden",
      ],
      "The IBAN must not exceed 34 characters.": [
        "Die IBAN darf höchstens 34 Zeichen lang sein.",
      ],
      "The IBAN must contain at least 4 characters.": [
        "Die IBAN muss mindestens 4 Zeichen enthalten.",
      ],
      "IBAN length is invalid for this country": [
        "Die IBAN-Länge ist für dieses Land ungültig",
      ],
      "The IBAN contains invalid characters": [
        "Die IBAN enthält ungültige Zeichen",
      ],
      "IBAN number is not valid, checksum is wrong": [
        "Die IBAN-Nummer ist ungültig, die Prüfsumme ist falsch",
      ],
      "The IBAN is not valid": ["Die IBAN ist ungültig"],
      "Use letters, numbers or any of these characters: - . _ ~": [
        "Verwenden Sie nur Buchstaben und Zahlen sowie als Sonderzeichen - . _ ~",
      ],
      "Failed to load cashouts.": [
        "Auszahlungen konnten nicht geladen werden.",
      ],
      "Try again": ["Erneut versuchen"],
      "Cashout is disabled": ["Auszahlungen aufs Konto sind deaktiviert"],
      "Cashout should be enabled in the configuration, the conversion rate should be initialized with fee(s), rates and a rounding mode.":
        [
          "In den Einstellungen müssen die Auszahlungen aufs Konto aktiviert und der Umrechnungskurs einschliesslich aller Gebühren, Kurse und einem Rundungsverfahren initialisiert worden sein.",
        ],
      "No cashouts have been created yet.": [
        "Es wurden noch keine Auszahlungen erstellt.",
      ],
      "Failed to load conversion rate information.": [
        "Informationen zum Umrechnungskurs konnten nicht geladen werden.",
      ],
      "Some cashout details could not be loaded.": [
        "Einige Auszahlungsdetails konnten nicht geladen werden.",
      ],
      "The partial list omits cashout IDs: %1$s.": [
        "In der unvollständigen Liste fehlen die Auszahlungs-IDs %1$s.",
      ],
      "View details": ["Details anzeigen"],
      "Debited": ["Belastet"],
      "Transferred": ["Überwiesen"],
      "Created": ["Erzeugt"],
      "Transfer reference": ["Überweisungsreferenz"],
      "Actions": ["Aktionen"],
      "Cashout history": ["Auszahlungsverlauf"],
      "Review previous transfers to your configured cashout account.": [
        "Frühere Überweisungen an Ihr konfiguriertes Auszahlungskonto anzeigen.",
      ],
      "Profile": ["Profil"],
      "Security": ["Sicherheit"],
      "Merchant integration": ["Händler-Integration"],
      "Back to overview": ["Zurück zur Übersicht"],
      "My account settings": ["Meine Kontoeinstellungen"],
      "Copy": ["Kopieren"],
      "Failed to load account details.": [
        "Kontodetails konnten nicht geladen werden.",
      ],
      'Use this information to link your Taler Merchant Backoffice account with the current bank account. You can start by copying the values, then go to your merchant backoffice service provider, login into your account and look for the "import" button in the "bank account" section.':
        [
          'Verwenden Sie diese Information, um Ihr Konto im Taler Merchant-Backend mit dem normalen Bankkonto zu verknüpfen. Sie können dafür die im Onlinebanking angezeigten Angaben kopieren und mit der "Import"-Taste im Abschnitt "Bankkonto" des Taler Merchant-Backend selbst einfügen bzw. Ihren Dienste-Verwalter eintragen lassen.',
        ],
      "Not available": ["Nicht verfügbar"],
      "Merchant integration is not available for this account.": [
        "Die Händler-Integration ist für dieses Konto nicht verfügbar.",
      ],
      "Account type": ["Kontentyp"],
      "Method to use for wire transfer.": [
        "Für Banküberweisungen zu verwendende Methode.",
      ],
      "IBAN": ["IBAN"],
      "International Bank Account Number.": [
        "IBAN (Internationale Bankkontonummer).",
      ],
      "Bank host": ["Bank-Host"],
      "Bank host where the service is located.": [
        "Adresse des Bankservers, der den Dienst anbietet.",
      ],
      "Account name": ["Kontobezeichnung"],
      "Bank account identifier for wire transfers.": [
        "Kennung des Bankkontos für Banküberweisungen.",
      ],
      "Address": ["Adresse"],
      "Bitcoin address for this account.": [
        "Bitcoin-Adresse für dieses Konto.",
      ],
      "Account address": ["Kontoadresse"],
      "Owner's name": ["Name des Kontoinhabers"],
      "Legal name of the person holding the account.": [
        "Rechtsgültiger Name des Kontoinhabers.",
      ],
      "Account info URL": ["URL für Kontoinformationen"],
      "From where the merchant can download information about incoming wire transfers to this account.":
        [
          "Von wo der Händler Informationen über eingehende Banküberweisungen auf dieses Konto herunterladen kann.",
        ],
      "Unable to create a cashout": [
        "Es war nicht möglich, eine Auszahlung auszuführen",
      ],
      "The bank configuration does not support cashout operations.": [
        "Die Konfiguration der Bankverbindung unterstützt keine Auszahlungen.",
      ],
      "Close": ["Schliessen"],
      "The bank returned incomplete conversion information.": [
        "Die Bank hat unvollständige Umrechnungsinformationen zurückgegeben.",
      ],
      "Please contact the bank administrator.": [
        "Bitte wenden Sie sich an den Bankadministrator.",
      ],
      "Authentication required": ["Authentifizierung erforderlich"],
      "Please sign in to create a cashout.": [
        "Bitte melden Sie sich an, um eine Auszahlung zu erstellen.",
      ],
      "Failed to calculate the conversion fee.": [
        "Die Umrechnungsgebühr konnte nicht berechnet werden.",
      ],
      "The amount is too small": ["Der Betrag ist zu klein"],
      "Conversion is not implemented.": ["Umrechnung ist nicht implementiert."],
      "At least a debit or credit amount must be provided.": [
        "Mindestens ein Belastungs- oder Gutschriftsbetrag muss angegeben werden.",
      ],
      "The amount has an invalid format.": [
        "Der Betrag hat ein ungültiges Format.",
      ],
      "The currency is not supported": ["Die Währung wird nicht unterstützt"],
      "Required": ["Erforderlich"],
      "Invalid": ["Ungültig"],
      "The balance is not sufficient": ["Das Guthaben ist nicht ausreichend"],
      "It is not possible to cash out less than %1$s: %2$s": [
        "Es ist nicht möglich, einen geringeren Betrag als %1$s: %2$s einzuzahlen",
      ],
      "The total transfer to the destination will be zero": [
        "Der zu übertragende Gesamtbetrag beträgt Null",
      ],
      "Failed to create the cashout.": [
        "Die Auszahlung konnte nicht erstellt werden.",
      ],
      "Cashout": ["Auszahlung"],
      "Account not found": ["Konto nicht gefunden"],
      "Duplicate request detected, check if the operation succeeded or try again.":
        [
          "Eine gleichartige Anfrage wurde bereits gestellt, bitte überprüfen Sie den Vorgang oder versuchen Sie es erneut.",
        ],
      "The conversion rate was applied incorrectly": [
        "Der Umrechnungskurs wurde fehlerhaft angewendet",
      ],
      "The account does not have sufficient funds": [
        "Das Konto verfügt über kein ausreichendes Guthaben",
      ],
      "Missing cashout URI in the profile": [
        "Die Auszahlungs-URI dieses Profils fehlt",
      ],
      "The amount is below the minimum amount permitted.": [
        "Der Betrag ist unterhalb des zulässigen Minimums.",
      ],
      "Sending the confirmation message failed, retry later or contact the administrator.":
        [
          "Der Versand der Bestätigung ist fehlgeschlagen, versuchen Sie den Vorgang bittespäter erneut oder kontaktieren Sie den Administrator.",
        ],
      "The server doesn't support the current TAN channel.": [
        "Der Server unterstützt nicht die aktuell gewählte TAN-Methode.",
      ],
      "Cashout details": ["Auszahlungsdetails"],
      "Review the destination account and conversion terms.": [
        "Zielkonto und Umrechnungsbedingungen prüfen.",
      ],
      "Conversion rate": ["Umrechnungskurs"],
      "Balance": ["Saldo"],
      "Fee": ["Gebühr"],
      "No fee": ["Keine Gebühr"],
      "To account": ["Auf Bankkonto"],
      "Legal name": ["Rechtlicher Name"],
      "If this name doesn't match the account holder's name, your transaction may fail.":
        [
          "Falls dieser Name nicht mit dem des wirtschaftlich Berechtigten des Bankkontos übereinstimmt, könnte Ihre Überweisung fehlschlagen.",
        ],
      "Unable to cash out": ["Auszahlung nicht möglich"],
      "Before being able to cash out to a bank account, you need to complete your profile":
        [
          "Bevor Sie auf ein Bankkonto einzahlen können, müssen Sie Ihr Profil vervollständigen",
        ],
      "What is this cashout for?": ["Wofür ist diese Auszahlung?"],
      "Enter the amount to send or receive": [
        "Den zu sendenden oder zu empfangenden Betrag eingeben",
      ],
      "Send %1$s": ["%1$s übertragen"],
      "Receive %1$s": ["%1$s erhalten"],
      "Amount": ["Betrag"],
      "Total cost": ["Gesamte Gebühren"],
      "Balance left": ["Verbleibendes Guthaben"],
      "Before fee": ["Vor Abzug von Gebühren"],
      "Total cashout transfer": ["Gesamter Auszahlungsbetrag"],
      "Cancel": ["Abbrechen"],
      "Cash out": ["Auszahlung"],
      "Not valid": ["Nicht gültig"],
      "Does not follow the pattern": ["Weicht vom Muster ab"],
      "Failed to create the transaction.": [
        "Die Transaktion konnte nicht erstellt werden.",
      ],
      "The request was invalid or the payto://-URI used unacceptable features.":
        [
          "Die Anfrage war ungültig oder die payto://-URI nutzte inakzeptable Merkmale.",
        ],
      "Not enough permission to complete the operation.": [
        "Es besteht keine ausreichende Berechtigung, um den Vorgang abzuschliessen.",
      ],
      "The bank administrator cannot be the transfer creditor.": [
        "Der Bankbetreiber kann nicht gleichzeitig Begünstigter von Überweisungen sein.",
      ],
      'The destination account "%1$s" was not found.': [
        'Das Empfängerkonto "%1$s" wurde nicht gefunden.',
      ],
      "The origin and the destination of the transfer can't be the same.": [
        "Ursprung und Ziel des Transfers können nicht gleich sein.",
      ],
      "Your balance is not sufficient for the operation.": [
        "Das Guthaben reicht für den Vorgang nicht aus.",
      ],
      'The origin account "%1$s" was not found.': [
        'Das Ursprungskonto "%1$s" wurde nicht gefunden.',
      ],
      "The attempt to create the transaction has failed. Please try again.": [
        "Die Vorbereitung der Transaktion hat nicht funktioniert. Bitte versuchen Sie es erneut.",
      ],
      "Confirm transaction.": ["Transaktion bestätigen."],
      "Transfer details": ["Überweisungsdetails"],
      "Enter the recipient, a reference, and the amount to send.": [
        "Empfänger, Referenz und zu sendenden Betrag eingeben.",
      ],
      "Maximum transfer": ["Maximaler Überweisungsbetrag"],
      "Debt limit": ["Kreditlimit"],
      "This is not your account balance. This account cannot go into debt.": [
        "Dies ist nicht Ihr Kontostand. Dieses Konto darf nicht ins Minus gehen.",
      ],
      "This is not your account balance. It includes borrowing up to the debt limit shown here.":
        [
          "Dies ist nicht Ihr Kontostand. Der Betrag schliesst den verfügbaren Kredit bis zum hier angezeigten Kreditlimit ein.",
        ],
      "Transfer input method": ["Eingabemethode für die Überweisung"],
      "Enter details": ["Details eingeben"],
      "Paste payto URI": ["payto-URI einfügen"],
      "Recipient": ["Empfänger"],
      "Account name of the recipient": ["Name des Empfängerkontos"],
      "username": ["Benutzername"],
      "IBAN of the recipient's account": ["IBAN des Empfängerkontos"],
      "What is this transfer for?": ["Wofür ist diese Überweisung?"],
      "Payto URI": ["payto-URI"],
      "Paste a payto URI containing the recipient, amount, and transfer reference.":
        [
          "Eine payto-URI mit Empfänger, Betrag und Überweisungsreferenz einfügen.",
        ],
      "Uniform resource identifier of the target account": [
        "URI (Uniform Resource Identifier) des Empfängerkontos",
      ],
      "payto://x-taler-bank/[bank-host]/[receiver-account]?message=[subject]&amount=[%1$s:X.Y]":
        [
          "payto://x-taler-bank/[Bankbetreiber]/[Empfängerkonto]?message=[Buchungsvermerk]&amount=[%1$s:X.Y]",
        ],
      "payto://iban/[receiver-iban]?message=[subject]&amount=[%1$s:X.Y]": [
        "payto://iban/[IBAN des Empfängers]?message=[Buchungsvermerk]&amount=[%1$s:X.Y]",
      ],
      "Recipient receives": ["Empfänger erhält"],
      "Bank fee": ["Bankgebühr"],
      "Total debited": ["Gesamtbelastung"],
      "Need to move money out of this bank?": [
        "Möchten Sie Geld aus dieser Bank auszahlen?",
      ],
      "Start a cashout": ["Auszahlung starten"],
      "Send transfer": ["Überweisung senden"],
      'Only "x-taler-bank" targets are supported': [
        'Nur "x-taler-bank"-Ziele werden unterstützt',
      ],
      'Only this host is allowed. Use "%1$s"': [
        'Nur dieser Bankbetreiber ist zulässig. Bitte verwenden Sie "%1$s"',
      ],
      "Account name is missing": ["Name oder Bezeichnung des Kontos fehlt"],
      'Only "IBAN" targets are supported': [
        "Nur IBAN-Ziele werden unterstützt",
      ],
      'Missing "amount" parameter to specify the amount to be transferred': [
        "Bitte geben Sie einen Betrag an, der übertragen werden soll",
      ],
      'The "amount" parameter is not valid': ["Der Betrag ist nicht gültig"],
      '"message" parameters to specify a reference text for the transfer are missing':
        [
          "Es fehlen Parameter für einen Referenz-Buchungsvermerk der Überweisungen",
        ],
      'The only currency allowed is "%1$s"': [
        'Die einzig zulässige Währung ist "%1$s"',
      ],
      "You cannot transfer an amount of zero.": [
        "Sie können keinen Betrag überweisen, der Null ist.",
      ],
      "Please enter a longer subject": [
        "Bitte geben Sie einen längeren Buchungsvermerk der Überweisung an",
      ],
      "Email and SMS authentication were disabled because their contact details were removed.":
        [
          "Die Authentifizierung per E-Mail und SMS wurde deaktiviert, weil die zugehörigen Kontaktdaten entfernt wurden.",
        ],
      "Email authentication was disabled because the email address was removed.":
        [
          "Die Authentifizierung per E-Mail wurde deaktiviert, weil die E-Mail-Adresse entfernt wurde.",
        ],
      "SMS authentication was disabled because the phone number was removed.": [
        "Die Authentifizierung per SMS wurde deaktiviert, weil die Telefonnummer entfernt wurde.",
      ],
      "Invalid email format": ["Ungültiges E-Mail-Format"],
      "Should start with +": ["Die Nummer sollte mit + beginnen"],
      "A phone number consists of numbers only": [
        "Eine Telefonnummer besteht nur aus Ziffern",
      ],
      "Login username": ["Nutzername zum Anmelden"],
      "Account ID for authentication": ["Konto-ID zur Authentifizierung"],
      "Full name": ["Vollständiger Name"],
      "Name of the account holder": ["Name des Kontoinhabers"],
      "Internal account": ["Internes Konto"],
      "Copy and share this account address to receive transfers.": [
        "Kopieren und teilen Sie diese Kontoadresse, um Überweisungen zu empfangen.",
      ],
      "Email": ["E-Mail"],
      "To be used when second factor authentication is enabled": [
        "Dies wird verwendet, wenn die Zwei-Faktor-Authentifizierung aktiviert ist",
      ],
      "Phone": ["Telefon"],
      "Enable second factor authentication": [
        "Zwei-Faktor-Authentifizierung aktivieren",
      ],
      "Using email": ["Per E-Mail"],
      "Add an email in your profile to enable this option": [
        "Fügen Sie Ihrem Profil eine E-Mail-Adresse hinzu, um diese Option zu aktivieren",
      ],
      "Using SMS": ["Per SMS"],
      "Add a phone number in your profile to enable this option": [
        "Fügen Sie Ihrem Profil eine Telefonnummer hinzu, um diese Option zu aktivieren",
      ],
      "Cashout account": ["Auszahlungskonto"],
      "External account to which cashout transfers are sent.": [
        "Externes Konto, an das Auszahlungsüberweisungen gesendet werden.",
      ],
      "Max debt": ["Maximale Kredithöhe"],
      "How much the balance can go below zero.": [
        "Dieser Wert gibt an, wie weit der Saldo ins Minus gehen kann.",
      ],
      "Is this account public?": ["Ist dieses Konto ein öffentliches?"],
      "Public accounts expose their balance and complete transaction history, including subjects and both account addresses, to anonymous visitors.":
        [
          "Bei öffentlichen Konten sind der Kontostand und der vollständige Transaktionsverlauf einschliesslich Verwendungszwecken und beider Kontoadressen für anonyme Besucher einsehbar.",
        ],
      "Does this account belong to a Payment Service Provider?": [
        "Gehört dieses Konto dem Anbieter eines Zahlungsdiensts?",
      ],
      "Account updated": ["Das Konto wurde aktualisiert"],
      "Failed to update the account.": [
        "Das Konto konnte nicht aktualisiert werden.",
      ],
      "The rights to change the account are not sufficient": [
        "Es besteht keine ausreichende Berechtigung zum Ändern des Kontos",
      ],
      "The username was not found": [
        "Der Name des Nutzers konnte nicht gefunden werden",
      ],
      "You can't change the legal name, please contact your account administrator.":
        [
          "Sie können den Namen des wirtschaftlichen Berechtigten nicht ändern, bitte benachrichtigen Sie den Administrator des Kontos.",
        ],
      "You can't change the debt limit, please contact your account administrator.":
        [
          "Sie sind nicht befugt, die Kredithöhe zu ändern, bitte verständigen Sie den Administrator des Kontos.",
        ],
      "You can't change the cashout address, please contact your account administrator.":
        [
          "Sie können die Adresse für Auszahlungen nicht ändern, bitte benachrichtigen Sie Ihren Administrator des Kontos.",
        ],
      "No information for the selected authentication channel.": [
        "Es sind keine Informationen für das gewählte Authentifizierungsverfahren verfügbar.",
      ],
      "Account update": ["Kontoaktualisierung"],
      "Authentication channel is not supported.": [
        "Das gewählte Authentifizierungsverfahren wird nicht unterstützt.",
      ],
      "Only the administrator can change the conversion rate.": [
        "Nur der Administrator kann den Umrechnungskurs ändern.",
      ],
      "The conversion rate class doesn't exist.": [
        "Die Umrechnungskurs-Klasse existiert nicht.",
      ],
      "The password is too short. Can't have less than 8 characters.": [
        "Das Passwort ist zu kurz. Es darf nicht weniger als 8 Zeichen haben.",
      ],
      "The password is too long. Can't have more than 64 characters.": [
        "Das Passwort ist zu lang. Es darf nicht mehr als 64 Zeichen haben.",
      ],
      'Account "%1$s"': ['Konto "%1$s"'],
      "Removed": ["Entfernt"],
      "This account can't be used.": [
        "Dieses Konto kann nicht genutzt werden.",
      ],
      "Account details": ["Kontodetails"],
      "Not configured": ["Nicht konfiguriert"],
      "Change details": ["Details ändern"],
      "Update": ["Aktualisieren"],
      "Delete account": ["Konto löschen"],
      "Permanently remove this bank account. The account must have a zero balance before it can be deleted.":
        [
          "Dieses Bankkonto dauerhaft löschen. Das Konto muss einen Saldo von null haben, bevor es gelöscht werden kann.",
        ],
      "The passwords do not match.": ["Die Passwörter stimmen nicht überein."],
      "Failed to update the password.": [
        "Das Passwort konnte nicht aktualisiert werden.",
      ],
      "Not authorized to change the password, maybe the session is invalid.": [
        "Sie sind zum Ändern des Passworts nicht berechtigt, möglicherweise ist die Sitzung nicht mehr gültig.",
      ],
      "You need to provide the old password. If you don't have it contact your account administrator.":
        [
          "Sie müssen das alte Passwort eingeben, sollten Sie es nicht mehr haben, verständigen Sie bitte Ihren Administrator des Kontos.",
        ],
      "The current password is incorrect, so the password cannot be changed.": [
        "Das aktuelle Passwort ist falsch, daher kann es nicht geändert werden.",
      ],
      "Password update": ["Passwortaktualisierung"],
      "You don't have the rights to change the password.": [
        "Sie haben keine Berechtigung, das Passwort zu ändern.",
      ],
      "Update password": ["Passwort erneuern"],
      "Choose a new password for your bank account.": [
        "Wählen Sie ein neues Passwort für Ihr Bankkonto.",
      ],
      'Choose a new password for account "%1$s".': [
        "Wählen Sie ein neues Passwort für das Konto „%1$s“.",
      ],
      "Current password": ["Aktuelles Passwort dieser Instanz"],
      "Your current password, for security": [
        "Zur Sicherheit bitte ihr bisheriges Passwort",
      ],
      "New password": ["Neues Passwort"],
      "Confirm new password": ["Neues Passwort bestätigen"],
      "Enter the new password again.": [
        "Geben Sie das neue Passwort erneut ein.",
      ],
      "Failed to load transactions.": [
        "Transaktionen konnten nicht geladen werden.",
      ],
      "Unknown account": ["Unbekanntes Konto"],
      "Recent activity": ["Letzte Aktivitäten"],
      "Transactions": ["Transaktionen"],
      "Subject": ["Buchungsvermerk"],
      "Today": ["Heute"],
      "Yesterday": ["Gestern"],
      "Invalid value": ["Ungültiger Wert"],
      "View all transactions": ["Alle Transaktionen anzeigen"],
      "No transactions yet.": ["Es liegen noch keine Transaktionen vor."],
      "Your account activity will appear here.": [
        "Ihre Kontoaktivitäten werden hier angezeigt.",
      ],
      "Date": ["Datum"],
      "Counterparty": ["Gegenpartei"],
      "Pagination": ["Seitennavigation"],
      "Newer": ["Neuere"],
      "Older": ["Ältere"],
      "Withdraw to Taler Wallet": ["Auf Taler-Wallet abheben"],
      "Move digital cash to your Taler Wallet.": [
        "Digitales Geld auf Ihre Taler-Wallet übertragen.",
      ],
      "Send bank transfer": ["Banküberweisung senden"],
      "Transfer money to another bank account.": [
        "Geld auf ein anderes Bankkonto überweisen.",
      ],
      "Convert regional currency and send it to your cashout account.": [
        "Regionale Währung umrechnen und an Ihr Auszahlungskonto senden.",
      ],
      "Copy account address": ["Kontoadresse kopieren"],
      "Current balance": ["Aktueller Saldo"],
      "Go to account details": ["Zu den Kontodetails"],
      "Failed to load the admin account.": [
        "Das Administratorkonto konnte nicht geladen werden.",
      ],
      "Admin account": ["Administratorkonto"],
      "Admin account activity": ["Aktivität des Administratorkontos"],
      "Failed to load the monitor info.": [
        "Die Überwachungsinformationen konnten nicht geladen werden.",
      ],
      "Failed to load cashout info.": [
        "Die Auszahlungsinformationen konnten nicht geladen werden.",
      ],
      "Querying for the current stats failed": [
        "Die Abfrage der aktuellen Statistik ist fehlgeschlagen",
      ],
      "The request parameters are invalid.": [
        "Die Anfrageparameter sind ungültig.",
      ],
      "The user is unauthorized": ["Dieser Nutzer ist nicht berechtigt"],
      "Querying for the previous stats failed": [
        "Die Abfrage der vorherigen Statistik ist fehlgeschlagen",
      ],
      "Bank activity": ["Bankaktivität"],
      "Select a section": ["Bitte wählen Sie einen Bereich aus"],
      "Last hour": ["Vergangene Stunde"],
      "Previous day": ["Tag zuvor"],
      "Last month": ["Vergangener Monat"],
      "Last year": ["Letztes Jahr"],
      "Tabs": ["Registerkarten"],
      "Last Year": ["Vergangenes Jahr"],
      "Trading volume from %1$s to %2$s": ["Umsatzvolumen von %1$s bis %2$s"],
      "Cash in": ["Geldeingang"],
      "Transferred from an external account to an account in this bank.": [
        "Überwiesen von einem externen Bankkonto auf das Konto dieser Bank.",
      ],
      "Transferred from an account in this bank to an external account.": [
        "Überwiesen von einem Konto dieser Bank auf ein externes Bankkonto.",
      ],
      "Taler pay-in": ["Taler-Einzahlung"],
      "Transferred from an account to a Taler exchange.": [
        "Überwiesen von einem Bankkonto an einen Taler Exchange.",
      ],
      "Transfers": ["Überweisungen"],
      "Taler payout": ["Taler-Auszahlung"],
      "Transferred from a Taler exchange to another account.": [
        "Überwiesen von einem Taler Exchange auf ein anderes Bankkonto.",
      ],
      "Download stats as CSV": ["Statistik herunterladen als CSV-Datei"],
      "previous": ["vorherige"],
      "Decreased by": ["Verringert um"],
      "Increased by": ["Vermehrt um"],
      'Account created with password "%1$s".': [
        'Das Konto wurde angelegt mit dem Passwort "%1$s".',
      ],
      "Failed to create a new account.": [
        "Ein neues Konto konnte nicht erstellt werden.",
      ],
      "Server replied that phone or email is invalid": [
        "Der Server meldete zurück, dass die Telefonnummer oder die Emailadresse falsch seien",
      ],
      "The rights to perform the operation are not sufficient": [
        "Die Berechtigung zum Durchführen des Vorgangs ist unzureichend",
      ],
      "Account username is already taken": [
        "Dieser Nutzername ist bereits vergeben",
      ],
      "Account ID is already taken": ["Die Konto-ID ist bereits vergeben"],
      "Bank ran out of bonus credit.": [
        "Die Bank verfügt über kein Bonusguthaben mehr.",
      ],
      "This account username is reserved and cannot be used.": [
        "Dieser Nutzername ist reserviert und kann nicht verwendet werden.",
      ],
      "Only an administrator is allowed to set the debt limit.": [
        "Nur ein Administrator ist befugt, die Kredithöhe festzulegen.",
      ],
      "Only admin can create accounts with second factor authentication.": [
        "Nur der Administrator kann Konten mit Zwei-Faktor-Authentifizierung erstellen.",
      ],
      "Can't create accounts": ["Die Anlage von Konten ist nicht möglich"],
      "Only a system administrator can create accounts.": [
        "Nur ein Systemadministrator kann Konten anlegen.",
      ],
      "Back to accounts": ["Zurück zu den Konten"],
      "New bank account": ["Neues Konto"],
      "Create an account and configure its initial access and profile.": [
        "Erstellen Sie ein Konto und richten Sie den anfänglichen Zugang und das Profil ein.",
      ],
      "Create account": ["Konto anlegen"],
      "Failed to download statistics.": [
        "Statistiken konnten nicht heruntergeladen werden.",
      ],
      "A statistics request failed. Please try again.": [
        "Eine Statistikanfrage ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
      ],
      "only admin can download stats": [
        "Nur der Administrator kann Statistiken herunterladen",
      ],
      "Back to dashboard": ["Zurück zur Übersicht"],
      "Download bank statistics": ["Bankstatistik herunterladen"],
      "Choose which reporting periods to include in the CSV file.": [
        "Wählen Sie die Berichtszeiträume aus, die in die CSV-Datei aufgenommen werden sollen.",
      ],
      "Include hour metric": ["Stunden-Metrik einbeziehen"],
      "Include day metric": ["Tages-Metrik einbeziehen"],
      "Include month metric": ["Monats-Metrik einbeziehen"],
      "Include year metric": ["Jahres-Metrik einbeziehen"],
      "Include table header": ["Tabellenkopfzeilen einbeziehen"],
      "Add previous metric for comparison": [
        "Vorherige Metrik zum Vergleich hinzufügen",
      ],
      "Fail on first error": ["Beim ersten Fehler abbrechen"],
      "Download": ["Herunterladen"],
      "Downloading… %1$s": ["Wird heruntergeladen… %1$s"],
      "Download completed with missing data": [
        "Download mit fehlenden Daten abgeschlossen",
      ],
      "Download completed": ["Download abgeschlossen"],
      "%1$s statistics requests failed. The file contains only the data that could be retrieved. Click here to save it.":
        [
          "%1$s Statistikanfragen sind fehlgeschlagen. Die Datei enthält nur die Daten, die abgerufen werden konnten. Klicken Sie hier, um sie zu speichern.",
        ],
      "Click here to save the file on your computer.": [
        "Hier klicken zum Speichern der Datei auf Ihrem Rechner.",
      ],
      "Name doesn't match": ["Der Name stimmt nicht überein"],
      "Faild to delete the account.": [
        "Das Konto konnte nicht gelöscht werden.",
      ],
      "Not enough permission to delete the account.": [
        "Es besteht keine ausreichende Berechtigung zum Löschen des Kontos.",
      ],
      "The username was not found.": ["Der Nutzername wurde nicht gefunden."],
      "Can't delete a reserved username.": [
        "Es ist nicht möglich, den reservierten Nutzernamen zu entfernen.",
      ],
      "Can't delete an account with balance different than zero.": [
        "Es ist nicht möglich, ein Konto mit einem Saldo ungleich Null zu löschen.",
      ],
      "Account deletion": ["Kontolöschung"],
      "there was an error reading the balance": [
        "Beim Lesen des Saldos ist ein Fehler aufgetreten",
      ],
      "Can't delete the account": [
        "Es war nicht möglich, das Konto zu löschen",
      ],
      "The account can't be deleted while still holding some balance. First make sure that the owner makes a complete cashout.":
        [
          "Das Konto kann nicht gelöscht werden, solange es noch ein Guthaben aufweist. Bitte sorgen Sie dafür, dass der Konteninhaber eine vollständige Auszahlung auf das eigene Bankkonto durchführt.",
        ],
      "Go back": ["Zurück"],
      'Delete account "%1$s"': ["Konto „%1$s“ löschen"],
      "This action cannot be undone": [
        "Diese Aktion kann nicht rückgängig gemacht werden",
      ],
      "All account data will be permanently removed.": [
        "Alle Kontodaten werden dauerhaft entfernt.",
      ],
      "Verification": ["Überprüfung"],
      "Enter the account name that is going to be deleted": [
        "Zum Löschen geben Sie den Namen des Kontos an",
      ],
      "Withdraw without setting amount": ["Abheben ohne festgelegten Betrag"],
      "Show install wallet first": ["Hilfstext: Zuerst Wallet installieren"],
      "Introduction": ["Einführung"],
      "Bank": ["Bank"],
      "Essay Shop": ["Essay-Shop"],
      "Donations": ["Spenden"],
      "GNU Taler logo": ["GNU-Taler-Logo"],
      "Withdraw toy currency into your GNU Taler wallet.": [
        "Heben Sie Spielgeld in Ihre GNU-Taler-Wallet ab.",
      ],
      "Demo pages": ["Demo-Seiten"],
      "You were signed out locally, but the bank could not confirm that the server token was revoked. Close other sessions or sign in again to review active tokens.":
        [
          "Sie wurden lokal abgemeldet, aber die Bank konnte nicht bestätigen, dass das Server-Token widerrufen wurde. Schliessen Sie andere Sitzungen oder melden Sie sich erneut an, um aktive Tokens zu prüfen.",
        ],
      "Dismiss": ["Ausblenden"],
      "Public accounts": ["Öffentliche Konten"],
      "Open interface preferences": ["Oberflächeneinstellungen öffnen"],
      "Interface preferences": ["Oberflächeneinstellungen"],
      "Choose how this bank interface behaves on this browser.": [
        "Legen Sie fest, wie sich diese Bankoberfläche in diesem Browser verhält.",
      ],
      "Close interface preferences": ["Oberflächeneinstellungen schliessen"],
      "Show debug information": ["Debug-Informationen anzeigen"],
      "Done": ["Fertig"],
      "Welcome": ["Willkommen"],
      "Welcome, %1$s": ["Herzlich willkommen, %1$s"],
      "Failed to load conversion rate.": [
        "Der Umrechnungskurs konnte nicht geladen werden.",
      ],
      "Not enough permission to access the conversion rate list.": [
        "Keine ausreichende Berechtigung für den Zugriff auf die Liste der Umrechnungskurse.",
      ],
      "The conversion-rate list was not found. Conversion may not be supported.":
        [
          "Die Umrechnungskursliste wurde nicht gefunden. Möglicherweise wird die Umrechnung nicht unterstützt.",
        ],
      "Conversion list not implemented.": [
        "Umrechnungsliste nicht implementiert.",
      ],
      "Conversion rate classes": ["Umrechnungskurs-Klassen"],
      "Configure different cash-in and cashout terms for groups of accounts.": [
        "Unterschiedliche Einzahlungs- und Auszahlungsbedingungen für Kontogruppen konfigurieren.",
      ],
      "Default conversion rate": ["Standardumrechnungskurs"],
      "Create conversion rate class": ["Umrechnungskurs-Klasse erstellen"],
      "No conversion rate classes": ["Keine Umrechnungskursklassen"],
      "All accounts currently use the default conversion rate.": [
        "Derzeit verwenden alle Konten den Standardumrechnungskurs.",
      ],
      "Name": ["Name"],
      "Description": ["Beschreibung"],
      "Cashin": ["Einzahlung"],
      "First page": ["Erste Seite"],
      "Next": ["Weiter"],
      "min:": ["Min.:"],
      "fee:": ["Gebühr:"],
      "only admin can setup conversion": [
        "Nur ein Administrator kann Umrechnungskurse einrichten",
      ],
      "Failed to calculate cashout fee.": [
        "Die Auszahlungsgebühr konnte nicht berechnet werden.",
      ],
      "Failed to update the conversion rate.": [
        "Der Umrechnungskurs konnte nicht aktualisiert werden.",
      ],
      "Wrong credentials": ["Ungültige Zugangsdaten"],
      "Conversion is disabled": ["Umrechnungen sind deaktiviert"],
      "Back to conversion settings": ["Zurück zu den Umrechnungseinstellungen"],
      "Review the default terms or choose a direction to update its settings.":
        [
          "Prüfen Sie die Standardbedingungen oder wählen Sie eine Richtung aus, deren Einstellungen Sie ändern möchten.",
        ],
      "Conversion view": ["Umrechnungsansicht"],
      "Details": ["Detail-Angaben"],
      "Cashout settings": ["Auszahlungseinstellungen"],
      "Cash-in settings": ["Einzahlungseinstellungen"],
      "Bad ratios": ["Das Verhältnis passt nicht"],
      "One ratio must be greater than or equal to 1, and the other must be less than or equal to 1.":
        [
          "Ein Verhältnis muss grösser oder gleich 1 sein, das andere kleiner oder gleich 1.",
        ],
      "Initial amount": ["Guthaben bei Erstanlage des Kontos"],
      "Use it to test how the conversion will affect the amount.": [
        "Hier testen Sie, um die Auswirkung des Umrechnungskurses auf einen Betrag zu prüfen.",
      ],
      "Sending to this bank": ["An diese Bank senden"],
      "Converted": ["Umgetauscht"],
      "Cashin after fee": ["Einzahlung nach Abzug von Gebühren"],
      "Sending from this bank": ["Senden von dieser Bank"],
      "Cashout after fee": ["Auszahlung nach Abzug von Gebühren"],
      "Bad configuration": ["Fehlerhafte Konfiguration"],
      "This configuration allows users to cash out more of what has been cashed in.":
        [
          "Diese Einstellung erlaubt Nutzern, höhere Beträge auf ihre Konten einzuzahlen als sie eingenommen haben.",
        ],
      "Must be > 0": ["Muss > 0 sein"],
      "Ratio": ["Verhältnis"],
      "Zero": ["Null"],
      "Up": ["Aufrunden"],
      "Nearest": ["Am nächsten"],
      "Minimum amount": ["Minimaler Betrag"],
      "Only cashout operations above this threshold will be allowed.": [
        "Nur Auszahlungen oberhalb dieses Schwellenwerts sind zulässig.",
      ],
      "Conversion ratio between currencies": [
        "Umrechnungsverhältnis zwischen den Währungen",
      ],
      "Example conversion": ["Beispiel einer Währungsumrechnung"],
      "1 %1$s will be converted into %2$s %3$s": [
        "1 %1$s wird getauscht zu %2$s %3$s",
      ],
      "Tiny amount": ["Kleinstbetrag"],
      "Rounding mode": ["Rundungsmethode"],
      "Amount will be rounded below to the largest possible value smaller than the input.":
        [
          "Der Betrag wird auf den grösstmöglichen Wert abgerundet, der kleiner als die Eingabe ist.",
        ],
      "Amount will be rounded up to the smallest possible value larger than the input.":
        [
          "Der Betrag wird auf den geringstmöglichen Wert aufgerundet, der grösser als die Eingabe ist.",
        ],
      "Amount will be rounded to the closest possible value.": [
        "Der Betrag wird auf den nächstmöglichen Wert gerundet.",
      ],
      'If none specified the fallback value is "%1$s ".': [
        'Falls nichts angegeben wird, ist der Standardwert "%1$s ".',
      ],
      "Examples": ["Beispiele"],
      "Rounding an amount of 1.24 with rounding value 0.1": [
        "Rundung eines Betrags von 1,24 mit Rundungswert 0,1",
      ],
      "Given the rounding value of 0.1 the possible values closest to 1.24 are: 1.1, 1.2, 1.3, 1.4.":
        [
          "Angesichts des Rundungswertes von 0,1 sind die möglichen Werte, die am nächsten an 1,24 liegen, folgende: 1.1, 1.2, 1.3, 1.4.",
        ],
      'With the "zero" mode the value will be rounded to 1.2': [
        "Mit der Methode „Null“ wird der Wert auf 1,2 gerundet",
      ],
      'With the "nearest" mode the value will be rounded to 1.2': [
        "Mit der Methode „Nähestens“ wird der Wert auf 1,2 gerundet",
      ],
      'With the "up" mode the value will be rounded to 1.3': [
        "Mit der Methode „Aufrunden“ wird der Wert auf 1,3 gerundet",
      ],
      "Rounding an amount of 1.26 with rounding value 0.1": [
        "Rundung eines Betrags von 1,26 mit Rundungswert 0,1",
      ],
      'With the "nearest" mode the value will be rounded to 1.3': [
        "Mit der Methode „Nähestens“ wird der Wert auf 1,3 gerundet",
      ],
      "Rounding an amount of 1.24 with rounding value 0.3": [
        "Rundung eines Betrags von 1,24 mit Rundungswert 0,3",
      ],
      "Given the rounding value of 0.3 the possible values closest to 1.24 are: 0.9, 1.2, 1.5, 1.8.":
        [
          "Mit einem Rundungswert von 0,3 sind die möglichen Werte, die am nächsten an 1,24 liegen, folgende: 0,9, 1,2, 1,5 und 1,8.",
        ],
      'With the "up" mode the value will be rounded to 1.5': [
        "Mit der Methode „Aufrunden“ wird der Wert auf 1,5 gerundet",
      ],
      "Rounding an amount of 1.26 with rounding value 0.3": [
        "Rundung eines Betrags von 1,26 mit Rundungswert 0,3",
      ],
      "Amount to be deducted before amount is credited.": [
        "Betrag, der vor der Gutschrift abzuziehen ist.",
      ],
      "Failed to load conversion details.": [
        "Die Umrechnungsdetails konnten nicht geladen werden.",
      ],
      "Conversion should be enabled in the configuration, the conversion rate should be initialized with fee(s), rates and a rounding mode.":
        [
          "Die Umrechnung sollte in der Konfiguration aktiviert sein, und der Umrechnungskurs sollte mit Gebühr(en), Kursen und einem Rundungsmodus initialisiert sein.",
        ],
      "Failed to delete conversion rate class": [
        "Die Umrechnungskurs-Klasse konnte nicht gelöscht werden",
      ],
      "Unauthorized": ["Unberechtigter Zugriff"],
      "Forbidden": ["Verboten"],
      "Conversion rate class was not found.": [
        "Die Umrechnungskursklasse wurde nicht gefunden.",
      ],
      "Deleting conversion rate classes is not supported by this bank.": [
        "Diese Bank unterstützt das Löschen von Umrechnungskursklassen nicht.",
      ],
      "Failed to update conversion rate class.": [
        "Die Umrechnungskurs-Klasse konnte nicht aktualisiert werden.",
      ],
      "Not Found": ["Nicht gefunden"],
      "Not implemented": ["Nicht implementiert"],
      "The name of the conversion is already used.": [
        "Der Name der Umrechnung wird bereits verwendet.",
      ],
      "Accounts": ["Konten"],
      "Test conversion": ["Umrechnung testen"],
      "Delete class": ["Klasse löschen"],
      "Manage this conversion rate class and the accounts assigned to it.": [
        "Verwalten Sie diese Umrechnungskursklasse und die ihr zugewiesenen Konten.",
      ],
      "Conversion rate class sections": ["Bereiche der Umrechnungskursklasse"],
      "identification": ["Kennung"],
      "Conversion rate class name": ["Name der Umrechnungskursklasse"],
      "Conversion rate class description": [
        "Beschreibung der Umrechnungskursklasse",
      ],
      "Users": ["Benutzer"],
      "Delete": ["Löschen"],
      "Failed to calculate the cashout fee.": [
        "Die Auszahlungsgebühr konnte nicht berechnet werden.",
      ],
      "Can't remove the conversion rate class": [
        "Die Umrechnungskurs-Klasse kann nicht entfernt werden",
      ],
      "There are some users associated with this class. You need to remove them first.":
        [
          "Dieser Klasse sind Benutzer zugeordnet. Sie müssen diese zuerst entfernen.",
        ],
      "You are going to remove the conversion rate class": [
        "Sie sind dabei, die Umrechnungskurs-Klasse zu entfernen",
      ],
      "This step can't be undone.": [
        "Dieser Schritt kann später nicht mehr rückgängig gemacht werden.",
      ],
      "Class": ["Klasse"],
      "Action": ["Aktion"],
      "Failed to update conversion class membership.": [
        "Die Zugehörigkeit zur Umrechnungsklasse konnte nicht aktualisiert werden.",
      ],
      "The account could not be updated. Please try again.": [
        "Das Konto konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.",
      ],
      "Conversion rate information is unavailable for these accounts.": [
        "Für diese Konten sind keine Umrechnungskursinformationen verfügbar.",
      ],
      "Failed to load users in conversion class.": [
        "Die Benutzer der Umrechnungskurs-Klasse konnten nicht geladen werden.",
      ],
      "Filters": ["Filter"],
      "Show from other classes": ["Aus anderen Klassen anzeigen"],
      "Account": ["Konto"],
      "Group ID": ["Gruppen-ID"],
      "No users in this conversion rate class": [
        "Keine Benutzer in dieser Umrechnungskurs-Klasse",
      ],
      "Remove": ["Entfernen"],
      "Add": ["Hinzufügen"],
      "Conversion rate name": ["Name des Umrechnungskurses"],
      "Short description of the class": ["Kurzbeschreibung der Klasse"],
      "Failed to create conversion class.": [
        "Die Umrechnungskurs-Klasse konnte nicht erstellt werden.",
      ],
      "New conversion rate class": ["Neue Umrechnungskurs-Klasse"],
      "Create a named set of conversion terms that can be assigned to accounts.":
        [
          "Erstellen Sie einen benannten Satz von Umrechnungsbedingungen, der Konten zugewiesen werden kann.",
        ],
      "Create class": ["Klasse erstellen"],
      "Failed to load public accounts.": [
        "Öffentliche Konten konnten nicht geladen werden.",
      ],
      "Browse transaction histories shared by public bank accounts.": [
        "Buchungsverläufe anzeigen, die von öffentlichen Bankkonten freigegeben wurden.",
      ],
      "No public accounts are available.": [
        "Es sind keine öffentlichen Konten verfügbar.",
      ],
      "View previous cashouts": ["Frühere Auszahlungen anzeigen"],
      "Cashout ID must be a number.": [
        "Die Auszahlungs-ID muss eine Zahl sein.",
      ],
      "Failed to load cashout details.": [
        "Die Auszahlungsdetails konnten nicht geladen werden.",
      ],
      "This cashout was not found. It may already have been aborted.": [
        "Diese Auszahlung wurde nicht gefunden. Möglicherweise wurde sie bereits abgebrochen.",
      ],
      "Back to cashout history": ["Zurück zum Auszahlungsverlauf"],
      "Amounts recorded for this completed cashout transfer.": [
        "Für diese abgeschlossene Auszahlung erfasste Beträge.",
      ],
      "Amount debited": ["Abgebuchter Betrag"],
      "Amount transferred": ["Überwiesener Betrag"],
      "Enter your full name.": ["Geben Sie Ihren vollständigen Namen ein."],
      "Repeat your password.": ["Passwort wiederholen"],
      "Create your bank account": ["Konto anlegen"],
      "Choose the credentials you will use to sign in.": [
        "Wählen Sie die Anmeldedaten, mit denen Sie sich anmelden.",
      ],
      "Already have an account?": ["Haben Sie bereits ein Konto?"],
      "Confirm password": ["Passwort bestätigen"],
      "Use between 8 and 64 characters. A longer, unique password is easier to keep secure.":
        [
          "Verwenden Sie 8 bis 64 Zeichen. Ein längeres, einmaliges Passwort lässt sich leichter sicher halten.",
        ],
      "Creating account…": ["Konto wird erstellt…"],
      "Check the account details and try again.": [
        "Prüfen Sie die Kontodaten und versuchen Sie es erneut.",
      ],
      "You are not authorized to create this account.": [
        "Sie sind nicht berechtigt, dieses Konto zu erstellen.",
      ],
      "Registration is unavailable because the bank cannot grant the account credit.":
        [
          "Die Registrierung ist nicht verfügbar, da die Bank dem Konto kein Guthaben gewähren kann.",
        ],
      "That username is reserved. Choose another username.": [
        "Dieser Benutzername ist reserviert. Wählen Sie einen anderen Benutzernamen.",
      ],
      "That username is already taken.": [
        "Dieser Nutzername ist leider bereits vergeben.",
      ],
      "That account ID is already taken.": [
        "Diese Konto-ID ist bereits vergeben.",
      ],
      "The bank is missing information for the selected authentication channel.":
        [
          "Es sind keine Informationen für das gewählte Authentifizierungsverfahren verfügbar.",
        ],
      "The selected authentication channel is not supported.": [
        "Das gewählte Authentifizierungsverfahren wird nicht unterstützt.",
      ],
      "Only an administrator may set the debt limit.": [
        "Nur ein Administrator ist befugt, die Kredithöhe festzulegen.",
      ],
      "Only an administrator may select a conversion rate class.": [
        "Nur ein Administrator darf eine Umrechnungskursklasse auswählen.",
      ],
      "The selected conversion rate class does not exist.": [
        "Die Umrechnungskurs-Klasse existiert nicht.",
      ],
      "Only an administrator may enable two-factor authentication while creating an account.":
        [
          "Nur ein Administrator darf beim Erstellen eines Kontos die Zwei-Faktor-Authentifizierung aktivieren.",
        ],
      "Account registration is unavailable": ["Kontoregistrierung"],
      "This bank is not accepting new account registrations.": [
        "Im Augenblick nimmt die Bank keine Neuregistrierungen an!",
      ],
      "Return to sign in": ["Zurück zur Anmeldung"],
      "Contact the bank administrator if you need an account.": [
        "Bitte wenden Sie sich an den Bankadministrator.",
      ],
      "Send money from this account to another bank account.": [
        "Geld von diesem Konto auf ein anderes Bankkonto überweisen.",
      ],
      "Failed to load withdrawal details.": [
        "Abhebungsdetails konnten nicht geladen werden.",
      ],
      "Choose amount": ["Betrag auswählen"],
      "Open wallet": ["Wallet öffnen"],
      "Review": ["Prüfen"],
      "Withdrawal progress": ["Fortschritt der Abhebung"],
      "Abort this withdrawal?": ["Diese Abhebung abbrechen?"],
      "This stops the withdrawal. No money will be transferred, and this operation cannot be resumed.":
        [
          "Dadurch wird die Abhebung abgebrochen. Es wird kein Geld überwiesen und dieser Vorgang kann nicht fortgesetzt werden.",
        ],
      "Keep withdrawal": ["Abhebung beibehalten"],
      "Abort withdrawal": ["Abhebung abbrechen"],
      'The payto URI returned by the server is invalid: "%1$s".': [
        'Der vom Server zurückgegebene Payto-URI ist ungültig: "%1$s".',
      ],
      'The withdrawal URI returned by the server is invalid: "%1$s".': [
        'Der vom Server zurückgegebene Auszahlungs-URI ist ungültig: "%1$s".',
      ],
      'The reserve public key returned by the server is invalid: "%1$s".': [
        'Der vom Server zurückgegebene öffentliche Reserveschlüssel ist ungültig: "%1$s".',
      ],
      "Enter an amount.": ["Geben Sie einen Betrag ein."],
      "Enter a valid amount.": ["Geben Sie einen gültigen Betrag ein."],
      "The amount must be greater than zero.": [
        "Der Betrag muss grösser als null sein.",
      ],
      "The amount is below the bank's minimum.": [
        "Der Betrag liegt unter dem Mindestbetrag der Bank.",
      ],
      "The amount is above the bank's maximum.": [
        "Der Betrag liegt über dem Höchstbetrag der Bank.",
      ],
      "Failed to abort the withdrawal.": [
        "Die Abhebung konnte nicht abgebrochen werden.",
      ],
      "The server did not understand the request.": [
        "Der Server hat die Anfrage nicht verstanden.",
      ],
      "The operation was not found.": [
        "Der Vorgang konnte nicht gefunden werden.",
      ],
      "The withdrawal operation has already been confirmed and cannot be aborted.":
        [
          "Der Abhebungsvorgang wurde bereits bestätigt und kann nicht abgebrochen werden.",
        ],
      "The bank could not be reached. Please try again.": [
        "Die Bank konnte nicht erreicht werden. Versuchen Sie es erneut.",
      ],
      "Withdrawal confirmation": ["Abhebungsbestätigung"],
      "Failed to confirm the withdrawal.": [
        "Die Abhebung konnte nicht bestätigt werden.",
      ],
      "The account does not have sufficient funds or the amount is outside the limits.":
        [
          "Das Konto verfügt nicht über ausreichendes Guthaben, oder der Betrag liegt ausserhalb der Grenzen.",
        ],
      "The withdrawal has been aborted and cannot be confirmed.": [
        "Die Abhebung wurde abgebrochen und kann nicht bestätigt werden.",
      ],
      "The wallet has not finished selecting an exchange account.": [
        "Die Wallet hat die Auswahl eines Exchange-Kontos noch nicht abgeschlossen.",
      ],
      "The withdrawal amount changed. Review the current amount and try again.":
        [
          "Der Abhebungsbetrag hat sich geändert. Prüfen Sie den aktuellen Betrag und versuchen Sie es erneut.",
        ],
      "Enter an amount before confirming the withdrawal.": [
        "Geben Sie vor der Bestätigung der Abhebung einen Betrag ein.",
      ],
      "Selected exchange": ["Ausgewählter Exchange"],
      "Sign in to confirm the withdrawal": [
        "Anmelden, um die Abhebung zu bestätigen",
      ],
      "Sign in as %1$s before reviewing and confirming this withdrawal.": [
        "Melden Sie sich als %1$s an, bevor Sie diese Abhebung prüfen und bestätigen.",
      ],
      "You are signed in as %1$s, but this withdrawal belongs to %2$s.": [
        "Sie sind als %1$s angemeldet, aber diese Abhebung gehört zu %2$s.",
      ],
      "Finish later": ["Später fortfahren"],
      "Confirm wallet withdrawal": ["Wallet-Abhebung bestätigen"],
      "Review how much will leave your bank account before confirming.": [
        "Prüfen Sie vor der Bestätigung, wie viel Ihr Bankkonto verlassen wird.",
      ],
      "Unsupported exchange account": ["Nicht unterstütztes Exchange-Konto"],
      "The exchange account does not use the transfer type configured by this bank. This withdrawal cannot be confirmed.":
        [
          "Das Exchange-Konto verwendet nicht die von dieser Bank konfigurierte Überweisungsart. Diese Abhebung kann nicht bestätigt werden.",
        ],
      "Withdrawal amount missing": ["Abhebungsbetrag fehlt"],
      "The bank did not provide an amount for this withdrawal. It cannot be confirmed.":
        [
          "Die Bank hat für diese Abhebung keinen Betrag angegeben. Sie kann nicht bestätigt werden.",
        ],
      "Bank amount configuration invalid": [
        "Die Betragskonfiguration der Bank ist ungültig",
      ],
      "The withdrawal amount and bank fee could not be combined safely. This withdrawal cannot be confirmed.":
        [
          "Abhebungsbetrag und Bankgebühr können nicht sicher zusammengeführt werden. Diese Abhebung kann nicht bestätigt werden.",
        ],
      "Wallet receives": ["Wallet erhält"],
      "Amount to your Taler Wallet": ["Betrag für Ihre Taler-Wallet"],
      "Allowed amount": ["Zulässiger Betrag"],
      "Maximum amount": ["Höchstbetrag"],
      "Amount unavailable": ["Betrag nicht verfügbar"],
      "From": ["Von"],
      "To": ["An"],
      "Taler Wallet": ["Taler-Wallet"],
      "Exchange": ["Exchange"],
      "Unavailable": ["Nicht verfügbar"],
      "Exchange details": ["Details des Exchange"],
      "Exchange IBAN": ["IBAN des Exchange"],
      "Bank hostname": ["Hostname der Bank"],
      "Exchange account": ["Exchange-Konto"],
      "No money is withdrawn until you confirm. You can finish this later from your account overview.":
        [
          "Bis zu Ihrer Bestätigung wird kein Geld abgehoben. Sie können den Vorgang später in Ihrer Kontoübersicht fortsetzen.",
        ],
      "Confirm withdrawal": ["Abhebung bestätigen"],
      "Unauthorized to make the operation, maybe the session has expired or the password changed.":
        [
          "Sie sind nicht berechtigt, den Vorgang durchzuführen, vielleicht ist die Sitzung abgelaufen oder das Passwort wurde geändert.",
        ],
      "The operation was rejected due to insufficient funds.": [
        "Der Vorgang wurde wegen unzureichendem Guthaben zurückgewiesen.",
      ],
      "Withdrawal aborted": ["Abhebung abgebrochen"],
      "Withdrawal confirmed": ["Abhebung bestätigt"],
      "The bank transfer to the Taler exchange has been initiated. Your Taler Wallet will receive the withdrawn amount shortly.":
        [
          "Die Banküberweisung an den Taler Exchange wurde eingeleitet. Ihre Taler-Wallet erhält den abgehobenen Betrag in Kürze.",
        ],
      "Back to account": ["Zurück zum Konto"],
      "Complete withdrawal with your Taler Wallet": [
        "Abhebung mit Ihrer Taler-Wallet abschliessen",
      ],
      "Scan this QR code with your Taler Wallet. Your wallet will select an exchange and prepare the withdrawal.":
        [
          "Scannen Sie diesen QR-Code mit Ihrer Taler-Wallet. Ihre Wallet wählt einen Exchange aus und bereitet die Abhebung vor.",
        ],
      "Withdrawal amount": ["Abhebungsbetrag"],
      "Suggested amount": ["Vorgeschlagener Betrag"],
      "You can change this amount in your wallet.": [
        "Sie können diesen Betrag in Ihrer Wallet ändern.",
      ],
      "QR code to continue the withdrawal in a Taler Wallet.": [
        "QR-Code, um die Abhebung in einer Taler-Wallet fortzusetzen.",
      ],
      "Open Taler Wallet manually": ["Taler-Wallet manuell öffnen"],
      "Don't have a Taler Wallet?": ["Sie haben noch keine Taler-Wallet?"],
      "Get a wallet": ["Wallet herunterladen"],
      "No money will be transferred until you return here to review and confirm the withdrawal.":
        [
          "Es wird kein Geld überwiesen, bis Sie hierher zurückkehren, um die Abhebung zu prüfen und zu bestätigen.",
        ],
      "Sign in to abort this withdrawal": [
        "Anmelden, um diese Abhebung abzubrechen",
      ],
      "The withdrawal operation has been confirmed previously and can not be aborted.":
        [
          "Der Abhebungsvorgang wurde bereits zuvor bestätigt und kann nicht abgebrochen werden.",
        ],
      "Withdrawal ready for confirmation": ["Abhebung kann bestätigt werden"],
      "Withdrawal waiting for your wallet": ["Abhebung wartet auf Ihre Wallet"],
      "The pending withdrawal could not be checked": [
        "Die ausstehende Abhebung konnte nicht geprüft werden",
      ],
      "Checking the pending withdrawal…": [
        "Ausstehende Abhebung wird geprüft…",
      ],
      "Review withdrawal": ["Abhebung prüfen"],
      "Retry": ["Erneut versuchen"],
      "Resume withdrawal": ["Abhebung fortsetzen"],
      "Finish or abort this withdrawal before starting another one.": [
        "Schliessen Sie diese Abhebung ab oder brechen Sie sie ab, bevor Sie eine neue beginnen.",
      ],
      "Dashboard": ["Übersicht"],
      "Admin activity": ["Administratoraktivität"],
      "Conversion": ["Umrechnung"],
      "My account": ["Mein Konto"],
      "Bank administration": ["Bankverwaltung"],
      "Failed to load the account list.": [
        "Die Kontoliste konnte nicht geladen werden.",
      ],
      "Search accounts": ["Konten durchsuchen"],
      "Search by username or name": ["Nach Benutzername oder Name suchen"],
      "Search": ["Suchen"],
      "Clear": ["Leeren"],
      "Unknown": ["Unbekannt"],
      "Change password": ["Passwort ändern"],
      "Previous": ["Zurück"],
      "The amount exceeds what is available to withdraw.": [
        "Der Betrag übersteigt den verfügbaren Höchstbetrag für die Abhebung.",
      ],
      "The server replied with an invalid taler://withdraw URI": [
        "Der Server antwortete mit einem ungültigen taler://withdraw URI",
      ],
      "Withdraw URI: %1$s": ["Abhebe-URI: %1$s"],
      "Failed to create the withdrawal.": [
        "Die Abhebung konnte nicht erstellt werden.",
      ],
      "The operation was rejected due to insufficient funds": [
        "Der Vorgang wurde wegen unzureichendem Guthaben zurückgewiesen",
      ],
      "Please sign in again.": ["Bitte melden Sie sich erneut an."],
      "Choose an amount. Next, open your wallet and return here to review and confirm the withdrawal.":
        [
          "Wählen Sie einen Betrag aus. Öffnen Sie danach Ihre Wallet und kehren Sie hierher zurück, um die Abhebung zu prüfen und zu bestätigen.",
        ],
      "Unable to calculate the withdrawal amount": [
        "Der Abhebungsbetrag konnte nicht berechnet werden",
      ],
      "The bank's withdrawal limits or fee are configured incorrectly.": [
        "Die Abhebungslimits oder die Gebühr der Bank sind falsch konfiguriert.",
      ],
      "Maximum withdrawal": ["Maximaler Abhebungsbetrag"],
      "There is not enough available balance to cover a withdrawal and the bank fee.":
        [
          "Das verfügbare Guthaben reicht nicht für eine Abhebung und die Bankgebühr aus.",
        ],
      "Use maximum available": ["Verfügbaren Höchstbetrag verwenden"],
      "No money moves until you review and confirm the withdrawal.": [
        "Es wird kein Geld bewegt, bevor Sie die Abhebung geprüft und bestätigt haben.",
      ],
      "Need a Taler Wallet?": ["Benötigen Sie eine Taler-Wallet?"],
      "Get the wallet": ["Wallet herunterladen"],
      "Dismiss wallet installation hint": [
        "Hinweis zur Wallet-Installation schliessen",
      ],
      "Continue to wallet": ["Weiter zur Wallet"],
      "Unable to start a withdrawal.": [
        "Die Abhebung konnte nicht gestartet werden.",
      ],
      "Your account was created. Sign in to continue.": [
        "Ihr Konto wurde erstellt. Melden Sie sich an, um fortzufahren.",
      ],
      "Conversion rate class ID “%1$s” is not a number.": [
        "Die ID der Umrechnungskursklasse „%1$s“ ist keine Zahl.",
      ],
      "Home": ["Startseite"],
      "Page not found": ["Seite nicht gefunden"],
      "The requested bank page does not exist.": [
        "Die angeforderte Bankseite existiert nicht.",
      ],
      "Unknown challenge.": ["Unbekannte Challenge."],
      "Failed to validate the verification code.": [
        "Der Bestätigungscode konnte nicht validiert werden.",
      ],
      "Too many challenges are active. Wait or confirm an existing challenge.":
        [
          "Derzeit sind zu viele Challenges aktiv. Sie müssen warten oder die aktuellen Challenges bestätigen.",
        ],
      "The verification code is incorrect.": [
        "Der Bestätigungscode ist falsch.",
      ],
      "The verification code has expired.": [
        "Der Bestätigungscode ist abgelaufen.",
      ],
      "Submit the transmitted code number.": [
        "Übermittelte Codenummer eingeben.",
      ],
      "The verification code sent to the email address starting with %1$s": [
        "Der Bestätigungscode wurde an die E-Mail-Adresse gesendet, die mit %1$s beginnt",
      ],
      "The verification code sent to the phone number ending with %1$s": [
        "Der Bestätigungscode wurde an die Telefonnummer gesendet, die mit %1$s endet",
      ],
      "Code": ["Code"],
      "Authentication code": ["Authentifizierungscode"],
      "It will expire at %1$s": ["Ende der Gültigkeit %1$s"],
      "This challenge is terminal and cannot be retransmitted.": [
        "Diese Authentifizierungsanforderung ist abgeschlossen und kann nicht erneut übertragen werden.",
      ],
      "Restart authentication": ["Authentifizierung neu starten"],
      "Back": ["Zurück"],
      "Verifying…": ["Wird überprüft…"],
      "Verify": ["Überprüfen"],
      "Complete": ["Abschliessen"],
      "Failed to start the challenge.": [
        "Die Challenge konnte nicht gestartet werden.",
      ],
      "Unable to send the verification code.": [
        "Der Bestätigungscode konnte nicht gesendet werden.",
      ],
      "The request was valid, but the server is refusing action.": [
        "Die Anfrage war gültig, aber der Server verweigert die Bearbeitung.",
      ],
      "The backend is not aware of the specified MFA challenge.": [
        "Dem Backend ist die angegebene Multi-Faktor-Überprüfung nicht bekannt.",
      ],
      "It is too early to request another transmission of the challenge.": [
        "Es muss noch gewartet werden, um eine weitere Übertragung des Überprüfungscodes zu verlangen.",
      ],
      "Code transmission failed.": ["Die Code-Übertragung ist fehlgeschlagen."],
      "Multi-factor authentication required": [
        "Multi-Faktor-Authentifizierung erforderlich",
      ],
      "This operation is protected with second factor authentication. In order to complete it we need to verify your identity using the authentication channel you provided.":
        [
          "Dieser Vorgang wird durch eine Zwei-Faktor-Authentifizierung geschützt. Um ihn abschliessen zu können, müssen wir Ihre Identität durch das von Ihnen gewählte Authentifizierungsverfahren überprüfen.",
        ],
      "The next challenge needs to be completed to confirm the operation.": [
        "Die nächste Challenge muss abgeschlossen werden, um den Vorgang zu bestätigen.",
      ],
      "All the next challenges need to be completed to confirm the operation.":
        [
          "Alle folgenden Challenges müssen abgeschlossen werden, um den Vorgang zu bestätigen.",
        ],
      "One of the next challenges needs to be completed to confirm the operation.":
        [
          "Eine der folgenden Challenges muss abgeschlossen werden, um den Vorgang zu bestätigen.",
        ],
      'To a phone ending with "%1$s"': [
        'An eine Telefonnummer, die mit "%1$s" endet',
      ],
      'To an email starting with " %1$s"': [
        'An eine E-Mail-Adresse, die mit " %1$s" beginnt',
      ],
      "I have a code": ["Ich habe bereits einen gültigen Bestätigungscode"],
      "Send me a message": ["Bestätigungscode zusenden"],
      "You have to wait until %1$s to send a new code.": [
        "Sie müssen bis %1$s warten, damit ein neuer Bestätigungscode gesendet werden kann.",
      ],
      "Use configured value (enabled)": [
        "Konfigurierten Wert verwenden (aktiviert)",
      ],
      "Use configured value (disabled)": [
        "Konfigurierten Wert verwenden (deaktiviert)",
      ],
      "Force enabled": ["Aktivierung erzwingen"],
      "Force disabled": ["Deaktivierung erzwingen"],
      "Enter a valid HTTP or HTTPS URL.": [
        "Geben Sie eine gültige HTTP- oder HTTPS-URL ein.",
      ],
      "Development settings": ["Entwicklungseinstellungen"],
      "These overrides are stored only in this browser.": [
        "Diese Überschreibungen werden nur in diesem Browser gespeichert.",
      ],
      "Corebank API base URL": ["Corebank-API-Basis-URL"],
      "Leave empty to use the configured URL: %1$s": [
        "Leer lassen, um die konfigurierte URL zu verwenden: %1$s",
      ],
      "Leave empty to derive the URL from this page.": [
        "Leer lassen, um die URL aus dieser Seite abzuleiten.",
      ],
      "Demo header": ["Demo-Kopfbereich"],
      "Control whether the demo header is shown in this browser.": [
        "Legt fest, ob der Demo-Kopfbereich in diesem Browser angezeigt wird.",
      ],
      "Control whether public account links are shown in this browser.": [
        "Legt fest, ob Links zu öffentlichen Konten in diesem Browser angezeigt werden.",
      ],
      "Overrides saved.": ["Überschreibungen gespeichert."],
      "Apply overrides": ["Überschreibungen anwenden"],
      "Clear overrides": ["Überschreibungen löschen"],
      "Back to bank": ["Zurück zur Bank"],
    },
  },
  domain: "messages",
  plural_forms: "nplurals=2; plural=n != 1;",
  lang: "de-CH",
  completeness: 100,
};

strings["ca"] = {
  locale_data: {
    messages: {
      "": {
        domain: "messages",
        lang: "ca",
        plural_forms: "nplurals=2; plural=n != 1;",
      },
      "Hide password": ["Amaga la contrasenya"],
      "Show password": ["Mostra la contrasenya"],
      "Hide": ["Amaga"],
      "Show": ["Mostra"],
      "Identity verification.": ["Verificació d'identitat."],
      "You do not have permission to access this account.": [
        "No teniu permís per accedir a aquest compte.",
      ],
      "This account is locked. Contact the bank administrator.": [
        "El compte està bloquejat i no pot iniciar sessió. Contacteu amb l'administrador.",
      ],
      "The password is incorrect.": ["La contrasenya és incorrecta."],
      "Account not found.": ["Compte no trobat"],
      "Could not reach the bank. Check your connection and try again.": [
        "No s’ha pogut contactar amb el banc. Comproveu la connexió i torneu-ho a provar.",
      ],
      "Confirm your password": ["Confirmeu la contrasenya"],
      "Sign in to %1$s": ["Inicia la sessió a %1$s"],
      "Enter the password for %1$s to continue.": [
        "Introduïu la contrasenya de %1$s per continuar.",
      ],
      "Use your bank account credentials to continue.": [
        "Utilitzeu les credencials del vostre compte bancari per continuar.",
      ],
      "Need an account?": ["Necessiteu un compte?"],
      "Create one": ["Crear un compte"],
      "Your session expired. Confirm your password to continue.": [
        "La sessió ha caducat. Confirmeu la contrasenya per continuar.",
      ],
      "Username": ["Nom d'usuari"],
      "Password": ["Contrasenya"],
      "Sign out": ["Tanca la sessió"],
      "Signing in…": ["S’està iniciant la sessió…"],
      "Continue": ["Continuar"],
      "Sign in": ["Inicia la sessió"],
      "Enter your username.": ["Introduïu el nom d’usuari."],
      "Use letters, numbers, or any of these characters: - . _ ~": [
        "Utilitzeu lletres, xifres o qualsevol d'aquests caràcters: - . _ ~",
      ],
      "The username must not exceed 126 characters.": [
        "El nom d’usuari no pot superar els 126 caràcters.",
      ],
      "Enter your password.": ["Introduïu la contrasenya."],
      "The password must contain at least 8 characters.": [
        "La contrasenya és massa curta. No pot tenir menys de 8 caràcters.",
      ],
      "The password must not exceed %1$s characters.": [
        "La contrasenya no pot superar els %1$s caràcters.",
      ],
      "IBAN country code not found": [
        "No s'ha trobat el codi de país de l'IBAN",
      ],
      "IBAN length is invalid for this country": [
        "La longitud de l'IBAN no és vàlida per a aquest país",
      ],
      "The IBAN contains invalid characters": [
        "L'IBAN conté caràcters no vàlids",
      ],
      "IBAN number is not valid, checksum is wrong": [
        "El número IBAN no és vàlid, la suma de verificació és incorrecta",
      ],
      "The IBAN is not valid": ["L'IBAN no és vàlid"],
      "Use letters, numbers or any of these characters: - . _ ~": [
        "Utilitzeu lletres, xifres o qualsevol d'aquests caràcters: - . _ ~",
      ],
      "Failed to load cashouts.": ["No s'han pogut carregar els cashouts."],
      "Try again": ["Torneu-ho a provar"],
      "Cashout is disabled": ["El cashout està desactivat"],
      "Cashout should be enabled in the configuration, the conversion rate should be initialized with fee(s), rates and a rounding mode.":
        [
          "El cashout s'ha d'habilitar a la configuració; el tipus de conversió s'ha d'inicialitzar amb comissió(ns), taxes i un mode d'arrodoniment.",
        ],
      "Failed to load conversion rate information.": [
        "No s'ha pogut carregar la informació del tipus de conversió.",
      ],
      "Some cashout details could not be loaded.": [
        "No s'han pogut carregar alguns detalls dels cashouts.",
      ],
      "The partial list omits cashout IDs: %1$s.": [
        "La llista parcial omet aquests identificadors de cashout: %1$s.",
      ],
      "Debited": ["Debitat"],
      "Transferred": ["Transferit"],
      "Created": ["Creat"],
      "Actions": ["Accions"],
      "Cashout history": ["Historial de reintegraments"],
      "Profile": ["Perfil"],
      "Security": ["Seguretat"],
      "Merchant integration": ["Integració del comerciant"],
      "Back to overview": ["Torna a la vista general"],
      "My account settings": ["Configuració del meu compte"],
      "Copy": ["Copia"],
      "Failed to load account details.": [
        "No s'han pogut carregar els detalls del compte.",
      ],
      'Use this information to link your Taler Merchant Backoffice account with the current bank account. You can start by copying the values, then go to your merchant backoffice service provider, login into your account and look for the "import" button in the "bank account" section.':
        [
          "Utilitzeu aquesta informació per vincular el vostre compte del Taler Merchant Backoffice amb el compte bancari actual. Podeu començar copiant els valors i, després, anar al vostre proveïdor de serveis de backoffice de comerciant, iniciar sessió al vostre compte i cercar el botó «importar» a la secció «compte bancari».",
        ],
      "Not available": ["No disponible"],
      "Merchant integration is not available for this account.": [
        "La integració amb comerciants no està disponible per a aquest compte.",
      ],
      "Account type": ["Tipus de compte"],
      "Method to use for wire transfer.": [
        "Mètode a utilitzar per a la transferència bancària.",
      ],
      "IBAN": ["IBAN"],
      "International Bank Account Number.": [
        "Número de compte bancari internacional.",
      ],
      "Bank host": ["Servidor del banc"],
      "Bank host where the service is located.": [
        "Amfitrió del banc on es troba el servei.",
      ],
      "Account name": ["Nom del compte"],
      "Bank account identifier for wire transfers.": [
        "Identificador del compte bancari per a transferències.",
      ],
      "Address": ["Adreça"],
      "Bitcoin address for this account.": [
        "Adreça de Bitcoin d'aquest compte.",
      ],
      "Account address": ["Adreça del compte"],
      "Owner's name": ["Nom del titular"],
      "Legal name of the person holding the account.": [
        "Nom legal de la persona titular del compte.",
      ],
      "Account info URL": ["URL d'informació del compte"],
      "From where the merchant can download information about incoming wire transfers to this account.":
        [
          "D'on el comerciant pot descarregar informació sobre les transferències entrants a aquest compte.",
        ],
      "Unable to create a cashout": ["No s'ha pogut crear el cashout"],
      "The bank configuration does not support cashout operations.": [
        "La configuració del banc no admet operacions de cashout.",
      ],
      "Close": ["Tancar"],
      "The bank returned incomplete conversion information.": [
        "El banc ha retornat informació de conversió incompleta.",
      ],
      "Please contact the bank administrator.": [
        "Poseu-vos en contacte amb l'administrador del banc.",
      ],
      "Authentication required": ["Cal autenticació"],
      "Please sign in to create a cashout.": [
        "Inicieu la sessió per crear un cashout.",
      ],
      "Failed to calculate the conversion fee.": [
        "No s'ha pogut calcular la comissió de conversió.",
      ],
      "The amount is too small": ["La quantitat és massa petita"],
      "Conversion is not implemented.": ["La conversió no està implementada."],
      "The currency is not supported": ["La divisa no és compatible"],
      "Required": ["Obligatori"],
      "Invalid": ["No vàlid"],
      "The balance is not sufficient": ["El saldo no és suficient"],
      "It is not possible to cash out less than %1$s: %2$s": [
        "No es pot fer un cashout de menys de %1$s: %2$s",
      ],
      "The total transfer to the destination will be zero": [
        "La transferència total a la destinació serà zero",
      ],
      "Failed to create the cashout.": ["No s'ha pogut crear el cashout."],
      "Cashout": ["Cashout"],
      "Account not found": ["Compte no trobat"],
      "Duplicate request detected, check if the operation succeeded or try again.":
        [
          "S'ha detectat una sol·licitud duplicada; comproveu si l'operació ha tingut èxit o torneu-ho a provar.",
        ],
      "The conversion rate was applied incorrectly": [
        "El tipus de conversió s'ha aplicat incorrectament",
      ],
      "The account does not have sufficient funds": [
        "El compte no té fons suficients",
      ],
      "Missing cashout URI in the profile": [
        "Falta l'URI de cashout al perfil",
      ],
      "The amount is below the minimum amount permitted.": [
        "La quantitat és inferior a la quantitat mínima permesa.",
      ],
      "Sending the confirmation message failed, retry later or contact the administrator.":
        [
          "L'enviament del missatge de confirmació ha fallat; torneu-ho a provar més tard o contacteu amb l'administrador.",
        ],
      "The server doesn't support the current TAN channel.": [
        "El servidor no admet el canal TAN actual.",
      ],
      "Conversion rate": ["Tipus de conversió"],
      "Balance": ["Saldo"],
      "Fee": ["Comissió"],
      "No fee": ["Sense comissió"],
      "To account": ["Al compte"],
      "Legal name": ["Nom legal"],
      "If this name doesn't match the account holder's name, your transaction may fail.":
        [
          "Si aquest nom no coincideix amb el del titular del compte, és possible que la transacció falli.",
        ],
      "Unable to cash out": ["No es pot fer el cashout"],
      "Before being able to cash out to a bank account, you need to complete your profile":
        [
          "Abans de poder fer un cashout a un compte bancari, heu de completar el vostre perfil",
        ],
      "Send %1$s": ["Enviar %1$s"],
      "Receive %1$s": ["Rebre %1$s"],
      "Amount": ["Quantitat"],
      "Total cost": ["Cost total"],
      "Balance left": ["Saldo restant"],
      "Before fee": ["Abans de la comissió"],
      "Total cashout transfer": ["Transferència total del cashout"],
      "Cancel": ["Cancel·lar"],
      "Cash out": ["Fer un cashout"],
      "Not valid": ["No vàlid"],
      "Does not follow the pattern": ["No segueix el patró"],
      "The request was invalid or the payto://-URI used unacceptable features.":
        [
          "La sol·licitud no era vàlida o l'URI payto:// utilitzava característiques inacceptables.",
        ],
      "Not enough permission to complete the operation.": [
        "No hi ha permisos suficients per completar l'operació.",
      ],
      "The bank administrator cannot be the transfer creditor.": [
        "L'administrador del banc no pot ser el creditor de la transferència.",
      ],
      'The destination account "%1$s" was not found.': [
        "No s'ha trobat el compte de destinació «%1$s».",
      ],
      "The origin and the destination of the transfer can't be the same.": [
        "L'origen i la destinació de la transferència no poden ser els mateixos.",
      ],
      "Your balance is not sufficient for the operation.": [
        "El vostre saldo no és suficient per a l'operació.",
      ],
      'The origin account "%1$s" was not found.': [
        "No s'ha trobat el compte d'origen «%1$s».",
      ],
      "The attempt to create the transaction has failed. Please try again.": [
        "L'intent de crear la transacció ha fallat. Torneu-ho a provar.",
      ],
      "Confirm transaction.": ["Confirmar la transacció."],
      "Enter the recipient, a reference, and the amount to send.": [""],
      "Maximum transfer": ["Transferència màxima"],
      "Debt limit": ["Límit de deute"],
      "This is not your account balance. This account cannot go into debt.": [
        "Això no és el saldo del vostre compte. Aquest compte no pot quedar en descobert.",
      ],
      "This is not your account balance. It includes borrowing up to the debt limit shown here.":
        [
          "Això no és el saldo del vostre compte. Inclou el crèdit disponible fins al límit de deute que es mostra aquí.",
        ],
      "Recipient": ["Destinatari"],
      "username": ["nom d'usuari"],
      "IBAN of the recipient's account": ["IBAN del compte del destinatari"],
      "What is this transfer for?": [""],
      "Paste a payto URI containing the recipient, amount, and transfer reference.":
        [""],
      "Uniform resource identifier of the target account": [
        "Identificador uniforme de recurs del compte de destinació",
      ],
      "payto://x-taler-bank/[bank-host]/[receiver-account]?message=[subject]&amount=[%1$s:X.Y]":
        [
          "payto://x-taler-bank/[bank-host]/[receiver-account]?message=[subject]&amount=[%1$s:X.Y]",
        ],
      "payto://iban/[receiver-iban]?message=[subject]&amount=[%1$s:X.Y]": [
        "payto://iban/[receiver-iban]?message=[subject]&amount=[%1$s:X.Y]",
      ],
      "Bank fee": ["Comissió bancària"],
      "Total debited": ["Total carregat"],
      "Need to move money out of this bank?": [""],
      'Only "x-taler-bank" targets are supported': [
        "Només s'admeten destinacions «x-taler-bank»",
      ],
      'Only this host is allowed. Use "%1$s"': [
        "Només es permet aquest amfitrió. Utilitzeu «%1$s»",
      ],
      "Account name is missing": ["Falta el nom del compte"],
      'Only "IBAN" targets are supported': [
        "Només s'admeten destinacions «IBAN»",
      ],
      'Missing "amount" parameter to specify the amount to be transferred': [
        "Falta el paràmetre «amount» per especificar la quantitat a transferir",
      ],
      'The "amount" parameter is not valid': [
        "El paràmetre «amount» no és vàlid",
      ],
      '"message" parameters to specify a reference text for the transfer are missing':
        [
          "Falten els paràmetres «message» per especificar un text de referència per a la transferència",
        ],
      'The only currency allowed is "%1$s"': [
        "L'única divisa permesa és «%1$s»",
      ],
      "You cannot transfer an amount of zero.": [
        "No podeu transferir una quantitat de zero.",
      ],
      "Please enter a longer subject": ["Introduïu un concepte més llarg"],
      "Email and SMS authentication were disabled because their contact details were removed.":
        [
          "L'autenticació per correu electrònic i per SMS s'ha desactivat perquè se n'han eliminat les dades de contacte.",
        ],
      "Email authentication was disabled because the email address was removed.":
        [
          "L'autenticació per correu electrònic s'ha desactivat perquè s'ha eliminat l'adreça electrònica.",
        ],
      "SMS authentication was disabled because the phone number was removed.": [
        "L'autenticació per SMS s'ha desactivat perquè s'ha eliminat el número de telèfon.",
      ],
      "Invalid email format": ["Format de correu electrònic no vàlid"],
      "Should start with +": ["Ha de començar amb +"],
      "A phone number consists of numbers only": [
        "Un número de telèfon només conté xifres",
      ],
      "Login username": ["Nom d'usuari d'accés"],
      "Account ID for authentication": ["ID de compte per a l'autenticació"],
      "Full name": ["Nom complet"],
      "Name of the account holder": ["Nom del titular del compte"],
      "Internal account": ["Compte intern"],
      "Copy and share this account address to receive transfers.": [
        "Copieu i compartiu aquesta adreça de compte per rebre transferències.",
      ],
      "Email": ["Correu electrònic"],
      "To be used when second factor authentication is enabled": [
        "S'utilitza quan l'autenticació de segon factor està habilitada",
      ],
      "Phone": ["Telèfon"],
      "Enable second factor authentication": [
        "Habilita l'autenticació de segon factor",
      ],
      "Using email": ["Mitjançant correu electrònic"],
      "Add an email in your profile to enable this option": [
        "Afegiu un correu electrònic al vostre perfil per habilitar aquesta opció",
      ],
      "Using SMS": ["Mitjançant SMS"],
      "Add a phone number in your profile to enable this option": [
        "Afegiu un número de telèfon al vostre perfil per habilitar aquesta opció",
      ],
      "Cashout account": ["Compte de cashout"],
      "External account to which cashout transfers are sent.": [""],
      "Max debt": ["Deute màxim"],
      "How much the balance can go below zero.": [
        "Fins a quin punt el saldo pot ser negatiu.",
      ],
      "Is this account public?": ["És aquest compte públic?"],
      "Public accounts expose their balance and complete transaction history, including subjects and both account addresses, to anonymous visitors.":
        [
          "Els comptes públics exposen el saldo i l'historial complet de transaccions, inclosos els conceptes i les adreces dels dos comptes, als visitants anònims.",
        ],
      "Does this account belong to a Payment Service Provider?": [
        "Pertany aquest compte a un proveïdor de serveis de pagament?",
      ],
      "Account updated": ["Compte actualitzat"],
      "Failed to update the account.": ["No s'ha pogut actualitzar el compte."],
      "The rights to change the account are not sufficient": [
        "No hi ha permisos suficients per canviar el compte",
      ],
      "The username was not found": ["No s'ha trobat el nom d'usuari"],
      "You can't change the legal name, please contact your account administrator.":
        [
          "No podeu canviar el nom legal; contacteu amb l'administrador del vostre compte.",
        ],
      "You can't change the debt limit, please contact your account administrator.":
        [
          "No podeu canviar el límit de deute; contacteu amb l'administrador del vostre compte.",
        ],
      "You can't change the cashout address, please contact your account administrator.":
        [
          "No podeu canviar l'adreça de cashout; contacteu amb l'administrador del vostre compte.",
        ],
      "No information for the selected authentication channel.": [
        "No hi ha informació per al canal d'autenticació seleccionat.",
      ],
      "Account update": ["Actualització del compte"],
      "Authentication channel is not supported.": [
        "El canal d'autenticació no és compatible.",
      ],
      "Only the administrator can change the conversion rate.": [
        "Només l'administrador pot canviar el tipus de conversió.",
      ],
      "The conversion rate class doesn't exist.": [
        "La classe de tipus de conversió no existeix.",
      ],
      "The password is too short. Can't have less than 8 characters.": [
        "La contrasenya és massa curta. No pot tenir menys de 8 caràcters.",
      ],
      "The password is too long. Can't have more than 64 characters.": [
        "La contrasenya és massa llarga. No pot tenir més de 64 caràcters.",
      ],
      'Account "%1$s"': ["Compte «%1$s»"],
      "Removed": ["Suprimit"],
      "This account can't be used.": ["Aquest compte no es pot utilitzar."],
      "Account details": ["Detalls del compte"],
      "Not configured": ["No configurat"],
      "Change details": ["Canviar les dades"],
      "Update": ["Actualitzar"],
      "Delete account": ["Suprimeix el compte"],
      "Permanently remove this bank account. The account must have a zero balance before it can be deleted.":
        [
          "Suprimeix permanentment aquest compte bancari. El compte ha de tenir saldo zero abans de poder-lo suprimir.",
        ],
      "The passwords do not match.": ["Les contrasenyes no coincideixen"],
      "Failed to update the password.": [
        "No s'ha pogut actualitzar la contrasenya.",
      ],
      "Not authorized to change the password, maybe the session is invalid.": [
        "No autoritzat a canviar la contrasenya; potser la sessió no és vàlida.",
      ],
      "You need to provide the old password. If you don't have it contact your account administrator.":
        [
          "Cal que proporcioneu la contrasenya antiga. Si no la teniu, contacteu amb l'administrador del vostre compte.",
        ],
      "The current password is incorrect, so the password cannot be changed.": [
        "",
      ],
      "Password update": ["Actualització de la contrasenya"],
      "You don't have the rights to change the password.": [
        "No teniu permisos per canviar la contrasenya.",
      ],
      "Update password": ["Actualitzar la contrasenya"],
      "Current password": ["Contrasenya actual"],
      "Your current password, for security": [
        "La vostra contrasenya actual, per seguretat",
      ],
      "New password": ["Contrasenya nova"],
      "Failed to load transactions.": [
        "No s'han pogut carregar les transaccions.",
      ],
      "Unknown account": ["Compte desconegut"],
      "Recent activity": ["Activitat recent"],
      "Transactions": ["Transaccions"],
      "Subject": ["Concepte"],
      "Today": ["Avui"],
      "Yesterday": ["Ahir"],
      "Invalid value": ["Valor no vàlid"],
      "View all transactions": ["Mostra totes les transaccions"],
      "No transactions yet.": ["Encara no hi ha transaccions."],
      "Your account activity will appear here.": [
        "L'activitat del teu compte apareixerà aquí.",
      ],
      "Date": ["Data"],
      "Counterparty": ["Contrapart"],
      "Pagination": ["Paginació"],
      "Newer": ["Més recents"],
      "Older": ["Més antigues"],
      "Withdraw to Taler Wallet": ["Retira a la cartera Taler"],
      "Move digital cash to your Taler Wallet.": [
        "Mou diners digitals a la teva cartera Taler.",
      ],
      "Send bank transfer": ["Envia una transferència bancària"],
      "Transfer money to another bank account.": [
        "Transfereix diners a un altre compte bancari.",
      ],
      "Convert regional currency and send it to your cashout account.": [
        "Converteix la moneda regional i envia-la al teu compte de reintegrament.",
      ],
      "Copy account address": ["Copia l’adreça del compte"],
      "Current balance": ["Saldo actual"],
      "Go to account details": ["Ves als detalls del compte"],
      "Failed to load the admin account.": [
        "No s'ha pogut carregar el compte d'administració.",
      ],
      "Admin account": ["Compte d'administració"],
      "Admin account activity": ["Activitat del compte d'administració"],
      "Failed to load the monitor info.": [
        "No s'ha pogut carregar la informació del monitor.",
      ],
      "Failed to load cashout info.": [
        "No s'ha pogut carregar la informació del cashout.",
      ],
      "Querying for the current stats failed": [
        "La consulta de les estadístiques actuals ha fallat",
      ],
      "The user is unauthorized": ["L'usuari no està autoritzat"],
      "Querying for the previous stats failed": [
        "La consulta de les estadístiques anteriors ha fallat",
      ],
      "Bank activity": ["Activitat bancària"],
      "Select a section": ["Selecciona una secció"],
      "Last hour": ["Última hora"],
      "Previous day": ["Dia anterior"],
      "Last month": ["Últim mes"],
      "Last year": ["Últim any"],
      "Tabs": ["Pestanyes"],
      "Last Year": ["Últim any"],
      "Trading volume from %1$s to %2$s": ["Volum d'operacions de %1$s a %2$s"],
      "Cash in": ["Entrada d'efectiu"],
      "Transferred from an external account to an account in this bank.": [
        "Transferit des d'un compte extern a un compte d'aquest banc.",
      ],
      "Transferred from an account in this bank to an external account.": [
        "Transferit des d'un compte d'aquest banc a un compte extern.",
      ],
      "Taler pay-in": ["Ingrés a Taler"],
      "Transferred from an account to a Taler exchange.": [
        "Transferit des d'un compte a un Proveïdor de canvi de Taler.",
      ],
      "Transfers": ["Transferències"],
      "Taler payout": ["Pagament de Taler"],
      "Transferred from a Taler exchange to another account.": [
        "Transferit des d'un Proveïdor de canvi de Taler a un altre compte.",
      ],
      "Download stats as CSV": ["Baixa les estadístiques en CSV"],
      "previous": ["anterior"],
      "Decreased by": ["Ha disminuït"],
      "Increased by": ["Ha augmentat"],
      'Account created with password "%1$s".': [
        'S\'ha creat el compte amb la contrasenya "%1$s".',
      ],
      "Failed to create a new account.": ["No s'ha pogut crear un compte nou."],
      "Server replied that phone or email is invalid": [
        "El servidor ha respost que el telèfon o el correu electrònic no és vàlid",
      ],
      "The rights to perform the operation are not sufficient": [
        "No hi ha permisos suficients per fer l'operació",
      ],
      "Account username is already taken": [
        "El nom d'usuari del compte ja està ocupat",
      ],
      "Account ID is already taken": ["L'ID del compte ja està ocupat"],
      "Bank ran out of bonus credit.": [
        "El banc s'ha quedat sense crèdit de bonificació.",
      ],
      "Only an administrator is allowed to set the debt limit.": [
        "Només un administrador pot establir el límit de deute.",
      ],
      "Only admin can create accounts with second factor authentication.": [
        "Només l'administrador pot crear comptes amb autenticació de segon factor.",
      ],
      "Can't create accounts": ["No es poden crear comptes"],
      "New bank account": ["Compte bancari nou"],
      "Create an account and configure its initial access and profile.": [""],
      "Create account": ["Crear un compte"],
      "Failed to download statistics.": [
        "No s'han pogut baixar les estadístiques.",
      ],
      "A statistics request failed. Please try again.": [
        "Una sol·licitud d'estadístiques ha fallat. Torneu-ho a provar.",
      ],
      "only admin can download stats": [
        "només l'administrador pot baixar les estadístiques",
      ],
      "Choose which reporting periods to include in the CSV file.": [""],
      "Include hour metric": ["Inclou la mètrica per hora"],
      "Include day metric": ["Inclou la mètrica diària"],
      "Include month metric": ["Inclou la mètrica mensual"],
      "Include year metric": ["Inclou la mètrica anual"],
      "Include table header": ["Inclou la capçalera de la taula"],
      "Add previous metric for comparison": [
        "Afegeix la mètrica anterior per comparar",
      ],
      "Fail on first error": ["Atura't en el primer error"],
      "Download": ["Baixar"],
      "Download completed with missing data": [
        "Baixada completada amb dades que falten",
      ],
      "Download completed": ["Baixada completada"],
      "%1$s statistics requests failed. The file contains only the data that could be retrieved. Click here to save it.":
        [
          "Han fallat %1$s sol·licituds d'estadístiques. El fitxer només conté les dades que s'han pogut obtenir. Feu clic aquí per desar-lo.",
        ],
      "Click here to save the file on your computer.": [
        "Feu clic aquí per desar el fitxer a l'ordinador.",
      ],
      "Name doesn't match": ["El nom no coincideix"],
      "Faild to delete the account.": ["No s'ha pogut suprimir el compte."],
      "Not enough permission to delete the account.": [
        "No hi ha permisos suficients per suprimir el compte.",
      ],
      "The username was not found.": ["No s'ha trobat el nom d'usuari."],
      "Can't delete a reserved username.": [
        "No es pot suprimir un nom d'usuari reservat.",
      ],
      "Can't delete an account with balance different than zero.": [
        "No es pot suprimir un compte amb un saldo diferent de zero.",
      ],
      "Account deletion": ["Supressió del compte"],
      "there was an error reading the balance": [
        "s'ha produït un error en llegir el saldo",
      ],
      "Can't delete the account": ["No es pot suprimir el compte"],
      "The account can't be deleted while still holding some balance. First make sure that the owner makes a complete cashout.":
        [
          "El compte no es pot suprimir mentre encara tingui saldo. Primer assegureu-vos que el titular fa un cashout complet.",
        ],
      "Go back": [""],
      "All account data will be permanently removed.": [""],
      "Verification": ["Verificació"],
      "Enter the account name that is going to be deleted": [
        "Introduïu el nom del compte que se suprimirà",
      ],
      "Withdraw without setting amount": ["Retirar sense fixar un import"],
      "Show install wallet first": [
        "Mostra primer la instal·lació de la cartera",
      ],
      "Introduction": ["Introducció"],
      "Bank": ["Banc"],
      "Essay Shop": ["Botiga d'assaigs"],
      "Donations": ["Donacions"],
      "GNU Taler logo": ["Logotip de GNU Taler"],
      "Withdraw toy currency into your GNU Taler wallet.": [
        "Retireu moneda de prova al vostre moneder GNU Taler.",
      ],
      "Demo pages": ["Pàgines de demostració"],
      "You were signed out locally, but the bank could not confirm that the server token was revoked. Close other sessions or sign in again to review active tokens.":
        [
          "Heu tancat la sessió localment, però el banc no ha pogut confirmar que el testimoni del servidor s'hagi revocat. Tanqueu les altres sessions o torneu a iniciar la sessió per revisar els testimonis actius.",
        ],
      "Dismiss": ["Descarta"],
      "Public accounts": ["Comptes públics"],
      "Open interface preferences": ["Obre les preferències de la interfície"],
      "Interface preferences": ["Preferències de la interfície"],
      "Choose how this bank interface behaves on this browser.": [
        "Trieu com es comporta aquesta interfície bancària en aquest navegador.",
      ],
      "Close interface preferences": [
        "Tanca les preferències de la interfície",
      ],
      "Show debug information": ["Mostra la informació de depuració"],
      "Done": ["Fet"],
      "Welcome": ["Us donem la benvinguda"],
      "Welcome, %1$s": ["Us donem la benvinguda, %1$s"],
      "Failed to load conversion rate.": [
        "No s'ha pogut carregar el tipus de conversió.",
      ],
      "Not enough permission to access the conversion rate list.": [
        "No hi ha permisos suficients per accedir a la llista de tipus de conversió.",
      ],
      "Conversion list not implemented.": [
        "La llista de conversió no està implementada.",
      ],
      "Conversion rate classes": ["Classes de tipus de conversió"],
      "Configure different cash-in and cashout terms for groups of accounts.": [
        "",
      ],
      "Default conversion rate": ["Tipus de conversió predeterminat"],
      "Create conversion rate class": [
        "Crear una classe de tipus de conversió",
      ],
      "Name": ["Nom"],
      "Description": ["Descripció"],
      "Cashin": ["Cashin"],
      "First page": ["Primera pàgina"],
      "Next": ["Següent"],
      "min:": ["mín.:"],
      "fee:": ["comissió:"],
      "only admin can setup conversion": [
        "només l'administrador pot configurar la conversió",
      ],
      "Failed to calculate cashout fee.": [
        "No s'ha pogut calcular la comissió del cashout.",
      ],
      "Failed to update the conversion rate.": [
        "No s'ha pogut actualitzar el tipus de conversió.",
      ],
      "Wrong credentials": ["Credencials incorrectes"],
      "Conversion is disabled": ["La conversió està desactivada"],
      "Review the default terms or choose a direction to update its settings.":
        [""],
      "Details": ["Detalls"],
      "Bad ratios": ["Ràtios incorrectes"],
      "Initial amount": ["Quantitat inicial"],
      "Use it to test how the conversion will affect the amount.": [
        "Utilitzeu-la per comprovar com afectarà la conversió a la quantitat.",
      ],
      "Sending to this bank": ["Enviant a aquest banc"],
      "Converted": ["Convertit"],
      "Cashin after fee": ["Cashin després de la comissió"],
      "Sending from this bank": ["Enviant des d'aquest banc"],
      "Cashout after fee": ["Cashout després de la comissió"],
      "Bad configuration": ["Configuració incorrecta"],
      "This configuration allows users to cash out more of what has been cashed in.":
        [
          "Aquesta configuració permet als usuaris fer cashout de més del que s'ha ingressat amb cashin.",
        ],
      "Must be > 0": ["Ha de ser > 0"],
      "Ratio": ["Ràtio"],
      "Zero": ["Zero"],
      "Up": ["Amunt"],
      "Nearest": ["Més proper"],
      "Minimum amount": ["Quantitat mínima"],
      "Only cashout operations above this threshold will be allowed.": [
        "Només es permetran operacions de cashout per sobre d'aquest llindar.",
      ],
      "Conversion ratio between currencies": [
        "Ràtio de conversió entre divises",
      ],
      "Example conversion": ["Exemple de conversió"],
      "1 %1$s will be converted into %2$s %3$s": [
        "1 %1$s es convertirà en %2$s %3$s",
      ],
      "Tiny amount": ["Quantitat molt petita"],
      "Rounding mode": ["Mode d'arrodoniment"],
      "Amount will be rounded below to the largest possible value smaller than the input.":
        [
          "La quantitat s'arrodonirà a la baixa, al valor més gran possible que sigui menor que l'entrada.",
        ],
      "Amount will be rounded up to the smallest possible value larger than the input.":
        [
          "La quantitat s'arrodonirà a l'alça, al valor més petit possible que sigui més gran que l'entrada.",
        ],
      "Amount will be rounded to the closest possible value.": [
        "La quantitat s'arrodonirà al valor possible més proper.",
      ],
      'If none specified the fallback value is "%1$s ".': [
        "Si no se n'especifica cap, el valor per defecte és «%1$s».",
      ],
      "Examples": ["Exemples"],
      "Rounding an amount of 1.24 with rounding value 0.1": [
        "Arrodonint una quantitat d'1,24 amb un valor d'arrodoniment de 0,1",
      ],
      "Given the rounding value of 0.1 the possible values closest to 1.24 are: 1.1, 1.2, 1.3, 1.4.":
        [
          "Donat el valor d'arrodoniment de 0,1, els valors possibles més propers a 1,24 són: 1,1, 1,2, 1,3, 1,4.",
        ],
      'With the "zero" mode the value will be rounded to 1.2': [
        "Amb el mode «zero» el valor s'arrodonirà a 1,2",
      ],
      'With the "nearest" mode the value will be rounded to 1.2': [
        "Amb el mode «més proper» el valor s'arrodonirà a 1,2",
      ],
      'With the "up" mode the value will be rounded to 1.3': [
        "Amb el mode «amunt» el valor s'arrodonirà a 1,3",
      ],
      "Rounding an amount of 1.26 with rounding value 0.1": [
        "Arrodonint una quantitat d'1,26 amb un valor d'arrodoniment de 0,1",
      ],
      'With the "nearest" mode the value will be rounded to 1.3': [
        "Amb el mode «més proper» el valor s'arrodonirà a 1,3",
      ],
      "Rounding an amount of 1.24 with rounding value 0.3": [
        "Arrodonint una quantitat d'1,24 amb un valor d'arrodoniment de 0,3",
      ],
      "Given the rounding value of 0.3 the possible values closest to 1.24 are: 0.9, 1.2, 1.5, 1.8.":
        [
          "Donat el valor d'arrodoniment de 0,3, els valors possibles més propers a 1,24 són: 0,9, 1,2, 1,5, 1,8.",
        ],
      'With the "up" mode the value will be rounded to 1.5': [
        "Amb el mode «amunt» el valor s'arrodonirà a 1,5",
      ],
      "Rounding an amount of 1.26 with rounding value 0.3": [
        "Arrodonint una quantitat d'1,26 amb un valor d'arrodoniment de 0,3",
      ],
      "Amount to be deducted before amount is credited.": [
        "Quantitat que es deduirà abans que s'aboni l'import.",
      ],
      "Failed to load conversion details.": [
        "No s'han pogut carregar els detalls de la conversió.",
      ],
      "Conversion should be enabled in the configuration, the conversion rate should be initialized with fee(s), rates and a rounding mode.":
        [
          "La conversió s'ha d'habilitar a la configuració; el tipus de conversió s'ha d'inicialitzar amb comissió(ns), taxes i un mode d'arrodoniment.",
        ],
      "Failed to delete conversion rate class": [
        "No s'ha pogut suprimir la classe de tipus de conversió",
      ],
      "Unauthorized": ["No autoritzat"],
      "Forbidden": ["Prohibit"],
      "Failed to update conversion rate class.": [
        "No s'ha pogut actualitzar la classe de tipus de conversió.",
      ],
      "Not Found": ["No trobat"],
      "Not implemented": ["No implementat"],
      "The name of the conversion is already used.": [
        "El nom de la conversió ja s'utilitza.",
      ],
      "Accounts": ["Comptes"],
      "identification": ["identificació"],
      "Users": ["Usuaris"],
      "Delete": ["Suprimir"],
      "Failed to calculate the cashout fee.": [
        "No s'ha pogut calcular la comissió del cashout.",
      ],
      "Can't remove the conversion rate class": [
        "No es pot eliminar la classe de tipus de conversió",
      ],
      "There are some users associated with this class. You need to remove them first.":
        [
          "Hi ha alguns usuaris associats a aquesta classe. Cal eliminar-los primer.",
        ],
      "You are going to remove the conversion rate class": [
        "Esteu a punt d'eliminar la classe de tipus de conversió",
      ],
      "This step can't be undone.": ["Aquest pas no es pot desfer."],
      "Class": ["Classe"],
      "Action": ["Acció"],
      "Failed to update conversion class membership.": [
        "No s'ha pogut actualitzar la pertinença a la classe de conversió.",
      ],
      "The account could not be updated. Please try again.": [
        "No s'ha pogut actualitzar el compte. Torneu-ho a provar.",
      ],
      "Conversion rate information is unavailable for these accounts.": [
        "La informació del tipus de conversió no està disponible per a aquests comptes.",
      ],
      "Failed to load users in conversion class.": [
        "No s'han pogut carregar els usuaris de la classe de conversió.",
      ],
      "Filters": ["Filtres"],
      "Show from other classes": ["Mostra d'altres classes"],
      "Account": ["Compte"],
      "Group ID": ["ID de grup"],
      "No users in this conversion rate class": [
        "No hi ha usuaris en aquesta classe de tipus de conversió",
      ],
      "Remove": ["Eliminar"],
      "Add": ["Afegir"],
      "Conversion rate name": ["Nom del tipus de conversió"],
      "Short description of the class": ["Descripció curta de la classe"],
      "Failed to create conversion class.": [
        "No s'ha pogut crear la classe de conversió.",
      ],
      "New conversion rate class": ["Classe de tipus de conversió nova"],
      "Create a named set of conversion terms that can be assigned to accounts.":
        [""],
      "Failed to load public accounts.": [
        "No s'han pogut carregar els comptes públics.",
      ],
      "Browse transaction histories shared by public bank accounts.": [
        "Consulteu els historials de transaccions compartits pels comptes bancaris públics.",
      ],
      "No public accounts are available.": [
        "No hi ha cap compte públic disponible.",
      ],
      "View previous cashouts": ["Mostra els reintegraments anteriors"],
      "Failed to load cashout details.": [
        "No s'han pogut carregar els detalls del cashout.",
      ],
      "Amounts recorded for this completed cashout transfer.": [""],
      "Enter your full name.": ["Introduïu el nom complet."],
      "Repeat your password.": ["Repetiu la contrasenya"],
      "Create your bank account": ["Crear un compte"],
      "Choose the credentials you will use to sign in.": [
        "Trieu les credencials que utilitzareu per iniciar la sessió.",
      ],
      "Already have an account?": ["Ja teniu un compte?"],
      "Confirm password": ["Confirma la contrasenya"],
      "Use between 8 and 64 characters. A longer, unique password is easier to keep secure.":
        [
          "Utilitzeu entre 8 i 64 caràcters. Una contrasenya més llarga i única és més fàcil de mantenir segura.",
        ],
      "Creating account…": ["S’està creant el compte…"],
      "Check the account details and try again.": [
        "Reviseu les dades del compte i torneu-ho a provar.",
      ],
      "You are not authorized to create this account.": [
        "No teniu autorització per crear aquest compte.",
      ],
      "Registration is unavailable because the bank cannot grant the account credit.":
        [
          "El registre no està disponible perquè el banc no pot concedir crèdit al compte.",
        ],
      "That username is reserved. Choose another username.": [
        "Aquest nom d’usuari està reservat. Trieu-ne un altre.",
      ],
      "That username is already taken.": [
        "Aquest nom d'usuari ja està ocupat.",
      ],
      "That account ID is already taken.": [
        "Aquest ID de compte ja està ocupat.",
      ],
      "The bank is missing information for the selected authentication channel.":
        ["No hi ha informació per al canal d'autenticació seleccionat."],
      "The selected authentication channel is not supported.": [
        "El canal d'autenticació no és compatible.",
      ],
      "Only an administrator may set the debt limit.": [
        "Només un administrador pot establir el límit de deute.",
      ],
      "Only an administrator may select a conversion rate class.": [
        "Només un administrador pot seleccionar una classe de tipus de conversió.",
      ],
      "The selected conversion rate class does not exist.": [
        "La classe de tipus de conversió no existeix.",
      ],
      "Only an administrator may enable two-factor authentication while creating an account.":
        [
          "Només un administrador pot activar l’autenticació de dos factors en crear un compte.",
        ],
      "Account registration is unavailable": ["Registre de compte"],
      "This bank is not accepting new account registrations.": [
        "Actualment, el banc no accepta nous registres!",
      ],
      "Return to sign in": ["Torna a l’inici de sessió"],
      "Contact the bank administrator if you need an account.": [
        "Poseu-vos en contacte amb l'administrador del banc.",
      ],
      "Failed to load withdrawal details.": [
        "No s'han pogut carregar els detalls de la retirada.",
      ],
      "Abort this withdrawal?": ["Voleu cancel·lar aquesta retirada?"],
      "This stops the withdrawal. No money will be transferred, and this operation cannot be resumed.":
        [
          "Això cancel·la la retirada. No es transferiran diners i aquesta operació no es podrà reprendre.",
        ],
      "Keep withdrawal": ["Manteniu la retirada"],
      "Abort withdrawal": ["Cancel·leu la retirada"],
      'The payto URI returned by the server is invalid: "%1$s".': [
        'L\'URI payto retornat pel servidor no és vàlid: "%1$s".',
      ],
      'The withdrawal URI returned by the server is invalid: "%1$s".': [
        'L\'URI de retirada retornat pel servidor no és vàlid: "%1$s".',
      ],
      'The reserve public key returned by the server is invalid: "%1$s".': [
        'La clau pública de reserva retornada pel servidor no és vàlida: "%1$s".',
      ],
      "Enter an amount.": ["Introduïu un import."],
      "Enter a valid amount.": ["Introduïu un import vàlid."],
      "The amount must be greater than zero.": [
        "L’import ha de ser superior a zero.",
      ],
      "The amount is below the bank's minimum.": [
        "L’import és inferior al mínim del banc.",
      ],
      "The amount is above the bank's maximum.": [
        "L’import és superior al màxim del banc.",
      ],
      "Failed to abort the withdrawal.": [
        "No s'ha pogut cancel·lar la retirada.",
      ],
      "The server did not understand the request.": [
        "El servidor no ha entès la sol·licitud.",
      ],
      "The operation was not found.": ["No s'ha trobat l'operació."],
      "The withdrawal operation has already been confirmed and cannot be aborted.":
        ["L’operació de retirada ja s’ha confirmat i no es pot cancel·lar."],
      "The bank could not be reached. Please try again.": [
        "No s’ha pogut contactar amb el banc. Torneu-ho a provar.",
      ],
      "Withdrawal confirmation": ["Confirmació de la retirada"],
      "Failed to confirm the withdrawal.": [
        "No s'ha pogut confirmar la retirada.",
      ],
      "The account does not have sufficient funds or the amount is outside the limits.":
        [
          "El compte no té fons suficients o la quantitat està fora dels límits.",
        ],
      "The withdrawal has been aborted and cannot be confirmed.": [
        "La retirada s’ha cancel·lat i no es pot confirmar.",
      ],
      "The wallet has not finished selecting an exchange account.": [
        "El moneder encara no ha acabat de seleccionar un compte de casa de canvi.",
      ],
      "The withdrawal amount changed. Review the current amount and try again.":
        [
          "L’import de la retirada ha canviat. Reviseu l’import actual i torneu-ho a provar.",
        ],
      "Enter an amount before confirming the withdrawal.": [
        "Introduïu un import abans de confirmar la retirada.",
      ],
      "Selected exchange": ["Casa de canvi seleccionada"],
      "Sign in to confirm the withdrawal": [
        "Inicieu la sessió per confirmar la retirada",
      ],
      "Sign in as %1$s before reviewing and confirming this withdrawal.": [
        "Inicieu la sessió com a %1$s abans de revisar i confirmar aquesta retirada.",
      ],
      "You are signed in as %1$s, but this withdrawal belongs to %2$s.": [
        "Heu iniciat la sessió com a %1$s, però aquesta retirada pertany a %2$s.",
      ],
      "Finish later": ["Acaba més tard"],
      "Confirm wallet withdrawal": ["Confirma la retirada al moneder"],
      "Review how much will leave your bank account before confirming.": [
        "Reviseu quant es retirarà del vostre compte bancari abans de confirmar.",
      ],
      "Unsupported exchange account": ["Compte de casa de canvi no compatible"],
      "The exchange account does not use the transfer type configured by this bank. This withdrawal cannot be confirmed.":
        [
          "El compte de la casa de canvi no utilitza el tipus de transferència configurat per aquest banc. Aquesta retirada no es pot confirmar.",
        ],
      "Withdrawal amount missing": ["Falta l’import de la retirada"],
      "The bank did not provide an amount for this withdrawal. It cannot be confirmed.":
        [
          "El banc no ha proporcionat cap import per a aquesta retirada. No es pot confirmar.",
        ],
      "Bank amount configuration invalid": [
        "La configuració dels imports del banc no és vàlida",
      ],
      "The withdrawal amount and bank fee could not be combined safely. This withdrawal cannot be confirmed.":
        [
          "L’import de la retirada i la comissió bancària no es poden combinar de manera segura. Aquesta retirada no es pot confirmar.",
        ],
      "Wallet receives": ["El moneder rep"],
      "Amount to your Taler Wallet": ["Import per al vostre moneder Taler"],
      "Allowed amount": ["Import permès"],
      "Maximum amount": ["Import màxim"],
      "Amount unavailable": ["Import no disponible"],
      "From": ["De"],
      "To": ["A"],
      "Taler Wallet": ["Moneder Taler"],
      "Exchange": ["Casa de canvi"],
      "Unavailable": ["No disponible"],
      "Exchange details": ["Detalls de la casa de canvi"],
      "Exchange IBAN": ["IBAN de la casa de canvi"],
      "Bank hostname": ["Nom d’amfitrió del banc"],
      "Exchange account": ["Compte de la casa de canvi"],
      "No money is withdrawn until you confirm. You can finish this later from your account overview.":
        [
          "No es retira cap diner fins que ho confirmeu. Podeu acabar més tard des del resum del compte.",
        ],
      "Confirm withdrawal": ["Confirma la retirada"],
      "Unauthorized to make the operation, maybe the session has expired or the password changed.":
        [
          "No autoritzat per fer l'operació; potser la sessió ha caducat o la contrasenya ha canviat.",
        ],
      "The operation was rejected due to insufficient funds.": [
        "L'operació s'ha rebutjat per fons insuficients.",
      ],
      "Withdrawal aborted": ["Retirada avortada"],
      "Withdrawal confirmed": ["Retirada confirmada"],
      "The bank transfer to the Taler exchange has been initiated. Your Taler Wallet will receive the withdrawn amount shortly.":
        [
          "S'ha iniciat la transferència bancària a la casa de canvi Taler. El vostre moneder Taler rebrà l’import retirat en breu.",
        ],
      "Back to account": ["Torna al compte"],
      "Complete withdrawal with your Taler Wallet": [
        "Completeu la retirada amb el vostre moneder Taler",
      ],
      "Scan this QR code with your Taler Wallet. Your wallet will select an exchange and prepare the withdrawal.":
        [
          "Escanegeu aquest codi QR amb el vostre moneder Taler. El moneder seleccionarà una casa de canvi i prepararà la retirada.",
        ],
      "Withdrawal amount": ["Import de la retirada"],
      "Suggested amount": ["Import suggerit"],
      "You can change this amount in your wallet.": [
        "Podeu canviar aquest import al vostre moneder.",
      ],
      "QR code to continue the withdrawal in a Taler Wallet.": [
        "Codi QR per continuar la retirada en un moneder Taler.",
      ],
      "Open Taler Wallet manually": ["Obre manualment el moneder Taler"],
      "Don't have a Taler Wallet?": ["No teniu cap moneder Taler?"],
      "Get a wallet": ["Obteniu un moneder"],
      "No money will be transferred until you return here to review and confirm the withdrawal.":
        [
          "No es transferirà cap diner fins que torneu aquí per revisar i confirmar la retirada.",
        ],
      "Sign in to abort this withdrawal": [
        "Inicieu la sessió per avortar aquesta retirada",
      ],
      "The withdrawal operation has been confirmed previously and can not be aborted.":
        [
          "L'operació de retirada ja s'ha confirmat prèviament i no es pot cancel·lar.",
        ],
      "Withdrawal ready for confirmation": ["Retirada a punt per confirmar"],
      "Withdrawal waiting for your wallet": [
        "Retirada en espera del vostre moneder",
      ],
      "The pending withdrawal could not be checked": [
        "No s’ha pogut comprovar la retirada pendent",
      ],
      "Checking the pending withdrawal…": [
        "S’està comprovant la retirada pendent…",
      ],
      "Review withdrawal": ["Reviseu la retirada"],
      "Retry": ["Torneu-ho a provar"],
      "Resume withdrawal": ["Repreneu la retirada"],
      "Finish or abort this withdrawal before starting another one.": [
        "Completeu o cancel·leu aquesta retirada abans d’iniciar-ne una altra.",
      ],
      "Dashboard": ["Tauler"],
      "Admin activity": ["Activitat d'administració"],
      "Conversion": ["Conversió"],
      "My account": ["El meu compte"],
      "Bank administration": ["Administració bancària"],
      "Failed to load the account list.": [
        "No s'ha pogut carregar la llista de comptes.",
      ],
      "Search accounts": ["Cerca comptes"],
      "Search by username or name": ["Cerca per nom d'usuari o nom"],
      "Search": ["Cerca"],
      "Clear": ["Netejar"],
      "Unknown": ["Desconegut"],
      "Change password": ["Canviar la contrasenya"],
      "Previous": ["Anterior"],
      "The amount exceeds what is available to withdraw.": [""],
      "The server replied with an invalid taler://withdraw URI": [
        "El servidor ha respost amb un URI taler://withdraw no vàlid",
      ],
      "Withdraw URI: %1$s": ["URI de retirada: %1$s"],
      "Failed to create the withdrawal.": ["No s'ha pogut crear la retirada."],
      "The operation was rejected due to insufficient funds": [
        "L'operació s'ha rebutjat per fons insuficients",
      ],
      "Please sign in again.": ["Torna a iniciar la sessió."],
      "The bank's withdrawal limits or fee are configured incorrectly.": [""],
      "Maximum withdrawal": ["Retirada màxima"],
      "There is not enough available balance to cover a withdrawal and the bank fee.":
        [""],
      "Dismiss wallet installation hint": [""],
      "Unable to start a withdrawal.": ["No es pot iniciar una retirada."],
      "Your account was created. Sign in to continue.": [
        "El compte s’ha creat. Inicieu la sessió per continuar.",
      ],
      "Home": ["Inici"],
      "Page not found": ["No s'ha trobat la pàgina"],
      "The requested bank page does not exist.": [
        "La pàgina del banc sol·licitada no existeix.",
      ],
      "Unknown challenge.": ["Repte desconegut."],
      "Failed to validate the verification code.": [
        "No s'ha pogut validar el codi de verificació.",
      ],
      "Too many challenges are active. Wait or confirm an existing challenge.":
        [
          "Hi ha massa reptes actius en aquest moment; heu d'esperar o confirmar els reptes actuals.",
        ],
      "The verification code is incorrect.": [
        "El codi de verificació és incorrecte.",
      ],
      "The verification code has expired.": [
        "El codi de verificació ha caducat.",
      ],
      "Submit the transmitted code number.": [
        "Envieu el número de codi transmès.",
      ],
      "The verification code sent to the email address starting with %1$s": [
        "El codi de verificació enviat a l'adreça de correu electrònic que comença amb %1$s",
      ],
      "The verification code sent to the phone number ending with %1$s": [
        "El codi de verificació enviat al número de telèfon que acaba amb %1$s",
      ],
      "Code": ["Codi"],
      "Authentication code": ["Codi d'autenticació"],
      "It will expire at %1$s": ["Caducarà a les %1$s"],
      "This challenge is terminal and cannot be retransmitted.": [
        "Aquest repte és terminal i no es pot retransmetre.",
      ],
      "Restart authentication": ["Reinicia l'autenticació"],
      "Back": ["Enrere"],
      "Verifying…": ["S’està verificant…"],
      "Verify": ["Verificar"],
      "Complete": ["Completar"],
      "Failed to start the challenge.": ["No s'ha pogut iniciar el repte."],
      "Unable to send the verification code.": [
        "No s'ha pogut enviar el codi de verificació.",
      ],
      "The request was valid, but the server is refusing action.": [
        "La sol·licitud era vàlida, però el servidor rebutja l'acció.",
      ],
      "The backend is not aware of the specified MFA challenge.": [
        "El backend no té constància del repte MFA especificat.",
      ],
      "It is too early to request another transmission of the challenge.": [
        "És massa aviat per sol·licitar una altra transmissió del repte.",
      ],
      "Code transmission failed.": ["La transmissió del codi ha fallat."],
      "Multi-factor authentication required": ["Cal autenticació multifactor"],
      "This operation is protected with second factor authentication. In order to complete it we need to verify your identity using the authentication channel you provided.":
        [
          "Aquesta operació està protegida amb autenticació de segon factor. Per completar-la, cal verificar la vostra identitat mitjançant el canal d'autenticació que heu proporcionat.",
        ],
      "The next challenge needs to be completed to confirm the operation.": [
        "Cal completar el següent repte per confirmar l'operació.",
      ],
      "All the next challenges need to be completed to confirm the operation.":
        ["Cal completar tots els següents reptes per confirmar l'operació."],
      "One of the next challenges needs to be completed to confirm the operation.":
        ["Cal completar un dels següents reptes per confirmar l'operació."],
      'To a phone ending with "%1$s"': ["A un telèfon que acaba amb «%1$s»"],
      'To an email starting with " %1$s"': [
        "A un correu electrònic que comença amb « %1$s»",
      ],
      "I have a code": ["Tinc un codi"],
      "Send me a message": ["Envieu-me un missatge"],
      "You have to wait until %1$s to send a new code.": [
        "Heu d'esperar fins a %1$s per enviar un codi nou.",
      ],
      "Use configured value (enabled)": [
        "Utilitza el valor configurat (activat)",
      ],
      "Use configured value (disabled)": [
        "Utilitza el valor configurat (desactivat)",
      ],
      "Force enabled": ["Força l'activació"],
      "Force disabled": ["Força la desactivació"],
      "Enter a valid HTTP or HTTPS URL.": [
        "Introduïu un URL HTTP o HTTPS vàlid.",
      ],
      "Development settings": ["Configuració de desenvolupament"],
      "These overrides are stored only in this browser.": [
        "Aquestes substitucions només s'emmagatzemen en aquest navegador.",
      ],
      "Corebank API base URL": ["URL base de l'API de Corebank"],
      "Leave empty to use the configured URL: %1$s": [
        "Deixeu-ho buit per utilitzar l'URL configurat: %1$s",
      ],
      "Leave empty to derive the URL from this page.": [
        "Deixeu-ho buit per obtenir l'URL d'aquesta pàgina.",
      ],
      "Demo header": ["Capçalera de demostració"],
      "Control whether the demo header is shown in this browser.": [
        "Controla si la capçalera de demostració es mostra en aquest navegador.",
      ],
      "Control whether public account links are shown in this browser.": [
        "Controla si els enllaços als comptes públics es mostren en aquest navegador.",
      ],
      "Overrides saved.": ["Substitucions desades."],
      "Apply overrides": ["Aplica les substitucions"],
      "Clear overrides": ["Esborra les substitucions"],
      "Back to bank": ["Torna al banc"],
    },
  },
  domain: "messages",
  plural_forms: "nplurals=2; plural=n != 1;",
  lang: "ca",
  completeness: 87,
};
